import { ref as O, watchEffect as be, unref as d, onUnmounted as We, defineComponent as E, openBlock as p, createElementBlock as x, normalizeClass as I, createElementVNode as L, toDisplayString as G, createCommentVNode as $, computed as k, renderSlot as w, Fragment as X, createTextVNode as ne, createBlock as D, toRef as z, inject as fe, onMounted as xe, createVNode as A, normalizeProps as W, guardReactiveProps as j, shallowRef as oe, readonly as Ja, watch as H, getCurrentScope as _a, onScopeDispose as el, isRef as ln, nextTick as Ne, toValue as ae, getCurrentInstance as $t, hasInjectionContext as tl, reactive as Ht, toRaw as nl, mergeProps as re, withCtx as T, withModifiers as ke, h as jn, provide as Xe, withKeys as sn, Transition as ct, mergeModels as he, useModel as De, withDirectives as ft, vModelText as Cs, renderList as ce, shallowReadonly as pt, Teleport as Ze, toRefs as Hn, normalizeStyle as se, useAttrs as Ie, useId as on, vModelRadio as Ts, TransitionGroup as rn, vShow as Lt, resolveDynamicComponent as $e, useSlots as un, createStaticVNode as Ss } from "vue";
import { library as Bs } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon as Q } from "@fortawesome/vue-fontawesome";
import { Big as Yt } from "big.js";
import Ds from "./assets/69bc6d5c702f3ada.svg";
import Is from "./assets/1b1de9c8d490d7ed.svg";
import Ms from "./assets/12cde57cbc53a39e.svg";
const Es = {
  brandColor: "#50fcea",
  secondaryColor: "#2d3544",
  textColor: "#dddddd",
  iconColor: "#99b5d0",
  sidebarBgColor: "#262f37",
  bodyBgColorA: "#2d3544",
  bodyBgColorB: "#40304b",
  successColor: "#50fc92",
  warningColor: "#ff9525",
  dangerColor: "#c4293e",
  infoColor: "#3391ff"
}, As = Symbol(
  "GP_THEME_DEFAULT"
), Fs = Symbol("GP_THEME"), Os = (e, t = 1) => {
  let n = e.replace("#", ""), a = t;
  n.length === 3 && (n = `${n[0]}${n[0]}${n[1]}${n[1]}${n[2]}${n[2]}`);
  const l = parseInt(n.substring(0, 2), 16), s = parseInt(n.substring(2, 4), 16), i = parseInt(n.substring(4, 6), 16);
  return a > 1 && a <= 100 && (a /= 100), `rgba(${l},${s},${i},${a})`;
}, $s = (e) => {
  if (typeof window > "u") return;
  const t = localStorage.getItem("gp-theme");
  if (t != null) {
    const n = JSON.parse(t), a = document.querySelector(":root");
    a != null && (a.style.setProperty("--gp-body-color", n.textColor), a.style.setProperty(
      "--gp-body-color-rgb",
      Os(n.textColor)
    ), a.style.setProperty("--gp-primary", n.brandColor), a.style.setProperty(
      "--gp-body-background",
      `linear-gradient(145deg, ${n.bodyBgColorA} 13%, ${n.bodyBgColorB} 75%)`
    ), a.style.setProperty(
      "--gp-sidebar-background",
      n.sidebarBgColor
    ), a.style.setProperty("--gp-flat-color", n.secondaryColor));
    const l = O(n);
    e.provide(Fs, l);
  }
}, Ls = (e) => {
  e.provide(As, Es);
}, Vs = (e) => {
  Ls(e), $s(e);
};
var dn = /* @__PURE__ */ ((e) => (e.TOP_LEFT = "top-left", e.TOP_CENTER = "top-center", e.TOP_RIGHT = "top-right", e.BOTTOM_LEFT = "bottom-left", e.BOTTOM_CENTER = "bottom-center", e.BOTTOM_RIGHT = "bottom-right", e))(dn || {});
const Un = Symbol("GP_TOASTS"), qn = Symbol("GP_TOASTS_OPTIONS"), al = O([]), Rs = {
  defaultTimeout: 5e3,
  positions: [dn.TOP_RIGHT]
};
function Ps(e, t, {
  defaultTimeout: n = 5e3,
  positions: a = [dn.TOP_RIGHT]
}) {
  t.defaultTimeout == null && (t.defaultTimeout = n), (t.positions == null || t.positions.length === 0) && (t.positions = a);
  const l = O([]);
  e.provide(Un, l), e.provide(qn, t);
}
/*!
 * Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const ll = {
  prefix: "fas",
  iconName: "circle-notch",
  icon: [512, 512, [], "f1ce", "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"]
}, sl = {
  prefix: "fas",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
}, lt = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, ba = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, Gs = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
}, Pn = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, Ns = {
  prefix: "fas",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
}, il = {
  prefix: "fas",
  iconName: "grip-vertical",
  icon: [320, 512, [], "f58e", "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"]
}, zs = {
  prefix: "fas",
  iconName: "ellipsis-vertical",
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"]
}, ol = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, rl = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, Je = rl, ul = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, dl = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, Ys = {
  prefix: "fas",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"]
}, Gn = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, Ve = (e, t) => {
  const n = O(""), a = be(() => {
    const l = d(e), s = d(t);
    l != null && l.length > 0 && s != null && s.length > 0 ? n.value = `${l}-input__${s}` : l == null && l.length === 0 && (n.value = `input__${s}`);
  });
  return We(() => {
    a();
  }), n;
}, Ct = (e) => {
  for (const [t, n] of Object.entries(e))
    /^fa/.test(t) && Bs.add(n);
}, Ws = ["for"], ht = /* @__PURE__ */ E({
  __name: "GpInputLabel",
  props: {
    label: {},
    componentId: {},
    hasError: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => e.label != null && e.label.length > 0 ? (p(), x("label", {
      key: 0,
      for: e.componentId,
      class: I(["mb-1 w-full text-sm transition-colors", { "text-gp-crab": e.hasError }])
    }, [
      L("strong", null, G(e.label), 1)
    ], 10, Ws)) : $("", !0);
  }
}), je = (e) => {
  const t = k(
    () => e.error != null && e.error.length > 0
  ), n = k(() => e.hint != null && e.hint.length > 0);
  return {
    hasError: t,
    hasHint: n
  };
}, pe = /* @__PURE__ */ E({
  __name: "GpInputHint",
  props: {
    error: { default: null },
    hint: { default: null }
  },
  setup(e) {
    const t = e, { hasError: n, hasHint: a } = je(t);
    return (l, s) => d(n) || d(a) ? (p(), x("p", {
      key: 0,
      class: I(["mb-0 mt-2 text-sm", {
        "text-gp-rhino": d(a) && !d(n),
        "text-gp-crab": d(n)
      }])
    }, [
      w(l.$slots, "default", {}, () => [
        d(n) ? (p(), x(X, { key: 0 }, [
          ne(G(e.error), 1)
        ], 64)) : (p(), x(X, { key: 1 }, [
          ne(G(e.hint), 1)
        ], 64))
      ])
    ], 2)) : $("", !0);
  }
}), st = /* @__PURE__ */ E({
  __name: "GpInputBtn",
  props: {
    icon: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, a = (l) => {
      n("click", l);
    };
    return (l, s) => (p(), x("button", {
      class: "size-input p-0",
      type: "button",
      onClick: a
    }, [
      w(l.$slots, "default", {}, () => [
        e.icon != null ? (p(), D(d(Q), {
          key: 0,
          class: "text-gp-rhino",
          icon: e.icon
        }, null, 8, ["icon"])) : $("", !0)
      ])
    ]));
  }
}), _e = (e, t) => {
  const n = O(!1);
  return {
    isFocused: n,
    handleFocus: (o) => {
      n.value = !0, t("focus", o);
    },
    manualFocus: () => {
      e.value.focus();
    },
    handleBlur: (o) => {
      n.value = !1, t("blur", o);
    },
    manualBlur: () => {
      e.value.blur();
    }
  };
}, cl = (e, t, n) => {
  const a = O(!1), l = k(() => {
    const o = d(t);
    return o != null && e.value != null ? e.value.length < o && a.value : !1;
  }), s = k(() => {
    const o = d(n);
    return o != null && e.value != null ? e.value.length > o && a.value : !1;
  }), i = k(() => l.value || s.value);
  return {
    valueEntered: a,
    minLengthNotFullfilled: l,
    maxLengthNotFullfilled: s,
    lengthConstraintNotFullfilled: i
  };
}, js = ["id", "name", "type", "placeholder", "minlength", "pattern", "value", "autocomplete", "readonly", "disabled"], Hs = { class: "flex" }, Kn = /* @__PURE__ */ E({
  __name: "GpTextInput",
  props: {
    modelValue: {},
    nullable: { type: Boolean, default: !1 },
    inputId: {},
    name: { default: "" },
    type: { default: "text" },
    autocomplete: { default: "off" },
    pattern: { default: null },
    placeholder: { default: null },
    minLength: { default: null },
    maxLength: { default: null },
    immediateLengthValidation: { type: Boolean, default: !1 },
    label: { default: null },
    hint: { default: null },
    canBeResetted: { type: Boolean, default: !1 },
    float: { type: Boolean, default: !1 },
    error: { default: null },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "blur", "focus", "keydown", "select", "mouseup"],
  setup(e, { expose: t, emit: n }) {
    const a = e, l = n;
    Ct({ faTimes: Je });
    const s = Ve(a.type, a.inputId), i = z(a, "minLength"), o = z(a, "maxLength"), r = z(a, "modelValue"), {
      minLengthNotFullfilled: u,
      maxLengthNotFullfilled: c,
      lengthConstraintNotFullfilled: f,
      valueEntered: m
    } = cl(r, i, o), h = (F) => {
      m.value || (m.value = !0);
      const N = F.target.value;
      N.length > 0 ? l("update:modelValue", N) : l("update:modelValue", a.nullable ? null : ""), l("input", F);
    }, g = () => {
      l("update:modelValue", a.nullable ? null : "");
    }, v = fe(
      "imask-input",
      () => O(null),
      !0
    ), { handleBlur: y, handleFocus: b, manualBlur: S, manualFocus: B } = _e(
      v,
      l
    ), M = (F) => {
      l("keydown", F);
    }, P = (F) => {
      l("select", F);
    }, V = (F) => {
      l("mouseup", F);
    }, { hasError: C } = je(a), R = k(() => {
      if (a.pattern == null || a.pattern === "" || !m.value) return !1;
      const F = a.modelValue ?? "";
      if (F.length === 0) return !1;
      try {
        return !new RegExp(`^(?:${a.pattern})$`).test(F);
      } catch {
        return !1;
      }
    });
    return xe(() => {
      a.autofocus && v.value.focus(), a.immediateLengthValidation && (m.value = !0);
    }), t({
      resetInput: g,
      inputElement: v,
      focus: B,
      blur: S
    }), (F, N) => (p(), x("div", {
      class: I(["transition-opacity", {
        "opacity-70": e.disabled,
        "opacity-100": !e.disabled
      }])
    }, [
      w(F.$slots, "label", {}, () => [
        A(ht, {
          "component-id": d(s),
          label: e.label,
          "has-error": d(C)
        }, null, 8, ["component-id", "label", "has-error"])
      ]),
      L("div", {
        class: I(["flex h-input transition-colors", {
          "rounded bg-gp-charcoal-grey shadow-xs": e.float,
          "border-b": !e.float,
          "border-gp-crab": !e.float && (d(C) || d(f) || R.value),
          "border-gp-rhino": !e.float && !d(C) && !d(f) && !R.value
        }])
      }, [
        w(F.$slots, "input-left"),
        L("input", {
          id: d(s),
          ref_key: "inputElement",
          ref: v,
          class: I(["flex-1 bg-transparent py-1 pl-0 leading-none focus-visible:outline-hidden", { "pl-2": e.float && F.$slots["input-left"] == null }]),
          name: e.name == null || e.name.length === 0 ? e.inputId : e.name,
          type: e.type,
          placeholder: e.placeholder ?? void 0,
          minlength: e.minLength ?? void 0,
          pattern: e.pattern ?? void 0,
          value: e.modelValue,
          autocomplete: e.autocomplete,
          readonly: e.readonly,
          disabled: e.disabled,
          onInput: h,
          onFocus: N[0] || (N[0] = //@ts-ignore
          (...ee) => d(b) && d(b)(...ee)),
          onBlur: N[1] || (N[1] = //@ts-ignore
          (...ee) => d(y) && d(y)(...ee)),
          onKeydown: M,
          onSelect: P,
          onMouseup: V
        }, null, 42, js),
        w(F.$slots, "input-right"),
        L("div", Hs, [
          e.canBeResetted && (e.modelValue != null && e.modelValue.length) > 0 && !e.disabled ? (p(), D(st, {
            key: 0,
            icon: ["fas", "fa-times"],
            onClick: g
          })) : $("", !0),
          w(F.$slots, "actions")
        ])
      ], 2),
      w(F.$slots, "hint", W(j({
        patternMismatch: R.value,
        minLengthNotFullfilled: d(u),
        maxLengthNotFullfilled: d(c)
      })), () => [
        A(pe, W(j({ hint: e.hint, error: e.error })), null, 16)
      ]),
      d(C) ? $("", !0) : (p(), x(X, { key: 0 }, [
        d(u) ? (p(), D(pe, {
          key: 0,
          error: `${(e.modelValue ?? "").length} / ${e.minLength} min`
        }, null, 8, ["error"])) : $("", !0),
        d(c) ? (p(), D(pe, {
          key: 1,
          error: `${(e.modelValue ?? "").length} / ${e.maxLength} max`
        }, null, 8, ["error"])) : $("", !0),
        R.value ? (p(), D(pe, {
          key: 2,
          error: "Value does not match the required pattern."
        })) : $("", !0)
      ], 64))
    ], 2));
  }
});
function Us(e, t) {
  var n;
  const a = oe();
  return be(() => {
    a.value = e();
  }, {
    ...t,
    flush: (n = void 0) != null ? n : "sync"
  }), Ja(a);
}
function Qn(e) {
  return _a() ? (el(e), !0) : !1;
}
const In = /* @__PURE__ */ new WeakMap(), qs = (...e) => {
  var t;
  const n = e[0], a = (t = $t()) == null ? void 0 : t.proxy;
  if (a == null && !tl())
    throw new Error("injectLocal must be called in setup");
  return a && In.has(a) && n in In.get(a) ? In.get(a)[n] : fe(...e);
}, fl = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Ks = (e) => typeof e < "u", Qs = (e) => e != null, Xs = Object.prototype.toString, Zs = (e) => Xs.call(e) === "[object Object]", Se = () => {
}, Js = /* @__PURE__ */ _s();
function _s() {
  var e, t;
  return fl && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Xn(e, t) {
  function n(...a) {
    return new Promise((l, s) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(l).catch(s);
    });
  }
  return n;
}
const ei = (e) => e();
function hl(e, t = {}) {
  let n, a, l = Se;
  const s = (r) => {
    clearTimeout(r), l(), l = Se;
  };
  let i;
  return (r) => {
    const u = ae(e), c = ae(t.maxWait);
    return n && s(n), u <= 0 || c !== void 0 && c <= 0 ? (a && (s(a), a = null), Promise.resolve(r())) : new Promise((f, m) => {
      l = t.rejectOnCancel ? m : f, i = r, c && !a && (a = setTimeout(() => {
        n && s(n), a = null, f(i());
      }, c)), n = setTimeout(() => {
        a && s(a), a = null, f(r());
      }, u);
    });
  };
}
function ml(...e) {
  let t = 0, n, a = !0, l = Se, s, i, o, r, u;
  !ln(e[0]) && typeof e[0] == "object" ? { delay: i, trailing: o = !0, leading: r = !0, rejectOnCancel: u = !1 } = e[0] : [i, o = !0, r = !0, u = !1] = e;
  const c = () => {
    n && (clearTimeout(n), n = void 0, l(), l = Se);
  };
  return (m) => {
    const h = ae(i), g = Date.now() - t, v = () => s = m();
    return c(), h <= 0 ? (t = Date.now(), v()) : (g > h && (r || !a) ? (t = Date.now(), v()) : o && (s = new Promise((y, b) => {
      l = u ? b : y, n = setTimeout(() => {
        t = Date.now(), a = !0, y(v()), c();
      }, Math.max(0, h - g));
    })), !r && !n && (n = setTimeout(() => a = !0, h)), a = !1, s);
  };
}
function ti(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const a = ((n = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", l = e.slice(a.length), s = Number.parseFloat(a) + t;
  return Number.isNaN(s) ? e : s + l;
}
function Mt(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function ni(e) {
  return $t();
}
function Et(e) {
  return Array.isArray(e) ? e : [e];
}
function ai(e, t = 200, n = {}) {
  return Xn(
    hl(t, n),
    e
  );
}
function li(e, t = 200, n = !1, a = !0, l = !1) {
  return Xn(
    ml(t, n, a, l),
    e
  );
}
function pl(e, t, n = {}) {
  const {
    eventFilter: a = ei,
    ...l
  } = n;
  return H(
    e,
    Xn(
      a,
      t
    ),
    l
  );
}
function Vt(e, t = !0, n) {
  ni() ? xe(e, n) : t ? e() : Ne(e);
}
function si(e, t, n = {}) {
  const {
    debounce: a = 0,
    maxWait: l = void 0,
    ...s
  } = n;
  return pl(
    e,
    t,
    {
      ...s,
      eventFilter: hl(a, { maxWait: l })
    }
  );
}
function ii(e, t, n) {
  return H(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
function Ut(e, t, n = {}) {
  const {
    throttle: a = 0,
    trailing: l = !0,
    leading: s = !0,
    ...i
  } = n;
  return pl(
    e,
    t,
    {
      ...i,
      eventFilter: ml(a, l, s)
    }
  );
}
function ka(e, t, n) {
  return H(
    e,
    (l, s, i) => {
      l && t(l, s, i);
    },
    {
      ...n,
      once: !1
    }
  );
}
const Re = fl ? window : void 0;
function ge(e) {
  var t;
  const n = ae(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function de(...e) {
  const t = [], n = () => {
    t.forEach((o) => o()), t.length = 0;
  }, a = (o, r, u, c) => (o.addEventListener(r, u, c), () => o.removeEventListener(r, u, c)), l = k(() => {
    const o = Et(ae(e[0])).filter((r) => r != null);
    return o.every((r) => typeof r != "string") ? o : void 0;
  }), s = ii(
    () => {
      var o, r;
      return [
        (r = (o = l.value) == null ? void 0 : o.map((u) => ge(u))) != null ? r : [Re].filter((u) => u != null),
        Et(ae(l.value ? e[1] : e[0])),
        Et(d(l.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ae(l.value ? e[3] : e[2])
      ];
    },
    ([o, r, u, c]) => {
      if (n(), !(o != null && o.length) || !(r != null && r.length) || !(u != null && u.length))
        return;
      const f = Zs(c) ? { ...c } : c;
      t.push(
        ...o.flatMap(
          (m) => r.flatMap(
            (h) => u.map((g) => a(m, h, g, f))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    s(), n();
  };
  return Qn(n), i;
}
let wa = !1;
function cn(e, t, n = {}) {
  const { window: a = Re, ignore: l = [], capture: s = !0, detectIframe: i = !1, controls: o = !1 } = n;
  if (!a)
    return o ? { stop: Se, cancel: Se, trigger: Se } : Se;
  if (Js && !wa) {
    wa = !0;
    const y = { passive: !0 };
    Array.from(a.document.body.children).forEach((b) => de(b, "click", Se, y)), de(a.document.documentElement, "click", Se, y);
  }
  let r = !0;
  const u = (y) => ae(l).some((b) => {
    if (typeof b == "string")
      return Array.from(a.document.querySelectorAll(b)).some((S) => S === y.target || y.composedPath().includes(S));
    {
      const S = ge(b);
      return S && (y.target === S || y.composedPath().includes(S));
    }
  });
  function c(y) {
    const b = ae(y);
    return b && b.$.subTree.shapeFlag === 16;
  }
  function f(y, b) {
    const S = ae(y), B = S.$.subTree && S.$.subTree.children;
    return B == null || !Array.isArray(B) ? !1 : B.some((M) => M.el === b.target || b.composedPath().includes(M.el));
  }
  const m = (y) => {
    const b = ge(e);
    if (y.target != null && !(!(b instanceof Element) && c(e) && f(e, y)) && !(!b || b === y.target || y.composedPath().includes(b))) {
      if ("detail" in y && y.detail === 0 && (r = !u(y)), !r) {
        r = !0;
        return;
      }
      t(y);
    }
  };
  let h = !1;
  const g = [
    de(a, "click", (y) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), m(y));
    }, { passive: !0, capture: s }),
    de(a, "pointerdown", (y) => {
      const b = ge(e);
      r = !u(y) && !!(b && !y.composedPath().includes(b));
    }, { passive: !0 }),
    i && de(a, "blur", (y) => {
      setTimeout(() => {
        var b;
        const S = ge(e);
        ((b = a.document.activeElement) == null ? void 0 : b.tagName) === "IFRAME" && !(S != null && S.contains(a.document.activeElement)) && t(y);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), v = () => g.forEach((y) => y());
  return o ? {
    stop: v,
    cancel: () => {
      r = !1;
    },
    trigger: (y) => {
      r = !0, m(y), r = !1;
    }
  } : v;
}
function oi() {
  const e = oe(!1), t = $t();
  return t && xe(() => {
    e.value = !0;
  }, t), e;
}
function Zn(e) {
  const t = oi();
  return k(() => (t.value, !!e()));
}
function ri(e, t, n = {}) {
  const { window: a = Re, ...l } = n;
  let s;
  const i = Zn(() => a && "MutationObserver" in a), o = () => {
    s && (s.disconnect(), s = void 0);
  }, r = k(() => {
    const m = ae(e), h = Et(m).map(ge).filter(Qs);
    return new Set(h);
  }), u = H(
    () => r.value,
    (m) => {
      o(), i.value && m.size && (s = new MutationObserver(t), m.forEach((h) => s.observe(h, l)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => s == null ? void 0 : s.takeRecords(), f = () => {
    u(), o();
  };
  return Qn(f), {
    isSupported: i,
    stop: f,
    takeRecords: c
  };
}
const ui = Symbol("vueuse-ssr-width");
function gl() {
  const e = tl() ? qs(ui, null) : null;
  return typeof e == "number" ? e : void 0;
}
function yt(e, t = {}) {
  const { window: n = Re, ssrWidth: a = gl() } = t, l = Zn(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), s = oe(typeof a == "number"), i = oe(), o = oe(!1), r = (u) => {
    o.value = u.matches;
  };
  return be(() => {
    if (s.value) {
      s.value = !l.value;
      const u = ae(e).split(",");
      o.value = u.some((c) => {
        const f = c.includes("not all"), m = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let g = !!(m || h);
        return m && g && (g = a >= Mt(m[1])), h && g && (g = a <= Mt(h[1])), f ? !g : g;
      });
      return;
    }
    l.value && (i.value = n.matchMedia(ae(e)), o.value = i.value.matches);
  }), de(i, "change", r, { passive: !0 }), k(() => o.value);
}
function di(e, t = {}) {
  function n(h, g) {
    let v = ae(e[ae(h)]);
    return g != null && (v = ti(v, g)), typeof v == "number" && (v = `${v}px`), v;
  }
  const { window: a = Re, strategy: l = "min-width", ssrWidth: s = gl() } = t, i = typeof s == "number", o = i ? oe(!1) : { value: !0 };
  i && Vt(() => o.value = !!a);
  function r(h, g) {
    return !o.value && i ? h === "min" ? s >= Mt(g) : s <= Mt(g) : a ? a.matchMedia(`(${h}-width: ${g})`).matches : !1;
  }
  const u = (h) => yt(() => `(min-width: ${n(h)})`, t), c = (h) => yt(() => `(max-width: ${n(h)})`, t), f = Object.keys(e).reduce((h, g) => (Object.defineProperty(h, g, {
    get: () => l === "min-width" ? u(g) : c(g),
    enumerable: !0,
    configurable: !0
  }), h), {});
  function m() {
    const h = Object.keys(e).map((g) => [g, f[g], Mt(n(g))]).sort((g, v) => g[2] - v[2]);
    return k(() => h.filter(([, g]) => g.value).map(([g]) => g));
  }
  return Object.assign(f, {
    greaterOrEqual: u,
    smallerOrEqual: c,
    greater(h) {
      return yt(() => `(min-width: ${n(h, 0.1)})`, t);
    },
    smaller(h) {
      return yt(() => `(max-width: ${n(h, -0.1)})`, t);
    },
    between(h, g) {
      return yt(() => `(min-width: ${n(h)}) and (max-width: ${n(g, -0.1)})`, t);
    },
    isGreater(h) {
      return r("min", n(h, 0.1));
    },
    isGreaterOrEqual(h) {
      return r("min", n(h));
    },
    isSmaller(h) {
      return r("max", n(h, -0.1));
    },
    isSmallerOrEqual(h) {
      return r("max", n(h));
    },
    isInBetween(h, g) {
      return r("min", n(h)) && r("max", n(g, -0.1));
    },
    current: m,
    active() {
      const h = m();
      return k(() => h.value.length === 0 ? "" : h.value.at(l === "min-width" ? -1 : 0));
    }
  });
}
function ci(e) {
  return JSON.parse(JSON.stringify(e));
}
function Jn(e, t, n = {}) {
  const { window: a = Re, ...l } = n;
  let s;
  const i = Zn(() => a && "ResizeObserver" in a), o = () => {
    s && (s.disconnect(), s = void 0);
  }, r = k(() => {
    const f = ae(e);
    return Array.isArray(f) ? f.map((m) => ge(m)) : [ge(f)];
  }), u = H(
    r,
    (f) => {
      if (o(), i.value && a) {
        s = new ResizeObserver(t);
        for (const m of f)
          m && s.observe(m, l);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    o(), u();
  };
  return Qn(c), {
    isSupported: i,
    stop: c
  };
}
function xa(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: a = !0,
    windowScroll: l = !0,
    immediate: s = !0,
    updateTiming: i = "sync"
  } = t, o = oe(0), r = oe(0), u = oe(0), c = oe(0), f = oe(0), m = oe(0), h = oe(0), g = oe(0);
  function v() {
    const b = ge(e);
    if (!b) {
      n && (o.value = 0, r.value = 0, u.value = 0, c.value = 0, f.value = 0, m.value = 0, h.value = 0, g.value = 0);
      return;
    }
    const S = b.getBoundingClientRect();
    o.value = S.height, r.value = S.bottom, u.value = S.left, c.value = S.right, f.value = S.top, m.value = S.width, h.value = S.x, g.value = S.y;
  }
  function y() {
    i === "sync" ? v() : i === "next-frame" && requestAnimationFrame(() => v());
  }
  return Jn(e, y), H(() => ge(e), (b) => !b && y()), ri(e, y, {
    attributeFilter: ["style", "class"]
  }), l && de("scroll", y, { capture: !0, passive: !0 }), a && de("resize", y, { passive: !0 }), Vt(() => {
    s && y();
  }), {
    height: o,
    bottom: r,
    left: u,
    right: c,
    top: f,
    width: m,
    x: h,
    y: g,
    update: y
  };
}
function _n(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: a = Re, box: l = "content-box" } = n, s = k(() => {
    var f, m;
    return (m = (f = ge(e)) == null ? void 0 : f.namespaceURI) == null ? void 0 : m.includes("svg");
  }), i = oe(t.width), o = oe(t.height), { stop: r } = Jn(
    e,
    ([f]) => {
      const m = l === "border-box" ? f.borderBoxSize : l === "content-box" ? f.contentBoxSize : f.devicePixelContentBoxSize;
      if (a && s.value) {
        const h = ge(e);
        if (h) {
          const g = h.getBoundingClientRect();
          i.value = g.width, o.value = g.height;
        }
      } else if (m) {
        const h = Et(m);
        i.value = h.reduce((g, { inlineSize: v }) => g + v, 0), o.value = h.reduce((g, { blockSize: v }) => g + v, 0);
      } else
        i.value = f.contentRect.width, o.value = f.contentRect.height;
    },
    n
  );
  Vt(() => {
    const f = ge(e);
    f && (i.value = "offsetWidth" in f ? f.offsetWidth : t.width, o.value = "offsetHeight" in f ? f.offsetHeight : t.height);
  });
  const u = H(
    () => ge(e),
    (f) => {
      i.value = f ? t.width : 0, o.value = f ? t.height : 0;
    }
  );
  function c() {
    r(), u();
  }
  return {
    width: i,
    height: o,
    stop: c
  };
}
function fi(e, t = {}) {
  const { initialValue: n = !1, focusVisible: a = !1, preventScroll: l = !1 } = t, s = oe(!1), i = k(() => ge(e)), o = { passive: !0 };
  de(i, "focus", (u) => {
    var c, f;
    (!a || (f = (c = u.target).matches) != null && f.call(c, ":focus-visible")) && (s.value = !0);
  }, o), de(i, "blur", () => s.value = !1, o);
  const r = k({
    get: () => s.value,
    set(u) {
      var c, f;
      !u && s.value ? (c = i.value) == null || c.blur() : u && !s.value && ((f = i.value) == null || f.focus({ preventScroll: l }));
    }
  });
  return H(
    i,
    () => {
      r.value = n;
    },
    { immediate: !0, flush: "post" }
  ), { focused: r };
}
const Ca = 1;
function vl(e, t = {}) {
  const {
    throttle: n = 0,
    idle: a = 200,
    onStop: l = Se,
    onScroll: s = Se,
    offset: i = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: o = {
      capture: !1,
      passive: !0
    },
    behavior: r = "auto",
    window: u = Re,
    onError: c = (C) => {
      console.error(C);
    }
  } = t, f = oe(0), m = oe(0), h = k({
    get() {
      return f.value;
    },
    set(C) {
      v(C, void 0);
    }
  }), g = k({
    get() {
      return m.value;
    },
    set(C) {
      v(void 0, C);
    }
  });
  function v(C, R) {
    var F, N, ee, _;
    if (!u)
      return;
    const Z = ae(e);
    if (!Z)
      return;
    (ee = Z instanceof Document ? u.document.body : Z) == null || ee.scrollTo({
      top: (F = ae(R)) != null ? F : g.value,
      left: (N = ae(C)) != null ? N : h.value,
      behavior: ae(r)
    });
    const U = ((_ = Z == null ? void 0 : Z.document) == null ? void 0 : _.documentElement) || (Z == null ? void 0 : Z.documentElement) || Z;
    h != null && (f.value = U.scrollLeft), g != null && (m.value = U.scrollTop);
  }
  const y = oe(!1), b = Ht({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), S = Ht({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), B = (C) => {
    y.value && (y.value = !1, S.left = !1, S.right = !1, S.top = !1, S.bottom = !1, l(C));
  }, M = ai(B, n + a), P = (C) => {
    var R;
    if (!u)
      return;
    const F = ((R = C == null ? void 0 : C.document) == null ? void 0 : R.documentElement) || (C == null ? void 0 : C.documentElement) || ge(C), { display: N, flexDirection: ee, direction: _ } = getComputedStyle(F), Z = _ === "rtl" ? -1 : 1, U = F.scrollLeft;
    S.left = U < f.value, S.right = U > f.value;
    const q = Math.abs(U * Z) <= (i.left || 0), te = Math.abs(U * Z) + F.clientWidth >= F.scrollWidth - (i.right || 0) - Ca;
    N === "flex" && ee === "row-reverse" ? (b.left = te, b.right = q) : (b.left = q, b.right = te), f.value = U;
    let ie = F.scrollTop;
    C === u.document && !ie && (ie = u.document.body.scrollTop), S.top = ie < m.value, S.bottom = ie > m.value;
    const ue = Math.abs(ie) <= (i.top || 0), Ce = Math.abs(ie) + F.clientHeight >= F.scrollHeight - (i.bottom || 0) - Ca;
    N === "flex" && ee === "column-reverse" ? (b.top = Ce, b.bottom = ue) : (b.top = ue, b.bottom = Ce), m.value = ie;
  }, V = (C) => {
    var R;
    if (!u)
      return;
    const F = (R = C.target.documentElement) != null ? R : C.target;
    P(F), y.value = !0, M(C), s(C);
  };
  return de(
    e,
    "scroll",
    n ? li(V, n, !0, !1) : V,
    o
  ), Vt(() => {
    try {
      const C = ae(e);
      if (!C)
        return;
      P(C);
    } catch (C) {
      c(C);
    }
  }), de(
    e,
    "scrollend",
    B,
    o
  ), {
    x: h,
    y: g,
    isScrolling: y,
    arrivedState: b,
    directions: S,
    measure() {
      const C = ae(e);
      u && C && P(C);
    }
  };
}
const hi = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function Rt(e = {}) {
  const {
    reactive: t = !1,
    target: n = Re,
    aliasMap: a = hi,
    passive: l = !0,
    onEventFired: s = Se
  } = e, i = Ht(/* @__PURE__ */ new Set()), o = {
    toJSON() {
      return {};
    },
    current: i
  }, r = t ? Ht(o) : o, u = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  function f(v, y) {
    v in r && (t ? r[v] = y : r[v].value = y);
  }
  function m() {
    i.clear();
    for (const v of c)
      f(v, !1);
  }
  function h(v, y) {
    var b, S;
    const B = (b = v.key) == null ? void 0 : b.toLowerCase(), P = [(S = v.code) == null ? void 0 : S.toLowerCase(), B].filter(Boolean);
    B && (y ? i.add(B) : i.delete(B));
    for (const V of P)
      c.add(V), f(V, y);
    B === "meta" && !y ? (u.forEach((V) => {
      i.delete(V), f(V, !1);
    }), u.clear()) : typeof v.getModifierState == "function" && v.getModifierState("Meta") && y && [...i, ...P].forEach((V) => u.add(V));
  }
  de(n, "keydown", (v) => (h(v, !0), s(v)), { passive: l }), de(n, "keyup", (v) => (h(v, !1), s(v)), { passive: l }), de("blur", m, { passive: l }), de("focus", m, { passive: l });
  const g = new Proxy(
    r,
    {
      get(v, y, b) {
        if (typeof y != "string")
          return Reflect.get(v, y, b);
        if (y = y.toLowerCase(), y in a && (y = a[y]), !(y in r))
          if (/[+_-]/.test(y)) {
            const B = y.split(/[+_-]/g).map((M) => M.trim());
            r[y] = k(() => B.map((M) => ae(g[M])).every(Boolean));
          } else
            r[y] = oe(!1);
        const S = Reflect.get(v, y, b);
        return t ? ae(S) : S;
      }
    }
  );
  return g;
}
function Ae(e, t, n, a = {}) {
  var l, s, i;
  const {
    clone: o = !1,
    passive: r = !1,
    eventName: u,
    deep: c = !1,
    defaultValue: f,
    shouldEmit: m
  } = a, h = $t(), g = n || (h == null ? void 0 : h.emit) || ((l = h == null ? void 0 : h.$emit) == null ? void 0 : l.bind(h)) || ((i = (s = h == null ? void 0 : h.proxy) == null ? void 0 : s.$emit) == null ? void 0 : i.bind(h == null ? void 0 : h.proxy));
  let v = u;
  t || (t = "modelValue"), v = v || `update:${t.toString()}`;
  const y = (B) => o ? typeof o == "function" ? o(B) : ci(B) : B, b = () => Ks(e[t]) ? y(e[t]) : f, S = (B) => {
    m ? m(B) && g(v, B) : g(v, B);
  };
  if (r) {
    const B = b(), M = O(B);
    let P = !1;
    return H(
      () => e[t],
      (V) => {
        P || (P = !0, M.value = y(V), Ne(() => P = !1));
      }
    ), H(
      M,
      (V) => {
        !P && (V !== e[t] || c) && S(V);
      },
      { deep: c }
    ), M;
  } else
    return k({
      get() {
        return b();
      },
      set(B) {
        S(B);
      }
    });
}
function mi(e = {}) {
  const {
    window: t = Re,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: l = !0,
    includeScrollbar: s = !0,
    type: i = "inner"
  } = e, o = oe(n), r = oe(a), u = () => {
    if (t)
      if (i === "outer")
        o.value = t.outerWidth, r.value = t.outerHeight;
      else if (i === "visual" && t.visualViewport) {
        const { width: f, height: m, scale: h } = t.visualViewport;
        o.value = Math.round(f * h), r.value = Math.round(m * h);
      } else s ? (o.value = t.innerWidth, r.value = t.innerHeight) : (o.value = t.document.documentElement.clientWidth, r.value = t.document.documentElement.clientHeight);
  };
  u(), Vt(u);
  const c = { passive: !0 };
  if (de("resize", u, c), t && i === "visual" && t.visualViewport && de(t.visualViewport, "resize", u, c), l) {
    const f = yt("(orientation: portrait)");
    H(f, () => u());
  }
  return { width: o, height: r };
}
const pi = ["id", "value", "name", "placeholder", "minlength", "maxlength", "disabled"], Wf = /* @__PURE__ */ E({
  __name: "GpTextArea",
  props: {
    modelValue: {},
    nullable: { type: Boolean },
    inputId: {},
    name: { default: "" },
    placeholder: { default: null },
    minLength: { default: null },
    maxLength: { default: null },
    immediateLengthValidation: { type: Boolean, default: !1 },
    label: { default: null },
    hint: { default: null },
    float: { type: Boolean, default: !1 },
    error: { default: null },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "blur", "focus"],
  setup(e, { expose: t, emit: n }) {
    const a = e, l = n, s = Ve("area", a.inputId), i = Ae(a, "modelValue", l), o = z(a, "minLength"), r = z(a, "maxLength"), {
      minLengthNotFullfilled: u,
      maxLengthNotFullfilled: c,
      lengthConstraintNotFullfilled: f,
      valueEntered: m
    } = cl(i, o, r), h = (P) => {
      m.value || (m.value = !0);
      const V = P.target.value;
      V.length > 0 ? i.value = V : i.value = a.nullable ? null : "";
    }, { hasError: g, hasHint: v } = je(a), y = O();
    xe(() => {
      a.autofocus && y.value.focus(), a.immediateLengthValidation && (m.value = !0);
    });
    const { manualBlur: b, manualFocus: S, handleBlur: B, handleFocus: M } = _e(
      y,
      l
    );
    return t({
      inputElement: y,
      focus: S,
      blur: b
    }), (P, V) => (p(), x("div", {
      class: I(["transition-opacity", {
        "opacity-70": e.disabled,
        "opacity-100": !e.disabled
      }])
    }, [
      w(P.$slots, "label", {}, () => [
        A(ht, {
          "component-id": d(s),
          label: e.label,
          "has-error": e.error != null && e.error.length > 0
        }, null, 8, ["component-id", "label", "has-error"])
      ]),
      L("div", {
        class: I(["transition-colors", {
          "rounded bg-gp-charcoal-grey shadow-xs": e.float,
          "border-b": !e.float,
          "border-gp-crab": !e.float && (d(g) || d(f)),
          "border-gp-rhino": !e.float && !d(g) && !d(f)
        }])
      }, [
        L("textarea", {
          id: d(s),
          ref_key: "inputElement",
          ref: y,
          value: d(i),
          name: e.name == null || e.name.length === 0 ? e.inputId : e.name,
          class: I(["block w-full bg-transparent px-0 py-1.5 leading-normal focus:outline-hidden", { "px-0": !e.float, "px-2": e.float }]),
          cols: "30",
          rows: "4",
          placeholder: e.placeholder,
          minlength: e.minLength,
          maxlength: e.maxLength,
          disabled: e.disabled,
          onInput: h,
          onFocus: V[0] || (V[0] = //@ts-ignore
          (...C) => d(M) && d(M)(...C)),
          onBlur: V[1] || (V[1] = //@ts-ignore
          (...C) => d(B) && d(B)(...C))
        }, null, 42, pi)
      ], 2),
      w(P.$slots, "hint", {}, () => [
        A(pe, W(j({ hint: e.hint, error: e.error })), null, 16),
        !d(g) && !d(v) ? (p(), x(X, { key: 0 }, [
          d(u) ? (p(), D(pe, {
            key: 0,
            error: `${d(i).length} / ${e.minLength} min`
          }, null, 8, ["error"])) : $("", !0),
          d(c) ? (p(), D(pe, {
            key: 1,
            error: `${d(i).length} / ${e.minLength} max`
          }, null, 8, ["error"])) : $("", !0)
        ], 64)) : $("", !0)
      ])
    ], 2));
  }
}), jf = /* @__PURE__ */ E({
  __name: "GpPasswordInput",
  props: {
    modelValue: {},
    inputId: {},
    name: { default: "" },
    nullable: { type: Boolean, default: !1 },
    autocomplete: { default: "new-password" },
    enableClearTextView: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    hint: { default: void 0 },
    canBeResetted: { type: Boolean, default: !1 },
    float: { type: Boolean },
    error: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "focus", "blur"],
  setup(e, { expose: t, emit: n }) {
    const a = e, l = n;
    Ct({ faEye: Pn, faEyeSlash: sl, faTimes: Je });
    const s = k(() => {
      const v = nl(a);
      return Object.entries(v).filter(
        ([y]) => ["type", "modelValue"].indexOf(
          y
        ) < 0
      ).reduce((y, [b, S]) => (y[b] = S, y), {});
    }), i = (v) => {
      a.nullable && v == null || v != null && v.length === 0 ? l("update:modelValue", a.nullable ? null : "") : l("update:modelValue", v);
    }, o = O(!1), r = (v) => {
      v.preventDefault(), o.value = !o.value;
    }, u = O(), { manualBlur: c, manualFocus: f, handleBlur: m, handleFocus: h } = _e(
      u,
      l
    );
    return t({
      inputComponent: u,
      resetInput: () => {
        u.value.resetInput();
      },
      blur: c,
      focus: f
    }), (v, y) => (p(), D(Kn, re({
      ref_key: "inputComponent",
      ref: u,
      type: o.value ? "text" : "password",
      "model-value": e.modelValue
    }, s.value, {
      "onUpdate:modelValue": i,
      onFocus: d(h),
      onBlur: d(m)
    }), {
      label: T(() => [
        w(v.$slots, "label")
      ]),
      actions: T(() => [
        e.enableClearTextView && e.modelValue.length > 0 && !e.disabled ? (p(), D(st, {
          key: 0,
          icon: ["fas", o.value ? "fa-eye-slash" : "fa-eye"],
          onClick: r
        }, null, 8, ["icon"])) : $("", !0),
        w(v.$slots, "actions")
      ]),
      hint: T(() => [
        w(v.$slots, "hint", {}, () => [
          A(pe, {
            error: e.error,
            hint: e.hint
          }, null, 8, ["error", "hint"])
        ])
      ]),
      _: 3
    }, 16, ["type", "model-value", "onFocus", "onBlur"]));
  }
});
var gi = /* @__PURE__ */ ((e) => (e[e.WEAK = 0] = "WEAK", e[e.MEDIUM = 1] = "MEDIUM", e[e.STRONG = 2] = "STRONG", e))(gi || {});
const Hf = (e, t = 100, n = [
  0,
  0,
  1,
  2,
  2
  /* STRONG */
]) => {
  let a = null;
  const l = O(void 0), s = (o) => o >= n.length ? 2 : o < n.length && o >= 0 ? n[o] : null, i = Ut(
    () => e.value,
    (o) => {
      if (a != null) {
        const { score: r } = a(o);
        l.value = s(r);
      }
    },
    { throttle: t }
  );
  return xe(async () => {
    a = (await import("zxcvbn")).default;
  }), We(() => {
    i();
  }), {
    strength: l
  };
}, yl = (e, t, n) => ({
  increment: () => {
    if (t.max == null || t.max != null && e.value + t.step <= t.max) {
      const i = new Yt(e.value), o = new Yt(t.step);
      e.value = i.plus(o).toNumber(), n("update:modelValue", e.value);
    }
  },
  decrement: () => {
    if (t.min == null || t.min != null && e.value - t.step >= t.min) {
      const i = new Yt(e.value), o = new Yt(t.step);
      e.value = i.minus(o).toNumber(), n("update:modelValue", e.value);
    }
  },
  resetInput: () => {
    e.value = t.min || t.nullable ? null : 0, n("update:modelValue", e.value);
  }
}), vi = (e) => {
  const t = k(() => new Intl.NumberFormat(e.locale, {
    minimumFractionDigits: e.minDecimal,
    maximumFractionDigits: e.maxDecimal,
    useGrouping: e.useGrouping,
    style: e.mode,
    currency: e.mode === "currency" ? e.currency : void 0,
    currencyDisplay: e.currencyDisplay
  })), n = (l) => t.value.format(l), a = k(() => e.modelValue == null ? "" : n(e.modelValue));
  return { formatter: t, formatValue: n, formattedValue: a };
}, bl = (e) => {
  const t = k(() => new Intl.NumberFormat(e.locale, {
    useGrouping: !0
  }).format(1e4).replace(/\d+/g, "").charAt(0)), n = k(() => new Intl.NumberFormat(e.locale, {}).format(1.1).replace(/\d+/g, "")), a = k(() => new Intl.NumberFormat(e.locale, {
    style: e.mode,
    currency: e.mode === "currency" ? e.currency : void 0,
    currencyDisplay: e.currencyDisplay,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(0).replace(/\d+/g, ""));
  return { groupingChar: t, decimalChar: n, currency: a, parseValue: (s) => {
    const i = s.trim().replace(new RegExp(`\\${t.value}`, "g"), "").replace(new RegExp(`\\${n.value}`, "g"), ".").replace(
      a.value.length > 0 ? new RegExp(`\\${a.value}`, "g") : void 0,
      ""
    );
    if (i.length > 0) {
      const o = parseFloat(i);
      return Number.isNaN(o) ? null : o;
    }
    return null;
  } };
}, yi = (e) => {
  const t = O(!0), n = O(""), a = () => {
    e.min != null && e.modelValue < e.min ? (t.value = !1, n.value = `value is below ${e.min}`) : e.max != null && e.modelValue > e.max && (t.value = !1, n.value = `value is above ${e.max}`);
  }, l = H(() => e.modelValue, a);
  return We(() => {
    l();
  }), { valid: t, errorMessage: n, validate: a };
}, bi = (e, t, n) => {
  const { decrement: a, increment: l } = yl(
    e,
    t,
    n
  ), { decimalChar: s, currency: i, parseValue: o } = bl(t), r = O(!1), u = () => {
    n("update:modelValue", e.value);
  }, c = k(
    () => t.min == null || t.min != null && t.min < 0
  ), f = k(() => t.maxDecimal > 0);
  return {
    isInputFocused: r,
    onInputBlur: (v) => {
      v.preventDefault(), r.value = !1;
      const y = v.target, b = o(y.value);
      y.value.length === 0 && t.nullable ? e.value = null : t.min != null && b < t.min ? e.value = t.min : t.max != null && b > t.max ? e.value = t.max : e.value = b, u(), n("blur", v);
    },
    onInputFocus: (v) => {
      r.value = !0, n("focus", v);
    },
    onInputKeyPress: (v) => {
      if (v.ctrlKey) return;
      if (t.preventEnter && v.key === "Enter" && v.preventDefault(), v.key === "ArrowUp") {
        l();
        return;
      }
      if (v.key === "ArrowDown") {
        a();
        return;
      }
      const y = c.value ? "-" : "", b = `[0-9\\${y}\\${s.value}]`;
      if (v.key.length === 1 && !new RegExp(b).test(v.key)) {
        v.preventDefault();
        return;
      }
      const S = v.target, B = S.value, M = S.selectionStart != null ? S.selectionStart : -1, P = S.selectionEnd != null ? S.selectionEnd : -1, V = B.slice(M, P);
      if (v.key === s.value && // decimal is not allowed (minDecimal === 0)
      (!f.value || // decimal is allowed
      f.value && // is already in text
      B.indexOf(s.value) > 0 && // marked text does not containing the decimal char
      V.indexOf(s.value) < 0)) {
        v.preventDefault();
        return;
      }
      if (v.key === "-" && // minus sign is not allowed (min <= 0)
      (!c.value || // minus sign is allowed but is already in text
      c.value && B.indexOf("-") >= 0 && V.indexOf(y) < 0 || // cursor is at the wrong position (not 0)
      M > B.indexOf(i.value) + i.value.length)) {
        v.preventDefault();
        return;
      }
      const C = B.match(
        new RegExp(`\\${s.value}(\\d+)$`)
      ), R = B.indexOf(s.value);
      v.key.length === 1 && v.key.match(/[0-9]/) && // input of decimal is allowed
      f.value && // cursor is after decimal separator
      M === P && M > R && // length exceeds maxDecimal
      C != null && C.length > 1 && C[1].length >= t.maxDecimal && v.preventDefault();
    }
  };
}, ki = (e, t) => ({
  handleCursorChange: (a) => {
    const l = a.target, s = d(e), i = d(t);
    if (i.length !== 0) {
      if (s.startsWith(i) && l.selectionStart < s.indexOf(i) + i.length) {
        l.selectionStart = s.indexOf(i) + i.length, l.selectionEnd = s.indexOf(i) + i.length;
        return;
      }
      s.startsWith(`-${i}`) && l.selectionStart < s.indexOf(i) + i.length && (l.selectionStart = s.indexOf(i), l.selectionEnd = s.indexOf(i)), s.endsWith(i) && l.selectionStart >= s.indexOf(i) + i.length && (l.selectionStart = s.indexOf(i), l.selectionEnd = s.indexOf(i));
    }
  }
}), Uf = (e, t = !0) => () => {
  e == null || e.value == null ? window.scrollTo({ top: 0, behavior: t ? "smooth" : "auto" }) : d(e).scrollTo({ top: 0, behavior: t ? "smooth" : "auto" });
}, wi = {
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1200,
  "2xl": 1440
}, fn = () => di(wi), xi = {
  key: 1,
  class: "flex h-input flex-1 flex-col content-center items-center"
}, qf = /* @__PURE__ */ E({
  __name: "GpNumberInput",
  props: {
    modelValue: {},
    nullable: { type: Boolean, default: !1 },
    inputId: {},
    name: { default: "" },
    locale: { default: "en-US" },
    minDecimal: { default: 0 },
    maxDecimal: { default: 0 },
    useGrouping: { type: Boolean, default: !0 },
    min: { default: null },
    max: { default: null },
    step: { default: 1 },
    mode: { default: void 0 },
    currency: { default: void 0 },
    currencyDisplay: { default: "symbol" },
    hideSpinner: { type: Boolean, default: !1 },
    preventEnter: { type: Boolean, default: !1 },
    placeholder: { default: null },
    label: { default: null },
    hint: { default: null },
    canBeResetted: { type: Boolean, default: !1 },
    float: { type: Boolean, default: !1 },
    error: { default: null },
    inputClass: { default: null },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { expose: t, emit: n }) {
    const a = e, l = n;
    Ct({ faChevronDown: ol, faChevronUp: lt });
    const s = O(a.modelValue), { formattedValue: i } = vi(a), { validate: o } = yi(a), { currency: r } = bl(a), { decrement: u, increment: c, resetInput: f } = yl(
      s,
      a,
      l
    ), { onInputFocus: m, onInputBlur: h, onInputKeyPress: g } = bi(
      s,
      a,
      l
    ), v = O(), { manualBlur: y, manualFocus: b } = _e(v, l), S = k(() => {
      const V = nl(a);
      return Object.entries(V).filter(
        ([C]) => [
          "class",
          "inputId",
          "type",
          "modelValue",
          "passwordStrength",
          "locale",
          "minDecimal",
          "maxDecimal",
          "useGrouping",
          "min",
          "max",
          "step",
          "preventEnter",
          "canBeResetted"
        ].indexOf(C) < 0
      ).reduce((C, [R, F]) => (C[R] = F, C), {});
    }), { handleCursorChange: B } = ki(i, r), M = Ve("number", a.inputId), P = H(
      () => a.modelValue,
      () => {
        s.value = a.modelValue, o();
      }
    );
    return We(() => {
      P();
    }), t({
      inputComponent: v,
      resetInput: f,
      focus: b,
      blur: y
    }), (V, C) => (p(), D(Kn, re({
      ref_key: "inputComponent",
      ref: v,
      type: "text",
      role: "spinbutton",
      "model-value": d(i)
    }, S.value, {
      "input-id": d(M),
      "aria-valuenow": e.modelValue,
      onBlur: d(h),
      onFocus: d(m),
      onKeydown: d(g),
      onMouseup: d(B)
    }), {
      label: T(() => [
        w(V.$slots, "label", {}, () => [
          A(ht, {
            "component-id": d(M),
            label: e.label,
            "has-error": e.error != null && e.error.length > 0
          }, null, 8, ["component-id", "label", "has-error"])
        ])
      ]),
      "input-left": T(() => [
        w(V.$slots, "input-left")
      ]),
      "input-right": T(() => [
        w(V.$slots, "input-right")
      ]),
      actions: T(() => [
        e.canBeResetted && e.modelValue != null && (e.min != null && e.modelValue !== e.min || e.min == null && e.modelValue !== 0) && !e.disabled ? (p(), D(st, {
          key: 0,
          icon: ["fas", "fa-times"],
          onClick: d(f)
        }, null, 8, ["onClick"])) : $("", !0),
        e.hideSpinner ? $("", !0) : (p(), x("div", xi, [
          L("button", {
            class: "block min-h-3.5 w-input flex-1 rounded px-0!",
            type: "button",
            "aria-label": "increment",
            onClick: C[0] || (C[0] = ke(
              //@ts-ignore
              (...R) => d(c) && d(c)(...R),
              ["prevent"]
            ))
          }, [
            A(d(Q), {
              class: "align-[0.25rem] text-xs text-gp-rhino",
              icon: ["fas", "fa-chevron-up"]
            })
          ]),
          L("button", {
            class: "block min-h-3.5 w-input flex-1 rounded px-0!",
            type: "button",
            "aria-label": "decrement",
            onClick: C[1] || (C[1] = ke(
              //@ts-ignore
              (...R) => d(u) && d(u)(...R),
              ["prevent"]
            ))
          }, [
            A(d(Q), {
              class: "align-[1rem] text-xs text-gp-rhino",
              icon: ["fas", "fa-chevron-down"]
            })
          ])
        ])),
        w(V.$slots, "actions")
      ]),
      hint: T(() => [
        w(V.$slots, "hint", {}, () => [
          A(pe, W(j({ error: e.error, hint: e.hint })), null, 16)
        ])
      ]),
      _: 3
    }, 16, ["model-value", "input-id", "aria-valuenow", "onBlur", "onFocus", "onKeydown", "onMouseup"]));
  }
});
function Ke(e) {
  return typeof e == "string" || e instanceof String;
}
function Ta(e) {
  var t;
  return typeof e == "object" && e != null && (e == null || (t = e.constructor) == null ? void 0 : t.name) === "Object";
}
function kl(e, t) {
  return Array.isArray(t) ? kl(e, (n, a) => t.includes(a)) : Object.entries(e).reduce((n, a) => {
    let [l, s] = a;
    return t(s, l) && (n[l] = s), n;
  }, {});
}
const Y = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function Ci(e) {
  switch (e) {
    case Y.LEFT:
      return Y.FORCE_LEFT;
    case Y.RIGHT:
      return Y.FORCE_RIGHT;
    default:
      return e;
  }
}
function Mn(e) {
  return e.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function qt(e, t) {
  if (t === e) return !0;
  const n = Array.isArray(t), a = Array.isArray(e);
  let l;
  if (n && a) {
    if (t.length != e.length) return !1;
    for (l = 0; l < t.length; l++) if (!qt(t[l], e[l])) return !1;
    return !0;
  }
  if (n != a) return !1;
  if (t && e && typeof t == "object" && typeof e == "object") {
    const s = t instanceof Date, i = e instanceof Date;
    if (s && i) return t.getTime() == e.getTime();
    if (s != i) return !1;
    const o = t instanceof RegExp, r = e instanceof RegExp;
    if (o && r) return t.toString() == e.toString();
    if (o != r) return !1;
    const u = Object.keys(t);
    for (l = 0; l < u.length; l++) if (!Object.prototype.hasOwnProperty.call(e, u[l])) return !1;
    for (l = 0; l < u.length; l++) if (!qt(e[u[l]], t[u[l]])) return !1;
    return !0;
  } else if (t && e && typeof t == "function" && typeof e == "function")
    return t.toString() === e.toString();
  return !1;
}
class Ti {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(t) {
    for (Object.assign(this, t); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
    if (this.insertedCount)
      for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end); )
        this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? Y.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? Y.RIGHT : Y.LEFT;
  }
}
function K(e, t) {
  return new K.InputMask(e, t);
}
function wl(e) {
  if (e == null) throw new Error("mask property should be defined");
  return e instanceof RegExp ? K.MaskedRegExp : Ke(e) ? K.MaskedPattern : e === Date ? K.MaskedDate : e === Number ? K.MaskedNumber : Array.isArray(e) || e === Array ? K.MaskedDynamic : K.Masked && e.prototype instanceof K.Masked ? e : K.Masked && e instanceof K.Masked ? e.constructor : e instanceof Function ? K.MaskedFunction : (console.warn("Mask not found for mask", e), K.Masked);
}
function At(e) {
  if (!e) throw new Error("Options in not defined");
  if (K.Masked) {
    if (e.prototype instanceof K.Masked) return {
      mask: e
    };
    const {
      mask: t = void 0,
      ...n
    } = e instanceof K.Masked ? {
      mask: e
    } : Ta(e) && e.mask instanceof K.Masked ? e : {};
    if (t) {
      const a = t.mask;
      return {
        ...kl(t, (l, s) => !s.startsWith("_")),
        mask: t.constructor,
        _mask: a,
        ...n
      };
    }
  }
  return Ta(e) ? {
    ...e
  } : {
    mask: e
  };
}
function ze(e) {
  if (K.Masked && e instanceof K.Masked) return e;
  const t = At(e), n = wl(t.mask);
  if (!n) throw new Error("Masked class is not found for provided mask " + t.mask + ", appropriate module needs to be imported manually before creating mask.");
  return t.mask === n && delete t.mask, t._mask && (t.mask = t._mask, delete t._mask), new n(t);
}
K.createMask = ze;
class ea {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let t;
    try {
      t = this._unsafeSelectionStart;
    } catch {
    }
    return t ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let t;
    try {
      t = this._unsafeSelectionEnd;
    } catch {
    }
    return t ?? this.value.length;
  }
  /** Safely sets element selection */
  select(t, n) {
    if (!(t == null || n == null || t === this.selectionStart && n === this.selectionEnd))
      try {
        this._unsafeSelect(t, n);
      } catch {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
K.MaskElement = ea;
const Sa = 90, Si = 89;
class hn extends ea {
  /** HTMLElement to use mask on */
  constructor(t) {
    super(), this.input = t, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var t, n, a;
    return (t = (n = (a = this.input).getRootNode) == null ? void 0 : n.call(a)) != null ? t : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(t) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", t.drop), this.input.addEventListener("click", t.click), this.input.addEventListener("focus", t.focus), this.input.addEventListener("blur", t.commit), this._handlers = t;
  }
  _onKeydown(t) {
    if (this._handlers.redo && (t.keyCode === Sa && t.shiftKey && (t.metaKey || t.ctrlKey) || t.keyCode === Si && t.ctrlKey))
      return t.preventDefault(), this._handlers.redo(t);
    if (this._handlers.undo && t.keyCode === Sa && (t.metaKey || t.ctrlKey))
      return t.preventDefault(), this._handlers.undo(t);
    t.isComposing || this._handlers.selectionChange(t);
  }
  _onBeforeinput(t) {
    if (t.inputType === "historyUndo" && this._handlers.undo)
      return t.preventDefault(), this._handlers.undo(t);
    if (t.inputType === "historyRedo" && this._handlers.redo)
      return t.preventDefault(), this._handlers.redo(t);
  }
  _onCompositionEnd(t) {
    this._handlers.input(t);
  }
  _onInput(t) {
    t.isComposing || this._handlers.input(t);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
K.HTMLMaskElement = hn;
class Bi extends hn {
  /** InputElement to use mask on */
  constructor(t) {
    super(t), this.input = t;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(t, n) {
    this.input.setSelectionRange(t, n);
  }
  get value() {
    return this.input.value;
  }
  set value(t) {
    this.input.value = t;
  }
}
K.HTMLMaskElement = hn;
class xl extends hn {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const t = this.rootElement, n = t.getSelection && t.getSelection(), a = n && n.anchorOffset, l = n && n.focusOffset;
    return l == null || a == null || a < l ? a : l;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const t = this.rootElement, n = t.getSelection && t.getSelection(), a = n && n.anchorOffset, l = n && n.focusOffset;
    return l == null || a == null || a > l ? a : l;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(t, n) {
    if (!this.rootElement.createRange) return;
    const a = this.rootElement.createRange();
    a.setStart(this.input.firstChild || this.input, t), a.setEnd(this.input.lastChild || this.input, n);
    const l = this.rootElement, s = l.getSelection && l.getSelection();
    s && (s.removeAllRanges(), s.addRange(a));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(t) {
    this.input.textContent = t;
  }
}
K.HTMLContenteditableMaskElement = xl;
class mn {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(t) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(t), this.states.length > mn.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(t) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + t, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
mn.MAX_LENGTH = 100;
class Di {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(t, n) {
    this.el = t instanceof ea ? t : t.isContentEditable && t.tagName !== "INPUT" && t.tagName !== "TEXTAREA" ? new xl(t) : new Bi(t), this.masked = ze(n), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new mn(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(t) {
    var n;
    return t == null || ((n = this.masked) == null ? void 0 : n.maskEquals(t));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(t) {
    if (this.maskEquals(t)) return;
    if (!(t instanceof K.Masked) && this.masked.constructor === wl(t)) {
      this.masked.updateOptions({
        mask: t
      });
      return;
    }
    const n = t instanceof K.Masked ? t : ze({
      mask: t
    });
    n.unmaskedValue = this.masked.unmaskedValue, this.masked = n;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(t) {
    this.value !== t && (this.masked.value = t, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(t) {
    this.unmaskedValue !== t && (this.masked.unmaskedValue = t, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(t) {
    this.rawInputValue !== t && (this.masked.rawInputValue = t, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(t) {
    this.masked.typedValueEquals(t) || (this.masked.typedValue = t, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(t, n) {
    const a = this._listeners[t];
    a && a.forEach((l) => l(n));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(t) {
    !this.el || !this.el.isActive || (this.el.select(t, t), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(t) {
    const n = this.masked.unmaskedValue, a = this.masked.value, l = this.masked.rawInputValue, s = this.displayValue, i = this.unmaskedValue !== n || this.value !== a || this._rawInputValue !== l;
    this._unmaskedValue = n, this._value = a, this._rawInputValue = l, this.el.value !== s && (this.el.value = s), t === "auto" ? this.alignCursor() : t != null && (this.cursorPos = t), i && this._fireChangeEvents(), !this._historyChanging && (i || this.history.isEmpty) && this.history.push({
      unmaskedValue: n,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(t) {
    const {
      mask: n,
      ...a
    } = t, l = !this.maskEquals(n), s = this.masked.optionsIsChanged(a);
    l && (this.mask = n), s && this.masked.updateOptions(a), (l || s) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(t) {
    t != null && (this.cursorPos = t, this._delayUpdateCursor(t));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(t) {
    this._abortUpdateCursor(), this._changingCursorPos = t, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, Y.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(t, n) {
    return this._listeners[t] || (this._listeners[t] = []), this._listeners[t].push(n), this;
  }
  /** Removes custom event listener */
  off(t, n) {
    if (!this._listeners[t]) return this;
    if (!n)
      return delete this._listeners[t], this;
    const a = this._listeners[t].indexOf(n);
    return a >= 0 && this._listeners[t].splice(a, 1), this;
  }
  /** Handles view input event */
  _onInput(t) {
    this._inputEvent = t, this._abortUpdateCursor();
    const n = new Ti({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), a = this.masked.rawInputValue, l = this.masked.splice(n.startChangePos, n.removed.length, n.inserted, n.removeDirection, {
      input: !0,
      raw: !0
    }).offset, s = a === this.masked.rawInputValue ? n.removeDirection : Y.NONE;
    let i = this.masked.nearestInputPos(n.startChangePos + l, s);
    s !== Y.NONE && (i = this.masked.nearestInputPos(i, Y.NONE)), this.updateControl(i), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(t) {
    t.preventDefault(), t.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(t) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(t) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(t) {
    t && (this._historyChanging = !0, this.unmaskedValue = t.unmaskedValue, this.el.select(t.selection.start, t.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
K.InputMask = Di;
class J {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(t) {
    return Array.isArray(t) ? t : [t, new J()];
  }
  constructor(t) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, t);
  }
  /** Aggregate changes */
  aggregate(t) {
    return this.inserted += t.inserted, this.rawInserted += t.rawInserted, this.tailShift += t.tailShift, this.skip = this.skip || t.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(t) {
    return this.inserted === t.inserted && this.tailShift === t.tailShift && this.rawInserted === t.rawInserted && this.skip === t.skip;
  }
}
K.ChangeDetails = J;
class Fe {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(t, n, a) {
    t === void 0 && (t = ""), n === void 0 && (n = 0), this.value = t, this.from = n, this.stop = a;
  }
  toString() {
    return this.value;
  }
  extend(t) {
    this.value += String(t);
  }
  appendTo(t) {
    return t.append(this.toString(), {
      tail: !0
    }).aggregate(t._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(t) {
    Object.assign(this, t);
  }
  unshift(t) {
    if (!this.value.length || t != null && this.from >= t) return "";
    const n = this.value[0];
    return this.value = this.value.slice(1), n;
  }
  shift() {
    if (!this.value.length) return "";
    const t = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), t;
  }
}
class ve {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    this._value = "", this._update({
      ...ve.DEFAULTS,
      ...t
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(t) {
    this.optionsIsChanged(t) && this.withValueRefresh(this._update.bind(this, t));
  }
  /** Sets new options */
  _update(t) {
    Object.assign(this, t);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(t) {
    this._value = t._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(t) {
    this.resolve(t, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(t, n) {
    n === void 0 && (n = {
      input: !0
    }), this.reset(), this.append(t, n, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(t) {
    this.resolve(t, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(t) {
    this.format ? this.value = this.format(t, this) : this.unmaskedValue = String(t);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(t) {
    this.resolve(t, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(t, n) {
    return t;
  }
  totalInputPositions(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), Math.min(this.displayValue.length, n - t);
  }
  /** Extracts value in range considering flags */
  extractInput(t, n, a) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), this.displayValue.slice(t, n);
  }
  /** Extracts tail in range */
  extractTail(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), new Fe(this.extractInput(t, n), t);
  }
  /** Appends tail */
  appendTail(t) {
    return Ke(t) && (t = new Fe(String(t))), t.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(t, n) {
    return t ? (this._value += t, new J({
      inserted: t,
      rawInserted: t
    })) : new J();
  }
  /** Appends char */
  _appendChar(t, n, a) {
    n === void 0 && (n = {});
    const l = this.state;
    let s;
    if ([t, s] = this.doPrepareChar(t, n), t && (s = s.aggregate(this._appendCharRaw(t, n)), !s.rawInserted && this.autofix === "pad")) {
      const i = this.state;
      this.state = l;
      let o = this.pad(n);
      const r = this._appendCharRaw(t, n);
      o = o.aggregate(r), r.rawInserted || o.equals(s) ? s = o : this.state = i;
    }
    if (s.inserted) {
      let i, o = this.doValidate(n) !== !1;
      if (o && a != null) {
        const r = this.state;
        if (this.overwrite === !0) {
          i = a.state;
          for (let c = 0; c < s.rawInserted.length; ++c)
            a.unshift(this.displayValue.length - s.tailShift);
        }
        let u = this.appendTail(a);
        if (o = u.rawInserted.length === a.toString().length, !(o && u.inserted) && this.overwrite === "shift") {
          this.state = r, i = a.state;
          for (let c = 0; c < s.rawInserted.length; ++c)
            a.shift();
          u = this.appendTail(a), o = u.rawInserted.length === a.toString().length;
        }
        o && u.inserted && (this.state = r);
      }
      o || (s = new J(), this.state = l, a && i && (a.state = i));
    }
    return s;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new J();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new J();
  }
  /** Appends symbols considering flags */
  append(t, n, a) {
    if (!Ke(t)) throw new Error("value should be string");
    const l = Ke(a) ? new Fe(String(a)) : a;
    n != null && n.tail && (n._beforeTailState = this.state);
    let s;
    [t, s] = this.doPrepare(t, n);
    for (let i = 0; i < t.length; ++i) {
      const o = this._appendChar(t[i], n, l);
      if (!o.rawInserted && !this.doSkipInvalid(t[i], n, l)) break;
      s.aggregate(o);
    }
    return (this.eager === !0 || this.eager === "append") && n != null && n.input && t && s.aggregate(this._appendEager()), l != null && (s.tailShift += this.appendTail(l).tailShift), s;
  }
  remove(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), this._value = this.displayValue.slice(0, t) + this.displayValue.slice(n), new J();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(t) {
    if (this._refreshing || !this._initialized) return t();
    this._refreshing = !0;
    const n = this.rawInputValue, a = this.value, l = t();
    return this.rawInputValue = n, this.value && this.value !== a && a.indexOf(this.value) === 0 && (this.append(a.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, l;
  }
  runIsolated(t) {
    if (this._isolated || !this._initialized) return t(this);
    this._isolated = !0;
    const n = this.state, a = t(this);
    return this.state = n, delete this._isolated, a;
  }
  doSkipInvalid(t, n, a) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(t, n) {
    return n === void 0 && (n = {}), J.normalize(this.prepare ? this.prepare(t, this, n) : t);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(t, n) {
    return n === void 0 && (n = {}), J.normalize(this.prepareChar ? this.prepareChar(t, this, n) : t);
  }
  /** Validates if value is acceptable */
  doValidate(t) {
    return (!this.validate || this.validate(this.value, this, t)) && (!this.parent || this.parent.doValidate(t));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(t, n, a, l, s) {
    a === void 0 && (a = ""), l === void 0 && (l = Y.NONE), s === void 0 && (s = {
      input: !0
    });
    const i = t + n, o = this.extractTail(i), r = this.eager === !0 || this.eager === "remove";
    let u;
    r && (l = Ci(l), u = this.extractInput(0, i, {
      raw: !0
    }));
    let c = t;
    const f = new J();
    if (l !== Y.NONE && (c = this.nearestInputPos(t, n > 1 && t !== 0 && !r ? Y.NONE : l), f.tailShift = c - t), f.aggregate(this.remove(c)), r && l !== Y.NONE && u === this.rawInputValue)
      if (l === Y.FORCE_LEFT) {
        let m;
        for (; u === this.rawInputValue && (m = this.displayValue.length); )
          f.aggregate(new J({
            tailShift: -1
          })).aggregate(this.remove(m - 1));
      } else l === Y.FORCE_RIGHT && o.unshift();
    return f.aggregate(this.append(a, s, o));
  }
  maskEquals(t) {
    return this.mask === t;
  }
  optionsIsChanged(t) {
    return !qt(this, t);
  }
  typedValueEquals(t) {
    const n = this.typedValue;
    return t === n || ve.EMPTY_VALUES.includes(t) && ve.EMPTY_VALUES.includes(n) || (this.format ? this.format(t, this) === this.format(this.typedValue, this) : !1);
  }
  pad(t) {
    return new J();
  }
}
ve.DEFAULTS = {
  skipInvalid: !0
};
ve.EMPTY_VALUES = [void 0, null, ""];
K.Masked = ve;
class nt {
  /** */
  constructor(t, n) {
    t === void 0 && (t = []), n === void 0 && (n = 0), this.chunks = t, this.from = n;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(t) {
    if (!String(t)) return;
    t = Ke(t) ? new Fe(String(t)) : t;
    const n = this.chunks[this.chunks.length - 1], a = n && // if stops are same or tail has no stop
    (n.stop === t.stop || t.stop == null) && // if tail chunk goes just after last chunk
    t.from === n.from + n.toString().length;
    if (t instanceof Fe)
      a ? n.extend(t.toString()) : this.chunks.push(t);
    else if (t instanceof nt) {
      if (t.stop == null) {
        let l;
        for (; t.chunks.length && t.chunks[0].stop == null; )
          l = t.chunks.shift(), l.from += t.from, this.extend(l);
      }
      t.toString() && (t.stop = t.blockIndex, this.chunks.push(t));
    }
  }
  appendTo(t) {
    if (!(t instanceof K.MaskedPattern))
      return new Fe(this.toString()).appendTo(t);
    const n = new J();
    for (let a = 0; a < this.chunks.length; ++a) {
      const l = this.chunks[a], s = t._mapPosToBlock(t.displayValue.length), i = l.stop;
      let o;
      if (i != null && // if block not found or stop is behind lastBlock
      (!s || s.index <= i) && ((l instanceof nt || // for continuous block also check if stop is exist
      t._stops.indexOf(i) >= 0) && n.aggregate(t._appendPlaceholder(i)), o = l instanceof nt && t._blocks[i]), o) {
        const r = o.appendTail(l);
        n.aggregate(r);
        const u = l.toString().slice(r.rawInserted.length);
        u && n.aggregate(t.append(u, {
          tail: !0
        }));
      } else
        n.aggregate(t.append(l.toString(), {
          tail: !0
        }));
    }
    return n;
  }
  get state() {
    return {
      chunks: this.chunks.map((t) => t.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(t) {
    const {
      chunks: n,
      ...a
    } = t;
    Object.assign(this, a), this.chunks = n.map((l) => {
      const s = "chunks" in l ? new nt() : new Fe();
      return s.state = l, s;
    });
  }
  unshift(t) {
    if (!this.chunks.length || t != null && this.from >= t) return "";
    const n = t != null ? t - this.from : t;
    let a = 0;
    for (; a < this.chunks.length; ) {
      const l = this.chunks[a], s = l.unshift(n);
      if (l.toString()) {
        if (!s) break;
        ++a;
      } else
        this.chunks.splice(a, 1);
      if (s) return s;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let t = this.chunks.length - 1;
    for (; 0 <= t; ) {
      const n = this.chunks[t], a = n.shift();
      if (n.toString()) {
        if (!a) break;
        --t;
      } else
        this.chunks.splice(t, 1);
      if (a) return a;
    }
    return "";
  }
}
class Ii {
  constructor(t, n) {
    this.masked = t, this._log = [];
    const {
      offset: a,
      index: l
    } = t._mapPosToBlock(n) || (n < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = a, this.index = l, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(t) {
    Object.assign(this, t);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const t = this._log.pop();
    return t && (this.state = t), t;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(t) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((n = this.block) == null ? void 0 : n.displayValue.length) || 0) {
      var n;
      if (t()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(t) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (t()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, Y.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, Y.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, Y.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, Y.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, Y.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, Y.NONE), !0;
    });
  }
}
class Cl {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    Object.assign(this, t), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this._value.length), this._value = this._value.slice(0, t) + this._value.slice(n), this._value || (this._isRawInput = !1), new J();
  }
  nearestInputPos(t, n) {
    n === void 0 && (n = Y.NONE);
    const a = 0, l = this._value.length;
    switch (n) {
      case Y.LEFT:
      case Y.FORCE_LEFT:
        return a;
      case Y.NONE:
      case Y.RIGHT:
      case Y.FORCE_RIGHT:
      default:
        return l;
    }
  }
  totalInputPositions(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this._value.length), this._isRawInput ? n - t : 0;
  }
  extractInput(t, n, a) {
    return t === void 0 && (t = 0), n === void 0 && (n = this._value.length), a === void 0 && (a = {}), a.raw && this._isRawInput && this._value.slice(t, n) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(t, n) {
    if (n === void 0 && (n = {}), this.isFilled) return new J();
    const a = this.eager === !0 || this.eager === "append", s = this.char === t && (this.isUnmasking || n.input || n.raw) && (!n.raw || !a) && !n.tail, i = new J({
      inserted: this.char,
      rawInserted: s ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = s && (n.raw || n.input), i;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const t = new J();
    return this.isFilled || (this._value = t.inserted = this.char), t;
  }
  extractTail() {
    return new Fe("");
  }
  appendTail(t) {
    return Ke(t) && (t = new Fe(String(t))), t.appendTo(this);
  }
  append(t, n, a) {
    const l = this._appendChar(t[0], n);
    return a != null && (l.tailShift += this.appendTail(a).tailShift), l;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(t) {
    this._value = t._value, this._isRawInput = !!t._rawInputValue;
  }
  pad(t) {
    return this._appendPlaceholder();
  }
}
class Kt {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    const {
      parent: n,
      isOptional: a,
      placeholderChar: l,
      displayChar: s,
      lazy: i,
      eager: o,
      ...r
    } = t;
    this.masked = ze(r), Object.assign(this, {
      parent: n,
      isOptional: a,
      placeholderChar: l,
      displayChar: s,
      lazy: i,
      eager: o
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.value.length), t === 0 && n >= 1 ? (this.isFilled = !1, this.masked.remove(t, n)) : new J();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(t, n) {
    if (n === void 0 && (n = {}), this.isFilled) return new J();
    const a = this.masked.state;
    let l = this.masked._appendChar(t, this.currentMaskFlags(n));
    return l.inserted && this.doValidate(n) === !1 && (l = new J(), this.masked.state = a), !l.inserted && !this.isOptional && !this.lazy && !n.input && (l.inserted = this.placeholderChar), l.skip = !l.inserted && !this.isOptional, this.isFilled = !!l.inserted, l;
  }
  append(t, n, a) {
    return this.masked.append(t, this.currentMaskFlags(n), a);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new J() : (this.isFilled = !0, new J({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new J();
  }
  extractTail(t, n) {
    return this.masked.extractTail(t, n);
  }
  appendTail(t) {
    return this.masked.appendTail(t);
  }
  extractInput(t, n, a) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.value.length), this.masked.extractInput(t, n, a);
  }
  nearestInputPos(t, n) {
    n === void 0 && (n = Y.NONE);
    const a = 0, l = this.value.length, s = Math.min(Math.max(t, a), l);
    switch (n) {
      case Y.LEFT:
      case Y.FORCE_LEFT:
        return this.isComplete ? s : a;
      case Y.RIGHT:
      case Y.FORCE_RIGHT:
        return this.isComplete ? s : l;
      case Y.NONE:
      default:
        return s;
    }
  }
  totalInputPositions(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.value.length), this.value.slice(t, n).length;
  }
  doValidate(t) {
    return this.masked.doValidate(this.currentMaskFlags(t)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(t)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(t) {
    this.masked.state = t.masked, this.isFilled = t.isFilled;
  }
  currentMaskFlags(t) {
    var n;
    return {
      ...t,
      _beforeTailState: (t == null || (n = t._beforeTailState) == null ? void 0 : n.masked) || (t == null ? void 0 : t._beforeTailState)
    };
  }
  pad(t) {
    return new J();
  }
}
Kt.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class Mi extends ve {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const n = t.mask;
    n && (t.validate = (a) => a.search(n) >= 0), super._update(t);
  }
}
K.MaskedRegExp = Mi;
class ye extends ve {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(t) {
    super({
      ...ye.DEFAULTS,
      ...t,
      definitions: Object.assign({}, Kt.DEFAULT_DEFINITIONS, t == null ? void 0 : t.definitions)
    });
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    t.definitions = Object.assign({}, this.definitions, t.definitions), super._update(t), this._rebuildMask();
  }
  _rebuildMask() {
    const t = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const n = this.mask;
    if (!n || !t) return;
    let a = !1, l = !1;
    for (let s = 0; s < n.length; ++s) {
      if (this.blocks) {
        const u = n.slice(s), c = Object.keys(this.blocks).filter((m) => u.indexOf(m) === 0);
        c.sort((m, h) => h.length - m.length);
        const f = c[0];
        if (f) {
          const {
            expose: m,
            repeat: h,
            ...g
          } = At(this.blocks[f]), v = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...g,
            repeat: h,
            parent: this
          }, y = h != null ? new K.RepeatBlock(
            v
            /* TODO */
          ) : ze(v);
          y && (this._blocks.push(y), m && (this.exposeBlock = y), this._maskedBlocks[f] || (this._maskedBlocks[f] = []), this._maskedBlocks[f].push(this._blocks.length - 1)), s += f.length - 1;
          continue;
        }
      }
      let i = n[s], o = i in t;
      if (i === ye.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (i === "{" || i === "}") {
        a = !a;
        continue;
      }
      if (i === "[" || i === "]") {
        l = !l;
        continue;
      }
      if (i === ye.ESCAPE_CHAR) {
        if (++s, i = n[s], !i) break;
        o = !1;
      }
      const r = o ? new Kt({
        isOptional: l,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...At(t[i]),
        parent: this
      }) : new Cl({
        char: i,
        eager: this.eager,
        isUnmasking: a
      });
      this._blocks.push(r);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((t) => t.state)
    };
  }
  set state(t) {
    if (!t) {
      this.reset();
      return;
    }
    const {
      _blocks: n,
      ...a
    } = t;
    this._blocks.forEach((l, s) => l.state = n[s]), super.state = a;
  }
  reset() {
    super.reset(), this._blocks.forEach((t) => t.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((t) => t.isComplete);
  }
  get isFilled() {
    return this._blocks.every((t) => t.isFilled);
  }
  get isFixed() {
    return this._blocks.every((t) => t.isFixed);
  }
  get isOptional() {
    return this._blocks.every((t) => t.isOptional);
  }
  doCommit() {
    this._blocks.forEach((t) => t.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((t, n) => t += n.unmaskedValue, "");
  }
  set unmaskedValue(t) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = t, this.appendTail(n), this.doCommit();
    } else super.unmaskedValue = t;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((t, n) => t += n.value, "")
    );
  }
  set value(t) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = t, this.appendTail(n), this.doCommit();
    } else super.value = t;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(t) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = t, this.appendTail(n), this.doCommit();
    } else super.typedValue = t;
  }
  get displayValue() {
    return this._blocks.reduce((t, n) => t += n.displayValue, "");
  }
  appendTail(t) {
    return super.appendTail(t).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var t;
    const n = new J();
    let a = (t = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : t.index;
    if (a == null) return n;
    this._blocks[a].isFilled && ++a;
    for (let l = a; l < this._blocks.length; ++l) {
      const s = this._blocks[l]._appendEager();
      if (!s.inserted) break;
      n.aggregate(s);
    }
    return n;
  }
  _appendCharRaw(t, n) {
    n === void 0 && (n = {});
    const a = this._mapPosToBlock(this.displayValue.length), l = new J();
    if (!a) return l;
    for (let i = a.index, o; o = this._blocks[i]; ++i) {
      var s;
      const r = o._appendChar(t, {
        ...n,
        _beforeTailState: (s = n._beforeTailState) == null || (s = s._blocks) == null ? void 0 : s[i]
      });
      if (l.aggregate(r), r.consumed) break;
    }
    return l;
  }
  extractTail(t, n) {
    t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length);
    const a = new nt();
    return t === n || this._forEachBlocksInRange(t, n, (l, s, i, o) => {
      const r = l.extractTail(i, o);
      r.stop = this._findStopBefore(s), r.from = this._blockStartPos(s), r instanceof nt && (r.blockIndex = s), a.extend(r);
    }), a;
  }
  extractInput(t, n, a) {
    if (t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), a === void 0 && (a = {}), t === n) return "";
    let l = "";
    return this._forEachBlocksInRange(t, n, (s, i, o, r) => {
      l += s.extractInput(o, r, a);
    }), l;
  }
  _findStopBefore(t) {
    let n;
    for (let a = 0; a < this._stops.length; ++a) {
      const l = this._stops[a];
      if (l <= t) n = l;
      else break;
    }
    return n;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(t) {
    const n = new J();
    if (this.lazy && t == null) return n;
    const a = this._mapPosToBlock(this.displayValue.length);
    if (!a) return n;
    const l = a.index, s = t ?? this._blocks.length;
    return this._blocks.slice(l, s).forEach((i) => {
      if (!i.lazy || t != null) {
        var o;
        n.aggregate(i._appendPlaceholder((o = i._blocks) == null ? void 0 : o.length));
      }
    }), n;
  }
  /** Finds block in pos */
  _mapPosToBlock(t) {
    let n = "";
    for (let a = 0; a < this._blocks.length; ++a) {
      const l = this._blocks[a], s = n.length;
      if (n += l.displayValue, t <= n.length)
        return {
          index: a,
          offset: t - s
        };
    }
  }
  _blockStartPos(t) {
    return this._blocks.slice(0, t).reduce((n, a) => n += a.displayValue.length, 0);
  }
  _forEachBlocksInRange(t, n, a) {
    n === void 0 && (n = this.displayValue.length);
    const l = this._mapPosToBlock(t);
    if (l) {
      const s = this._mapPosToBlock(n), i = s && l.index === s.index, o = l.offset, r = s && i ? s.offset : this._blocks[l.index].displayValue.length;
      if (a(this._blocks[l.index], l.index, o, r), s && !i) {
        for (let u = l.index + 1; u < s.index; ++u)
          a(this._blocks[u], u, 0, this._blocks[u].displayValue.length);
        a(this._blocks[s.index], s.index, 0, s.offset);
      }
    }
  }
  remove(t, n) {
    t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length);
    const a = super.remove(t, n);
    return this._forEachBlocksInRange(t, n, (l, s, i, o) => {
      a.aggregate(l.remove(i, o));
    }), a;
  }
  nearestInputPos(t, n) {
    if (n === void 0 && (n = Y.NONE), !this._blocks.length) return 0;
    const a = new Ii(this, t);
    if (n === Y.NONE)
      return a.pushRightBeforeInput() || (a.popState(), a.pushLeftBeforeInput()) ? a.pos : this.displayValue.length;
    if (n === Y.LEFT || n === Y.FORCE_LEFT) {
      if (n === Y.LEFT) {
        if (a.pushRightBeforeFilled(), a.ok && a.pos === t) return t;
        a.popState();
      }
      if (a.pushLeftBeforeInput(), a.pushLeftBeforeRequired(), a.pushLeftBeforeFilled(), n === Y.LEFT) {
        if (a.pushRightBeforeInput(), a.pushRightBeforeRequired(), a.ok && a.pos <= t || (a.popState(), a.ok && a.pos <= t)) return a.pos;
        a.popState();
      }
      return a.ok ? a.pos : n === Y.FORCE_LEFT ? 0 : (a.popState(), a.ok || (a.popState(), a.ok) ? a.pos : 0);
    }
    return n === Y.RIGHT || n === Y.FORCE_RIGHT ? (a.pushRightBeforeInput(), a.pushRightBeforeRequired(), a.pushRightBeforeFilled() ? a.pos : n === Y.FORCE_RIGHT ? this.displayValue.length : (a.popState(), a.ok || (a.popState(), a.ok) ? a.pos : this.nearestInputPos(t, Y.LEFT))) : t;
  }
  totalInputPositions(t, n) {
    t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length);
    let a = 0;
    return this._forEachBlocksInRange(t, n, (l, s, i, o) => {
      a += l.totalInputPositions(i, o);
    }), a;
  }
  /** Get block by name */
  maskedBlock(t) {
    return this.maskedBlocks(t)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(t) {
    const n = this._maskedBlocks[t];
    return n ? n.map((a) => this._blocks[a]) : [];
  }
  pad(t) {
    const n = new J();
    return this._forEachBlocksInRange(0, this.displayValue.length, (a) => n.aggregate(a.pad(t))), n;
  }
}
ye.DEFAULTS = {
  ...ve.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
ye.STOP_CHAR = "`";
ye.ESCAPE_CHAR = "\\";
ye.InputDefinition = Kt;
ye.FixedDefinition = Cl;
K.MaskedPattern = ye;
class jt extends ye {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(t) {
    super(t);
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const {
      to: n = this.to || 0,
      from: a = this.from || 0,
      maxLength: l = this.maxLength || 0,
      autofix: s = this.autofix,
      ...i
    } = t;
    this.to = n, this.from = a, this.maxLength = Math.max(String(n).length, l), this.autofix = s;
    const o = String(this.from).padStart(this.maxLength, "0"), r = String(this.to).padStart(this.maxLength, "0");
    let u = 0;
    for (; u < r.length && r[u] === o[u]; ) ++u;
    i.mask = r.slice(0, u).replace(/0/g, "\\0") + "0".repeat(this.maxLength - u), super._update(i);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(t) {
    let n = "", a = "";
    const [, l, s] = t.match(/^(\D*)(\d*)(\D*)/) || [];
    return s && (n = "0".repeat(l.length) + s, a = "9".repeat(l.length) + s), n = n.padEnd(this.maxLength, "0"), a = a.padEnd(this.maxLength, "9"), [n, a];
  }
  doPrepareChar(t, n) {
    n === void 0 && (n = {});
    let a;
    return [t, a] = super.doPrepareChar(t.replace(/\D/g, ""), n), t || (a.skip = !this.isComplete), [t, a];
  }
  _appendCharRaw(t, n) {
    if (n === void 0 && (n = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(t, n);
    const a = String(this.from).padStart(this.maxLength, "0"), l = String(this.to).padStart(this.maxLength, "0"), [s, i] = this.boundaries(this.value + t);
    return Number(i) < this.from ? super._appendCharRaw(a[this.value.length], n) : Number(s) > this.to ? !n.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(a[this.value.length], n).aggregate(this._appendCharRaw(t, n)) : super._appendCharRaw(l[this.value.length], n) : super._appendCharRaw(t, n);
  }
  doValidate(t) {
    const n = this.value;
    if (n.search(/[^0]/) === -1 && n.length <= this._matchFrom) return !0;
    const [l, s] = this.boundaries(n);
    return this.from <= Number(s) && Number(l) <= this.to && super.doValidate(t);
  }
  pad(t) {
    const n = new J();
    if (this.value.length === this.maxLength) return n;
    const a = this.value, l = this.maxLength - this.value.length;
    if (l) {
      this.reset();
      for (let s = 0; s < l; ++s)
        n.aggregate(super._appendCharRaw("0", t));
      a.split("").forEach((s) => this._appendCharRaw(s));
    }
    return n;
  }
}
K.MaskedRange = jt;
const Ei = "d{.}`m{.}`Y";
class Ge extends ye {
  static extractPatternOptions(t) {
    const {
      mask: n,
      pattern: a,
      ...l
    } = t;
    return {
      ...l,
      mask: Ke(n) ? n : a
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(t) {
    super(Ge.extractPatternOptions({
      ...Ge.DEFAULTS,
      ...t
    }));
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const {
      mask: n,
      pattern: a,
      blocks: l,
      ...s
    } = {
      ...Ge.DEFAULTS,
      ...t
    }, i = Object.assign({}, Ge.GET_DEFAULT_BLOCKS());
    t.min && (i.Y.from = t.min.getFullYear()), t.max && (i.Y.to = t.max.getFullYear()), t.min && t.max && i.Y.from === i.Y.to && (i.m.from = t.min.getMonth() + 1, i.m.to = t.max.getMonth() + 1, i.m.from === i.m.to && (i.d.from = t.min.getDate(), i.d.to = t.max.getDate())), Object.assign(i, this.blocks, l), super._update({
      ...s,
      mask: Ke(n) ? n : a,
      blocks: i
    });
  }
  doValidate(t) {
    const n = this.date;
    return super.doValidate(t) && (!this.isComplete || this.isDateExist(this.value) && n != null && (this.min == null || this.min <= n) && (this.max == null || n <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(t) {
    return this.format(this.parse(t, this), this).indexOf(t) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(t) {
    this.typedValue = t;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(t) {
    super.typedValue = t;
  }
  maskEquals(t) {
    return t === Date || super.maskEquals(t);
  }
  optionsIsChanged(t) {
    return super.optionsIsChanged(Ge.extractPatternOptions(t));
  }
}
Ge.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: jt,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: jt,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: jt,
    from: 1900,
    to: 9999
  }
});
Ge.DEFAULTS = {
  ...ye.DEFAULTS,
  mask: Date,
  pattern: Ei,
  format: (e, t) => {
    if (!e) return "";
    const n = String(e.getDate()).padStart(2, "0"), a = String(e.getMonth() + 1).padStart(2, "0"), l = e.getFullYear();
    return [n, a, l].join(".");
  },
  parse: (e, t) => {
    const [n, a, l] = e.split(".").map(Number);
    return new Date(l, a - 1, n);
  }
};
K.MaskedDate = Ge;
class pn extends ve {
  constructor(t) {
    super({
      ...pn.DEFAULTS,
      ...t
    }), this.currentMask = void 0;
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    super._update(t), "mask" in t && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(t.mask) ? t.mask.map((n) => {
      const {
        expose: a,
        ...l
      } = At(n), s = ze({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...l
      });
      return a && (this.exposeMask = s), s;
    }) : []);
  }
  _appendCharRaw(t, n) {
    n === void 0 && (n = {});
    const a = this._applyDispatch(t, n);
    return this.currentMask && a.aggregate(this.currentMask._appendChar(t, this.currentMaskFlags(n))), a;
  }
  _applyDispatch(t, n, a) {
    t === void 0 && (t = ""), n === void 0 && (n = {}), a === void 0 && (a = "");
    const l = n.tail && n._beforeTailState != null ? n._beforeTailState._value : this.value, s = this.rawInputValue, i = n.tail && n._beforeTailState != null ? n._beforeTailState._rawInputValue : s, o = s.slice(i.length), r = this.currentMask, u = new J(), c = r == null ? void 0 : r.state;
    return this.currentMask = this.doDispatch(t, {
      ...n
    }, a), this.currentMask && (this.currentMask !== r ? (this.currentMask.reset(), i && (this.currentMask.append(i, {
      raw: !0
    }), u.tailShift = this.currentMask.value.length - l.length), o && (u.tailShift += this.currentMask.append(o, {
      raw: !0,
      tail: !0
    }).tailShift)) : c && (this.currentMask.state = c)), u;
  }
  _appendPlaceholder() {
    const t = this._applyDispatch();
    return this.currentMask && t.aggregate(this.currentMask._appendPlaceholder()), t;
  }
  _appendEager() {
    const t = this._applyDispatch();
    return this.currentMask && t.aggregate(this.currentMask._appendEager()), t;
  }
  appendTail(t) {
    const n = new J();
    return t && n.aggregate(this._applyDispatch("", {}, t)), n.aggregate(this.currentMask ? this.currentMask.appendTail(t) : super.appendTail(t));
  }
  currentMaskFlags(t) {
    var n, a;
    return {
      ...t,
      _beforeTailState: ((n = t._beforeTailState) == null ? void 0 : n.currentMaskRef) === this.currentMask && ((a = t._beforeTailState) == null ? void 0 : a.currentMask) || t._beforeTailState
    };
  }
  doDispatch(t, n, a) {
    return n === void 0 && (n = {}), a === void 0 && (a = ""), this.dispatch(t, this, n, a);
  }
  doValidate(t) {
    return super.doValidate(t) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(t)));
  }
  doPrepare(t, n) {
    n === void 0 && (n = {});
    let [a, l] = super.doPrepare(t, n);
    if (this.currentMask) {
      let s;
      [a, s] = super.doPrepare(a, this.currentMaskFlags(n)), l = l.aggregate(s);
    }
    return [a, l];
  }
  doPrepareChar(t, n) {
    n === void 0 && (n = {});
    let [a, l] = super.doPrepareChar(t, n);
    if (this.currentMask) {
      let s;
      [a, s] = super.doPrepareChar(a, this.currentMaskFlags(n)), l = l.aggregate(s);
    }
    return [a, l];
  }
  reset() {
    var t;
    (t = this.currentMask) == null || t.reset(), this.compiledMasks.forEach((n) => n.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(t) {
    this.exposeMask ? (this.exposeMask.value = t, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = t;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(t) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = t, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = t;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(t) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = t, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let n = String(t);
    this.currentMask && (this.currentMask.typedValue = t, n = this.currentMask.unmaskedValue), this.unmaskedValue = n;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var t;
    return !!((t = this.currentMask) != null && t.isComplete);
  }
  get isFilled() {
    var t;
    return !!((t = this.currentMask) != null && t.isFilled);
  }
  remove(t, n) {
    const a = new J();
    return this.currentMask && a.aggregate(this.currentMask.remove(t, n)).aggregate(this._applyDispatch()), a;
  }
  get state() {
    var t;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((n) => n.state),
      currentMaskRef: this.currentMask,
      currentMask: (t = this.currentMask) == null ? void 0 : t.state
    };
  }
  set state(t) {
    const {
      compiledMasks: n,
      currentMaskRef: a,
      currentMask: l,
      ...s
    } = t;
    n && this.compiledMasks.forEach((i, o) => i.state = n[o]), a != null && (this.currentMask = a, this.currentMask.state = l), super.state = s;
  }
  extractInput(t, n, a) {
    return this.currentMask ? this.currentMask.extractInput(t, n, a) : "";
  }
  extractTail(t, n) {
    return this.currentMask ? this.currentMask.extractTail(t, n) : super.extractTail(t, n);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(t, n) {
    return this.currentMask ? this.currentMask.nearestInputPos(t, n) : super.nearestInputPos(t, n);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(t) {
    this._overwrite = t;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(t) {
    this._eager = t;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(t) {
    this._skipInvalid = t;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(t) {
    this._autofix = t;
  }
  maskEquals(t) {
    return Array.isArray(t) ? this.compiledMasks.every((n, a) => {
      if (!t[a]) return;
      const {
        mask: l,
        ...s
      } = t[a];
      return qt(n, s) && n.maskEquals(l);
    }) : super.maskEquals(t);
  }
  typedValueEquals(t) {
    var n;
    return !!((n = this.currentMask) != null && n.typedValueEquals(t));
  }
}
pn.DEFAULTS = {
  ...ve.DEFAULTS,
  dispatch: (e, t, n, a) => {
    if (!t.compiledMasks.length) return;
    const l = t.rawInputValue, s = t.compiledMasks.map((i, o) => {
      const r = t.currentMask === i, u = r ? i.displayValue.length : i.nearestInputPos(i.displayValue.length, Y.FORCE_LEFT);
      return i.rawInputValue !== l ? (i.reset(), i.append(l, {
        raw: !0
      })) : r || i.remove(u), i.append(e, t.currentMaskFlags(n)), i.appendTail(a), {
        index: o,
        weight: i.rawInputValue.length,
        totalInputPositions: i.totalInputPositions(0, Math.max(u, i.nearestInputPos(i.displayValue.length, Y.FORCE_LEFT)))
      };
    });
    return s.sort((i, o) => o.weight - i.weight || o.totalInputPositions - i.totalInputPositions), t.compiledMasks[s[0].index];
  }
};
K.MaskedDynamic = pn;
class gn extends ye {
  constructor(t) {
    super({
      ...gn.DEFAULTS,
      ...t
    });
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const {
      enum: n,
      ...a
    } = t;
    if (n) {
      const l = n.map((o) => o.length), s = Math.min(...l), i = Math.max(...l) - s;
      a.mask = "*".repeat(s), i && (a.mask += "[" + "*".repeat(i) + "]"), this.enum = n;
    }
    super._update(a);
  }
  _appendCharRaw(t, n) {
    n === void 0 && (n = {});
    const a = Math.min(this.nearestInputPos(0, Y.FORCE_RIGHT), this.value.length), l = this.enum.filter((s) => this.matchValue(s, this.unmaskedValue + t, a));
    if (l.length) {
      l.length === 1 && this._forEachBlocksInRange(0, this.value.length, (i, o) => {
        const r = l[0][o];
        o >= this.value.length || r === i.value || (i.reset(), i._appendChar(r, n));
      });
      const s = super._appendCharRaw(l[0][this.value.length], n);
      return l.length === 1 && l[0].slice(this.unmaskedValue.length).split("").forEach((i) => s.aggregate(super._appendCharRaw(i))), s;
    }
    return new J({
      skip: !this.isComplete
    });
  }
  extractTail(t, n) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), new Fe("", t);
  }
  remove(t, n) {
    if (t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), t === n) return new J();
    const a = Math.min(super.nearestInputPos(0, Y.FORCE_RIGHT), this.value.length);
    let l;
    for (l = t; l >= 0 && !(this.enum.filter((o) => this.matchValue(o, this.value.slice(a, l), a)).length > 1); --l)
      ;
    const s = super.remove(l, n);
    return s.tailShift += l - t, s;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
gn.DEFAULTS = {
  ...ye.DEFAULTS,
  matchValue: (e, t, n) => e.indexOf(t, n) === n
};
K.MaskedEnum = gn;
class Ai extends ve {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    super._update({
      ...t,
      validate: t.mask
    });
  }
}
K.MaskedFunction = Ai;
var Tl;
class Te extends ve {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(t) {
    super({
      ...Te.DEFAULTS,
      ...t
    });
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    super._update(t), this._updateRegExps();
  }
  _updateRegExps() {
    const t = "^" + (this.allowNegative ? "[+|\\-]?" : ""), n = "\\d*", a = (this.scale ? "(" + Mn(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(t + n + a), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(Mn).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(Mn(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(t) {
    return t.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(t) {
    const n = t.split(this.radix);
    return n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), n.join(this.radix);
  }
  doPrepareChar(t, n) {
    n === void 0 && (n = {});
    const [a, l] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (n.input && n.raw || !n.input && !n.raw) ? t.replace(this._mapToRadixRegExp, this.radix) : t), n);
    return t && !a && (l.skip = !0), a && !this.allowPositive && !this.value && a !== "-" && l.aggregate(this._appendChar("-")), [a, l];
  }
  _separatorsCount(t, n) {
    n === void 0 && (n = !1);
    let a = 0;
    for (let l = 0; l < t; ++l)
      this._value.indexOf(this.thousandsSeparator, l) === l && (++a, n && (t += this.thousandsSeparator.length));
    return a;
  }
  _separatorsCountFromSlice(t) {
    return t === void 0 && (t = this._value), this._separatorsCount(this._removeThousandsSeparators(t).length, !0);
  }
  extractInput(t, n, a) {
    return t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), [t, n] = this._adjustRangeWithSeparators(t, n), this._removeThousandsSeparators(super.extractInput(t, n, a));
  }
  _appendCharRaw(t, n) {
    n === void 0 && (n = {});
    const a = n.tail && n._beforeTailState ? n._beforeTailState._value : this._value, l = this._separatorsCountFromSlice(a);
    this._value = this._removeThousandsSeparators(this.value);
    const s = this._value;
    this._value += t;
    const i = this.number;
    let o = !isNaN(i), r = !1;
    if (o) {
      let m;
      this.min != null && this.min < 0 && this.number < this.min && (m = this.min), this.max != null && this.max > 0 && this.number > this.max && (m = this.max), m != null && (this.autofix ? (this._value = this.format(m, this).replace(Te.UNMASKED_RADIX, this.radix), r || (r = s === this._value && !n.tail)) : o = !1), o && (o = !!this._value.match(this._numberRegExp));
    }
    let u;
    o ? u = new J({
      inserted: this._value.slice(s.length),
      rawInserted: r ? "" : t,
      skip: r
    }) : (this._value = s, u = new J()), this._value = this._insertThousandsSeparators(this._value);
    const c = n.tail && n._beforeTailState ? n._beforeTailState._value : this._value, f = this._separatorsCountFromSlice(c);
    return u.tailShift += (f - l) * this.thousandsSeparator.length, u;
  }
  _findSeparatorAround(t) {
    if (this.thousandsSeparator) {
      const n = t - this.thousandsSeparator.length + 1, a = this.value.indexOf(this.thousandsSeparator, n);
      if (a <= t) return a;
    }
    return -1;
  }
  _adjustRangeWithSeparators(t, n) {
    const a = this._findSeparatorAround(t);
    a >= 0 && (t = a);
    const l = this._findSeparatorAround(n);
    return l >= 0 && (n = l + this.thousandsSeparator.length), [t, n];
  }
  remove(t, n) {
    t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length), [t, n] = this._adjustRangeWithSeparators(t, n);
    const a = this.value.slice(0, t), l = this.value.slice(n), s = this._separatorsCount(a.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(a + l));
    const i = this._separatorsCountFromSlice(a);
    return new J({
      tailShift: (i - s) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(t, n) {
    if (!this.thousandsSeparator) return t;
    switch (n) {
      case Y.NONE:
      case Y.LEFT:
      case Y.FORCE_LEFT: {
        const a = this._findSeparatorAround(t - 1);
        if (a >= 0) {
          const l = a + this.thousandsSeparator.length;
          if (t < l || this.value.length <= l || n === Y.FORCE_LEFT)
            return a;
        }
        break;
      }
      case Y.RIGHT:
      case Y.FORCE_RIGHT: {
        const a = this._findSeparatorAround(t);
        if (a >= 0)
          return a + this.thousandsSeparator.length;
      }
    }
    return t;
  }
  doCommit() {
    if (this.value) {
      const t = this.number;
      let n = t;
      this.min != null && (n = Math.max(n, this.min)), this.max != null && (n = Math.min(n, this.max)), n !== t && (this.unmaskedValue = this.format(n, this));
      let a = this.value;
      this.normalizeZeros && (a = this._normalizeZeros(a)), this.padFractionalZeros && this.scale > 0 && (a = this._padFractionalZeros(a)), this._value = a;
    }
    super.doCommit();
  }
  _normalizeZeros(t) {
    const n = this._removeThousandsSeparators(t).split(this.radix);
    return n[0] = n[0].replace(/^(\D*)(0*)(\d*)/, (a, l, s, i) => l + i), t.length && !/\d$/.test(n[0]) && (n[0] = n[0] + "0"), n.length > 1 && (n[1] = n[1].replace(/0*$/, ""), n[1].length || (n.length = 1)), this._insertThousandsSeparators(n.join(this.radix));
  }
  _padFractionalZeros(t) {
    if (!t) return t;
    const n = t.split(this.radix);
    return n.length < 2 && n.push(""), n[1] = n[1].padEnd(this.scale, "0"), n.join(this.radix);
  }
  doSkipInvalid(t, n, a) {
    n === void 0 && (n = {});
    const l = this.scale === 0 && t !== this.thousandsSeparator && (t === this.radix || t === Te.UNMASKED_RADIX || this.mapToRadix.includes(t));
    return super.doSkipInvalid(t, n, a) && !l;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, Te.UNMASKED_RADIX);
  }
  set unmaskedValue(t) {
    super.unmaskedValue = t;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(t) {
    this.rawInputValue = this.format(t, this).replace(Te.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(t) {
    this.typedValue = t;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(t) {
    return (super.typedValueEquals(t) || Te.EMPTY_VALUES.includes(t) && Te.EMPTY_VALUES.includes(this.typedValue)) && !(t === 0 && this.value === "");
  }
}
Tl = Te;
Te.UNMASKED_RADIX = ".";
Te.EMPTY_VALUES = [...ve.EMPTY_VALUES, 0];
Te.DEFAULTS = {
  ...ve.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [Tl.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (e) => e.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
K.MaskedNumber = Te;
const Nn = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function Sl(e, t, n) {
  t === void 0 && (t = Nn.MASKED), n === void 0 && (n = Nn.MASKED);
  const a = ze(e);
  return (l) => a.runIsolated((s) => (s[t] = l, s[n]));
}
function Fi(e, t, n, a) {
  return Sl(t, n, a)(e);
}
K.PIPE_TYPE = Nn;
K.createPipe = Sl;
K.pipe = Fi;
class Oi extends ye {
  get repeatFrom() {
    var t;
    return (t = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? t : 0;
  }
  get repeatTo() {
    var t;
    return (t = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? t : 1 / 0;
  }
  constructor(t) {
    super(t);
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    var n, a, l;
    const {
      repeat: s,
      ...i
    } = At(t);
    this._blockOpts = Object.assign({}, this._blockOpts, i);
    const o = ze(this._blockOpts);
    this.repeat = (n = (a = s ?? o.repeat) != null ? a : this.repeat) != null ? n : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((l = this._blocks) == null ? void 0 : l.length) || 0, this.repeatFrom)),
      blocks: {
        m: o
      },
      eager: o.eager,
      overwrite: o.overwrite,
      skipInvalid: o.skipInvalid,
      lazy: o.lazy,
      placeholderChar: o.placeholderChar,
      displayChar: o.displayChar
    });
  }
  _allocateBlock(t) {
    if (t < this._blocks.length) return this._blocks[t];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push(ze(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(t, n) {
    n === void 0 && (n = {});
    const a = new J();
    for (
      let r = (l = (s = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : s.index) != null ? l : Math.max(this._blocks.length - 1, 0), u, c;
      // try to get a block or
      // try to allocate a new block if not allocated already
      u = (i = this._blocks[r]) != null ? i : c = !c && this._allocateBlock(r);
      ++r
    ) {
      var l, s, i, o;
      const f = u._appendChar(t, {
        ...n,
        _beforeTailState: (o = n._beforeTailState) == null || (o = o._blocks) == null ? void 0 : o[r]
      });
      if (f.skip && c) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (a.aggregate(f), f.consumed) break;
    }
    return a;
  }
  _trimEmptyTail(t, n) {
    var a, l;
    t === void 0 && (t = 0);
    const s = Math.max(((a = this._mapPosToBlock(t)) == null ? void 0 : a.index) || 0, this.repeatFrom, 0);
    let i;
    n != null && (i = (l = this._mapPosToBlock(n)) == null ? void 0 : l.index), i == null && (i = this._blocks.length - 1);
    let o = 0;
    for (let r = i; s <= r && !this._blocks[r].unmaskedValue; --r, ++o)
      ;
    o && (this._blocks.splice(i - o + 1, o), this.mask = this.mask.slice(o));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(t, n) {
    t === void 0 && (t = 0), n === void 0 && (n = this.displayValue.length);
    const a = super.remove(t, n);
    return this._trimEmptyTail(t, n), a;
  }
  totalInputPositions(t, n) {
    return t === void 0 && (t = 0), n == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(t, n);
  }
  get state() {
    return super.state;
  }
  set state(t) {
    this._blocks.length = t._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = t;
  }
}
K.RepeatBlock = Oi;
try {
  globalThis.IMask = K;
} catch {
}
var $i = {
  // common
  mask: void 0,
  prepare: Function,
  prepareChar: Function,
  validate: Function,
  commit: Function,
  overwrite: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  eager: {
    required: !1,
    default: void 0,
    validator: (e) => ["append", "remove"].includes(e) || typeof e == "boolean"
  },
  skipInvalid: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  // pattern
  placeholderChar: String,
  displayChar: String,
  lazy: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  definitions: Object,
  blocks: Object,
  // enum
  enum: Array,
  // range
  maxLength: Number,
  from: Number,
  to: Number,
  // date
  pattern: String,
  format: Function,
  parse: Function,
  autofix: {
    required: !1,
    default: void 0,
    validator: (e) => e === "pad" || typeof e == "boolean"
  },
  // number
  radix: String,
  thousandsSeparator: String,
  mapToRadix: Array,
  scale: Number,
  normalizeZeros: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  padFractionalZeros: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  min: [Number, Date],
  max: [Number, Date],
  // dynamic
  dispatch: Function
};
function Bl(e, t) {
  let {
    emit: n,
    onAccept: a,
    onComplete: l,
    defaultValue: s,
    defaultUnmaskedValue: i,
    defaultTypedValue: o
  } = t === void 0 ? {} : t;
  const r = ln(e) ? e : O(e), u = O(), c = O(), f = O(""), m = O(""), h = O();
  let g, v = f.value, y = m.value, b = h.value;
  function S() {
    b = h.value = c.value.typedValue, y = m.value = c.value.unmaskedValue, v = f.value = c.value.value;
  }
  function B(N) {
    S(), n && (n("accept", f.value, N), n("accept:masked", f.value, N), n("accept:typed", h.value, N), n("accept:unmasked", m.value, N)), a == null || a(N);
  }
  function M(N) {
    n && (n("complete", c.value.value, N), n("complete:masked", c.value.value, N), n("complete:typed", c.value.typedValue, N), n("complete:unmasked", c.value.unmaskedValue, N)), l == null || l(N);
  }
  const P = () => {
    !c.value || m.value === void 0 || (y !== m.value && (c.value.unmaskedValue = m.value, c.value.unmaskedValue !== m.value && B()), y = void 0);
  };
  H(m, P);
  const V = () => {
    !c.value || f.value === void 0 || (v !== f.value && (c.value.value = f.value, c.value.value !== f.value && B()), v = void 0);
  };
  H(f, V);
  const C = () => {
    !c.value || h.value === void 0 || (b !== h.value && (c.value.typedValue = h.value, c.value.masked.typedValueEquals(h.value) || B()), b = void 0);
  };
  H(h, C);
  function R() {
    g = u.value;
    const N = r.value;
    !g || !(N != null && N.mask) || (c.value = K(g, N), s !== void 0 && (f.value = s), i !== void 0 && (m.value = i), o !== void 0 && (h.value = o), P(), V(), C(), S(), c.value.on("accept", B).on("complete", M));
  }
  function F() {
    var N;
    (N = c.value) == null || N.destroy(), c.value = void 0;
  }
  return xe(R), We(F), H([u, r], () => {
    const N = u.value, ee = r.value;
    (!(ee != null && ee.mask) || N !== g) && F(), N && (c.value ? c.value.updateOptions(ee) : R());
  }), {
    el: u,
    mask: Ja(c),
    masked: f,
    unmasked: m,
    typed: h
  };
}
function Li(e, t) {
  return e = {
    ...e
  }, Object.keys(e).forEach((n) => {
    (e[n] === void 0 || t.includes(n)) && delete e[n];
  }), e;
}
const Vi = ["typed", "unmasked", "value", "modelValue"];
E({
  name: "imask-input",
  inheritAttrs: !1,
  props: {
    // plugin
    modelValue: String,
    value: String,
    unmasked: String,
    typed: {
      validator: () => !0
    },
    ...$i
  },
  emits: ["update:modelValue", "update:masked", "update:value", "update:unmasked", "update:typed", "accept", "accept:value", "accept:masked", "accept:unmasked", "accept:typed", "complete", "complete:value", "complete:masked", "complete:unmasked", "complete:typed"],
  setup(e, t) {
    let {
      attrs: n,
      emit: a
    } = t;
    const {
      el: l,
      mask: s,
      masked: i,
      unmasked: o,
      typed: r
    } = Bl(Li(e, Vi), {
      emit: a,
      onAccept: (h) => {
        const g = i.value;
        a("accept:value", g, h), a("update:value", g, h), a("update:masked", g, h), a("update:modelValue", g, h), a("update:unmasked", o.value, h), a("update:typed", r.value, h);
      },
      onComplete: (h) => {
        a("complete:value", i.value, h);
      }
    }), u = z(e, "value"), c = z(e, "modelValue"), f = z(e, "unmasked"), m = z(e, "typed");
    return i.value = c.value || u.value || "", o.value = f.value || "", r.value = m.value, H(u, (h) => i.value = h), H(c, (h) => i.value = h), H(f, (h) => o.value = h), H(m, (h) => r.value = h), () => {
      const h = {
        ...n,
        value: e.value != null ? e.value : e.modelValue != null ? e.modelValue : s.value ? s.value.displayValue : "",
        ref: l
      };
      return e.mask || (h.onInput = (g) => {
        a("update:modelValue", g.target.value), a("update:value", g.target.value);
      }), jn("input", h);
    };
  }
});
const Kf = /* @__PURE__ */ E({
  __name: "GpMaskInput",
  props: {
    modelValue: {},
    nullable: { type: Boolean, default: !1 },
    inputId: {},
    name: { default: "" },
    autocomplete: { default: "off" },
    mask: { default: void 0 },
    placeholder: { default: null },
    label: { default: null },
    hint: { default: null },
    canBeResetted: { type: Boolean, default: !1 },
    float: { type: Boolean, default: !1 },
    error: { default: null },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = e, a = t, { el: l, mask: s } = Bl({
      mask: n.mask
    });
    be(() => {
      if (s.value != null) {
        if (n.nullable && s.value.value === "") {
          a("update:modelValue", null);
          return;
        }
        a("update:modelValue", s.value.value);
      }
    });
    const i = (f) => {
      a("input", f);
    };
    Xe("imask-input", l);
    const o = O(null), { handleBlur: r, handleFocus: u } = _e(
      o,
      a
    ), c = k(() => {
      const { mask: f, ...m } = n;
      return m;
    });
    return (f, m) => (p(), D(Kn, re({
      ref_key: "inputComponent",
      ref: o
    }, c.value, {
      onInput: i,
      onFocus: d(u),
      onBlur: d(r)
    }), {
      label: T(() => [
        w(f.$slots, "label")
      ]),
      actions: T(() => [
        w(f.$slots, "actions")
      ]),
      hint: T(() => [
        w(f.$slots, "hint", {}, () => [
          A(pe, {
            error: e.error,
            hint: e.hint
          }, null, 8, ["error", "hint"])
        ])
      ]),
      _: 3
    }, 16, ["onFocus", "onBlur"]));
  }
}), Ri = ["tabindex", "onKeydown"], Pi = ["id", "value", "name", "aria-checked"], Gi = ["for"], Qf = /* @__PURE__ */ E({
  __name: "GpSwitch",
  props: {
    modelValue: { type: Boolean },
    inputId: {},
    name: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    labelPos: { default: "right" },
    enableLabelClick: { type: Boolean, default: !1 },
    hint: { default: null },
    error: { default: null },
    disableFocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e, { expose: t, emit: n }) {
    const a = e, l = Ve("switch", a.inputId), s = n, i = Ae(a, "modelValue", s), o = () => {
      a.disabled || (i.value = !i.value);
    }, r = O(null), { isFocused: u, manualBlur: c, manualFocus: f, handleBlur: m, handleFocus: h } = _e(r, s), g = () => {
      u.value && o();
    };
    return t({
      focus: f,
      blur: c
    }), (v, y) => (p(), x("div", {
      class: I(["transition-opacity", {
        "opacity-70": e.disabled
      }])
    }, [
      L("div", {
        class: I(["flex w-fit items-center", { "flex-row-reverse": e.labelPos === "left" }]),
        "data-testid": "gp-switch"
      }, [
        L("div", {
          ref_key: "inputElement",
          ref: r,
          class: I(["relative h-5 w-10 rounded-2xl border bg-gp-midnight-2 transition-colors", {
            "cursor-pointer": !e.disabled,
            "border-gp-green": d(i),
            "border-gp-dark-mouse": !d(i),
            "focus:outline focus:outline-2 focus:outline-gp-cyan/50": !e.disableFocus
          }]),
          tabindex: e.disableFocus ? void 0 : 0,
          "data-testid": "gp-switch-toggle",
          onFocus: y[0] || (y[0] = //@ts-ignore
          (...b) => d(h) && d(h)(...b)),
          onBlur: y[1] || (y[1] = //@ts-ignore
          (...b) => d(m) && d(m)(...b)),
          onKeydown: sn(ke(g, ["prevent"]), ["space"]),
          onClick: ke(o, ["prevent"])
        }, [
          L("span", {
            class: I(["absolute -left-px -top-px size-5 translate-x-0 rounded-full transition-transform", {
              "translate-x-full": d(i),
              "bg-gp-green": d(i),
              "bg-gp-rhino": !d(i)
            }])
          }, null, 2),
          L("input", {
            id: d(l),
            tabindex: "-1",
            type: "checkbox",
            value: d(i),
            name: e.name == null || e.name.length === 0 ? e.inputId : e.name,
            style: { display: "none" },
            "aria-checked": d(i),
            "data-testid": "gp-switch-input"
          }, null, 8, Pi)
        ], 42, Ri),
        w(v.$slots, "label", {}, () => [
          e.label != null && e.label.length > 0 ? (p(), x("label", {
            key: 0,
            for: d(l),
            class: I(["leading-4", [
              e.labelPos === "left" ? "mr-4" : "ml-4",
              !e.enableLabelClick || e.disabled ? "pointer-events-none" : "pointer-events-auto cursor-pointer"
            ]])
          }, G(e.label), 11, Gi)) : $("", !0)
        ])
      ], 2),
      w(v.$slots, "hint", {}, () => [
        A(pe, W(j({ hint: e.hint, error: e.error })), null, 16)
      ])
    ], 2));
  }
}), Ni = 200, zi = "--gp-transition-duration", Yi = (
  /* tw */
  "duration-(--gp-transition-duration)"
), vn = (e) => {
  const t = (s, i = !1) => {
    const o = s;
    if (e.value == null) {
      o.style.setProperty(
        "--gp-transition-duration",
        `${Ni}ms`
      );
      return;
    }
    if (typeof e.value == "number") {
      o.style.setProperty(
        "--gp-transition-duration",
        `${e.value}ms`
      );
      return;
    }
    const r = i ? e.value.leave : e.value.enter;
    o.style.setProperty("--gp-transition-duration", `${r}ms`);
  };
  return {
    TRANSITION_DURATION_VARIABLE: zi,
    TRANSITION_DURATION_CLASS: Yi,
    onTransitioning: t,
    onEnterTransitioning: (s) => {
      t(s);
    },
    onLeaveTransitioning: (s) => {
      t(s, !0);
    },
    onAfterTransitioning: (s) => {
      s.style.removeProperty("--gp-transition-duration");
    }
  };
}, Dl = (e, t) => {
  const {
    TRANSITION_DURATION_CLASS: n,
    onEnterTransitioning: a,
    onLeaveTransitioning: l,
    onAfterTransitioning: s
  } = vn(z(e));
  return {
    transitionBinding: k(() => d(t) ? {} : {
      enterFromClass: (
        /* tw */
        "opacity-0"
      ),
      enterActiveClass: (
        /* tw */
        `transition-opacity ease-in ${n} delay-[var(--gp-transition-in-delay,0ms)]`
      ),
      enterToClass: (
        /* tw */
        "opacity-100"
      ),
      leaveFromClass: (
        /* tw */
        "opacity-100"
      ),
      leaveActiveClass: (
        /* tw */
        `transition-opacity ease-out ${n} delay-[var(--gp-transition-out-delay,0ms)]`
      ),
      leaveToClass: (
        /* tw */
        "opacity-0"
      ),
      onEnter: a,
      onLeave: l,
      onAfterEnter: s,
      onAfterLeave: s
    })
  };
}, Ye = /* @__PURE__ */ E({
  __name: "GpFadeTransition",
  props: {
    disabled: { type: Boolean, default: !1 },
    duration: { default: 200 },
    mode: { default: "default" }
  },
  setup(e) {
    const t = e, { transitionBinding: n } = Dl(
      z(t, "duration"),
      z(t, "disabled")
    );
    return (a, l) => (p(), D(ct, W(j({ ...d(n), mode: e.mode })), {
      default: T(() => [
        w(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Wi = ["tabindex", "onKeydown"], ji = ["id", "value", "name", "checked", "aria-checked"], Hi = ["for"], Qt = /* @__PURE__ */ E({
  __name: "GpCheckbox",
  props: {
    modelValue: { type: [Boolean, null], default: void 0 },
    nullable: { type: Boolean, default: !1 },
    inputId: {},
    name: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    labelPos: { default: "right" },
    enableLabelClick: { type: Boolean, default: !1 },
    hint: { default: null },
    error: { default: null },
    disableFocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e, { expose: t, emit: n }) {
    const a = e, l = n, s = Ve("checkbox", a.inputId), i = Ae(a, "modelValue", l), o = () => {
      if (!a.disabled) {
        if (a.nullable) {
          if (i.value) {
            i.value = null;
            return;
          }
          if (i.value == null) {
            i.value = !1;
            return;
          }
          i.value = !0;
          return;
        }
        i.value = !i.value;
      }
    };
    H(
      () => a.nullable,
      () => {
        !a.nullable && i.value === null && (i.value = !1);
      }
    );
    const r = O(null), { isFocused: u, handleBlur: c, handleFocus: f, manualBlur: m, manualFocus: h } = _e(r, l), g = () => {
      u.value && o();
    };
    return t({
      focus: h,
      blur: m
    }), (v, y) => (p(), x("div", {
      class: I(["transition-opacity", {
        "opacity-70": e.disabled
      }]),
      "data-testid": "gp-checkbox"
    }, [
      L("div", {
        class: I(["flex items-center", { "flex-row-reverse": e.labelPos === "left" }])
      }, [
        L("div", {
          ref_key: "inputElement",
          ref: r,
          class: I(["size-6 rounded border bg-transparent text-center", {
            "cursor-pointer": !e.disabled,
            "border-gp-cyan": d(i),
            "border-gp-rhino": !d(i),
            "focus:outline focus:outline-2 focus:outline-gp-cyan/50": !e.disableFocus
          }]),
          "data-testid": "gp-checkbox-toggle",
          tabindex: e.disableFocus ? void 0 : 0,
          onFocus: y[0] || (y[0] = //@ts-ignore
          (...b) => d(f) && d(f)(...b)),
          onBlur: y[1] || (y[1] = //@ts-ignore
          (...b) => d(c) && d(c)(...b)),
          onKeydown: sn(ke(g, ["prevent"]), ["space"]),
          onClick: ke(o, ["prevent"])
        }, [
          A(Ye, { mode: "out-in" }, {
            default: T(() => [
              d(i) ? (p(), D(d(Q), {
                key: 0,
                class: "text-sm text-gp-cyan",
                icon: d(Gn)
              }, null, 8, ["icon"])) : e.nullable && d(i) == !1 ? (p(), D(d(Q), {
                key: 1,
                class: "text-sm text-gp-cyan",
                icon: d(Je)
              }, null, 8, ["icon"])) : $("", !0)
            ]),
            _: 1
          }),
          L("input", {
            id: d(s),
            type: "checkbox",
            value: d(i),
            name: e.name == null || e.name.length === 0 ? d(s) : e.name,
            style: { display: "none" },
            "data-testid": "gp-checkbox-input",
            checked: d(i),
            "aria-checked": d(i)
          }, null, 8, ji)
        ], 42, Wi),
        w(v.$slots, "label", {}, () => [
          e.label != null && e.label.length > 0 ? (p(), x("label", {
            key: 0,
            for: d(s),
            class: I(["leading-4", [
              e.labelPos === "left" ? "mr-4" : "ml-4",
              !e.enableLabelClick || e.disabled ? "pointer-events-none" : "pointer-events-auto cursor-pointer"
            ]])
          }, G(e.label), 11, Hi)) : $("", !0)
        ])
      ], 2),
      w(v.$slots, "hint", {}, () => [
        A(pe, W(j({ hint: e.hint, error: e.error })), null, 16)
      ])
    ], 2));
  }
}), Ui = (e, t, n, a, l) => (i) => {
  if (typeof i == "object") {
    if (l.value && t.value != null && t.value[n.value] === i[n.value]) {
      t.value = null, e.value = null;
      return;
    }
    t.value = i, a.value ? e.value = t.value : e.value = t.value[n.value];
    return;
  }
  if (l.value && t.value === i) {
    t.value = null, e.value = null;
    return;
  }
  t.value = i, e.value = t.value;
}, qi = (e, t, n, a, l, s, i) => {
  const o = (c) => {
    t.value = c, e.value = c;
  }, r = (c) => {
    if (e.value == null || e.value === "") {
      if (i.value) {
        o(null);
        return;
      }
      if (n.value.length === 0) return;
      const f = n.value[0];
      if (f[a.value] != null && !s.value) {
        o(f[a.value]);
        return;
      }
      o(f);
      return;
    }
    if (s.value) {
      const f = e;
      if (c != null && f.value[a.value] !== c[a.value]) {
        const m = n.value.find(
          (h) => h[a.value] === f.value[a.value]
        );
        m != null && o(m);
        return;
      }
      if (typeof f == "object") {
        if (f.value[a.value] != null && e.value[l.value] == null) {
          const m = n.value.find(
            (h) => h[a.value] === f.value[a.value]
          );
          m != null ? o(m) : t.value = f.value;
          return;
        }
        if (
          // our model value MUST a value key
          f.value[a.value] != null && // either the internal model value is empty
          (t.value == null || // or the internal model value is different from the model value
          t.value[a.value] !== f.value[a.value])
        ) {
          const m = n.value.find(
            (h) => h[a.value] === f.value[a.value]
          );
          m != null ? t.value = m : t.value = f.value;
          return;
        }
      }
      return;
    }
    if (n.value.length === 0) {
      t.value = e.value;
      return;
    }
    t.value = n.value.find((f) => typeof f == "object" ? f[a.value] === e.value : f === e.value);
  }, u = (c) => {
    r(c);
  };
  H(e, (c) => {
    u(c);
  }), H(n, () => {
    u(e.value);
  }), xe(async () => {
    u(e.value);
  });
}, Ki = { class: "flex" }, Qi = {
  key: 0,
  class: "flex size-input items-center justify-center p-0"
}, ta = /* @__PURE__ */ E({
  __name: "GpDropdownToggle",
  props: {
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    isOpened: { type: Boolean, default: !1 },
    float: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    nullable: { type: Boolean, default: !1 },
    allowedToBeCleared: { type: Boolean, default: !1 }
  },
  emits: ["open", "close", "clearValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = async () => {
      n.disabled || n.loading || (n.isOpened ? a("close") : a("open"));
    }, s = k(() => n.nullable && n.allowedToBeCleared && !n.disabled && !n.loading);
    return (i, o) => (p(), x("div", {
      ref: "selectContainer",
      class: I(["relative flex h-input w-full transition-all", {
        // default style
        "after:absolute after:inset-x-0 after:bottom-0 after:h-px after:transition-all": !e.float,
        "bg-gp-midnight-2 after:inset-x-4": !e.float && e.isOpened,
        // float style
        "bg-gp-midnight-2 shadow-xs": e.float,
        "rounded pl-2": e.float && !e.isOpened,
        // always force style, if result list is open, regardless of style
        "rounded-t px-4 shadow-sm": e.isOpened,
        // interaction
        "cursor-pointer": !e.isOpened && !e.disabled && !e.loading,
        [e.hasError ? "after:bg-gp-fire" : "after:bg-gp-rhino"]: !0
      }])
    }, [
      w(i.$slots, "default"),
      L("div", Ki, [
        e.disabled ? $("", !0) : (p(), x(X, { key: 0 }, [
          w(i.$slots, "actions", {}, () => [
            A(Ye, null, {
              default: T(() => [
                s.value ? (p(), D(st, {
                  key: 0,
                  icon: d(Je),
                  tabindex: "-1",
                  onClick: o[0] || (o[0] = (r) => a("clearValue"))
                }, null, 8, ["icon"])) : $("", !0)
              ]),
              _: 1
            }),
            e.loading ? (p(), x("div", Qi, [
              A(d(Q), {
                tabindex: "-1",
                class: "animate-spin text-gp-rhino",
                icon: d(ll)
              }, null, 8, ["icon"])
            ])) : $("", !0)
          ]),
          w(i.$slots, "toggle-icon", {}, () => [
            e.loading ? $("", !0) : (p(), D(st, {
              key: 0,
              tabindex: "-1",
              onClick: ke(l, ["stop"])
            }, {
              default: T(() => [
                A(d(Q), {
                  class: I(["text-gp-rhino transition-transform", { "rotate-180": !e.isOpened, "rotate-0": e.isOpened }]),
                  icon: d(lt)
                }, null, 8, ["class", "icon"])
              ]),
              _: 1
            }))
          ])
        ], 64))
      ])
    ], 2));
  }
}), Xi = ["id", "tabindex", "aria-labelledby", "aria-label", "aria-controls", "name", "placeholder"], Il = /* @__PURE__ */ E({
  __name: "GpDropdownFilterInput",
  props: /* @__PURE__ */ he({
    componentId: { default: "" },
    disabled: { type: Boolean, default: !1 },
    tabindex: { default: 0 },
    label: { default: "" },
    name: { default: "" },
    ariaLabelledby: { default: "" },
    ariaLabel: { default: "" },
    placeholder: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const n = De(e, "modelValue"), a = O(null);
    return t({ focus: () => {
      a.value && a.value.focus();
    } }), (s, i) => ft((p(), x("input", {
      id: e.componentId,
      ref_key: "filterInput",
      ref: a,
      "onUpdate:modelValue": i[0] || (i[0] = (o) => n.value = o),
      type: "text",
      class: "-z-1 w-full min-w-0 flex-1 bg-transparent px-0 py-1 leading-snug outline-hidden",
      tabindex: e.disabled ? -1 : e.tabindex,
      role: "combobox",
      "aria-labelledby": s.$attrs.ariaLabelledby,
      "aria-label": s.$attrs.ariaLabel || (e.label === "p-emptylabel" ? void 0 : e.label),
      "aria-expanded": !0,
      "aria-controls": `${e.componentId}_list`,
      name: e.name == null || e.name.length === 0 ? e.componentId : e.name,
      placeholder: e.placeholder,
      autocomplete: "off"
    }, null, 8, Xi)), [
      [Cs, n.value]
    ]);
  }
}), Zi = ["id", "aria-labelledby", "aria-label", "aria-expanded", "aria-controls"], Ji = /* @__PURE__ */ E({
  __name: "GpDropdownValueContainer",
  props: {
    componentId: {},
    disabled: { type: Boolean, default: !1 },
    tabindex: { default: 0 },
    label: { default: "" },
    loading: { type: Boolean, default: !1 },
    isOpened: { type: Boolean, default: !1 },
    valueContainerText: { default: "" }
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, l) => (p(), x("span", {
      id: e.componentId,
      class: I(["flex-1 items-center truncate py-1 leading-snug focus:outline-hidden", {
        "pointer-events-none": e.disabled || e.loading
      }]),
      role: "combobox",
      tabindex: 0,
      "aria-labelledby": a.$attrs.ariaLabelledby,
      "aria-label": a.$attrs.ariaLabel || (e.label === "p-emptylabel" ? void 0 : e.label),
      "aria-expanded": e.isOpened,
      "aria-controls": `${e.componentId}_list`,
      onClick: l[0] || (l[0] = (s) => n("open")),
      onFocus: l[1] || (l[1] = (s) => n("open"))
    }, [
      w(a.$slots, "default", {}, () => [
        ne(G(e.valueContainerText), 1)
      ])
    ], 42, Zi));
  }
}), _i = /* @__PURE__ */ E({
  __name: "GpDropdownSingleValue",
  props: /* @__PURE__ */ he({
    isOpened: { type: Boolean },
    filter: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    componentId: { default: "" },
    inputId: {},
    name: { default: "" },
    tabindex: { default: 0 },
    label: { default: "" },
    loading: { type: Boolean, default: !1 },
    valueContainerText: { default: "" }
  }, {
    filterQuery: {},
    filterQueryModifiers: {}
  }),
  emits: /* @__PURE__ */ he(["open"], ["update:filterQuery"]),
  setup(e, { emit: t }) {
    const n = De(e, "filterQuery"), a = e, l = t, s = O();
    return be(async () => {
      a.isOpened && (await Ne(), s.value && s.value.focus());
    }), (i, o) => e.filter && e.isOpened && !e.disabled ? (p(), D(Il, {
      key: 0,
      ref_key: "filterInput",
      ref: s,
      "model-value": n.value,
      "component-id": e.componentId,
      "input-id": e.inputId,
      disabled: e.disabled,
      tabindex: e.tabindex,
      label: e.label,
      name: e.name,
      placeholder: e.valueContainerText || e.placeholder,
      "onUpdate:modelValue": o[0] || (o[0] = (r) => n.value = r)
    }, null, 8, ["model-value", "component-id", "input-id", "disabled", "tabindex", "label", "name", "placeholder"])) : (p(), D(Ji, {
      key: 1,
      "component-id": e.componentId,
      disabled: e.disabled,
      tabindex: e.tabindex,
      label: e.label,
      loading: e.loading,
      "is-opened": e.isOpened,
      "value-container-text": e.valueContainerText,
      onOpen: o[1] || (o[1] = (r) => l("open"))
    }, {
      default: T(() => [
        w(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["component-id", "disabled", "tabindex", "label", "loading", "is-opened", "value-container-text"]));
  }
}), yn = Symbol("GetItemLabelKey"), eo = (e) => ({ disabledClasses: k(() => ({
  /* tw */
  "opacity-70": e.disabled
})) }), to = ["aria-selected"], no = /* @__PURE__ */ E({
  __name: "GpDropdownItem",
  props: {
    item: {},
    labelKey: { default: "label" },
    isSelected: { type: Boolean, default: !1 },
    isFocused: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["itemSelected"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = z(n, "item"), s = fe(yn), i = () => {
      a("itemSelected", l.value);
    }, { disabledClasses: o } = eo(n), r = z(() => n.item);
    return (u, c) => (p(), x("div", {
      class: I(["px-4 py-1 transition-colors", {
        ...d(o),
        "cursor-pointer hover:bg-gp-dark-mouse-light": !e.disabled,
        "bg-gp-dark-mouse-light": e.isFocused,
        "bg-gp-dark-mouse": e.isSelected
      }]),
      "data-gp-element": "gp-dropdown-item",
      role: "option",
      "aria-selected": e.isSelected,
      onClick: ke(i, ["stop"])
    }, [
      w(u.$slots, "itemContent", {
        item: r.value,
        isSelected: e.isSelected,
        disabled: e.disabled
      }, () => [
        ne(G(d(s)(r.value)), 1)
      ])
    ], 10, to));
  }
}), Ml = (e, t, n) => e[t] != null ? e[t].toString() : `${e}__${n}`, it = {
  primary: (
    /* tw */
    "hover:bg-gp-cyan-light"
  ),
  flat: (
    /* tw */
    "hover:bg-gp-charcoal-grey-light"
  ),
  neutral: (
    /* tw */
    "hover:bg-gp-mouse-light"
  ),
  danger: (
    /* tw */
    "hover:bg-gp-fire-light"
  ),
  success: (
    /* tw */
    "hover:bg-gp-green-light"
  ),
  warning: (
    /* tw */
    "hover:bg-gp-orange-light"
  ),
  info: (
    /* tw */
    "hover:bg-gp-ocean-light"
  ),
  transparent: (
    /* tw */
    "hover:bg-transparent"
  )
}, Xt = {
  neutral: (
    /* tw */
    "bg-gp-mouse text-gp-black!"
  ),
  primary: (
    /* tw */
    "bg-gp-cyan text-gp-black!"
  ),
  flat: (
    /* tw */
    "bg-gp-charcoal-grey text-gp-mouse!"
  ),
  danger: (
    /* tw */
    "bg-gp-fire text-gp-mouse!"
  ),
  success: (
    /* tw */
    "bg-gp-green text-gp-black!"
  ),
  warning: (
    /* tw */
    "bg-gp-orange text-gp-black!"
  ),
  // info need white text to increase contrast
  info: (
    /* tw */
    "bg-gp-ocean text-white!"
  ),
  transparent: (
    /* tw */
    "bg-transparent"
  )
}, Pt = (e) => k(() => Xt[e.value]), Zt = {
  primary: (
    /* tw */
    "border-gp-cyan text-gp-cyan"
  ),
  neutral: (
    /* tw */
    "border-gp-mouse text-gp-mouse"
  ),
  danger: (
    /* tw */
    "border-gp-fire text-gp-fire"
  ),
  success: (
    /* tw */
    "border-gp-green text-gp-green"
  ),
  warning: (
    /* tw */
    "border-gp-orange text-gp-orange"
  ),
  info: (
    /* tw */
    "border-gp-ocean text-gp-ocean"
  )
}, El = (e) => k(() => Zt[e.value]), ao = {
  default: (
    /* tw */
    "text-gp-mouse"
  ),
  primary: (
    /* tw */
    "text-gp-cyan"
  ),
  danger: (
    /* tw */
    "text-gp-crab"
  ),
  warning: (
    /* tw */
    "text-gp-orange"
  ),
  success: (
    /* tw */
    "text-gp-green"
  ),
  info: (
    /* tw */
    "text-gp-ocean"
  )
}, lo = (e, t) => {
  const n = z(e, "tagType"), a = (
    /* tw */
    "inline-block font-bold rounded"
  ), l = k(() => t.value ? "" : ["lg", "large"].includes(e.size) ? (
    /* tw */
    "px-4"
  ) : ["xs", "extra-small"].includes(e.size) ? (
    /* tw */
    "px-1"
  ) : (
    /* tw */
    "px-2"
  )), s = k(() => ["lg", "large"].includes(e.size) ? t.value ? (
    /* tw */
    "h-component-lg w-component-lg text-center leading-[3.125rem]"
  ) : (
    /* tw */
    " py-3 min-h-component-lg"
  ) : ["xs", "extra-small"].includes(e.size) ? t.value ? (
    /* tw */
    "text-center leading-relaxed text-xs h-[1.25rem] w-[1.25rem]"
  ) : (
    /* tw */
    "text-xs leading-normal"
  ) : t.value ? (
    /* tw */
    "h-component-base w-component-base text-center leading-[1.875rem]"
  ) : (
    /* tw */
    "py-1 min-h-component-base leading-tight"
  )), i = k(() => [
    /* tw */
    "bg-gp-charcoal-grey",
    ao[n.value]
  ].join(
    " "
  )), o = Pt(n), r = k(() => e.flat ? it.flat : it[e.tagType]), u = k(() => /* tw */ "border box-border".concat(
    " ",
    /* tw */
    Zt[e.tagType]
  ));
  return k(() => {
    const f = [a, s.value, l.value];
    return e.outline ? f.push(u.value) : e.flat ? f.push(i.value) : f.push(o.value), e.hover && (f.push("transition-colors"), f.push(r.value)), f;
  });
}, bn = (e) => {
  const t = k(
    () => e.label != null && e.label.length > 0
  ), n = k(() => !t.value && e.icon != null);
  return {
    hasLabel: t,
    hasIconOnly: n
  };
}, En = /* @__PURE__ */ E({
  __name: "GpTag",
  props: {
    tagType: { default: "neutral" },
    size: { default: "sm" },
    hover: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !1 },
    icon: { default: null },
    label: { default: void 0 }
  },
  setup(e) {
    const t = e, { hasLabel: n } = bn(t), a = k(() => !n.value && t.icon != null), l = lo(t, a), s = k(() => a.value ? "" : ["lg", "large"].includes(t.size) ? "mr-2" : "mr-1");
    return (i, o) => (p(), x("span", {
      class: I(d(l))
    }, [
      w(i.$slots, "default", {}, () => [
        e.icon != null ? (p(), D(d(Q), {
          key: 0,
          icon: e.icon,
          class: I(s.value)
        }, null, 8, ["icon", "class"])) : $("", !0),
        ne(" " + G(e.label), 1)
      ])
    ], 2));
  }
}), Al = /* @__PURE__ */ E({
  __name: "GpDropdownTagContainer",
  props: {
    isOpened: { type: Boolean },
    modelValue: {},
    valueKey: {},
    wrap: { type: Boolean, default: !1 },
    filter: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    nullable: { type: Boolean, default: !1 }
  },
  emits: ["clearItem"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = z(() => n.valueKey), s = fe(yn), i = k(() => n.disabled ? !1 : n.nullable ? !0 : n.modelValue.length > 1), o = O(null), r = O(), u = O(!1);
    be(async () => {
      if (n.wrap) {
        u.value = !1;
        return;
      }
      if (n.isOpened && !u.value) {
        await Ne();
        const g = Array.from(o.value.children).reduce((v, y) => y instanceof HTMLElement ? v + y.clientWidth : v, 0) > o.value.offsetWidth;
        u.value = g;
      } else n.isOpened || (u.value = !1);
    });
    const c = O(-1);
    be(async () => {
      if (
        // skip if modelValue is empty
        n.modelValue == null || // skip if wrap is enabled
        n.wrap || // skip, if filtering is enabled and the dropdown is opened, then we use the overflow
        // behaviour from above
        n.filter && n.isOpened
      ) {
        c.value = -1;
        return;
      }
      await Ne();
      let h = 0;
      c.value = Array.from(o.value.children).findIndex(
        (g) => g instanceof HTMLElement && (h += g.clientWidth, h > o.value.offsetWidth)
      ), c.value === n.modelValue.length && (c.value = -1);
    });
    const f = k(() => c.value === -1 ? n.modelValue : n.modelValue.slice(0, c.value)), m = (h) => {
      a("clearItem", h);
    };
    return (h, g) => (p(), x("div", {
      ref_key: "tagContainer",
      ref: o,
      class: I(["flex items-center gap-1", {
        "flex-wrap": e.wrap
      }])
    }, [
      e.filter && u.value ? (p(), D(En, {
        key: 0,
        class: "text-nowrap",
        label: `+ ${e.modelValue.length.toString()}`,
        size: "xs",
        rounded: "",
        "tag-type": "neutral"
      }, null, 8, ["label"])) : $("", !0),
      w(h.$slots, "prepend"),
      w(h.$slots, "value", {}, () => [
        u.value ? $("", !0) : (p(!0), x(X, { key: 0 }, ce(f.value, (v, y) => w(h.$slots, "valueItem", {
          key: d(Ml)(v, l.value, y),
          item: v,
          index: y,
          handleClearItem: () => m(v)
        }, () => [
          A(En, {
            ref_for: !0,
            ref_key: "tags",
            ref: r,
            class: I(["text-nowrap", {
              "cursor-pointer": i.value
            }]),
            size: "xs",
            "tag-type": "neutral",
            hover: "",
            "data-testid": "tag",
            onClick: ke((b) => m(v), ["stop"])
          }, {
            default: T(() => [
              w(h.$slots, "valueItemContent", {
                item: v,
                index: y
              }, () => [
                ne(G(d(s)(v)), 1)
              ]),
              i.value ? (p(), D(d(Q), {
                key: 0,
                class: "ml-1",
                icon: d(Je)
              }, null, 8, ["icon"])) : $("", !0)
            ]),
            _: 2
          }, 1032, ["class", "onClick"])
        ])), 128))
      ]),
      c.value !== -1 && (!e.isOpened && e.filter || !e.filter) ? (p(), D(En, {
        key: 1,
        class: "text-nowrap",
        label: `+ ${e.modelValue.length - c.value}`,
        size: "xs",
        rounded: "",
        "tag-type": "neutral"
      }, null, 8, ["label"])) : $("", !0),
      w(h.$slots, "append")
    ], 2));
  }
}), so = (e, t, n) => {
  const a = (i) => {
    if (e.value == null) return !1;
    const o = e.value;
    return typeof i == "object" ? o.some(
      (r) => r[n.value] === i[n.value]
    ) : o.includes(i);
  }, l = (i) => e.value == null ? !1 : typeof i == "object" ? e.value[n.value] === i[n.value] : e.value === i;
  return (i) => e.value == null ? !1 : t.value ? a(i) : l(i);
}, io = (e, t, n, a) => {
  const l = k(() => n.value.length), s = (r) => {
    r.preventDefault(), t.value < l.value - 1 ? t.value += 1 : t.value === l.value - 1 && (t.value = l.value - 1);
  }, i = (r) => {
    r.preventDefault(), t.value > 0 ? t.value -= 1 : t.value === -1 && (t.value = 0);
  }, o = (r) => {
    r.key === "Enter" && t.value >= 0 && r.preventDefault(), a("select", n.value[t.value]);
  };
  Rt({
    passive: !0,
    onEventFired: (r) => {
      if (r.type !== "keydown")
        switch (r.code) {
          case "ArrowDown":
            s(r);
            break;
          case "ArrowUp":
            i(r);
            break;
          case "Enter":
          case "NumpadEnter":
            o(r);
            break;
        }
    }
  });
}, oo = {
  key: 1,
  class: "px-4 py-2"
}, ro = {
  key: 2,
  class: "px-4 py-2"
}, Fl = /* @__PURE__ */ E({
  __name: "GpDropdownResultList",
  props: /* @__PURE__ */ he({
    modelValue: {},
    filterEmptyText: { default: "" },
    filteredItems: {},
    valueKey: {},
    labelKey: {},
    multiple: { default: () => !1 },
    isAsyncFiltering: { type: Boolean, default: !1 },
    asyncFilteringText: { default: "Filtering..." }
  }, {
    isOpened: { type: Boolean },
    isOpenedModifiers: {}
  }),
  emits: /* @__PURE__ */ he(["select", "clearItem"], ["update:isOpened"]),
  setup(e, { emit: t }) {
    const n = De(e, "isOpened"), a = e, l = t, s = z(() => a.filteredItems), i = z(() => a.labelKey), o = k(() => s.value.length === 0), r = O(null), u = O(null), { y: c } = vl(u, {}), f = O(), m = O(-1);
    be(async () => {
      if (s.value.length === 0 || u.value == null || m.value < 0)
        return;
      await Ne();
      const B = f.value[m.value];
      (B.offsetTop < c.value || B.offsetTop + B.clientHeight > c.value + u.value.clientHeight) && B.scrollIntoView({
        block: "nearest"
      });
    }), io(r, m, s, l);
    const h = z(() => a.modelValue), g = z(() => a.multiple), v = z(() => a.valueKey), y = so(
      h,
      g,
      v
    ), b = (B) => {
      l("clearItem", B);
    }, S = z(() => a.modelValue);
    return (B, M) => n.value ? (p(), x("div", {
      key: 0,
      ref_key: "resultsContainer",
      ref: r,
      class: "overflow-hidden rounded-b bg-gp-midnight-2 shadow-xs",
      "data-gp-element": "gp-dropdown__results-container"
    }, [
      g.value && S.value != null && S.value.length > 0 ? (p(), D(Al, {
        key: 0,
        class: "px-4 pb-2 pt-4",
        "is-opened": n.value,
        "model-value": S.value,
        "value-key": v.value,
        wrap: !0,
        disabled: !1,
        nullable: !1,
        onClearItem: b
      }, null, 8, ["is-opened", "model-value", "value-key"])) : $("", !0),
      o.value && !a.isAsyncFiltering ? (p(), x("div", oo, [
        w(B.$slots, "empty", {
          filterEmptyText: a.filterEmptyText
        }, () => [
          ne(G(a.filterEmptyText), 1)
        ])
      ])) : a.isAsyncFiltering ? (p(), x("div", ro, [
        w(B.$slots, "loading", {
          asyncFilteringText: a.asyncFilteringText
        }, () => [
          A(d(Q), {
            icon: d(ll),
            class: "mr-2 animate-spin"
          }, null, 8, ["icon"]),
          ne(" " + G(a.asyncFilteringText), 1)
        ])
      ])) : (p(), x("ul", {
        key: 3,
        ref_key: "resultsList",
        ref: u,
        class: "relative left-0 m-0 max-h-40 overflow-y-auto px-0",
        tabindex: "-1"
      }, [
        (p(!0), x(X, null, ce(s.value, (P, V) => (p(), x("li", {
          ref_for: !0,
          ref_key: "dropdownItems",
          ref: f,
          key: d(Ml)(P, v.value, V)
        }, [
          A(no, {
            item: P,
            "label-key": i.value,
            "is-selected": d(y)(P),
            "is-focused": V === m.value,
            onItemSelected: (C) => l("select", P)
          }, {
            itemContent: T(({ item: C, isSelected: R, disabled: F }) => [
              w(B.$slots, "itemContent", {
                item: C,
                isSelected: R,
                disabled: F
              })
            ]),
            _: 3
          }, 8, ["item", "label-key", "is-selected", "is-focused", "onItemSelected"])
        ]))), 128))
      ], 512))
    ], 512)) : $("", !0);
  }
}), Ol = (e, t, n = null) => (l) => {
  if (l == null || d(l) == null) return "";
  if (d(n) != null)
    return d(n).call(null, l);
  const s = d(l);
  return d(e) != null && typeof s == "object" ? s[d(e)] || s[d(t)] || "" : l.toString();
}, $l = (e, t, n, a, l, s, i, o) => {
  const r = Ol(a, n, o), u = O(!1), c = O(e.value), f = () => e.value.filter(
    (y) => y === t.value || y[n.value] === t.value || r(y).toLocaleLowerCase().startsWith(t.value)
  ), m = async () => {
    if (!l.value) {
      c.value = e.value;
      return;
    }
    const y = d(s);
    if (y != null) {
      c.value = y(
        e.value,
        t.value
      );
      return;
    }
    const b = d(i);
    if (b != null) {
      u.value = !0;
      try {
        c.value = await b(
          e.value,
          t.value
        );
      } catch {
      } finally {
        u.value = !1;
      }
      return;
    }
    c.value = f();
  }, h = (y) => {
    l.value || (y == null ? t.value = "" : t.value = r(y));
  }, g = async () => {
    await m();
  }, v = k(() => c.value.length === 0);
  return H(
    () => e.value,
    () => {
      m();
    }
  ), si(
    () => t.value,
    () => {
      m();
    },
    {
      debounce: 50
    }
  ), {
    filteredItems: c,
    isResultsEmpty: v,
    onSearchInput: g,
    filterItemsByQuery: m,
    defaultFilterFn: f,
    setFilterQuery: h,
    isAsyncFiltering: u
  };
}, Jt = Math.min, at = Math.max, _t = Math.round, Wt = Math.floor, Oe = (e) => ({
  x: e,
  y: e
}), uo = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ba(e, t, n) {
  return at(e, Jt(t, n));
}
function kn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ot(e) {
  return e.split("-")[0];
}
function wn(e) {
  return e.split("-")[1];
}
function Ll(e) {
  return e === "x" ? "y" : "x";
}
function Vl(e) {
  return e === "y" ? "height" : "width";
}
function qe(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Rl(e) {
  return Ll(qe(e));
}
function co(e, t, n) {
  n === void 0 && (n = !1);
  const a = wn(e), l = Rl(e), s = Vl(l);
  let i = l === "x" ? a === (n ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = en(i)), [i, en(i)];
}
function fo(e) {
  const t = en(e);
  return [zn(e), t, zn(t)];
}
function zn(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Da = ["left", "right"], Ia = ["right", "left"], ho = ["top", "bottom"], mo = ["bottom", "top"];
function po(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Ia : Da : t ? Da : Ia;
    case "left":
    case "right":
      return t ? ho : mo;
    default:
      return [];
  }
}
function go(e, t, n, a) {
  const l = wn(e);
  let s = po(ot(e), n === "start", a);
  return l && (s = s.map((i) => i + "-" + l), t && (s = s.concat(s.map(zn)))), s;
}
function en(e) {
  const t = ot(e);
  return uo[t] + e.slice(t.length);
}
function vo(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function yo(e) {
  return typeof e != "number" ? vo(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function tn(e) {
  const {
    x: t,
    y: n,
    width: a,
    height: l
  } = e;
  return {
    width: a,
    height: l,
    top: n,
    left: t,
    right: t + a,
    bottom: n + l,
    x: t,
    y: n
  };
}
function Ma(e, t, n) {
  let {
    reference: a,
    floating: l
  } = e;
  const s = qe(t), i = Rl(t), o = Vl(i), r = ot(t), u = s === "y", c = a.x + a.width / 2 - l.width / 2, f = a.y + a.height / 2 - l.height / 2, m = a[o] / 2 - l[o] / 2;
  let h;
  switch (r) {
    case "top":
      h = {
        x: c,
        y: a.y - l.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: a.y + a.height
      };
      break;
    case "right":
      h = {
        x: a.x + a.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: a.x - l.width,
        y: f
      };
      break;
    default:
      h = {
        x: a.x,
        y: a.y
      };
  }
  switch (wn(t)) {
    case "start":
      h[i] -= m * (n && u ? -1 : 1);
      break;
    case "end":
      h[i] += m * (n && u ? -1 : 1);
      break;
  }
  return h;
}
async function bo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: a,
    y: l,
    platform: s,
    rects: i,
    elements: o,
    strategy: r
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = kn(t, e), g = yo(h), y = o[m ? f === "floating" ? "reference" : "floating" : f], b = tn(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(y))) == null || n ? y : y.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: r
  })), S = f === "floating" ? {
    x: a,
    y: l,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, B = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), M = await (s.isElement == null ? void 0 : s.isElement(B)) ? await (s.getScale == null ? void 0 : s.getScale(B)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = tn(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: S,
    offsetParent: B,
    strategy: r
  }) : S);
  return {
    top: (b.top - P.top + g.top) / M.y,
    bottom: (P.bottom - b.bottom + g.bottom) / M.y,
    left: (b.left - P.left + g.left) / M.x,
    right: (P.right - b.right + g.right) / M.x
  };
}
const ko = 50, wo = async (e, t, n) => {
  const {
    placement: a = "bottom",
    strategy: l = "absolute",
    middleware: s = [],
    platform: i
  } = n, o = i.detectOverflow ? i : {
    ...i,
    detectOverflow: bo
  }, r = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: l
  }), {
    x: c,
    y: f
  } = Ma(u, a, r), m = a, h = 0;
  const g = {};
  for (let v = 0; v < s.length; v++) {
    const y = s[v];
    if (!y)
      continue;
    const {
      name: b,
      fn: S
    } = y, {
      x: B,
      y: M,
      data: P,
      reset: V
    } = await S({
      x: c,
      y: f,
      initialPlacement: a,
      placement: m,
      strategy: l,
      middlewareData: g,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = B ?? c, f = M ?? f, g[b] = {
      ...g[b],
      ...P
    }, V && h < ko && (h++, typeof V == "object" && (V.placement && (m = V.placement), V.rects && (u = V.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: l
    }) : V.rects), {
      x: c,
      y: f
    } = Ma(u, m, r)), v = -1);
  }
  return {
    x: c,
    y: f,
    placement: m,
    strategy: l,
    middlewareData: g
  };
}, xo = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, a;
      const {
        placement: l,
        middlewareData: s,
        rects: i,
        initialPlacement: o,
        platform: r,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...y
      } = kn(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const b = ot(l), S = qe(o), B = ot(o) === o, M = await (r.isRTL == null ? void 0 : r.isRTL(u.floating)), P = m || (B || !v ? [en(o)] : fo(o)), V = g !== "none";
      !m && V && P.push(...go(o, v, g, M));
      const C = [o, ...P], R = await r.detectOverflow(t, y), F = [];
      let N = ((a = s.flip) == null ? void 0 : a.overflows) || [];
      if (c && F.push(R[b]), f) {
        const U = co(l, i, M);
        F.push(R[U[0]], R[U[1]]);
      }
      if (N = [...N, {
        placement: l,
        overflows: F
      }], !F.every((U) => U <= 0)) {
        var ee, _;
        const U = (((ee = s.flip) == null ? void 0 : ee.index) || 0) + 1, q = C[U];
        if (q && (!(f === "alignment" ? S !== qe(q) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        N.every((ue) => qe(ue.placement) === S ? ue.overflows[0] > 0 : !0)))
          return {
            data: {
              index: U,
              overflows: N
            },
            reset: {
              placement: q
            }
          };
        let te = (_ = N.filter((ie) => ie.overflows[0] <= 0).sort((ie, ue) => ie.overflows[1] - ue.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!te)
          switch (h) {
            case "bestFit": {
              var Z;
              const ie = (Z = N.filter((ue) => {
                if (V) {
                  const Ce = qe(ue.placement);
                  return Ce === S || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Ce === "y";
                }
                return !0;
              }).map((ue) => [ue.placement, ue.overflows.filter((Ce) => Ce > 0).reduce((Ce, xs) => Ce + xs, 0)]).sort((ue, Ce) => ue[1] - Ce[1])[0]) == null ? void 0 : Z[0];
              ie && (te = ie);
              break;
            }
            case "initialPlacement":
              te = o;
              break;
          }
        if (l !== te)
          return {
            reset: {
              placement: te
            }
          };
      }
      return {};
    }
  };
}, Co = /* @__PURE__ */ new Set(["left", "top"]);
async function To(e, t) {
  const {
    placement: n,
    platform: a,
    elements: l
  } = e, s = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), i = ot(n), o = wn(n), r = qe(n) === "y", u = Co.has(i) ? -1 : 1, c = s && r ? -1 : 1, f = kn(t, e);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return o && typeof g == "number" && (h = o === "end" ? g * -1 : g), r ? {
    x: h * c,
    y: m * u
  } : {
    x: m * u,
    y: h * c
  };
}
const So = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, a;
      const {
        x: l,
        y: s,
        placement: i,
        middlewareData: o
      } = t, r = await To(t, e);
      return i === ((n = o.offset) == null ? void 0 : n.placement) && (a = o.arrow) != null && a.alignmentOffset ? {} : {
        x: l + r.x,
        y: s + r.y,
        data: {
          ...r,
          placement: i
        }
      };
    }
  };
}, Bo = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: a,
        placement: l,
        platform: s
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: r = {
          fn: (b) => {
            let {
              x: S,
              y: B
            } = b;
            return {
              x: S,
              y: B
            };
          }
        },
        ...u
      } = kn(e, t), c = {
        x: n,
        y: a
      }, f = await s.detectOverflow(t, u), m = qe(ot(l)), h = Ll(m);
      let g = c[h], v = c[m];
      if (i) {
        const b = h === "y" ? "top" : "left", S = h === "y" ? "bottom" : "right", B = g + f[b], M = g - f[S];
        g = Ba(B, g, M);
      }
      if (o) {
        const b = m === "y" ? "top" : "left", S = m === "y" ? "bottom" : "right", B = v + f[b], M = v - f[S];
        v = Ba(B, v, M);
      }
      const y = r.fn({
        ...t,
        [h]: g,
        [m]: v
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - a,
          enabled: {
            [h]: i,
            [m]: o
          }
        }
      };
    }
  };
};
function xn() {
  return typeof window < "u";
}
function mt(e) {
  return na(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Be(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pe(e) {
  var t;
  return (t = (na(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function na(e) {
  return xn() ? e instanceof Node || e instanceof Be(e).Node : !1;
}
function Me(e) {
  return xn() ? e instanceof Element || e instanceof Be(e).Element : !1;
}
function He(e) {
  return xn() ? e instanceof HTMLElement || e instanceof Be(e).HTMLElement : !1;
}
function Ea(e) {
  return !xn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Be(e).ShadowRoot;
}
function Gt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: a,
    display: l
  } = Ee(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + n) && l !== "inline" && l !== "contents";
}
function Do(e) {
  return /^(table|td|th)$/.test(mt(e));
}
function Cn(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Io = /transform|translate|scale|rotate|perspective|filter/, Mo = /paint|layout|strict|content/, et = (e) => !!e && e !== "none";
let An;
function aa(e) {
  const t = Me(e) ? Ee(e) : e;
  return et(t.transform) || et(t.translate) || et(t.scale) || et(t.rotate) || et(t.perspective) || !la() && (et(t.backdropFilter) || et(t.filter)) || Io.test(t.willChange || "") || Mo.test(t.contain || "");
}
function Eo(e) {
  let t = Qe(e);
  for (; He(t) && !wt(t); ) {
    if (aa(t))
      return t;
    if (Cn(t))
      return null;
    t = Qe(t);
  }
  return null;
}
function la() {
  return An == null && (An = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), An;
}
function wt(e) {
  return /^(html|body|#document)$/.test(mt(e));
}
function Ee(e) {
  return Be(e).getComputedStyle(e);
}
function Tn(e) {
  return Me(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Qe(e) {
  if (mt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ea(e) && e.host || // Fallback.
    Pe(e)
  );
  return Ea(t) ? t.host : t;
}
function Pl(e) {
  const t = Qe(e);
  return wt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : He(t) && Gt(t) ? t : Pl(t);
}
function Ft(e, t, n) {
  var a;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const l = Pl(e), s = l === ((a = e.ownerDocument) == null ? void 0 : a.body), i = Be(l);
  if (s) {
    const o = Yn(i);
    return t.concat(i, i.visualViewport || [], Gt(l) ? l : [], o && n ? Ft(o) : []);
  } else
    return t.concat(l, Ft(l, [], n));
}
function Yn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Gl(e) {
  const t = Ee(e);
  let n = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const l = He(e), s = l ? e.offsetWidth : n, i = l ? e.offsetHeight : a, o = _t(n) !== s || _t(a) !== i;
  return o && (n = s, a = i), {
    width: n,
    height: a,
    $: o
  };
}
function sa(e) {
  return Me(e) ? e : e.contextElement;
}
function kt(e) {
  const t = sa(e);
  if (!He(t))
    return Oe(1);
  const n = t.getBoundingClientRect(), {
    width: a,
    height: l,
    $: s
  } = Gl(t);
  let i = (s ? _t(n.width) : n.width) / a, o = (s ? _t(n.height) : n.height) / l;
  return (!i || !Number.isFinite(i)) && (i = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: i,
    y: o
  };
}
const Ao = /* @__PURE__ */ Oe(0);
function Nl(e) {
  const t = Be(e);
  return !la() || !t.visualViewport ? Ao : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Fo(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Be(e) ? !1 : t;
}
function rt(e, t, n, a) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const l = e.getBoundingClientRect(), s = sa(e);
  let i = Oe(1);
  t && (a ? Me(a) && (i = kt(a)) : i = kt(e));
  const o = Fo(s, n, a) ? Nl(s) : Oe(0);
  let r = (l.left + o.x) / i.x, u = (l.top + o.y) / i.y, c = l.width / i.x, f = l.height / i.y;
  if (s) {
    const m = Be(s), h = a && Me(a) ? Be(a) : a;
    let g = m, v = Yn(g);
    for (; v && a && h !== g; ) {
      const y = kt(v), b = v.getBoundingClientRect(), S = Ee(v), B = b.left + (v.clientLeft + parseFloat(S.paddingLeft)) * y.x, M = b.top + (v.clientTop + parseFloat(S.paddingTop)) * y.y;
      r *= y.x, u *= y.y, c *= y.x, f *= y.y, r += B, u += M, g = Be(v), v = Yn(g);
    }
  }
  return tn({
    width: c,
    height: f,
    x: r,
    y: u
  });
}
function Sn(e, t) {
  const n = Tn(e).scrollLeft;
  return t ? t.left + n : rt(Pe(e)).left + n;
}
function zl(e, t) {
  const n = e.getBoundingClientRect(), a = n.left + t.scrollLeft - Sn(e, n), l = n.top + t.scrollTop;
  return {
    x: a,
    y: l
  };
}
function Oo(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: a,
    strategy: l
  } = e;
  const s = l === "fixed", i = Pe(a), o = t ? Cn(t.floating) : !1;
  if (a === i || o && s)
    return n;
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Oe(1);
  const c = Oe(0), f = He(a);
  if ((f || !f && !s) && ((mt(a) !== "body" || Gt(i)) && (r = Tn(a)), f)) {
    const h = rt(a);
    u = kt(a), c.x = h.x + a.clientLeft, c.y = h.y + a.clientTop;
  }
  const m = i && !f && !s ? zl(i, r) : Oe(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - r.scrollLeft * u.x + c.x + m.x,
    y: n.y * u.y - r.scrollTop * u.y + c.y + m.y
  };
}
function $o(e) {
  return Array.from(e.getClientRects());
}
function Lo(e) {
  const t = Pe(e), n = Tn(e), a = e.ownerDocument.body, l = at(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), s = at(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let i = -n.scrollLeft + Sn(e);
  const o = -n.scrollTop;
  return Ee(a).direction === "rtl" && (i += at(t.clientWidth, a.clientWidth) - l), {
    width: l,
    height: s,
    x: i,
    y: o
  };
}
const Aa = 25;
function Vo(e, t) {
  const n = Be(e), a = Pe(e), l = n.visualViewport;
  let s = a.clientWidth, i = a.clientHeight, o = 0, r = 0;
  if (l) {
    s = l.width, i = l.height;
    const c = la();
    (!c || c && t === "fixed") && (o = l.offsetLeft, r = l.offsetTop);
  }
  const u = Sn(a);
  if (u <= 0) {
    const c = a.ownerDocument, f = c.body, m = getComputedStyle(f), h = c.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, g = Math.abs(a.clientWidth - f.clientWidth - h);
    g <= Aa && (s -= g);
  } else u <= Aa && (s += u);
  return {
    width: s,
    height: i,
    x: o,
    y: r
  };
}
function Ro(e, t) {
  const n = rt(e, !0, t === "fixed"), a = n.top + e.clientTop, l = n.left + e.clientLeft, s = He(e) ? kt(e) : Oe(1), i = e.clientWidth * s.x, o = e.clientHeight * s.y, r = l * s.x, u = a * s.y;
  return {
    width: i,
    height: o,
    x: r,
    y: u
  };
}
function Fa(e, t, n) {
  let a;
  if (t === "viewport")
    a = Vo(e, n);
  else if (t === "document")
    a = Lo(Pe(e));
  else if (Me(t))
    a = Ro(t, n);
  else {
    const l = Nl(e);
    a = {
      x: t.x - l.x,
      y: t.y - l.y,
      width: t.width,
      height: t.height
    };
  }
  return tn(a);
}
function Yl(e, t) {
  const n = Qe(e);
  return n === t || !Me(n) || wt(n) ? !1 : Ee(n).position === "fixed" || Yl(n, t);
}
function Po(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let a = Ft(e, [], !1).filter((o) => Me(o) && mt(o) !== "body"), l = null;
  const s = Ee(e).position === "fixed";
  let i = s ? Qe(e) : e;
  for (; Me(i) && !wt(i); ) {
    const o = Ee(i), r = aa(i);
    !r && o.position === "fixed" && (l = null), (s ? !r && !l : !r && o.position === "static" && !!l && (l.position === "absolute" || l.position === "fixed") || Gt(i) && !r && Yl(e, i)) ? a = a.filter((c) => c !== i) : l = o, i = Qe(i);
  }
  return t.set(e, a), a;
}
function Go(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: a,
    strategy: l
  } = e;
  const i = [...n === "clippingAncestors" ? Cn(t) ? [] : Po(t, this._c) : [].concat(n), a], o = Fa(t, i[0], l);
  let r = o.top, u = o.right, c = o.bottom, f = o.left;
  for (let m = 1; m < i.length; m++) {
    const h = Fa(t, i[m], l);
    r = at(h.top, r), u = Jt(h.right, u), c = Jt(h.bottom, c), f = at(h.left, f);
  }
  return {
    width: u - f,
    height: c - r,
    x: f,
    y: r
  };
}
function No(e) {
  const {
    width: t,
    height: n
  } = Gl(e);
  return {
    width: t,
    height: n
  };
}
function zo(e, t, n) {
  const a = He(t), l = Pe(t), s = n === "fixed", i = rt(e, !0, s, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const r = Oe(0);
  function u() {
    r.x = Sn(l);
  }
  if (a || !a && !s)
    if ((mt(t) !== "body" || Gt(l)) && (o = Tn(t)), a) {
      const h = rt(t, !0, s, t);
      r.x = h.x + t.clientLeft, r.y = h.y + t.clientTop;
    } else l && u();
  s && !a && l && u();
  const c = l && !a && !s ? zl(l, o) : Oe(0), f = i.left + o.scrollLeft - r.x - c.x, m = i.top + o.scrollTop - r.y - c.y;
  return {
    x: f,
    y: m,
    width: i.width,
    height: i.height
  };
}
function Fn(e) {
  return Ee(e).position === "static";
}
function Oa(e, t) {
  if (!He(e) || Ee(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Pe(e) === n && (n = n.ownerDocument.body), n;
}
function Wl(e, t) {
  const n = Be(e);
  if (Cn(e))
    return n;
  if (!He(e)) {
    let l = Qe(e);
    for (; l && !wt(l); ) {
      if (Me(l) && !Fn(l))
        return l;
      l = Qe(l);
    }
    return n;
  }
  let a = Oa(e, t);
  for (; a && Do(a) && Fn(a); )
    a = Oa(a, t);
  return a && wt(a) && Fn(a) && !aa(a) ? n : a || Eo(e) || n;
}
const Yo = async function(e) {
  const t = this.getOffsetParent || Wl, n = this.getDimensions, a = await n(e.floating);
  return {
    reference: zo(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function Wo(e) {
  return Ee(e).direction === "rtl";
}
const jo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Oo,
  getDocumentElement: Pe,
  getClippingRect: Go,
  getOffsetParent: Wl,
  getElementRects: Yo,
  getClientRects: $o,
  getDimensions: No,
  getScale: kt,
  isElement: Me,
  isRTL: Wo
};
function jl(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Ho(e, t) {
  let n = null, a;
  const l = Pe(e);
  function s() {
    var o;
    clearTimeout(a), (o = n) == null || o.disconnect(), n = null;
  }
  function i(o, r) {
    o === void 0 && (o = !1), r === void 0 && (r = 1), s();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: m,
      height: h
    } = u;
    if (o || t(), !m || !h)
      return;
    const g = Wt(f), v = Wt(l.clientWidth - (c + m)), y = Wt(l.clientHeight - (f + h)), b = Wt(c), B = {
      rootMargin: -g + "px " + -v + "px " + -y + "px " + -b + "px",
      threshold: at(0, Jt(1, r)) || 1
    };
    let M = !0;
    function P(V) {
      const C = V[0].intersectionRatio;
      if (C !== r) {
        if (!M)
          return i();
        C ? i(!1, C) : a = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !jl(u, e.getBoundingClientRect()) && i(), M = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...B,
        // Handle <iframe>s
        root: l.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, B);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function Uo(e, t, n, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: l = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: r = !1
  } = a, u = sa(e), c = l || s ? [...u ? Ft(u) : [], ...t ? Ft(t) : []] : [];
  c.forEach((b) => {
    l && b.addEventListener("scroll", n, {
      passive: !0
    }), s && b.addEventListener("resize", n);
  });
  const f = u && o ? Ho(u, n) : null;
  let m = -1, h = null;
  i && (h = new ResizeObserver((b) => {
    let [S] = b;
    S && S.target === u && h && t && (h.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var B;
      (B = h) == null || B.observe(t);
    })), n();
  }), u && !r && h.observe(u), t && h.observe(t));
  let g, v = r ? rt(e) : null;
  r && y();
  function y() {
    const b = rt(e);
    v && !jl(v, b) && n(), v = b, g = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    c.forEach((S) => {
      l && S.removeEventListener("scroll", n), s && S.removeEventListener("resize", n);
    }), f == null || f(), (b = h) == null || b.disconnect(), h = null, r && cancelAnimationFrame(g);
  };
}
const Hl = So, qo = Bo, Ul = xo, Ko = (e, t, n) => {
  const a = /* @__PURE__ */ new Map(), l = {
    platform: jo,
    ...n
  }, s = {
    ...l.platform,
    _c: a
  };
  return wo(e, t, {
    ...l,
    platform: s
  });
};
function Qo(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function $a(e) {
  if (Qo(e)) {
    const t = e.$el;
    return na(t) && mt(t) === "#comment" ? null : t;
  }
  return e;
}
function St(e) {
  return typeof e == "function" ? e() : d(e);
}
function ql(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function La(e, t) {
  const n = ql(e);
  return Math.round(t * n) / n;
}
function Kl(e, t, n) {
  n === void 0 && (n = {});
  const a = n.whileElementsMounted, l = k(() => {
    var C;
    return (C = St(n.open)) != null ? C : !0;
  }), s = k(() => St(n.middleware)), i = k(() => {
    var C;
    return (C = St(n.placement)) != null ? C : "bottom";
  }), o = k(() => {
    var C;
    return (C = St(n.strategy)) != null ? C : "absolute";
  }), r = k(() => {
    var C;
    return (C = St(n.transform)) != null ? C : !0;
  }), u = k(() => $a(e.value)), c = k(() => $a(t.value)), f = O(0), m = O(0), h = O(o.value), g = O(i.value), v = oe({}), y = O(!1), b = k(() => {
    const C = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return C;
    const R = La(c.value, f.value), F = La(c.value, m.value);
    return r.value ? {
      ...C,
      transform: "translate(" + R + "px, " + F + "px)",
      ...ql(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: R + "px",
      top: F + "px"
    };
  });
  let S;
  function B() {
    if (u.value == null || c.value == null)
      return;
    const C = l.value;
    Ko(u.value, c.value, {
      middleware: s.value,
      placement: i.value,
      strategy: o.value
    }).then((R) => {
      f.value = R.x, m.value = R.y, h.value = R.strategy, g.value = R.placement, v.value = R.middlewareData, y.value = C !== !1;
    });
  }
  function M() {
    typeof S == "function" && (S(), S = void 0);
  }
  function P() {
    if (M(), a === void 0) {
      B();
      return;
    }
    if (u.value != null && c.value != null) {
      S = a(u.value, c.value, B);
      return;
    }
  }
  function V() {
    l.value || (y.value = !1);
  }
  return H([s, i, o, l], B, {
    flush: "sync"
  }), H([u, c], P, {
    flush: "sync"
  }), H(l, V, {
    flush: "sync"
  }), _a() && el(M), {
    x: pt(f),
    y: pt(m),
    strategy: pt(h),
    placement: pt(g),
    middlewareData: pt(v),
    isPositioned: pt(y),
    floatingStyles: b,
    update: B
  };
}
const Xo = [
  /* tw */
  "z-(--gp-overlay-z-index)",
  /* tw */
  "top-(--gp-overlay-top)",
  /* tw */
  "left-(--gp-overlay-left)",
  /* tw */
  "[position:var(--gp-overlay-position)]"
], bt = {
  offset: 0,
  zIndex: 1055,
  fullWidth: !1,
  position: "absolute"
}, Va = (e) => e == null ? bt : {
  offset: e.offset || bt.offset,
  zIndex: e.zIndex || bt.zIndex,
  fullWidth: e.fullWidth || bt.fullWidth,
  position: e.position || bt.position
}, ia = (e, t, n = bt, a = !1) => {
  const l = k(() => {
    const v = e.value;
    return v == null ? null : v.$el ?? v;
  }), s = k(() => {
    const v = t.value;
    return v == null ? null : v.$el ?? v;
  }), { x: i, y: o, update: r, strategy: u, middlewareData: c } = Kl(
    l,
    s,
    {
      /**
       * flip: overflow starts with anchor
       * shift: overflow starts at the edge of viewport
       */
      middleware: [Ul(), Hl(Va(n).offset)],
      placement: "bottom-start"
    }
  ), f = k(() => {
    const { zIndex: v, fullWidth: y } = Va(n), b = {
      zIndex: v,
      top: `${Math.abs(o.value) ?? 0}px`,
      left: `${i.value == null || y ? 0 : Math.abs(i.value)}px`,
      position: `${u.value}`
    };
    return a ? {
      "--gp-overlay-z-index": b.zIndex,
      "--gp-overlay-top": b.top,
      "--gp-overlay-left": b.left,
      "--gp-overlay-position": b.position
    } : {
      ...b
    };
  }), m = () => {
    r();
  }, { height: h, width: g } = mi();
  return Ut(
    g,
    () => {
      r();
    },
    { throttle: 20 }
  ), Ut(
    h,
    () => {
      r();
    },
    { throttle: 20 }
  ), {
    overlayStyle: f,
    middlewareData: c,
    alignOverlay: m
  };
}, ut = (e) => {
  if (e != null) {
    if (typeof e == "string")
      return { [e]: !0 };
    if (typeof e == "object" && e.length != null)
      return { [e.join(" ")]: !0 };
    if (typeof e == "object")
      return e;
  }
  return null;
}, dt = (e) => {
  if (e != null) {
    if (typeof e == "string" && e.length > 0)
      return e.split(";").map((t) => t.split(":")).map(([t, n]) => ({ [t.trim()]: n.trim() }));
    if (Array.isArray(e))
      return e.reduce((t, n) => typeof n == "string" ? {
        ...t,
        ...n.split(";").map((a) => a.split(":")).map(([a, l]) => ({ [a.trim()]: l.trim() }))
      } : t, {});
    if (typeof e == "object")
      return e;
  }
  return null;
}, oa = () => {
  const e = (t, n, a, l) => (t == null || typeof t != "object" || t.forEach((s) => {
    if (s.type == null) return;
    const i = s.type, o = i.name || i.__name;
    if (typeof a == "string" && o === a && s.props != null) {
      n.push(s);
      return;
    }
    if (typeof a != "string" && a.includes(o)) {
      n.push(s);
      return;
    }
    if (l != null) {
      const r = l(i, s);
      r != null && n.push(r);
    }
    s.children != null && s.children.length > 0 && n.concat(
      // look into its children to find more column defintiions
      e(
        s.children,
        n,
        a,
        l
      )
    );
  }), n);
  return {
    getDefinitionsRecursive: e
  };
}, ra = (e, t, n, a, l, {
  applyParentWidth: s = !0
} = {}) => {
  const { width: i } = _n(
    e,
    { height: 0, width: 0 },
    { box: "border-box" }
  ), { overlayStyle: o, alignOverlay: r, middlewareData: u } = ia(
    e,
    t,
    {},
    !0
  ), c = k(() => {
    const g = dt(l.value);
    return {
      ...o.value,
      ...g,
      "--gp-overlay-width": s ? `${i.value}px` : void 0
    };
  }), f = k(() => ({
    ...ut(a.value),
    [Xo.join(" ")]: !0,
    "w-(--gp-overlay-width)": s
  })), m = (g) => {
    g && r();
  }, h = k(() => u.value.flip && u.value.flip.overflows != null && u.value.flip.overflows.find(
    (g) => g.placement === "bottom-end"
  ) ? "up" : "down");
  return be(() => {
    n.value && m(!0);
  }), {
    resultListStyle: c,
    resultListClass: f,
    alignResultContainer: m,
    transitionDirection: h,
    width: i
  };
}, ua = (e, t, n) => {
  cn(
    e,
    () => {
      n.value = !1;
    },
    {
      ignore: [t]
    }
  );
}, Ql = (e) => {
  const t = (n) => {
    n.preventDefault(), e.value && (e.value = !1);
  };
  Rt({
    onEventFired: (n) => {
      n.key === "Escape" && t(n);
    }
  });
}, Xl = (e, t, n) => {
  const {
    TRANSITION_DURATION_CLASS: a,
    onEnterTransitioning: l,
    onLeaveTransitioning: s,
    onAfterTransitioning: i
  } = vn(z(e)), o = k(() => d(n) === "down" ? "origin-top" : "origin-bottom"), r = k(
    () => d(n) === "down" ? "-translate-y-2" : "translate-y-2"
  ), u = "translate-y-0", c = k(
    () => d(n) === "down" ? "-translate-y-2" : "translate-y-2"
  );
  return {
    transitionBinding: k(() => d(t) ? {} : {
      enterFromClass: (
        /* tw */
        `opacity-0 scale-y-95 ${r.value}`
      ),
      enterActiveClass: (
        /* tw */
        `transition-[opacity,transform] ease-in ${a} ${o.value}`
      ),
      enterToClass: (
        /* tw */
        `opacity-100 scale-y-100 ${u}`
      ),
      leaveFromClass: (
        /* tw */
        `opacity-100 scale-y-100 ${u}`
      ),
      leaveActiveClass: (
        /* tw */
        `transition-[opacity,transform] ease-out ${a} ${o.value}`
      ),
      leaveToClass: (
        /* tw */
        `opacity-0 scale-y-95 ${c.value}`
      ),
      onEnter: l,
      onAfterEnter: i,
      onLeave: s,
      onAfterLeave: i
    })
  };
}, da = /* @__PURE__ */ E({
  __name: "GpFadeSlideTransition",
  props: {
    disabled: { type: Boolean, default: !1 },
    duration: { default: () => ({
      enter: 200,
      leave: 100
    }) },
    direction: { default: "down" }
  },
  setup(e) {
    const t = e, { transitionBinding: n } = Xl(
      z(t, "duration"),
      z(t, "disabled"),
      z(t, "direction")
    );
    return (a, l) => (p(), D(ct, W(j(d(n))), {
      default: T(() => [
        w(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ca = /* @__PURE__ */ E({
  __name: "GpDropdownBase",
  props: {
    componentId: {},
    label: { default: "" },
    error: { default: "" },
    hint: { default: "" },
    disabled: { type: Boolean, default: !1 },
    fadeSlideDirection: { default: "down" }
  },
  setup(e) {
    const t = e, { hasError: n } = je(t);
    return (a, l) => (p(), x("div", {
      class: I(["transition-opacity", {
        "opacity-70": e.disabled
      }])
    }, [
      w(a.$slots, "label", { componentId: e.componentId }, () => [
        A(ht, {
          "component-id": e.componentId,
          label: e.label,
          "has-error": d(n)
        }, null, 8, ["component-id", "label", "has-error"])
      ]),
      w(a.$slots, "toggle"),
      (p(), D(Ze, { to: "body" }, [
        A(da, { direction: e.fadeSlideDirection }, {
          default: T(() => [
            w(a.$slots, "dropdown")
          ]),
          _: 3
        }, 8, ["direction"])
      ])),
      w(a.$slots, "hint", {}, () => [
        A(pe, W(j({ hint: e.hint, error: e.error })), null, 16)
      ])
    ], 2));
  }
}), Zo = /* @__PURE__ */ E({
  __name: "GpDropdownSingle",
  props: /* @__PURE__ */ he({
    emitObject: { default: () => !1 },
    multiple: { default: () => !1 },
    nullable: { type: Boolean, default: !1 },
    data: { default: () => [] },
    valueKey: { default: "key" },
    labelKey: { default: "label" },
    filter: { type: Boolean, default: !1 },
    filterInputPlaceholder: { default: "" },
    filterItemsFn: { type: Function, default: void 0 },
    filterItemsAsyncFn: { type: Function, default: void 0 },
    asyncFilterText: { default: "loading..." },
    itemLabelFn: { type: Function, default: void 0 },
    filterEmptyText: { default: "no elements found" },
    loading: { type: Boolean, default: !1 },
    loadingMessage: { default: "loading..." },
    persist: { type: Boolean, default: !1 },
    resultListClass: { default: "" },
    resultListStyle: { default: "" },
    inputId: {},
    name: {},
    tabindex: { default: 0 },
    label: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    hint: { default: "" },
    error: { default: "" },
    float: { type: Boolean, default: !1 },
    componentId: {},
    modelValue: {}
  }, {
    filterQuery: {
      default: ""
    },
    filterQueryModifiers: {}
  }),
  emits: /* @__PURE__ */ he(["update:modelValue"], ["update:filterQuery"]),
  setup(e, { emit: t }) {
    const n = De(e, "filterQuery"), a = e, s = Ae(
      a,
      "modelValue",
      t
    ), i = O(!1), {
      data: o,
      valueKey: r,
      labelKey: u,
      emitObject: c,
      nullable: f,
      filter: m
    } = Hn(a), h = O(null);
    qi(
      s,
      h,
      o,
      r,
      u,
      c,
      f
    );
    const g = Ui(
      s,
      h,
      r,
      c,
      f
    ), v = (U) => {
      g(U), a.persist || (i.value = !1);
    }, y = () => {
      v(null);
    }, { filteredItems: b, isAsyncFiltering: S } = $l(
      o,
      n,
      r,
      u,
      m,
      a.filterItemsFn,
      a.filterItemsAsyncFn,
      a.itemLabelFn
    ), B = fe(yn), M = Us(() => h.value == null ? "" : B(h.value)), P = k(() => a.loading ? a.loadingMessage : h.value == null ? a.placeholder || "Select an item..." : M.value), V = z(() => a.resultListStyle), C = z(() => a.resultListClass), R = O(null), F = O(null), { resultListStyle: N, resultListClass: ee, transitionDirection: _ } = ra(
      R,
      F,
      i,
      C,
      V
    );
    ua(F, R, i), Ql(i);
    const { hasError: Z } = je(a);
    return be(() => {
      const U = h;
      Array.isArray(h.value) && (U.value = h.value[0]);
    }), (U, q) => (p(), D(ca, {
      "component-id": a.componentId,
      label: a.label,
      hint: a.hint,
      error: a.error,
      "fade-slide-direction": d(_),
      disabled: a.disabled
    }, {
      label: T(() => [
        w(U.$slots, "label", {
          componentId: a.componentId
        })
      ]),
      toggle: T(() => [
        A(ta, {
          ref_key: "selectContainer",
          ref: R,
          "is-opened": i.value,
          nullable: a.nullable,
          disabled: a.disabled,
          loading: a.loading,
          float: a.float,
          "has-error": d(Z),
          "allowed-to-be-cleared": d(s) != null,
          onClearValue: q[2] || (q[2] = (te) => s.value = null),
          onClearItem: y,
          onOpen: q[3] || (q[3] = (te) => i.value = !0),
          onClose: q[4] || (q[4] = (te) => i.value = !1)
        }, {
          default: T(() => [
            A(_i, {
              "is-opened": i.value,
              "input-id": a.componentId,
              "component-id": a.componentId,
              filter: a.filter,
              disabled: a.disabled,
              tabindex: a.tabindex,
              placeholder: a.filterInputPlaceholder,
              label: a.label,
              name: a.name,
              loading: a.loading,
              "value-container-text": P.value,
              "filter-query": n.value,
              onOpen: q[0] || (q[0] = (te) => i.value = !0),
              "onUpdate:filterQuery": q[1] || (q[1] = (te) => n.value = te)
            }, {
              default: T(() => [
                w(U.$slots, "value", {
                  fullValue: h.value
                })
              ]),
              _: 3
            }, 8, ["is-opened", "input-id", "component-id", "filter", "disabled", "tabindex", "placeholder", "label", "name", "loading", "value-container-text", "filter-query"])
          ]),
          _: 3
        }, 8, ["is-opened", "nullable", "disabled", "loading", "float", "has-error", "allowed-to-be-cleared"])
      ]),
      dropdown: T(() => [
        i.value ? (p(), D(Fl, {
          key: 0,
          ref_key: "resultsContainer",
          ref: F,
          "model-value": h.value,
          "filtered-items": d(b),
          "emit-object": a.emitObject,
          multiple: a.multiple,
          "filter-empty-text": a.filterEmptyText,
          "async-filtering-text": a.asyncFilterText,
          "is-async-filtering": d(S),
          "is-opened": i.value,
          style: se(d(N)),
          class: I(d(ee)),
          "value-key": a.valueKey,
          "label-key": a.label,
          onSelect: v,
          onClearItem: y
        }, {
          loading: T((te) => [
            w(U.$slots, "resultsLoading", W(j(te)))
          ]),
          empty: T((te) => [
            w(U.$slots, "resultsEmpty", W(j(te)))
          ]),
          itemContent: T(({ item: te, isSelected: ie }) => [
            w(U.$slots, "itemContent", W(j({
              item: te,
              isSelected: ie
            })))
          ]),
          _: 3
        }, 8, ["model-value", "filtered-items", "emit-object", "multiple", "filter-empty-text", "async-filtering-text", "is-async-filtering", "is-opened", "style", "class", "value-key", "label-key"])) : $("", !0)
      ]),
      hint: T(() => [
        w(U.$slots, "hint")
      ]),
      _: 3
    }, 8, ["component-id", "label", "hint", "error", "fade-slide-direction", "disabled"]));
  }
}), Jo = ["tabindex", "aria-labelledby", "aria-label", "aria-expanded", "aria-controls", "id"], _o = { key: 0 }, er = /* @__PURE__ */ E({
  __name: "GpDropdownMultipleValue",
  props: /* @__PURE__ */ he({
    componentId: {},
    isOpened: { type: Boolean, default: !1 },
    modelValue: {},
    valueKey: { default: "key" },
    nullable: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    tabindex: { default: 0 },
    label: { default: "" },
    name: { default: "" },
    filter: { type: Boolean, default: !1 },
    filterInputPlaceholder: { default: "" }
  }, {
    filterQuery: {
      default: ""
    },
    filterQueryModifiers: {}
  }),
  emits: /* @__PURE__ */ he(["open", "clearItem"], ["update:filterQuery"]),
  setup(e, { emit: t }) {
    const n = De(e, "filterQuery"), a = e, l = z(() => a.valueKey), s = t, i = (r) => {
      r.type === "keydown" && r.key === "Backspace" && n.value === "" && (r.preventDefault(), s("clearItem", a.modelValue[a.modelValue.length - 1]));
    }, o = O(null);
    return be(async () => {
      a.filter && (a.isOpened ? (await Ne(), o.value.focus()) : n.value = "");
    }), (r, u) => (p(), x("div", {
      ref: "multipleContainer",
      class: "h-full flex-1 overflow-hidden",
      role: "combobox",
      tabindex: e.disabled ? -1 : e.tabindex,
      "aria-labelledby": r.$attrs.ariaLabelledby,
      "aria-label": r.$attrs.ariaLabel || (e.label === "p-emptylabel" ? void 0 : e.label),
      "aria-expanded": e.isOpened,
      "aria-controls": `${e.componentId}_list`,
      id: e.componentId,
      onClick: u[3] || (u[3] = (c) => s("open"))
    }, [
      A(Al, {
        "is-opened": e.isOpened,
        "model-value": e.modelValue,
        "value-key": l.value,
        wrap: !1,
        disabled: e.disabled,
        nullable: e.nullable,
        filter: e.filter,
        class: "size-full",
        onClearItem: u[2] || (u[2] = (c) => s("clearItem", c))
      }, {
        prepend: T(() => [
          (e.modelValue == null || e.modelValue.length === 0) && !(e.isOpened && e.filter) ? (p(), x("span", _o, G(e.placeholder || "Select an item..."), 1)) : $("", !0)
        ]),
        value: T(() => [
          w(r.$slots, "value")
        ]),
        valueItem: T((c) => [
          w(r.$slots, "valueItem", W(j(c)))
        ]),
        valueItemContent: T((c) => [
          w(r.$slots, "valueItemContent", W(j(c)))
        ]),
        append: T(() => [
          e.isOpened && e.filter ? (p(), D(Il, {
            key: 0,
            ref_key: "filterInput",
            ref: o,
            modelValue: n.value,
            "onUpdate:modelValue": u[0] || (u[0] = (c) => n.value = c),
            class: "min-w-52",
            "component-id": e.componentId,
            "is-opened": e.isOpened,
            disabled: e.disabled,
            tabindex: e.tabindex,
            label: e.label,
            placeholder: e.filterInputPlaceholder,
            name: e.name,
            "aria-labelledby": r.$attrs.ariaLabelledby,
            "aria-label": r.$attrs.ariaLabel,
            onKeydown: u[1] || (u[1] = sn((c) => i(c), ["backspace"]))
          }, null, 8, ["modelValue", "component-id", "is-opened", "disabled", "tabindex", "label", "placeholder", "name", "aria-labelledby", "aria-label"])) : $("", !0)
        ]),
        _: 3
      }, 8, ["is-opened", "model-value", "value-key", "disabled", "nullable", "filter"])
    ], 8, Jo));
  }
}), tr = (e, t, n, a) => (s) => {
  e.value == null && (e.value = []);
  const i = t;
  if (i.value == null && (i.value = []), typeof s == "object") {
    i.value.some(
      (o) => o[n.value] === s[n.value]
    ) ? i.value = i.value.filter(
      (o) => o[n.value] !== s[n.value]
    ) : i.value.push(s), a.value ? e.value = i.value : e.value = i.value.map(
      (o) => o[n.value]
    );
    return;
  }
  if (i.value.includes(s)) {
    t.value = i.value.filter(
      (o) => o !== s
    ), e.value = i.value;
    return;
  }
  i.value.push(s), e.value = i.value;
}, nr = (e, t, n, a, l, s) => {
  const i = () => {
    const u = e, c = n.value[0];
    t.value = u.value.map((f) => typeof f == "object" ? n.value.find(
      (m) => m[a.value] === f[a.value]
    ) : typeof c == "object" ? n.value.find(
      (m) => m[a.value] === f
    ) : n.value.find((m) => m === f));
  }, o = () => {
    const u = e;
    if (s.value) {
      if (e.value == null || e.value === "") {
        e.value = [], t.value = [];
        return;
      }
      if (u.value != null && u.value.length === 0) {
        t.value = [];
        return;
      }
    }
    if (n.value.length === 0) return;
    const c = n.value[0];
    if (u.value != null && u.value.length > 0) {
      const f = c;
      if (
        // if the first and only item is already in the model value, we do not have to do anything
        // this is to avoid updating the model value infinitely
        u.value.length === 1 && u.value.some(
          (m) => m === f[a.value] || m[a.value] === f[a.value]
        )
      ) {
        i();
        return;
      }
      i();
    } else
      t.value = [c], !l.value && typeof c == "object" ? u.value = [c[a.value]] : u.value = [c];
  }, r = () => {
    o();
  };
  H(e, () => {
    r();
  }), H(n, () => {
    r();
  }), xe(async () => {
    r();
  });
}, ar = /* @__PURE__ */ E({
  __name: "GpDropdownMultiple",
  props: /* @__PURE__ */ he({
    emitObject: { default: () => !1 },
    multiple: {},
    nullable: { type: Boolean, default: !1 },
    data: { default: () => [] },
    valueKey: { default: "key" },
    labelKey: { default: "label" },
    filter: { type: Boolean, default: !1 },
    filterInputPlaceholder: {},
    filterItemsFn: { type: Function, default: void 0 },
    filterItemsAsyncFn: { type: Function, default: void 0 },
    asyncFilterText: { default: "loading..." },
    itemLabelFn: { type: Function, default: void 0 },
    filterEmptyText: { default: "no elements found" },
    loading: { type: Boolean, default: !1 },
    loadingMessage: { default: "loading..." },
    persist: { type: Boolean },
    resultListClass: {},
    resultListStyle: {},
    inputId: {},
    name: { default: "" },
    tabindex: { default: 0 },
    label: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    hint: { default: "" },
    error: { default: "" },
    float: { type: Boolean, default: !1 },
    componentId: {},
    modelValue: { default: void 0 }
  }, {
    filterQuery: {
      default: ""
    },
    filterQueryModifiers: {}
  }),
  emits: /* @__PURE__ */ he(["update:modelValue"], ["update:filterQuery"]),
  setup(e, { emit: t }) {
    const n = De(e, "filterQuery"), a = e, s = Ae(
      a,
      "modelValue",
      t
    ), i = O(!1), {
      data: o,
      valueKey: r,
      labelKey: u,
      nullable: c,
      filter: f,
      emitObject: m
    } = Hn(a), h = O([]);
    nr(
      s,
      h,
      o,
      r,
      m,
      c
    );
    const g = tr(
      s,
      h,
      r,
      m
    ), v = (Z) => {
      g(Z), a.persist || (i.value = !1);
    }, y = (Z) => {
      v(Z);
    }, { filteredItems: b, isAsyncFiltering: S } = $l(
      o,
      n,
      r,
      u,
      f,
      a.filterItemsFn,
      a.filterItemsAsyncFn,
      a.itemLabelFn
    ), B = k(() => a.loading ? a.loadingMessage : h.value == null || h.value.length === 0 ? a.placeholder || "Select an item..." : ""), M = z(() => a.resultListStyle), P = z(() => a.resultListClass), V = O(null), C = O(null), { resultListStyle: R, resultListClass: F, transitionDirection: N } = ra(
      V,
      C,
      i,
      P,
      M
    );
    ua(C, V, i), Ql(i);
    const { hasError: ee } = je(a), _ = () => {
      const Z = h;
      s.value != null ? Array.isArray(h.value) || (Z.value = [h.value]) : h.value = [], !(s.value != null && s.value.length > 0 && Z.value.length === 0) && (m.value ? s.value = h.value : s.value = h.value.map(
        (U) => !m.value && typeof U == "object" ? U[r.value] : U
      ));
    };
    return xe(() => {
      _();
    }), (Z, U) => (p(), D(ca, {
      "component-id": a.componentId,
      label: a.label,
      hint: a.hint,
      error: a.error,
      "fade-slide-direction": d(N),
      disabled: a.disabled
    }, {
      label: T(() => [
        w(Z.$slots, "hint", {
          componentId: a.componentId
        })
      ]),
      toggle: T(() => [
        A(ta, {
          ref_key: "selectContainer",
          ref: V,
          "is-opened": i.value,
          nullable: a.nullable,
          disabled: a.disabled,
          loading: a.loading,
          float: a.float,
          "allowed-to-be-cleared": a.modelValue != null && a.modelValue.length > 0,
          "has-error": d(ee),
          onClearValue: U[2] || (U[2] = (q) => s.value = []),
          onOpen: U[3] || (U[3] = (q) => i.value = !0),
          onClose: U[4] || (U[4] = (q) => i.value = !1)
        }, {
          default: T(() => [
            A(er, {
              "filter-query": n.value,
              "is-opened": i.value,
              "model-value": h.value,
              "component-id": a.componentId,
              disabled: a.disabled,
              tabindex: a.tabindex,
              label: a.label,
              name: a.name,
              loading: a.loading,
              placeholder: B.value || a.placeholder,
              filter: a.filter,
              "filter-input-placeholder": a.filterInputPlaceholder,
              "onUpdate:filterQuery": U[0] || (U[0] = (q) => n.value = q),
              onClearItem: y,
              onOpen: U[1] || (U[1] = (q) => i.value = !0)
            }, {
              value: T(() => [
                w(Z.$slots, "value", W(j({
                  fullValue: h.value
                })))
              ]),
              valueItem: T(({ item: q, index: te, handleClearItem: ie }) => [
                w(Z.$slots, "valueItem", W(j({
                  item: q,
                  index: te,
                  handleClearItem: ie
                })))
              ]),
              valueItemContent: T(({ item: q, index: te }) => [
                w(Z.$slots, "valueItemContent", W(j({
                  item: q,
                  index: te
                })))
              ]),
              _: 3
            }, 8, ["filter-query", "is-opened", "model-value", "component-id", "disabled", "tabindex", "label", "name", "loading", "placeholder", "filter", "filter-input-placeholder"])
          ]),
          _: 3
        }, 8, ["is-opened", "nullable", "disabled", "loading", "float", "allowed-to-be-cleared", "has-error"])
      ]),
      dropdown: T(() => [
        i.value ? (p(), D(Fl, {
          key: 0,
          ref_key: "resultsContainer",
          ref: C,
          "model-value": h.value,
          "filtered-items": d(b),
          "emit-object": a.emitObject,
          multiple: a.multiple,
          "filter-empty-text": a.filterEmptyText,
          "async-filtering-text": a.asyncFilterText,
          "is-async-filtering": d(S),
          "is-opened": i.value,
          style: se(d(R)),
          class: I(d(F)),
          "value-key": a.valueKey,
          "label-key": a.labelKey,
          onSelect: v,
          onClearItem: y
        }, {
          loading: T((q) => [
            w(Z.$slots, "loading", W(j(q)))
          ]),
          empty: T((q) => [
            w(Z.$slots, "empty", W(j(q)))
          ]),
          itemContent: T(({ item: q, isSelected: te, disabled: ie }) => [
            w(Z.$slots, "itemContent", W(j({
              item: q,
              isSelected: te,
              disabled: ie
            })))
          ]),
          _: 3
        }, 8, ["model-value", "filtered-items", "emit-object", "multiple", "filter-empty-text", "async-filtering-text", "is-async-filtering", "is-opened", "style", "class", "value-key", "label-key"])) : $("", !0)
      ]),
      hint: T(() => [
        w(Z.$slots, "hint")
      ]),
      _: 3
    }, 8, ["component-id", "label", "hint", "error", "fade-slide-direction", "disabled"]));
  }
}), Xf = /* @__PURE__ */ E({
  __name: "GpDropdown",
  props: /* @__PURE__ */ he({
    emitObject: { default: () => !1 },
    multiple: { default: () => !1 },
    nullable: { type: Boolean, default: !1 },
    data: { default: () => [] },
    valueKey: { default: () => "key" },
    labelKey: { default: "label" },
    filter: { type: Boolean, default: !1 },
    filterInputPlaceholder: { default: "" },
    filterItemsFn: { type: Function, default: void 0 },
    filterItemsAsyncFn: { type: Function, default: void 0 },
    asyncFilterText: { default: "loading..." },
    itemLabelFn: { type: Function, default: void 0 },
    inputId: {},
    name: { default: "" },
    tabindex: { default: 0 },
    label: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    hint: { default: "" },
    error: { default: "" },
    float: { type: Boolean, default: !1 },
    filterEmptyText: { default: "no elements found" },
    loading: { type: Boolean, default: !1 },
    loadingMessage: { default: "loading..." },
    persist: { type: Boolean, default: !1 },
    resultListClass: { default: "" },
    resultListStyle: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {},
    filterQuery: {},
    filterQueryModifiers: {}
  }),
  emits: ["update:modelValue", "update:filterQuery"],
  setup(e) {
    const t = De(e, "modelValue"), n = De(e, "filterQuery"), a = e, l = t, s = t, i = Ol(
      a.labelKey,
      a.valueKey,
      a.itemLabelFn
    );
    Xe(yn, i);
    const o = Ve("select", a.inputId);
    return (r, u) => a.multiple ? (p(), D(ar, re({ key: 0 }, a, {
      "component-id": d(o),
      "model-value": d(s),
      "filter-query": n.value,
      "onUpdate:modelValue": u[0] || (u[0] = (c) => t.value = c),
      "onUpdate:filterQuery": u[1] || (u[1] = (c) => n.value = c)
    }), {
      label: T(() => [
        w(r.$slots, "label", { componentId: d(o) })
      ]),
      value: T(({ fullValue: c }) => [
        w(r.$slots, "value", W(j({
          fullValue: c
        })))
      ]),
      valueItem: T(({ index: c, item: f, handleClearItem: m }) => [
        w(r.$slots, "valueItem", W(j({
          index: c,
          item: f,
          handleClearItem: m
        })))
      ]),
      valueItemContent: T(({ item: c, index: f }) => [
        w(r.$slots, "valueItemContent", W(j({
          item: c,
          index: f
        })), () => [
          L("span", null, G(d(i)(c)), 1)
        ])
      ]),
      resultsLoading: T(() => [
        w(r.$slots, "resultsLoading")
      ]),
      resultsEmpty: T(() => [
        w(r.$slots, "resultsEmpty")
      ]),
      itemContent: T(({ item: c, isSelected: f }) => [
        w(r.$slots, "itemContent", W(j({
          item: c,
          isSelected: f
        })))
      ]),
      hint: T(() => [
        w(r.$slots, "hint")
      ]),
      _: 3
    }, 16, ["component-id", "model-value", "filter-query"])) : (p(), D(Zo, re({ key: 1 }, a, {
      "component-id": d(o),
      "model-value": d(l),
      "filter-query": n.value,
      "onUpdate:modelValue": u[2] || (u[2] = (c) => t.value = c),
      "onUpdate:filterQuery": u[3] || (u[3] = (c) => n.value = c)
    }), {
      label: T(() => [
        w(r.$slots, "label", { componentId: d(o) })
      ]),
      value: T(({ fullValue: c }) => [
        w(r.$slots, "value", W(j({
          fullValue: c
        })))
      ]),
      resultsLoading: T(() => [
        w(r.$slots, "resultsLoading")
      ]),
      resultsEmpty: T(() => [
        w(r.$slots, "resultsEmpty")
      ]),
      itemContent: T(({ item: c, isSelected: f }) => [
        w(r.$slots, "itemContent", W(j({
          item: c,
          isSelected: f
        })))
      ]),
      hint: T(() => [
        w(r.$slots, "hint")
      ]),
      _: 3
    }, 16, ["component-id", "model-value", "filter-query"]));
  }
}), lr = (e, t, n, a) => {
  const l = () => {
    n.disabled || n.trigger === "hover" && (n.hoverDelay ? setTimeout(() => {
      e.value = !0;
    }, n.hoverDelay) : e.value = !0);
  }, s = () => {
    n.disabled || n.trigger === "hover" && (e.value = !1);
  }, i = O(!1), o = () => {
    n.disabled || (e.value = !0, i.value = !0);
  }, r = () => {
    n.disabled || (e.value = !1);
  }, u = () => {
    n.disabled || (["hover", "click"].includes(n.trigger) && !i.value && (e.value = !e.value), e.value || (i.value = !1));
  };
  return cn(
    t,
    () => {
      n.disabled || ["hover", "click"].includes(n.trigger) && (e.value = !1);
    },
    {
      ignore: [`#${a}`]
    }
  ), {
    onMouseEnter: l,
    onMouseLeave: s,
    onFocusIn: o,
    onFocusOut: r,
    onClick: u,
    onTouchStart: () => {
      n.disabled || n.trigger === "hover" && (e.value = !e.value);
    }
  };
}, sr = ["tabindex"], ir = { class: "mb-0" }, or = /* @__PURE__ */ E({
  __name: "GpTooltip",
  props: {
    content: { default: "tooltip content" },
    tooltipType: { default: "flat" },
    shape: { default: "rounded" },
    contentClass: { default: null },
    triggerClass: { default: null },
    triggerStyle: { type: [Boolean, null, String, Object, Array], default: null },
    trigger: { default: "hover" },
    positioning: { default: "fixed" },
    teleportTarget: { default: "body" },
    hoverDelay: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    isOpened: { type: Boolean, default: !1 },
    placement: { default: "auto" }
  },
  setup(e) {
    const t = e, n = O(), a = O(), l = Ie(), { x: s, y: i, strategy: o, update: r } = Kl(
      n,
      a,
      {
        middleware: [qo(), Ul(), Hl(4)],
        strategy: "fixed",
        placement: t.placement === "auto" ? null : t.placement,
        whileElementsMounted: (...V) => Uo(...V, { animationFrame: !0 })
      }
    ), u = k(() => ({
      "--gp-tooltip-left": `${s.value}px`,
      "--gp-tooltip-top": `${i.value}px`,
      position: o.value,
      zIndex: 1055
    })), c = z(t, "tooltipType"), f = Pt(c), m = k(() => {
      const V = (
        /* tw */
        "left-(--gp-tooltip-left) top-(--gp-tooltip-top)"
      );
      if (t.contentClass != null)
        return [t.contentClass, V];
      const C = ["max-w-xs px-2 py-1 shadow-lg", f.value];
      return t.shape === "pill" ? C.push("rounded-full") : C.push("rounded"), C.join(" ").concat(" ", V);
    }), h = O(t.isOpened);
    H(
      () => t.isOpened,
      (V) => {
        t.trigger === "prop" && (h.value = V);
      }
    ), be(async () => {
      h.value && (await Ne(), r());
    });
    const v = `gp-tooltip-${on().replace(/[^a-zA-Z0-9_-]/g, "_").replace(/^_+|_+$/g, "") || "tooltip"}`, {
      onClick: y,
      onFocusIn: b,
      onFocusOut: S,
      onMouseEnter: B,
      onMouseLeave: M,
      onTouchStart: P
    } = lr(
      h,
      n,
      t,
      v
    );
    return (V, C) => (p(), x(X, null, [
      L("span", re({
        ref_key: "tooltipTriggerRef",
        ref: n
      }, d(l), {
        tabindex: t.trigger !== "prop" ? 0 : void 0,
        onMouseenter: C[0] || (C[0] = //@ts-ignore
        (...R) => d(B) && d(B)(...R)),
        onMouseleave: C[1] || (C[1] = //@ts-ignore
        (...R) => d(M) && d(M)(...R)),
        onTouchstart: C[2] || (C[2] = //@ts-ignore
        (...R) => d(P) && d(P)(...R)),
        onFocusin: C[3] || (C[3] = //@ts-ignore
        (...R) => d(b) && d(b)(...R)),
        onFocusout: C[4] || (C[4] = //@ts-ignore
        (...R) => d(S) && d(S)(...R)),
        onClick: C[5] || (C[5] = //@ts-ignore
        (...R) => d(y) && d(y)(...R))
      }), [
        w(V.$slots, "default")
      ], 16, sr),
      (p(), D(Ze, {
        to: e.teleportTarget,
        disabled: e.positioning === "static"
      }, [
        A(Ye, null, {
          default: T(() => [
            h.value && !e.disabled ? (p(), x("div", {
              key: 0,
              id: v,
              ref_key: "tooltipRef",
              ref: a,
              role: "tooltip",
              class: I(m.value),
              style: se(u.value)
            }, [
              w(V.$slots, "content", {}, () => [
                L("p", ir, G(e.content), 1)
              ])
            ], 6)) : $("", !0)
          ]),
          _: 3
        })
      ], 8, ["to", "disabled"]))
    ], 64));
  }
}), rr = (e, t, n, a, l, s, i, o, r, u) => {
  const { width: c } = xa(t), { width: f, left: m } = xa(e), h = k(() => ae(a)), g = k(() => ae(l)), v = (C) => (C - h.value.value) / (g.value.value - h.value.value) * 100, y = k(
    () => ae(s)
  ), b = (C) => {
    const R = m.value + c.value / 2, F = f.value - c.value / 2, ee = (C - R) / F * 100, _ = ae(i);
    if (y.value && y.value.length) {
      const U = y.value;
      let q = null;
      if (U.forEach((te, ie) => {
        let ue = te;
        if (ie + 1 in y.value && (ue = U[ie + 1]), ee >= g.value.percentage)
          q = g.value.value;
        else if (ee >= te.percentage && ee <= ue.percentage) {
          const Ce = (ue.value - te.value) / (ue.percentage - te.percentage);
          q = te.value + (ee - te.percentage) * Ce, q = Math.round(q / _) * _;
        }
      }), q < h.value.value ? q = h.value.value : q > g.value.value && (q = g.value.value), u) {
        const te = y.value.reduce(
          (ie, ue) => Math.abs(ue.value - q) < Math.abs(ie.value - q) ? ue : ie
        );
        te !== void 0 && (q = te.value);
      }
      return r ? q : Math.round(q);
    }
    let Z = ee / 100 * g.value.value;
    return Z < h.value.value ? Z = h.value.value : Z > g.value.value && (Z = g.value.value), r ? n.value : Math.round(Z);
  }, S = k(() => {
    let C = 0;
    if (y.value && y.value.length) {
      const R = y.value;
      R.forEach((F, N) => {
        let ee = F;
        if (N + 1 in R && (ee = R[N + 1]), n.value >= F.value && n.value <= ee.value) {
          let _ = (ee.value - F.value) / (ee.percentage - F.percentage);
          Number.isNaN(_) && (_ = 1), C = f.value / 100 * (F.percentage + (n.value - F.value) / _) - c.value / 2;
        }
      }, void 0);
    } else
      C = n.value / g.value.value * f.value - c.value / 2;
    return C;
  }), B = O(!1), M = () => {
    o || (B.value = !0);
  }, P = () => {
    o || B.value && (B.value = !1, document.body.style.cursor = "auto");
  }, V = (C) => {
    if (!o && B.value) {
      const R = C.type === "touchmove" ? C.changedTouches[0].clientX : C.clientX, F = b(R);
      F <= g.value.value && F >= h.value.value && (n.value = F);
    }
  };
  return de("mousemove", V), de("mouseup", P), de("touchmove", V), de("touchend", P), {
    handleLeft: S,
    isDragging: B,
    getValueByPosition: b,
    getStepPercentage: v,
    onHandleMouseUp: P,
    onHandleMouseDown: M
  };
}, Zl = 10, ur = (e, t, n, a, l) => {
  const s = k(() => ae(t).value), i = k(() => ae(n).value), o = k(
    () => s.value === 0 ? 0 : Math.log(s.value)
  ), r = k(() => Math.log(i.value)), u = k(() => r.value - o.value), c = (m) => Math.exp(o.value + u.value / 100 * m);
  return {
    sliderMarkers: k(() => {
      const m = ae(e);
      if (m != null && m.length > 0)
        return m.map((v) => {
          if (typeof v == "number")
            return {
              id: v,
              value: v,
              percentage: v / i.value * 100
            };
          if (typeof v == "object")
            return v;
        }).filter((v) => v != null);
      let h = [];
      const g = ae(a || Zl);
      if (i.value - s.value <= g)
        for (let v = s.value; v <= i.value; v++) {
          const y = (v - s.value) / (i.value - s.value) * 100;
          h.push({
            id: v,
            value: v,
            percentage: y
          });
        }
      else
        for (let v = 0; v <= g; v++) {
          const y = v / g * 100;
          let b = 0;
          ae(l) && y > 0 ? b = Math.round(c(y)) : b = Math.round(
            s.value + (i.value - s.value) * (y / 100)
          ), h.push({
            id: v,
            value: b,
            percentage: y
          });
        }
      return h = h.filter(
        (v, y, b) => y === b.findIndex((S) => S.value === v.value)
      ), h.forEach(
        (v, y, b) => v.percentage = y / (b.length - 1) * 100
      ), h;
    })
  };
}, dr = { class: "absolute left-1/2 -translate-x-1/2 translate-y-5 text-sm" }, cr = /* @__PURE__ */ E({
  name: "GpSliderMarker",
  __name: "GpSliderMarker",
  props: {
    marker: {},
    max: {}
  },
  setup(e) {
    const t = k(() => typeof e.marker == "number" ? e.marker : e.marker.value), n = k(() => typeof e.marker == "object" && e.marker.percentage != null ? e.marker.percentage : t.value / e.max * 100);
    return (a, l) => (p(), x("div", {
      class: "absolute left-(--gp-slider-mark-position) before:absolute before:left-0 before:top-0 before:h-4 before:w-px before:bg-gray-500 before:content-['']",
      style: se({
        "--gp-slider-mark-position": n.value + "%"
      })
    }, [
      L("div", dr, G(t.value), 1)
    ], 4));
  }
}), fr = { class: "relative h-10" }, hr = /* @__PURE__ */ E({
  name: "GpSliderMarkers",
  __name: "GpSliderMarkers",
  props: {
    markers: { default: () => [] },
    valueMax: { default: 100 }
  },
  setup(e) {
    return (t, n) => (p(), x("div", fr, [
      (p(!0), x(X, null, ce(e.markers, (a) => (p(), D(cr, {
        "data-testid": `gp-slider-marker-${typeof a == "number" ? a : a.id}`,
        key: typeof a == "number" ? a : a.id,
        marker: a,
        max: e.valueMax
      }, null, 8, ["data-testid", "marker", "max"]))), 128))
    ]));
  }
}), mr = /* @__PURE__ */ E({
  name: "GpSliderProgress",
  __name: "GpSliderProgress",
  props: {
    transition: {}
  },
  setup(e) {
    return (t, n) => (p(), x("div", {
      class: "h-(--gp-slider-progress-height) w-(--gp-slider-progress-width) rounded bg-linear-to-r from-gp-midnight-gradient-a to-gp-midnight-gradient-b shadow-gp-default transition-(--gp-slider-progress-transition)",
      style: se({
        "--gp-slider-progress-transition": e.transition
      })
    }, null, 4));
  }
}), pr = {
  ref: "sliderContainer",
  class: "w-full"
}, gr = ["id", "aria-valuemin", "aria-valuemax", "aria-valuenow", "name"], Zf = /* @__PURE__ */ E({
  __name: "GpSlider",
  props: /* @__PURE__ */ he({
    inputId: {},
    name: { default: "" },
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    hint: { default: "" },
    error: { default: "" },
    valueMin: { default: 0 },
    valueMax: { default: 100 },
    markerCount: { default: () => Zl },
    logaritmicMarkers: { type: Boolean, default: !1 },
    markers: { default: () => [] },
    steps: { default: 1 },
    valueIsMarker: { type: Boolean, default: !1 },
    tooltip: { type: Boolean, default: !1 },
    progress: { type: Boolean, default: !0 },
    hideMarkers: { type: Boolean, default: !1 },
    floatingValues: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = De(e, "modelValue"), n = Ve("slider", e.inputId), { hasError: a } = je({ error: e.error, hint: e.hint }), l = k(() => {
      const b = e.markers.map((M) => typeof M == "number" ? M : M.value), S = Math.max(...b), B = Math.min(...b);
      return e.markers.map((M) => {
        if (typeof M == "number")
          return {
            id: M,
            value: M,
            percentage: (M - B) / (S - B) * 100
          };
        if (typeof M == "object")
          return M;
      }).filter((M) => M != null);
    }), s = k(() => {
      if ((e.valueMin == null || e.valueMax == null) && e.markers.length === 0) {
        console.warn(
          "valueMin or valueMax is not set. Either use sliderMarkers or set valueMin and valueMax"
        );
        return;
      }
      if (e.valueMin != null && e.markers.length === 0)
        return {
          id: 0,
          value: e.valueMin,
          percentage: 0
        };
      if (e.valueMin != null && e.valueMax != null && e.valueMin >= e.valueMax) {
        console.warn("valueMin is either equal or greater than valueMax");
        return;
      }
      if (l.value.length === 0) {
        console.warn("markers is empty!");
        return;
      }
      return {
        id: 0,
        value: Math.min(...l.value.map((b) => b.value)),
        percentage: 0
      };
    }), i = k(() => e.valueMax != null ? {
      id: e.markers.length - 1,
      value: e.valueMax,
      percentage: 100
    } : {
      id: e.markers.length - 1,
      value: Math.max(...l.value.map((b) => b.value)),
      percentage: 100
    }), { sliderMarkers: o } = ur(
      l,
      s,
      i,
      e.markerCount,
      e.logaritmicMarkers
    ), r = O(), u = O(), {
      handleLeft: c,
      isDragging: f,
      getValueByPosition: m,
      onHandleMouseDown: h,
      onHandleMouseUp: g
    } = rr(
      r,
      u,
      t,
      s,
      i,
      o,
      e.steps,
      e.disabled,
      e.floatingValues,
      e.valueIsMarker
    ), v = (b) => {
      if (e.disabled) return;
      const S = m(b.clientX);
      t.value = S;
    }, y = k(() => t.value != null ? t.value.toString() : "");
    return (b, S) => (p(), x("div", {
      class: I(["transition-opacity", {
        "opacity-70": e.disabled,
        "opacity-100": !e.disabled
      }]),
      style: {
        "--gp-slider-max-width": "100%"
      }
    }, [
      w(b.$slots, "label", {}, () => [
        A(ht, {
          "component-id": d(n),
          label: e.label,
          "has-error": d(a)
        }, null, 8, ["component-id", "label", "has-error"])
      ]),
      L("div", pr, [
        L("div", {
          ref: "slider",
          class: I(["vue-smart-slider max-w-(--gp-slider-max-width)", { disabled: e.disabled }])
        }, [
          L("div", {
            ref_key: "rail",
            ref: r,
            id: d(n),
            class: I(["vue-smart-slider-rail relative rounded border border-gp-rhino bg-gp-midnight-2", {
              "pointer-events-none": e.disabled,
              "cursor-pointer": !e.disabled
            }]),
            "aria-valuemin": e.valueMin,
            "aria-valuemax": e.valueMax,
            "aria-valuenow": t.value,
            role: "slider",
            "data-testid": "gp-slider-rail",
            name: e.name || e.inputId,
            onClick: v
          }, [
            e.progress ? (p(), D(mr, {
              key: 0,
              style: se({
                "--gp-slider-progress-height": "1.25rem",
                "--gp-slider-progress-width": d(c) + "px"
              })
            }, null, 8, ["style"])) : $("", !0),
            A(d(or), {
              disabled: !e.tooltip,
              content: y.value,
              trigger: "prop",
              class: "absolute left-(--gp-slider-handle-left) top-1/2 block -translate-y-1/2 transition-(--gp-slider-control-transition)",
              style: se({
                "--gp-slider-handle-left": d(c) + "px",
                "--gp-slider-handle-transition": "left 100ms ease-in, width 100ms ease-in"
              }),
              "is-opened": d(f),
              onMouseup: d(g),
              onMousedown: d(h),
              onTouchend: d(g),
              onTouchstart: d(h)
            }, {
              default: T(() => [
                L("div", {
                  ref_key: "handle",
                  ref: u,
                  class: I(["h-7 w-8 rounded border border-gp-rhino bg-gp-midnight-2 after:absolute after:left-1/2 after:top-1/2 after:block after:-translate-x-1/2 after:-translate-y-1/2 after:text-gp-mouse after:opacity-20 after:content-['||']", { "shadow-sm": d(f) }])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["disabled", "content", "style", "is-opened", "onMouseup", "onMousedown", "onTouchend", "onTouchstart"])
          ], 10, gr),
          d(o).length && !e.hideMarkers ? (p(), D(hr, {
            key: 0,
            class: "mt-2 w-full",
            markers: d(o),
            "value-max": e.valueMax
          }, null, 8, ["markers", "value-max"])) : $("", !0)
        ], 2)
      ], 512),
      w(b.$slots, "hint", {}, () => [
        A(d(pe), W(j({ hint: e.hint, error: e.error })), null, 16)
      ])
    ], 2));
  }
}), vr = ["tabindex", "onKeydown"], yr = ["id", "value", "disabled"], br = ["for"], kr = /* @__PURE__ */ E({
  __name: "GpRadioInput",
  props: /* @__PURE__ */ he({
    inputId: {},
    label: { default: "" },
    value: {},
    disabled: { type: Boolean, default: !1 },
    disableFocus: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ he(["focus", "blur"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = De(e, "modelValue"), l = n, s = k(() => a.value === e.value), i = () => {
      e.disabled || (a.value = e.value);
    }, o = () => {
      e.disableFocus || e.disabled || u.value && i();
    }, r = O(), { isFocused: u, handleBlur: c, handleFocus: f, manualBlur: m, manualFocus: h } = _e(r, l);
    t({
      focus: h,
      blur: m
    });
    const g = Ve("radio-input", e.inputId);
    return (v, y) => (p(), x("div", {
      class: I(["flex w-fit flex-wrap items-center", {
        "opacity-70": e.disabled,
        "cursor-pointer": !e.disabled
      }])
    }, [
      L("span", {
        ref: "input",
        class: I(["flex size-6 items-center justify-center rounded-full border bg-gp-midnight-2 transition-all after:block after:size-3 after:origin-center after:rounded-full after:bg-gp-cyan after:transition-transform", {
          "border-gp-rhino after:scale-0": !s.value,
          "border-gp-cyan after:scale-100": s.value
        }]),
        tabindex: e.disableFocus ? void 0 : 0,
        onClick: y[0] || (y[0] = ke(() => i(), ["prevent"])),
        onFocus: y[1] || (y[1] = //@ts-ignore
        (...b) => d(f) && d(f)(...b)),
        onBlur: y[2] || (y[2] = //@ts-ignore
        (...b) => d(c) && d(c)(...b)),
        onKeydown: sn(ke(o, ["prevent"]), ["space"])
      }, null, 42, vr),
      ft(L("input", {
        type: "radio",
        "onUpdate:modelValue": y[3] || (y[3] = (b) => a.value = b),
        id: d(g),
        value: e.value,
        class: "hidden",
        disabled: e.disabled
      }, null, 8, yr), [
        [Ts, a.value]
      ]),
      L("label", {
        class: I(["ml-4", {
          "pointer-events-none": e.disabled
        }]),
        for: d(g)
      }, [
        w(v.$slots, "label", W(j({ option: e.value, isSelected: s.value })), () => [
          ne(G(e.label), 1)
        ])
      ], 10, br)
    ], 2));
  }
}), Jf = /* @__PURE__ */ E({
  name: "GpRadio",
  __name: "GpRadio",
  props: /* @__PURE__ */ he({
    inputId: {},
    radioOptions: {},
    label: { default: "" },
    error: { default: "" },
    hint: { default: "" },
    vertical: { type: Boolean },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = De(e, "modelValue"), n = Ve("radio", e.inputId), { hasError: a } = je({ error: e.error, hint: e.hint }), l = k(() => e.radioOptions.map((i) => typeof i == "string" ? {
      value: i,
      label: i
    } : i)), s = (i) => {
      e.disabled || (t.value = i);
    };
    return (i, o) => (p(), x("div", {
      class: I(["transition-opacity", {
        "pointer-events-none opacity-70": e.disabled
      }])
    }, [
      w(i.$slots, "label", {}, () => [
        A(ht, {
          "component-id": d(n),
          label: e.label,
          "has-error": d(a)
        }, null, 8, ["component-id", "label", "has-error"])
      ]),
      L("div", {
        class: I(["flex gap-4", {
          "flex-col": e.vertical
        }])
      }, [
        w(i.$slots, "default", W(j({
          toggle: s,
          currentValue: t.value
        })), () => [
          (p(!0), x(X, null, ce(l.value, (r, u) => (p(), D(kr, re({
            key: r.value || r,
            "input-id": `${d(n)}-${u}`
          }, { ref_for: !0 }, r, {
            "model-value": t.value,
            "onUpdate:modelValue": s
          }), {
            label: T(({ option: c, isSelected: f }) => [
              w(i.$slots, "option-label", re({ ref_for: !0 }, { option: c, isSelected: f }))
            ]),
            _: 2
          }, 1040, ["input-id", "model-value"]))), 128))
        ])
      ], 2),
      w(i.$slots, "hint", {}, () => [
        A(pe, W(j({ hint: e.hint, error: e.error })), null, 16)
      ])
    ], 2));
  }
}), Jl = Symbol(
  "DatePickerVModelSymbol"
), _l = Symbol(
  "DatePickerDisplayDateSymbol"
), es = 6048e5, wr = 864e5, Ra = Symbol.for("constructDateFrom");
function Le(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Ra in e ? e[Ra](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function me(e, t) {
  return Le(t || e, e);
}
function fa(e, t, n) {
  const a = me(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return Le(e, NaN);
  if (!t)
    return a;
  const l = a.getDate(), s = Le(e, a.getTime());
  s.setMonth(a.getMonth() + t + 1, 0);
  const i = s.getDate();
  return l >= i ? s : (a.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    l
  ), a);
}
let xr = {};
function Bn() {
  return xr;
}
function Ot(e, t) {
  var o, r, u, c;
  const n = Bn(), a = (t == null ? void 0 : t.weekStartsOn) ?? ((r = (o = t == null ? void 0 : t.locale) == null ? void 0 : o.options) == null ? void 0 : r.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, l = me(e, t == null ? void 0 : t.in), s = l.getDay(), i = (s < a ? 7 : 0) + s - a;
  return l.setDate(l.getDate() - i), l.setHours(0, 0, 0, 0), l;
}
function nn(e, t) {
  return Ot(e, { ...t, weekStartsOn: 1 });
}
function ts(e, t) {
  const n = me(e, t == null ? void 0 : t.in), a = n.getFullYear(), l = Le(n, 0);
  l.setFullYear(a + 1, 0, 4), l.setHours(0, 0, 0, 0);
  const s = nn(l), i = Le(n, 0);
  i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0);
  const o = nn(i);
  return n.getTime() >= s.getTime() ? a + 1 : n.getTime() >= o.getTime() ? a : a - 1;
}
function Pa(e) {
  const t = me(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Cr(e, ...t) {
  const n = Le.bind(
    null,
    t.find((a) => typeof a == "object")
  );
  return t.map(n);
}
function Ga(e, t) {
  const n = me(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Tr(e, t, n) {
  const [a, l] = Cr(
    n == null ? void 0 : n.in,
    e,
    t
  ), s = Ga(a), i = Ga(l), o = +s - Pa(s), r = +i - Pa(i);
  return Math.round((o - r) / wr);
}
function Sr(e, t) {
  const n = ts(e, t), a = Le(e, 0);
  return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), nn(a);
}
function Br(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Dr(e) {
  return !(!Br(e) && typeof e != "number" || isNaN(+me(e)));
}
function Ir(e, t) {
  const n = me(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Mr = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Er = (e, t, n) => {
  let a;
  const l = Mr[e];
  return typeof l == "string" ? a = l : t === 1 ? a = l.one : a = l.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function On(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Ar = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Fr = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Or = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $r = {
  date: On({
    formats: Ar,
    defaultWidth: "full"
  }),
  time: On({
    formats: Fr,
    defaultWidth: "full"
  }),
  dateTime: On({
    formats: Or,
    defaultWidth: "full"
  })
}, Lr = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Vr = (e, t, n, a) => Lr[e];
function Bt(e) {
  return (t, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let l;
    if (a === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      l = e.formattingValues[o] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, o = n != null && n.width ? String(n.width) : e.defaultWidth;
      l = e.values[o] || e.values[i];
    }
    const s = e.argumentCallback ? e.argumentCallback(t) : t;
    return l[s];
  };
}
const Rr = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Pr = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Gr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Nr = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, zr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Yr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Wr = (e, t) => {
  const n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, jr = {
  ordinalNumber: Wr,
  era: Bt({
    values: Rr,
    defaultWidth: "wide"
  }),
  quarter: Bt({
    values: Pr,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Bt({
    values: Gr,
    defaultWidth: "wide"
  }),
  day: Bt({
    values: Nr,
    defaultWidth: "wide"
  }),
  dayPeriod: Bt({
    values: zr,
    defaultWidth: "wide",
    formattingValues: Yr,
    defaultFormattingWidth: "wide"
  })
};
function Dt(e) {
  return (t, n = {}) => {
    const a = n.width, l = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], s = t.match(l);
    if (!s)
      return null;
    const i = s[0], o = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], r = Array.isArray(o) ? Ur(o, (f) => f.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      Hr(o, (f) => f.test(i))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(r) : r, u = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(u)
    ) : u;
    const c = t.slice(i.length);
    return { value: u, rest: c };
  };
}
function Hr(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Ur(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function qr(e) {
  return (t, n = {}) => {
    const a = t.match(e.matchPattern);
    if (!a) return null;
    const l = a[0], s = t.match(e.parsePattern);
    if (!s) return null;
    let i = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const o = t.slice(l.length);
    return { value: i, rest: o };
  };
}
const Kr = /^(\d+)(th|st|nd|rd)?/i, Qr = /\d+/i, Xr = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Zr = {
  any: [/^b/i, /^(a|c)/i]
}, Jr = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, _r = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, eu = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, tu = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, nu = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, au = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, lu = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, su = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, iu = {
  ordinalNumber: qr({
    matchPattern: Kr,
    parsePattern: Qr,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Dt({
    matchPatterns: Xr,
    defaultMatchWidth: "wide",
    parsePatterns: Zr,
    defaultParseWidth: "any"
  }),
  quarter: Dt({
    matchPatterns: Jr,
    defaultMatchWidth: "wide",
    parsePatterns: _r,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Dt({
    matchPatterns: eu,
    defaultMatchWidth: "wide",
    parsePatterns: tu,
    defaultParseWidth: "any"
  }),
  day: Dt({
    matchPatterns: nu,
    defaultMatchWidth: "wide",
    parsePatterns: au,
    defaultParseWidth: "any"
  }),
  dayPeriod: Dt({
    matchPatterns: lu,
    defaultMatchWidth: "any",
    parsePatterns: su,
    defaultParseWidth: "any"
  })
}, ou = {
  code: "en-US",
  formatDistance: Er,
  formatLong: $r,
  formatRelative: Vr,
  localize: jr,
  match: iu,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ru(e, t) {
  const n = me(e, t == null ? void 0 : t.in);
  return Tr(n, Ir(n)) + 1;
}
function uu(e, t) {
  const n = me(e, t == null ? void 0 : t.in), a = +nn(n) - +Sr(n);
  return Math.round(a / es) + 1;
}
function ns(e, t) {
  var c, f, m, h;
  const n = me(e, t == null ? void 0 : t.in), a = n.getFullYear(), l = Bn(), s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? l.firstWeekContainsDate ?? ((h = (m = l.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = Le((t == null ? void 0 : t.in) || e, 0);
  i.setFullYear(a + 1, 0, s), i.setHours(0, 0, 0, 0);
  const o = Ot(i, t), r = Le((t == null ? void 0 : t.in) || e, 0);
  r.setFullYear(a, 0, s), r.setHours(0, 0, 0, 0);
  const u = Ot(r, t);
  return +n >= +o ? a + 1 : +n >= +u ? a : a - 1;
}
function du(e, t) {
  var o, r, u, c;
  const n = Bn(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((r = (o = t == null ? void 0 : t.locale) == null ? void 0 : o.options) == null ? void 0 : r.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, l = ns(e, t), s = Le((t == null ? void 0 : t.in) || e, 0);
  return s.setFullYear(l, 0, a), s.setHours(0, 0, 0, 0), Ot(s, t);
}
function cu(e, t) {
  const n = me(e, t == null ? void 0 : t.in), a = +Ot(n, t) - +du(n, t);
  return Math.round(a / es) + 1;
}
function le(e, t) {
  const n = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(t, "0");
  return n + a;
}
const Ue = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
    return le(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : le(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return le(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return le(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return le(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return le(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return le(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, a = e.getMilliseconds(), l = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return le(l, t.length);
  }
}, gt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Na = {
  // Era
  G: function(e, t, n) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const a = e.getFullYear(), l = a > 0 ? a : 1 - a;
      return n.ordinalNumber(l, { unit: "year" });
    }
    return Ue.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    const l = ns(e, a), s = l > 0 ? l : 1 - l;
    if (t === "YY") {
      const i = s % 100;
      return le(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : le(s, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = ts(e);
    return le(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return le(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return le(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return le(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ue.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return le(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    const l = cu(e, a);
    return t === "wo" ? n.ordinalNumber(l, { unit: "week" }) : le(l, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const a = uu(e);
    return t === "Io" ? n.ordinalNumber(a, { unit: "week" }) : le(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Ue.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const a = ru(e);
    return t === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : le(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const a = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    const l = e.getDay(), s = (l - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return le(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(l, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(l, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(l, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    const l = e.getDay(), s = (l - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return le(s, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(l, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(l, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(l, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(l, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const a = e.getDay(), l = a === 0 ? 7 : a;
    switch (t) {
      // 2
      case "i":
        return String(l);
      // 02
      case "ii":
        return le(l, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(l, { unit: "day" });
      // Tue
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const l = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const a = e.getHours();
    let l;
    switch (a === 12 ? l = gt.noon : a === 0 ? l = gt.midnight : l = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const a = e.getHours();
    let l;
    switch (a >= 17 ? l = gt.evening : a >= 12 ? l = gt.afternoon : a >= 4 ? l = gt.morning : l = gt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return Ue.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Ue.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const a = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : le(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let a = e.getHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : le(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ue.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ue.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ue.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Ya(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return tt(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return tt(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Ya(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return tt(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return tt(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + za(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + tt(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + za(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + tt(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const a = Math.trunc(+e / 1e3);
    return le(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return le(+e, t.length);
  }
};
function za(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), l = Math.trunc(a / 60), s = a % 60;
  return s === 0 ? n + String(l) : n + String(l) + t + le(s, 2);
}
function Ya(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + le(Math.abs(e) / 60, 2) : tt(e, t);
}
function tt(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), l = le(Math.trunc(a / 60), 2), s = le(a % 60, 2);
  return n + l + t + s;
}
const Wa = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, as = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, fu = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], a = n[1], l = n[2];
  if (!l)
    return Wa(e, t);
  let s;
  switch (a) {
    case "P":
      s = t.dateTime({ width: "short" });
      break;
    case "PP":
      s = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = t.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", Wa(a, t)).replace("{{time}}", as(l, t));
}, hu = {
  p: as,
  P: fu
}, mu = /^D+$/, pu = /^Y+$/, gu = ["D", "DD", "YY", "YYYY"];
function vu(e) {
  return mu.test(e);
}
function yu(e) {
  return pu.test(e);
}
function bu(e, t, n) {
  const a = ku(e, t, n);
  if (console.warn(a), gu.includes(e)) throw new RangeError(a);
}
function ku(e, t, n) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const wu = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, xu = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Cu = /^'([^]*?)'?$/, Tu = /''/g, Su = /[a-zA-Z]/;
function Bu(e, t, n) {
  var c, f, m, h;
  const a = Bn(), l = a.locale ?? ou, s = a.firstWeekContainsDate ?? ((f = (c = a.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = a.weekStartsOn ?? ((h = (m = a.locale) == null ? void 0 : m.options) == null ? void 0 : h.weekStartsOn) ?? 0, o = me(e, n == null ? void 0 : n.in);
  if (!Dr(o))
    throw new RangeError("Invalid time value");
  let r = t.match(xu).map((g) => {
    const v = g[0];
    if (v === "p" || v === "P") {
      const y = hu[v];
      return y(g, l.formatLong);
    }
    return g;
  }).join("").match(wu).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const v = g[0];
    if (v === "'")
      return { isToken: !1, value: Du(g) };
    if (Na[v])
      return { isToken: !0, value: g };
    if (v.match(Su))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + v + "`"
      );
    return { isToken: !1, value: g };
  });
  l.localize.preprocessor && (r = l.localize.preprocessor(o, r));
  const u = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: l
  };
  return r.map((g) => {
    if (!g.isToken) return g.value;
    const v = g.value;
    (yu(v) || vu(v)) && bu(v, t, String(e));
    const y = Na[v[0]];
    return y(o, v, l.localize, u);
  }).join("");
}
function Du(e) {
  const t = e.match(Cu);
  return t ? t[1].replace(Tu, "'") : e;
}
function ja(e, t) {
  const a = me(e, t == null ? void 0 : t.in).getFullYear();
  return Math.floor(a / 10) * 10;
}
function ls(e, t) {
  return +me(e) > +me(t);
}
function ss(e, t) {
  return +me(e) < +me(t);
}
function Iu(e, t, n) {
  return fa(e, -t, n);
}
const Mu = (e, t) => {
  const n = O(ja(t.value));
  return {
    viewDecade: n,
    toggleDecadeYearsView: () => {
      if (e.value === "decade-years") {
        e.value = "month-days";
        return;
      }
      n.value = ja(t.value), e.value = "decade-years";
    },
    goToNextDecade: () => {
      n.value += 10;
    },
    goToPreviousDecade: () => {
      n.value -= 10;
    }
  };
}, Eu = (e, t) => ({
  goToNextMonth: () => {
    if (e.value === "month-days") {
      t.value = fa(t.value, 1);
      return;
    }
  },
  goToPreviousMonth: () => {
    if (e.value === "month-days") {
      t.value = Iu(t.value, 1);
      return;
    }
  }
}), Au = (e, t) => {
  const n = O(t.value.getFullYear());
  return {
    viewYear: n,
    toggleYearMonthsView: () => {
      if (e.value === "year-months") {
        e.value = "month-days";
        return;
      }
      n.value = t.value.getFullYear(), e.value = "year-months";
    },
    goToNextYear: () => {
      n.value += 1;
    },
    goToPreviousYear: () => {
      n.value -= 1;
    }
  };
}, Fu = (e, t) => {
  const { goToNextMonth: n, goToPreviousMonth: a } = Eu(
    e,
    t
  ), {
    viewDecade: l,
    toggleDecadeYearsView: s,
    goToNextDecade: i,
    goToPreviousDecade: o
  } = Mu(e, t), { viewYear: r, toggleYearMonthsView: u, goToNextYear: c, goToPreviousYear: f } = Au(e, t);
  return {
    goToNext: () => {
      if (e.value === "decade-years") {
        i();
        return;
      }
      if (e.value === "year-months") {
        c();
        return;
      }
      n();
    },
    goToPrevious: () => {
      if (e.value === "decade-years") {
        o();
        return;
      }
      if (e.value === "year-months") {
        f();
        return;
      }
      a();
    },
    viewDecade: l,
    toggleDecadeYearsView: s,
    viewYear: r,
    toggleYearMonthsView: u
  };
}, Nt = () => {
  const e = fe(Jl), t = k(() => e.value === null ? null : e.value.getMonth()), n = k(() => e.value === null ? null : e.value.getFullYear());
  return {
    dateVModel: e,
    vModelMonth: t,
    vModelYear: n
  };
}, Dn = (e) => {
  const t = k(() => ["sm", "small"].includes(e.size)), n = k(
    () => ["lg", "large"].includes(e.size) || e.size == null
  );
  return {
    isSmall: t,
    isLarge: n
  };
}, $n = {
  primary: (
    /* tw */
    "focus:outline-gp-cyan-light/50!"
  ),
  flat: (
    /* tw */
    "focus:outline-gp-charcoal-grey-light/50!"
  ),
  neutral: (
    /* tw */
    "focus:outline-gp-mouse-light/50!"
  ),
  danger: (
    /* tw */
    "focus:outline-gp-fire-light/50! "
  ),
  success: (
    /* tw */
    "focus:outline-gp-green-light/50! "
  ),
  warning: (
    /* tw */
    "focus:outline-gp-orange-light/50! "
  ),
  info: (
    /* tw */
    "focus:outline-gp-ocean-light/50! "
  ),
  transparent: (
    /* tw */
    "focus:outline-gp-mouse-light/50! "
  )
}, Ha = (
  /* tw */
  "border-transparent"
), Ou = (
  /* tw */
  "border-x-0 border-t-0 rounded-none border-b-gp-rhino text-sm"
), is = (e) => {
  const { isLarge: t, isSmall: n } = Dn(e), { hasIconOnly: a } = bn(e);
  return k(() => {
    const s = new Array();
    return t.value ? (s.push(
      /* tw */
      "py-3 tracking-lg-btn focus:outline-4!"
    ), a.value ? s.push(
      /* tw */
      "w-component-lg"
    ) : e.btnType !== "underline" && s.push(
      /* tw */
      "px-6"
    )) : n.value && (s.push(
      /* tw */
      "py-1 tracking-wider leading-5 focus:outline-2!"
    ), a.value ? s.push(
      /* tw */
      "w-component-base"
    ) : e.btnType !== "underline" && s.push("px-3")), e.btnType === "flat" ? (s.push(Xt.flat), s.push(it.flat), s.push($n.flat), s.push(Ha)) : e.btnType === "cancel" ? s.push(Zt.neutral) : e.outline ? s.push(Zt[e.btnType]) : e.btnType === "underline" ? (s.push(Ou), s.push($n.transparent)) : (s.push(Xt[e.btnType]), s.push(it[e.btnType]), s.push($n[e.btnType]), s.push(Ha)), e.disabled && s.push(
      /* tw */
      "opacity-70 pointer-events-none"
    ), s;
  });
}, $u = ["disabled", "type"], we = /* @__PURE__ */ E({
  __name: "GpBtn",
  props: {
    label: { default: void 0 },
    size: { default: "large" },
    btnType: { default: "primary" },
    outline: { type: Boolean, default: !1 },
    icon: { default: null },
    disabled: { type: Boolean, default: !1 },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = is(n), { hasLabel: s } = bn(n), { isLarge: i, isSmall: o } = Dn(n), r = (u) => {
      a("click", u);
    };
    return (u, c) => (p(), x("button", {
      class: I(["whitespace-nowrap rounded border font-bold uppercase transition-colors focus:outline-2!", d(l)]),
      disabled: e.disabled,
      type: e.type,
      onClick: r
    }, [
      w(u.$slots, "default", {}, () => [
        e.icon != null ? (p(), D(d(Q), {
          key: 0,
          icon: e.icon,
          class: I({
            "mr-1": d(o) && d(s),
            "mr-2": d(i) && d(s)
          })
        }, null, 8, ["icon", "class"])) : $("", !0),
        ne(" " + G(e.label), 1)
      ]),
      w(u.$slots, "end")
    ], 10, $u));
  }
}), xt = /* @__PURE__ */ E({
  name: "GpSlideTransition",
  __name: "GpSlideTransition",
  props: {
    mode: { default: "default" },
    direction: { default: "left" },
    disabled: { type: Boolean, default: !1 },
    duration: { default: 200 }
  },
  setup(e) {
    const t = z(() => e.duration), {
      TRANSITION_DURATION_CLASS: n,
      onEnterTransitioning: a,
      onLeaveTransitioning: l,
      onAfterTransitioning: s
    } = vn(t), i = {
      left: {
        enterFromClass: (
          /* tw */
          "translate-x-(--gp-slide-size) opacity-0"
        ),
        enterActiveClass: `transition-all transition-ease-in ${n}`,
        enterToClass: "translate-x-0 opacity-100",
        leaveFromClass: "translate-x-0 opacity-100",
        leaveActiveClass: `transition-all transition-ease-out ${n}`,
        leaveToClass: (
          /* tw */
          "-translate-x-(--gp-slide-size) opacity-0"
        )
      },
      right: {
        enterFromClass: (
          /* tw */
          "-translate-x-(--gp-slide-size) opacity-0"
        ),
        enterActiveClass: `transition-all transition-ease-in ${n}`,
        enterToClass: "translate-x-0 opacity-100",
        leaveFromClass: "translate-x-0 opacity-100",
        leaveActiveClass: `transition-all transition-ease-out ${n}`,
        leaveToClass: (
          /* tw */
          "translate-x-(--gp-slide-size) opacity-0"
        )
      },
      up: {
        enterFromClass: (
          /* tw */
          "translate-y-(--gp-slide-size) opacity-0"
        ),
        enterActiveClass: `transition-all transition-ease-in ${n}`,
        enterToClass: "translate-y-0 opacity-100",
        leaveFromClass: "translate-y-0 opacity-100",
        leaveActiveClass: `transition-all transition-ease-out ${n}`,
        leaveToClass: (
          /* tw */
          "-translate-y-(--gp-slide-size) opacity-0"
        )
      },
      down: {
        enterFromClass: (
          /* tw */
          "-translate-y-(--gp-slide-size) opacity-0"
        ),
        enterActiveClass: `transition-all transition-ease-in ${n}`,
        enterToClass: "translate-y-0 opacity-100",
        leaveFromClass: "translate-y-0 opacity-100",
        leaveActiveClass: `transition-all transition-ease-out ${n}`,
        leaveToClass: (
          /* tw */
          "translate-y-(--gp-slide-size) opacity-0"
        )
      }
    }, o = k(
      () => i[e.direction] ?? i.left
    ), r = k(() => e.disabled ? {} : (
      // transition classes, adapt as needed
      {
        ...o.value,
        onEnter: a,
        onLeave: l,
        onAfterEnter: s,
        onAfterLeave: s
      }
    ));
    return (u, c) => (p(), D(ct, re({ ...r.value, mode: e.mode }, { style: {
      "--gp-slide-size": "100%"
    } }), {
      default: T(() => [
        w(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Lu = { class: "text-center" }, Vu = /* @__PURE__ */ E({
  __name: "GpDateDecadeYearsNavigator",
  props: {
    viewDecade: {},
    slideDirection: {}
  },
  emits: ["toggleDecadeYearsView"],
  setup(e, { emit: t }) {
    const n = t, a = k(() => `${e.viewDecade} - ${e.viewDecade + 9}`);
    return (l, s) => (p(), x("div", Lu, [
      A(we, {
        size: "sm",
        "btn-type": "transparent",
        "data-testid": "calendar-year-btn",
        onClick: s[0] || (s[0] = (i) => n("toggleDecadeYearsView"))
      }, {
        default: T(() => [
          A(xt, {
            mode: "out-in",
            direction: e.slideDirection,
            style: {
              "--gp-slide-size": "3rem"
            }
          }, {
            default: T(() => [
              (p(), x("span", {
                key: e.viewDecade,
                class: "block"
              }, G(a.value), 1))
            ]),
            _: 1
          }, 8, ["direction"])
        ]),
        _: 1
      })
    ]));
  }
}), Ru = { class: "mt-2" }, ha = /* @__PURE__ */ E({
  __name: "GpDatePickerViewLayout",
  props: {
    month: { default: () => -1 },
    year: {}
  },
  setup(e) {
    const t = O("left");
    return H(
      () => e.month,
      (n, a) => {
        n > a ? t.value = "left" : t.value = "right";
      }
    ), H(
      () => e.year,
      (n, a) => {
        n > a ? t.value = "left" : t.value = "right";
      }
    ), (n, a) => (p(), x("div", Ru, [
      w(n.$slots, "header"),
      A(xt, {
        mode: "out-in",
        style: {
          // undefined -> default 100%
          "--gp-slide-size": "2rem"
        },
        direction: t.value
      }, {
        default: T(() => [
          w(n.$slots, "default")
        ]),
        _: 3
      }, 8, ["direction"])
    ]));
  }
}), ma = (e, t) => k(() => {
  const a = d(e), l = d(t);
  return a ? [Xt.primary, it.primary].join(
    " "
  ) : l ? (
    /* tw */
    "bg-gp-midnight-3-a"
  ) : it.flat;
}), pa = (e) => {
  const t = d(e);
  return k(() => t ? (
    /* tw */
    "cursor-not-allowed line-through decoration-gp-rhino opacity-50 pointer-events-none"
  ) : (
    /* tw */
    "cursor-pointer"
  ));
}, Pu = { class: "text-center" }, Gu = ["aria-selected", "aria-disabled"], Nu = /* @__PURE__ */ E({
  __name: "GpDateDecadeYearsItem",
  props: {
    year: {},
    isCurrentSelectedYear: { type: Boolean, default: !1 },
    isTodaysYear: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["selectYear"],
  setup(e, { emit: t }) {
    const n = t, a = z(() => e.isCurrentSelectedYear), l = z(() => e.isTodaysYear), s = z(() => e.disabled), i = ma(
      a,
      l
    ), o = pa(s), r = (u) => {
      e.disabled || n("selectYear", u);
    };
    return (u, c) => (p(), x("li", Pu, [
      L("button", {
        class: I(["h-component-base rounded px-4 py-1 transition-colors", [d(i), d(o)]]),
        onClick: c[0] || (c[0] = () => r(e.year)),
        "aria-selected": e.isCurrentSelectedYear,
        "aria-disabled": e.disabled ? e.disabled : void 0
      }, G(e.year), 11, Gu)
    ]));
  }
}), zt = () => {
  const e = fe(_l), t = k(() => e.value ? e.value.getMonth() : (/* @__PURE__ */ new Date()).getMonth()), n = k(() => e.value ? e.value.getFullYear() : (/* @__PURE__ */ new Date()).getFullYear());
  return {
    displayDate: e,
    displayMonth: t,
    displayYear: n
  };
}, zu = {
  class: "grid grid-cols-2 gap-2",
  "data-testid": "calendar-years-grid"
}, Yu = /* @__PURE__ */ E({
  __name: "GpDateDecadeYearsGrid",
  props: {
    years: { default: () => [] },
    minDate: { default: null },
    maxDate: { default: null }
  },
  setup(e) {
    const { displayDate: t } = zt(), n = (o) => o === (/* @__PURE__ */ new Date()).getFullYear(), { vModelYear: a } = Nt(), l = (o) => o === a.value, s = (o) => {
      t.value = new Date(o, t.value.getMonth(), 1);
    }, i = (o) => e.minDate && e.maxDate ? o < e.minDate.getFullYear() || o > e.maxDate.getFullYear() : e.minDate ? o < e.minDate.getFullYear() : e.maxDate ? o > e.maxDate.getFullYear() : !1;
    return (o, r) => (p(), x("ul", zu, [
      (p(!0), x(X, null, ce(e.years, (u) => (p(), D(Nu, {
        key: u,
        year: u,
        "is-current-selected-year": l(u),
        "is-todays-year": n(u),
        disabled: i(u),
        onSelectYear: s,
        "data-testid": `calendar-year-${u}`
      }, null, 8, ["year", "is-current-selected-year", "is-todays-year", "disabled", "data-testid"]))), 128))
    ]));
  }
}), Wu = /* @__PURE__ */ E({
  __name: "GpDateDecadeYearsView",
  props: {
    viewDecade: {},
    minDate: {},
    maxDate: {}
  },
  setup(e) {
    const t = O(
      null
    ), n = k(() => Array.from({ length: 10 }, (a, l) => e.viewDecade + l));
    return (a, l) => (p(), D(ha, {
      ref_key: "viewLayout",
      ref: t,
      year: e.viewDecade
    }, {
      default: T(() => [
        (p(), D(Yu, {
          class: "mt-2",
          years: n.value,
          key: n.value[0],
          "min-date": e.minDate,
          "max-date": e.maxDate
        }, null, 8, ["years", "min-date", "max-date"]))
      ]),
      _: 1
    }, 8, ["year"]));
  }
}), ju = { class: "flex" }, Hu = { class: "w-2/3 text-center" }, Uu = { class: "w-1/3 text-center" }, qu = /* @__PURE__ */ E({
  __name: "GpDateMonthDaysNavigator",
  props: {
    slideDirection: {},
    localizations: {}
  },
  emits: ["toggleYearMonthsView", "toggleYearView"],
  setup(e, { emit: t }) {
    const { displayMonth: n, displayYear: a } = zt(), l = t, s = k(() => {
      if (e.localizations != null && e.localizations.months != null && e.localizations.months.length) {
        if (e.localizations.months.length !== 12)
          throw new Error("The months array must contain 12 items");
        return e.localizations.months[n.value];
      }
      return new Date(0, n.value).toLocaleString(void 0, {
        month: "long"
      });
    });
    return (i, o) => (p(), x("div", ju, [
      L("div", Hu, [
        A(we, {
          size: "sm",
          "btn-type": "transparent",
          "data-testid": "calendar-month-btn",
          onClick: o[0] || (o[0] = (r) => l("toggleYearMonthsView"))
        }, {
          default: T(() => [
            A(xt, {
              mode: "out-in",
              direction: e.slideDirection,
              style: {
                "--gp-slide-size": "0.5rem"
              }
            }, {
              default: T(() => [
                (p(), x("span", {
                  key: d(n),
                  class: "block"
                }, G(s.value), 1))
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _: 1
        })
      ]),
      L("div", Uu, [
        A(we, {
          size: "sm",
          "btn-type": "transparent",
          "data-testid": "calendar-year-btn",
          onClick: o[1] || (o[1] = (r) => l("toggleYearView"))
        }, {
          default: T(() => [
            A(xt, {
              mode: "out-in",
              direction: e.slideDirection,
              style: {
                "--gp-slide-size": "0.5rem"
              }
            }, {
              default: T(() => [
                (p(), x("span", { key: d(a) }, G(d(a)), 1))
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _: 1
        })
      ])
    ]));
  }
}), Ku = ["aria-selected", "aria-disabled"], Ln = /* @__PURE__ */ E({
  __name: "GpDateMonthDaysItem",
  props: {
    day: {},
    isToday: { type: Boolean, default: !1 },
    isSelected: { type: Boolean, default: !1 },
    isDisplayedMonth: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, a = k(() => e.isSelected), l = k(() => e.isToday), s = k(() => e.disabled), i = ma(a, l), o = pa(s);
    return (r, u) => (p(), x("li", null, [
      L("button", {
        class: I(["size-component-base rounded-full text-center leading-7 transition-colors", {
          [d(i)]: !0,
          [d(o)]: !0,
          "opacity-50": !e.isDisplayedMonth
        }]),
        onClick: u[0] || (u[0] = (c) => !e.disabled && n("click")),
        "aria-selected": e.isSelected,
        "aria-disabled": e.disabled ? e.disabled : void 0
      }, G(e.day), 11, Ku)
    ]));
  }
}), Qu = {
  class: "grid grid-cols-7 justify-items-center gap-2",
  "data-testid": "calendar-month-days-grid"
}, Xu = /* @__PURE__ */ E({
  __name: "GpDateMonthDaysGrid",
  props: {
    minDate: { default: null },
    maxDate: { default: null }
  },
  setup(e) {
    const { dateVModel: t, vModelMonth: n, vModelYear: a } = Nt(), {
      displayDate: l,
      displayMonth: s,
      displayYear: i
    } = zt(), o = k(() => l.value.getDay() === 0 ? 7 : l.value.getDay()), r = k(() => new Date(
      i.value,
      s.value + 1,
      0
    ).getDate()), u = k(() => s.value - 1), c = k(() => {
      const b = new Date(
        i.value,
        s.value,
        0
      ).getDate();
      return o.value === 0 ? [] : Array.from(
        // size of the array is the first day of the current month minus 1
        { length: o.value - 1 },
        // fill the array with the last days of the previous month by calculating the difference
        (S, B) => b - B
      ).reverse();
    }), f = k(() => s.value + 1), m = k(() => {
      const b = fa(l.value, 1);
      return new Date(
        b.getFullYear(),
        b.getMonth(),
        1
      ).getDay() === 0 ? 1 : 8 - new Date(b.getFullYear(), b.getMonth(), 1).getDay();
    }), h = ({ day: b }) => {
      const S = /* @__PURE__ */ new Date();
      return S.getFullYear() === i.value && S.getMonth() === s.value && S.getDate() === b;
    }, g = ({ day: b }) => a.value === i.value && n.value === s.value && t.value.getDate() === b, v = ({ day: b, month: S }) => !!(e.minDate != null && ss(new Date(i.value, S, b), e.minDate) || e.maxDate != null && ls(new Date(i.value, S, b), e.maxDate)), y = ({ day: b, month: S }) => {
      if (S === 12) {
        t.value = new Date(i.value + 1, 0, b);
        return;
      } else if (S === -1) {
        t.value = new Date(i.value - 1, 11, b);
        return;
      }
      t.value = new Date(i.value, S, b);
    };
    return (b, S) => (p(), x("ul", Qu, [
      (p(!0), x(X, null, ce(c.value, (B) => (p(), D(Ln, {
        key: `${u.value}-${B}`,
        class: "col-span-1",
        day: B,
        "is-selected": !1,
        "is-today": !1,
        "is-displayed-month": !1,
        disabled: v({ day: B, month: u.value }),
        onClick: (M) => y({ day: B, month: u.value }),
        "data-testid": `calendar-day-${u.value}-${B}`
      }, null, 8, ["day", "disabled", "onClick", "data-testid"]))), 128)),
      (p(!0), x(X, null, ce(r.value, (B) => (p(), D(Ln, {
        key: `${d(s)}-${B}`,
        class: "col-span-1",
        day: B,
        "is-selected": g({ day: B }),
        "is-today": h({ day: B }),
        disabled: v({ day: B, month: d(s) }),
        onClick: (M) => y({ day: B, month: d(s) }),
        "data-testid": `calendar-day-${d(s)}-${B}`
      }, null, 8, ["day", "is-selected", "is-today", "disabled", "onClick", "data-testid"]))), 128)),
      (p(!0), x(X, null, ce(m.value, (B) => (p(), D(Ln, {
        key: `${f.value}-${B}`,
        class: "col-span-1",
        day: B,
        "is-selected": !1,
        "is-today": !1,
        "is-displayed-month": !1,
        disabled: v({ day: B, month: f.value }),
        onClick: (M) => y({ day: B, month: f.value }),
        "data-testid": `calendar-day-${f.value}-${B}`
      }, null, 8, ["day", "disabled", "onClick", "data-testid"]))), 128))
    ]));
  }
}), Zu = { class: "grid grid-cols-7" }, Ju = /* @__PURE__ */ E({
  __name: "GpDateMonthDaysView",
  props: {
    localizations: {},
    minDate: {},
    maxDate: {}
  },
  setup(e) {
    const { dateVModel: t, vModelYear: n, vModelMonth: a } = Nt(), {
      displayDate: l,
      displayMonth: s,
      displayYear: i
    } = zt(), o = O();
    H(t, () => {
      l.value = new Date(n.value, a.value, 1);
    });
    const r = k(() => {
      if (e.localizations != null && e.localizations.weekdaysShort != null && e.localizations.weekdaysShort.length > 0)
        if (e.localizations.weekdaysShort.length !== 7)
          console.warn(
            "The provided localizations.weekdaysShort array does not contain 7 weekdays. Using default weekday names based on current locale."
          );
        else
          return e.localizations.weekdaysShort;
      return Array.from({ length: 7 }, (u, c) => c + 1).map(
        (u) => new Date(1970, 1, u + 1).toLocaleDateString(navigator.language, {
          weekday: "short"
        })
      );
    });
    return (u, c) => (p(), D(ha, {
      ref_key: "viewLayout",
      ref: o,
      year: d(i),
      month: d(s)
    }, {
      header: T(() => [
        L("ul", Zu, [
          (p(!0), x(X, null, ce(r.value, (f) => (p(), x("li", {
            class: "col-span-1 text-center text-sm text-gp-rhino",
            key: f,
            "data-testid": "calendar-weekday"
          }, G(f), 1))), 128))
        ])
      ]),
      default: T(() => [
        (p(), D(Xu, {
          key: `${d(i)}-${d(s)}`,
          "min-date": e.minDate,
          "max-date": e.maxDate
        }, null, 8, ["min-date", "max-date"]))
      ]),
      _: 1
    }, 8, ["year", "month"]));
  }
}), _u = { class: "flex w-full items-center justify-between" }, ed = /* @__PURE__ */ E({
  __name: "GpDatePickerNavigator",
  props: {
    prevDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["navigatePrev", "navigateNext"],
  setup(e, { emit: t }) {
    const n = t, a = O("left"), l = () => {
      a.value = "right", n("navigatePrev");
    }, s = () => {
      a.value = "left", n("navigateNext");
    };
    return (i, o) => (p(), x("div", _u, [
      A(we, {
        icon: d(ul),
        size: "sm",
        "btn-type": "flat",
        disabled: e.prevDisabled,
        "data-testid": "calendar-prev-btn",
        onClick: l
      }, null, 8, ["icon", "disabled"]),
      A(xt, {
        mode: "out-in",
        direction: "down",
        style: {
          "--gp-slide-size": ".5rem"
        }
      }, {
        default: T(() => [
          w(i.$slots, "default", W(j({
            slideDirection: a.value
          })))
        ]),
        _: 3
      }),
      A(we, {
        icon: d(dl),
        size: "sm",
        "btn-type": "flat",
        disabled: e.nextDisabled,
        "data-testid": "calendar-next-btn",
        onClick: s
      }, null, 8, ["icon", "disabled"])
    ]));
  }
}), td = { class: "text-center" }, nd = /* @__PURE__ */ E({
  __name: "GpDateYearMonthsNavigator",
  props: {
    viewYear: {},
    slideDirection: {}
  },
  emits: ["toggleYearMonthsView"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, l) => (p(), x("div", td, [
      A(we, {
        size: "sm",
        "btn-type": "transparent",
        "data-testid": "calendar-year-btn",
        onClick: l[0] || (l[0] = (s) => n("toggleYearMonthsView"))
      }, {
        default: T(() => [
          A(xt, {
            mode: "out-in",
            direction: e.slideDirection,
            style: {
              "--gp-slide-size": "0.5rem"
            }
          }, {
            default: T(() => [
              (p(), x("span", {
                key: e.viewYear,
                class: "block"
              }, G(e.viewYear), 1))
            ]),
            _: 1
          }, 8, ["direction"])
        ]),
        _: 1
      })
    ]));
  }
}), ad = { class: "p-2 text-center" }, ld = ["aria-selected", "aria-disabled"], sd = /* @__PURE__ */ E({
  __name: "GpDateYearMonthsItem",
  props: {
    label: {},
    month: {},
    isCurrentSelectedMonth: { type: Boolean, default: !1 },
    isTodaysMonth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["selectMonth"],
  setup(e, { emit: t }) {
    const n = t, a = z(() => e.isCurrentSelectedMonth), l = z(() => e.isTodaysMonth), s = z(() => e.disabled), i = ma(
      a,
      l
    ), o = pa(s), r = (u) => {
      e.disabled || n("selectMonth", u);
    };
    return (u, c) => (p(), x("li", ad, [
      L("button", {
        class: I(["h-component-base rounded px-4 py-1 transition-colors", [d(i), d(o)]]),
        onClick: c[0] || (c[0] = () => r(e.month)),
        "aria-selected": e.isCurrentSelectedMonth,
        "aria-disabled": e.disabled ? e.disabled : void 0
      }, G(e.label), 11, ld)
    ]));
  }
}), id = {
  class: "grid grid-cols-3",
  "data-testid": "calendar-year-months-grid"
}, od = /* @__PURE__ */ E({
  __name: "GpDateYearMonthsGrid",
  props: {
    viewYear: {},
    minDate: { default: null },
    maxDate: { default: null },
    localizations: {}
  },
  setup(e) {
    const { displayDate: t } = zt(), n = (u) => u === (/* @__PURE__ */ new Date()).getMonth() && e.viewYear === (/* @__PURE__ */ new Date()).getFullYear(), { vModelMonth: a, vModelYear: l } = Nt(), s = (u) => u === a.value && e.viewYear === l.value, i = (u) => {
      t.value = new Date(e.viewYear, u, 1);
    }, o = k(() => {
      if (e.localizations != null && e.localizations.monthsShort != null && e.localizations.monthsShort.length > 0)
        if (e.localizations.monthsShort.length !== 12)
          console.warn(
            "The provided localizations.monthsShort array does not contain 12 months. Using default month names based on current locale."
          );
        else
          return e.localizations.monthsShort;
      return Array.from({ length: 12 }, (u, c) => new Date(0, c).toLocaleString(void 0, { month: "short" }));
    }), r = (u) => e.minDate ? new Date(e.viewYear, u, 1) < new Date(e.minDate.getFullYear(), e.minDate.getMonth(), 1) : e.maxDate ? new Date(e.viewYear, u, 1) > new Date(e.maxDate.getFullYear(), e.maxDate.getMonth(), 1) : !1;
    return (u, c) => (p(), x("ul", id, [
      (p(), x(X, null, ce(12, (f) => A(sd, {
        key: f,
        month: f - 1,
        label: o.value[f - 1],
        "is-current-selected-month": s(f - 1),
        "is-todays-month": n(f - 1),
        disabled: r(f - 1),
        onSelectMonth: i,
        "data-testid": `calendar-month-${f - 1}`
      }, null, 8, ["month", "label", "is-current-selected-month", "is-todays-month", "disabled", "data-testid"])), 64))
    ]));
  }
}), rd = /* @__PURE__ */ E({
  __name: "GpDateYearMonthsView",
  props: {
    viewYear: {},
    minDate: { default: null },
    maxDate: { default: null },
    localizations: {}
  },
  setup(e) {
    const t = O(
      null
    );
    return (n, a) => (p(), D(ha, {
      ref_key: "viewLayout",
      ref: t,
      year: e.viewYear
    }, {
      default: T(() => [
        (p(), D(od, {
          key: `${e.viewYear}`,
          "view-year": e.viewYear,
          "min-date": e.minDate,
          "max-date": e.maxDate,
          localizations: e.localizations
        }, null, 8, ["view-year", "min-date", "max-date", "localizations"]))
      ]),
      _: 1
    }, 8, ["year"]));
  }
}), ud = {
  class: "min-w-80 overflow-x-hidden rounded-b bg-gp-midnight-2 p-4",
  "data-testid": "datepicker-calendar"
}, dd = /* @__PURE__ */ E({
  __name: "GpDatePickerCalendar",
  props: {
    localizations: {},
    minDate: { default: null },
    maxDate: { default: null }
  },
  setup(e) {
    const { vModelYear: t, vModelMonth: n } = Nt(), a = () => t.value == null ? (/* @__PURE__ */ new Date()).getFullYear() : t.value, l = () => n.value == null ? (/* @__PURE__ */ new Date()).getMonth() : n.value, s = oe(new Date(a(), l(), 1));
    Xe(_l, s);
    const i = O("month-days"), {
      viewDecade: o,
      toggleDecadeYearsView: r,
      viewYear: u,
      toggleYearMonthsView: c,
      goToNext: f,
      goToPrevious: m
    } = Fu(i, s);
    return H(
      s,
      () => {
        i.value = "month-days";
      },
      {
        immediate: !0
      }
    ), (h, g) => (p(), x("div", ud, [
      A(ed, {
        onNavigateNext: d(f),
        onNavigatePrev: d(m)
      }, {
        default: T(({ slideDirection: v }) => [
          i.value === "decade-years" ? (p(), D(Vu, {
            key: 0,
            class: "flex-1",
            "view-decade": d(o),
            "slide-direction": v,
            onToggleDecadeYearsView: d(r)
          }, null, 8, ["view-decade", "slide-direction", "onToggleDecadeYearsView"])) : i.value === "year-months" ? (p(), D(nd, {
            key: 1,
            class: "flex-1",
            "view-year": d(u),
            "slide-direction": v,
            onToggleYearMonthsView: d(c)
          }, null, 8, ["view-year", "slide-direction", "onToggleYearMonthsView"])) : (p(), D(qu, {
            key: 2,
            class: "flex-1",
            localizations: e.localizations,
            "slide-direction": v,
            onToggleYearMonthsView: d(c),
            onToggleYearView: d(r)
          }, null, 8, ["localizations", "slide-direction", "onToggleYearMonthsView", "onToggleYearView"]))
        ]),
        _: 1
      }, 8, ["onNavigateNext", "onNavigatePrev"]),
      A(Ye, {
        mode: "out-in",
        style: {
          "--gp-transition-in-delay": "300ms"
        }
      }, {
        default: T(() => [
          i.value === "decade-years" ? (p(), D(Wu, {
            key: 0,
            "view-decade": d(o),
            "min-date": e.minDate,
            "max-date": e.maxDate
          }, null, 8, ["view-decade", "min-date", "max-date"])) : i.value === "year-months" ? (p(), D(rd, {
            key: 1,
            "view-year": d(u),
            "min-date": e.minDate,
            "max-date": e.maxDate,
            localizations: e.localizations
          }, null, 8, ["view-year", "min-date", "max-date", "localizations"])) : (p(), D(Ju, {
            key: 2,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            localizations: e.localizations
          }, null, 8, ["min-date", "max-date", "localizations"]))
        ]),
        _: 1
      })
    ]));
  }
}), cd = { class: "flex-1 leading-7" }, fd = { key: 0 }, hd = {
  key: 1,
  class: "text-gp-rhino"
}, _f = /* @__PURE__ */ E({
  name: "GpDatePicker",
  __name: "GpDatePicker",
  props: /* @__PURE__ */ he({
    inputId: {},
    placeholder: { default: "Select a date..." },
    label: { default: "" },
    error: { default: "" },
    hint: { default: "" },
    disabled: { type: Boolean, default: !1 },
    float: { type: Boolean, default: !1 },
    nullable: { type: Boolean, default: !1 },
    minDate: { default: null },
    maxDate: { default: null },
    dateFormat: { type: [String, Function], default: "yyyy-MM-dd" },
    calendarOverlay: { default: () => ({
      applyParentWidth: !0,
      closeOnSelect: !0,
      class: "",
      style: {}
    }) },
    calendarLocalizations: { default: () => ({
      weekdaysShort: [],
      months: [],
      monthsShort: []
    }) }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const n = De(e, "modelValue");
    Xe(Jl, n);
    const a = Ve("datepicker", e.inputId), { hasError: l } = je({ error: e.error, hint: e.hint }), s = O(!1), i = O(), o = O(), r = z(() => e.calendarOverlay.class), u = z(() => e.calendarOverlay.style), c = z(
      () => e.calendarOverlay.applyParentWidth
    ), { resultListClass: f, resultListStyle: m } = ra(
      i,
      o,
      s,
      r,
      u,
      {
        applyParentWidth: c.value
      }
    );
    ua(o, i, s);
    const h = k(() => n.value == null ? e.placeholder : typeof e.dateFormat == "function" ? e.dateFormat(n.value) : Bu(n.value, e.dateFormat)), g = () => {
      e.disabled || (s.value = !s.value);
    }, v = () => {
      n.value = null;
    }, y = k(() => {
      if (e.minDate === "today") {
        const S = /* @__PURE__ */ new Date();
        return new Date(S.getFullYear(), S.getMonth(), S.getDate());
      }
      return e.minDate;
    }), b = k(() => {
      if (e.maxDate === "today") {
        const S = /* @__PURE__ */ new Date();
        return new Date(S.getFullYear(), S.getMonth(), S.getDate());
      }
      return e.maxDate;
    });
    return be(() => {
      e.calendarOverlay.closeOnSelect && n.value != null && (s.value = !1);
    }), xe(() => {
      if (!(e.nullable && n.value == null)) {
        if (y.value != null && ss(n.value, y.value)) {
          n.value = y.value;
          return;
        }
        if (b.value != null && ls(n.value, b.value)) {
          n.value = b.value;
          return;
        }
      }
    }), t({
      toggle: g
    }), (S, B) => (p(), D(ca, {
      "component-id": d(a),
      label: e.label,
      hint: e.hint,
      error: e.error,
      disabled: e.disabled
    }, {
      toggle: T(() => [
        A(ta, {
          ref_key: "selectContainer",
          ref: i,
          disabled: e.disabled,
          "is-opened": s.value,
          float: e.float,
          "has-error": d(l),
          nullable: e.nullable,
          "allowed-to-be-cleared": n.value != null,
          "data-testid": "datepicker-toggle",
          onOpen: B[0] || (B[0] = (M) => s.value = !0),
          onClose: B[1] || (B[1] = (M) => s.value = !1),
          onClearValue: B[2] || (B[2] = (M) => n.value = null),
          onClick: g
        }, {
          default: T(() => [
            L("div", cd, [
              w(S.$slots, "default", W(j({ modelValue: n.value })), () => [
                n.value != null ? (p(), x("span", fd, G(h.value), 1)) : (p(), x("span", hd, G(e.placeholder), 1))
              ])
            ])
          ]),
          actions: T(() => [
            w(S.$slots, "actions"),
            e.nullable && n.value != null ? (p(), D(st, {
              key: 0,
              tabindex: "-1",
              "data-testid": "datepicker-clear-btn",
              onClick: ke(v, ["stop"])
            }, {
              default: T(() => [
                A(d(Q), {
                  icon: d(Je),
                  class: "text-gp-rhino"
                }, null, 8, ["icon"])
              ]),
              _: 1
            })) : $("", !0)
          ]),
          "toggle-icon": T(() => [
            A(st, {
              tabindex: "-1",
              onClick: ke(g, ["stop"])
            }, {
              default: T(() => [
                A(d(Q), {
                  icon: d(Ys),
                  class: "text-gp-rhino"
                }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 3
        }, 8, ["disabled", "is-opened", "float", "has-error", "nullable", "allowed-to-be-cleared"])
      ]),
      dropdown: T(() => [
        s.value ? (p(), D(dd, {
          key: 0,
          ref_key: "overlayContainer",
          ref: o,
          "min-date": y.value,
          "max-date": b.value,
          localizations: e.calendarLocalizations,
          class: I(d(f)),
          style: se(d(m))
        }, null, 8, ["min-date", "max-date", "localizations", "class", "style"])) : $("", !0)
      ]),
      default: T(() => [
        w(S.$slots, "label", W(j({ componentId: d(a) })), () => [
          A(ht, {
            "component-id": d(a),
            label: e.label,
            "has-error": d(l)
          }, null, 8, ["component-id", "label", "has-error"])
        ]),
        w(S.$slots, "hint", {}, () => [
          A(pe, W(j({ hint: e.hint, error: e.error })), null, 16)
        ])
      ]),
      _: 3
    }, 8, ["component-id", "label", "hint", "error", "disabled"]));
  }
});
function md(e, t, n) {
  const a = [...e], l = a[t];
  return a.splice(t, 1), a.splice(n, 0, l), a;
}
function os(e, t, n = {
  reorderDisabled: !1,
  showGhost: !1
}) {
  const { reorderDisabled: a = !1, showGhost: l = !1 } = n, s = O(), i = O(), o = k(() => s.value !== void 0);
  let r = !1;
  function u(y, b) {
    if (!a) {
      if (l) {
        const S = document.querySelector(`[data-drag-el="${b}"]`);
        y.dataTransfer.setDragImage(S, 0, 0);
      } else
        y.dataTransfer.setDragImage(new Image(), 0, 0);
      s.value = b, r = !1;
    }
  }
  function c() {
    a || r || (s.value = void 0, i.value = void 0);
  }
  function f(y, b) {
    a || s.value !== void 0 && (y.preventDefault(), i.value = b);
  }
  function m(y, b) {
    a || s.value !== void 0 && s.value !== b && t(s.value, b);
  }
  const h = k(
    () => Array.from(e.value.entries()).map(([y, b]) => ({
      index: y,
      row: b
    }))
  );
  H(
    () => h.value,
    () => {
      s.value = void 0, i.value = void 0, r = !1;
    }
  );
  const g = k(() => {
    let y;
    return i.value !== void 0 && s.value !== void 0 && (y = md(
      h.value.map(({ index: b }) => b),
      s.value,
      i.value
    )), [...h.value].sort(
      ({ index: b }, { index: S }) => y ? y.indexOf(b) - y.indexOf(S) : 0
    );
  });
  return {
    isDragging: o,
    currentDraggedRow: s,
    currentDragOverPos: i,
    liveOrderedData: g,
    rowIsDropTarget: (y) => i.value !== void 0 && i.value === y,
    handleDragStart: u,
    handleDragEnd: c,
    handleDragOver: f,
    handleDrop: m
  };
}
const pd = { style: {
  "--gp-dnd-drop-target-bg": "rgba(0, 0, 0, 0.1)"
} }, gd = ["draggable", "data-drag-el", "onDragstart", "onDragover", "onDrop"], vd = ["draggable"], yd = { class: "flex-1" }, eh = /* @__PURE__ */ E({
  __name: "GpDragAndDropList",
  props: /* @__PURE__ */ he({
    valueKey: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    showHandle: { type: Boolean, default: !1 },
    handleOnly: { type: Boolean, default: !1 },
    itemClass: { default: "" },
    itemStyle: { type: [Boolean, null, String, Object, Array], default: "" },
    showControls: { type: Boolean, default: !1 },
    controlsOnly: { type: Boolean, default: !1 },
    controlsClass: { default: "" },
    controlsStyle: { type: [Boolean, null, String, Object, Array], default: "" }
  }, {
    modelValue: {
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = De(e, "modelValue"), n = e, a = (M) => typeof M == "string" || typeof M == "number" ? M : n.valueKey ? M[n.valueKey] : M.key, l = (M, P) => {
      const V = t.value[M], C = [...t.value];
      C.splice(M, 1), C.splice(P, 0, V), t.value = C;
    }, {
      currentDraggedRow: s,
      liveOrderedData: i,
      handleDragStart: o,
      handleDragOver: r,
      handleDrop: u,
      handleDragEnd: c,
      rowIsDropTarget: f
    } = os(t, l, {
      showGhost: !0,
      reorderDisabled: n.disabled
    }), m = k(() => !n.disabled && !n.handleOnly && !n.controlsOnly), h = k(() => ut(n.itemClass)), g = k(() => dt(
      n.itemStyle
    )), v = k(() => ut(n.controlsClass)), y = k(() => dt(
      n.itemStyle
    )), b = (M) => {
      M !== 0 && l(M, M - 1);
    }, S = (M) => {
      M !== t.value.length - 1 && l(M, M + 1);
    }, B = k(() => t.value[s.value]);
    return (M, P) => (p(), x("ul", pd, [
      (p(!0), x(X, null, ce(d(i), ({ row: V }, C) => (p(), x("li", {
        key: `${a(V)}-${C}`,
        draggable: m.value,
        class: I(["flex items-center transition-all", {
          "cursor-move": m.value,
          "bg-(--gp-dnd-drop-target-bg)": d(f)(C),
          "bg-transparent": !d(f)(C),
          itemClassNormalized: h.value
        }]),
        "data-drag-el": `${C}`,
        style: se(g.value),
        onDragstart: (R) => d(o)(R, C),
        onDragover: (R) => d(r)(R, C),
        onDrop: (R) => d(u)(R, C),
        onDragend: P[0] || (P[0] = () => d(c)())
      }, [
        w(M.$slots, "item", {
          item: V,
          index: C,
          currentDraggedItem: B.value,
          currentDraggedIndex: d(s),
          moveItemUp: b,
          moveItemDown: S
        }, () => [
          (e.showHandle || e.handleOnly) && !e.disabled && !e.controlsOnly ? (p(), x("span", {
            key: 0,
            draggable: e.handleOnly,
            class: "mr-2 cursor-move hover:text-gp-cyan"
          }, [
            w(M.$slots, "handle", {
              item: V,
              index: C,
              currentDraggedIndex: d(s),
              itemDragged: B.value
            }, () => [
              A(d(Q), { icon: d(il) }, null, 8, ["icon"])
            ])
          ], 8, vd)) : $("", !0),
          L("div", yd, [
            d(f)(C) ? w(M.$slots, "drop-target", {
              key: 0,
              index: C,
              currentDraggedIndex: d(s),
              item: B.value
            }, () => [
              w(M.$slots, "item-content", {
                index: C,
                currentDraggedIndex: d(s),
                item: B.value
              })
            ]) : w(M.$slots, "item-content", {
              key: 1,
              index: C,
              item: V,
              currentDraggedIndex: d(s),
              currentDraggedItem: B.value
            })
          ]),
          e.showControls || e.controlsOnly ? (p(), x("div", {
            key: 1,
            name: "controls",
            class: I(v.value),
            style: se(y.value)
          }, [
            w(M.$slots, "controls", {
              item: V,
              index: C,
              moveItemUp: () => b(C),
              moveItemDown: () => S(C)
            }, () => [
              A(we, {
                disabled: C === 0,
                icon: d(lt),
                size: "sm",
                "btn-type": "transparent",
                onClick: (R) => b(C)
              }, null, 8, ["disabled", "icon", "onClick"]),
              A(we, {
                disabled: C === t.value.length - 1,
                icon: d(ol),
                size: "sm",
                "btn-type": "transparent",
                onClick: (R) => S(C)
              }, null, 8, ["disabled", "icon", "onClick"])
            ])
          ], 6)) : $("", !0)
        ])
      ], 46, gd))), 128))
    ]));
  }
}), bd = (e = 0) => {
  if (e === 0)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}, rs = (e, t, n = () => {
}) => {
  const { TRANSITION_DURATION_CLASS: a, TRANSITION_DURATION_VARIABLE: l } = vn(), s = (g, v = !1) => {
    const y = d(e);
    return y == null ? bd(g.scrollHeight) : typeof y == "number" ? y : v ? y.leave : y.enter;
  }, i = (g = !1) => [
    "transition-[height]",
    "h-(--gp-expand-height)",
    "[will-change:height]",
    g ? "ease-out" : "ease-in",
    "overflow-hidden",
    a
  ], o = (g) => {
    g.style.setProperty("--gp-expand-height", "0px");
  }, r = (g) => {
    i().forEach((v) => g.classList.add(v)), g.style.setProperty(
      l,
      `${s(g)}ms`
    ), g.style.setProperty("--gp-expand-height", `${g.scrollHeight}px`);
  }, u = (g) => {
    i().forEach((v) => g.classList.remove(v)), g.style.removeProperty(l), g.style.removeProperty("--gp-expand-height"), g.classList.add("h-auto"), n("expanded");
  }, c = (g) => {
    g.classList.add("h-(--gp-expand-height)"), g.style.setProperty("--gp-expand-height", `${g.scrollHeight}px`), g.classList.remove("h-auto");
  }, f = (g) => {
    i(!0).forEach(
      (v) => g.classList.add(v)
    ), g.style.setProperty(
      l,
      `${s(g, !0)}ms`
    ), g.style.setProperty("--gp-expand-height", "0px");
  }, m = (g) => {
    i(!0).forEach(
      (v) => g.classList.remove(v)
    ), g.style.removeProperty("--gp-expand-height"), g.style.removeProperty(l), g.classList.remove("h-auto"), n("collapsed");
  };
  return {
    transitionBinding: k(() => d(t) ? {} : {
      onBeforeEnter: o,
      onEnter: r,
      onAfterEnter: u,
      onBeforeLeave: c,
      onLeave: f,
      onAfterLeave: m
    })
  };
}, Wn = /* @__PURE__ */ E({
  __name: "GpExpandTransition",
  props: {
    disabled: { type: Boolean, default: !1 },
    duration: { default: void 0 }
  },
  emits: ["expanded", "collapsed"],
  setup(e, { emit: t }) {
    const n = e, a = t, { transitionBinding: l } = rs(
      z(n, "duration"),
      z(n, "disabled"),
      a
    );
    return (s, i) => (p(), D(ct, W(j(d(l))), {
      default: T(() => [
        w(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), th = /* @__PURE__ */ E({
  __name: "GpExpandTransitionGroup",
  props: {
    disabled: { type: Boolean, default: !1 },
    duration: { default: void 0 }
  },
  setup(e) {
    const t = e, { transitionBinding: n } = rs(
      z(t, "duration"),
      z(t, "disabled")
    );
    return (a, l) => (p(), D(rn, W(j(d(n))), {
      default: T(() => [
        w(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), nh = /* @__PURE__ */ E({
  __name: "GpFadeSlideTransitionGroup",
  props: {
    disabled: { type: Boolean, default: !1 },
    duration: { default: () => ({
      enter: 200,
      leave: 100
    }) },
    direction: { default: "down" }
  },
  setup(e) {
    const t = e, { transitionBinding: n } = Xl(
      z(t, "duration"),
      z(t, "disabled"),
      z(t, "direction")
    );
    return (a, l) => (p(), D(rn, W(j(d(n))), {
      default: T(() => [
        w(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ah = /* @__PURE__ */ E({
  __name: "GpFadeTransitionGroup",
  props: {
    disabled: { type: Boolean, default: !1 },
    duration: { default: void 0 }
  },
  setup(e) {
    const t = e, { transitionBinding: n } = Dl(
      z(t, "duration"),
      z(t, "disabled")
    );
    return (a, l) => (p(), D(rn, W(j(d(n))), {
      default: T(() => [
        w(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), us = Symbol(
  "UseMobileBehaviourInjections"
), kd = (e, t) => {
  const n = O(!1), a = O(!0), l = fn(), s = () => {
    n.value = !1;
  }, i = H(
    () => e.isOpened,
    (r) => {
      r || s();
    }
  ), o = Ut(
    l.greaterOrEqual("xl"),
    (r) => {
      e.persistent || (r ? (a.value = !0, t("update:isOpened", !1)) : a.value = !1, n.value = !1);
    },
    { throttle: 200, immediate: !0 }
  );
  return Xe(us, {
    isDesktop: a,
    isBodyOpened: n,
    closeSidebar: s
  }), We(() => {
    i(), o();
  }), {
    isDesktop: a,
    isBodyOpened: n,
    closeSidebar: s
  };
}, ds = (e) => {
  H(
    () => e.isOpened,
    () => {
      e.scrollLock && (e.isOpened ? document.querySelector(e.scrollLockTarget).classList.add(
        /* tw */
        "overflow-hidden"
      ) : e.isOpened || document.querySelector(e.scrollLockTarget).classList.remove(
        /* tw */
        "overflow-hidden"
      ));
    },
    { immediate: !0 }
  ), We(() => {
    document.querySelector(e.scrollLockTarget).classList.remove(
      /* tw */
      "overflow-hidden"
    );
  });
}, wd = {
  ref: "element",
  class: "flex flex-col bg-gp-midnight-1 shadow-md",
  role: "navigation"
}, xd = { class: "flex grow flex-row overflow-auto py-8 pl-2 pr-6 xl:pl-8" }, Cd = { class: "xl:hidden" }, Td = { class: "grow overflow-auto pl-2 xl:px-0" }, Sd = /* @__PURE__ */ E({
  __name: "GpNavigationBody",
  emits: ["closeBtnClicked"],
  setup(e, { emit: t }) {
    Ct({ faTimes: Je });
    const n = t;
    return (a, l) => (p(), x("aside", wd, [
      L("div", xd, [
        L("div", Cd, [
          L("button", {
            class: "p-3 text-xl leading-4",
            onClick: l[0] || (l[0] = (s) => n("closeBtnClicked"))
          }, [
            A(d(Q), {
              class: "text-gp-rhino",
              icon: ["fas", "times"]
            })
          ])
        ]),
        L("div", Td, [
          w(a.$slots, "nav-body")
        ])
      ]),
      w(a.$slots, "nav-footer")
    ], 512));
  }
}), Ua = /* @__PURE__ */ E({
  __name: "GpNavigationMain",
  props: {
    isOpened: { type: Boolean, default: !1 },
    positioning: { default: "fixed" },
    bodyWidth: { default: "20rem" },
    persistent: { type: Boolean, default: !1 }
  },
  emits: ["update:isOpened"],
  setup(e, { emit: t }) {
    const n = t, { closeSidebar: a, isBodyOpened: l, isDesktop: s } = fe(
      us
    );
    return (i, o) => (p(), x("div", {
      class: I(["h-dvh", {
        "fixed top-0 z-10": e.positioning === "fixed" || e.positioning === "static" && !d(s)
      }])
    }, [
      e.isOpened ? (p(), x("div", {
        key: 0,
        class: "absolute top-0 hidden h-full w-screen bg-gp-midnight-1/70 md:block xl:hidden",
        onClick: o[0] || (o[0] = //@ts-ignore
        (...r) => d(a) && d(a)(...r))
      })) : $("", !0),
      A(ct, {
        "enter-from-class": "-translate-x-full",
        "enter-active-class": "transition-transform duration-200 ease-in",
        "leave-active-class": "transition-transform duration-200 ease-out",
        "leave-to-class": "-translate-x-full",
        onAfterLeave: o[1] || (o[1] = (r) => n("update:isOpened", !1))
      }, {
        default: T(() => [
          ft(A(Sd, {
            class: I(["absolute h-full w-screen transition-transform md:w-(--gp-navigation-width) xl:translate-x-0", {
              "xl:static": e.positioning === "static"
            }]),
            style: se({ "--gp-navigation-width": e.bodyWidth }),
            onCloseBtnClicked: d(a)
          }, {
            "nav-body": T(() => [
              w(i.$slots, "nav-body")
            ]),
            "nav-footer": T(() => [
              w(i.$slots, "nav-footer")
            ]),
            _: 3
          }, 8, ["class", "style", "onCloseBtnClicked"]), [
            [Lt, d(s) || d(l)]
          ])
        ]),
        _: 3
      })
    ], 2));
  }
}), lh = /* @__PURE__ */ E({
  __name: "GpNavigation",
  props: {
    isOpened: { type: Boolean, default: !1 },
    positioning: { default: "fixed" },
    teleportTarget: { default: "body" },
    scrollLock: { type: Boolean, default: !0 },
    scrollLockTarget: { default: "body" },
    bodyWidth: { default: "20rem" },
    persistent: { type: Boolean, default: !1 }
  },
  emits: ["update:isOpened"],
  setup(e, { emit: t }) {
    const n = e, a = t, { isDesktop: l, isBodyOpened: s } = kd(n, a);
    return ds(n), (i, o) => (p(), D(Ze, {
      to: e.teleportTarget,
      disabled: e.positioning === "static" && d(l)
    }, [
      e.persistent ? (p(), D(Ye, {
        key: 1,
        disabled: d(l),
        onEnter: o[3] || (o[3] = (r) => s.value = !0),
        onLeave: o[4] || (o[4] = (r) => s.value = !1)
      }, {
        default: T(() => [
          ft(A(Ua, {
            "body-width": e.bodyWidth,
            "is-opened": e.isOpened,
            positioning: e.positioning,
            "onUpdate:isOpened": o[2] || (o[2] = (r) => a("update:isOpened", r))
          }, {
            "nav-body": T(() => [
              w(i.$slots, "nav-body")
            ]),
            "nav-footer": T(() => [
              w(i.$slots, "nav-footer")
            ]),
            _: 3
          }, 8, ["body-width", "is-opened", "positioning"]), [
            [Lt, d(l) || e.isOpened]
          ])
        ]),
        _: 3
      }, 8, ["disabled"])) : (p(), D(Ye, {
        key: 0,
        disabled: d(l),
        onEnter: o[1] || (o[1] = (r) => s.value = !0)
      }, {
        default: T(() => [
          d(l) || e.isOpened ? (p(), D(Ua, {
            key: 0,
            "body-width": e.bodyWidth,
            "is-opened": e.isOpened,
            positioning: e.positioning,
            "onUpdate:isOpened": o[0] || (o[0] = (r) => a("update:isOpened", r))
          }, {
            "nav-body": T(() => [
              w(i.$slots, "nav-body")
            ]),
            "nav-footer": T(() => [
              w(i.$slots, "nav-footer")
            ]),
            _: 3
          }, 8, ["body-width", "is-opened", "positioning"])) : $("", !0)
        ]),
        _: 3
      }, 8, ["disabled"]))
    ], 8, ["to", "disabled"]));
  }
}), Bd = { class: "mb-8 list-none pl-0" }, Dd = {
  key: 0,
  class: "mb-3 font-bold uppercase"
}, sh = /* @__PURE__ */ E({
  __name: "GpNavigationGroup",
  props: {
    hideGroupLabel: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (p(), x("ul", Bd, [
      e.hideGroupLabel ? $("", !0) : (p(), x("li", Dd, [
        w(t.$slots, "nav-group-header")
      ])),
      w(t.$slots, "nav-group-links")
    ]));
  }
}), Id = { class: "mb-2" }, ih = /* @__PURE__ */ E({
  __name: "GpNavigationItem",
  props: {
    isActive: { type: Boolean, default: !1 },
    text: { default: "G-Portal" },
    icon: { default: null },
    blank: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (p(), x("li", Id, [
      w(t.$slots, "default")
    ]));
  }
}), Md = ["href", "target"], oh = /* @__PURE__ */ E({
  __name: "GpNavigationItemLink",
  props: {
    href: {},
    target: { default: null },
    disabled: { type: Boolean, default: !1 },
    isActive: { type: Boolean, default: !1 },
    label: { default: "" },
    icon: { default: null }
  },
  setup(e) {
    return (t, n) => (p(), x("a", {
      href: e.href,
      target: e.target,
      class: I(["block rounded p-1 no-underline transition-colors hover:bg-gp-midnight-2", {
        "bg-gp-midnight-2": e.isActive,
        "bg-transparent": !e.isActive,
        "pointer-events-none opacity-70": e.disabled
      }])
    }, [
      w(t.$slots, "default", {}, () => [
        e.icon != null ? (p(), D(d(Q), {
          key: 0,
          class: "mr-2 w-4 text-gp-rhino",
          icon: e.icon
        }, null, 8, ["icon"])) : $("", !0),
        ne(" " + G(e.label), 1)
      ])
    ], 10, Md));
  }
}), rh = /* @__PURE__ */ E({
  __name: "GpNavigationItemBtn",
  props: {
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    isActive: { type: Boolean, default: !1 },
    label: { default: "" },
    icon: { default: null }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, l) => (p(), x("button", {
      class: I(["block rounded p-1 no-underline transition-colors hover:bg-gp-midnight-2", {
        "bg-gp-midnight-2": e.isActive,
        "bg-transparent": !e.isActive,
        "pointer-events-none opacity-70": e.disabled
      }]),
      onClick: l[0] || (l[0] = (s) => n("click", s))
    }, [
      w(a.$slots, "default", {}, () => [
        e.icon != null ? (p(), D(d(Q), {
          key: 0,
          class: "mr-2 w-4 text-gp-rhino",
          icon: e.icon
        }, null, 8, ["icon"])) : $("", !0),
        ne(" " + G(e.label), 1)
      ])
    ], 2));
  }
}), uh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Ed = ["href", "target"], dh = /* @__PURE__ */ E({
  __name: "GpBtnLink",
  props: {
    href: {},
    target: { default: null },
    disabled: { type: Boolean, default: !1 },
    size: { default: "large" },
    btnType: { default: "primary" },
    outline: { type: Boolean },
    label: { default: "" },
    icon: { default: null }
  },
  setup(e) {
    const t = e, n = is(t), { hasLabel: a } = bn(t), { isLarge: l, isSmall: s } = Dn(t);
    return (i, o) => (p(), x("a", {
      href: e.href,
      target: e.target,
      class: I(["inline-block whitespace-nowrap rounded border text-center font-bold uppercase no-underline transition-colors focus:outline-2!", d(n)])
    }, [
      w(i.$slots, "default", {}, () => [
        e.icon ? (p(), D(d(Q), {
          key: 0,
          icon: e.icon,
          class: I({
            "mr-1": d(s) && d(a),
            "mr-2": d(l) && d(a)
          })
        }, null, 8, ["icon", "class"])) : $("", !0),
        ne(" " + G(e.label), 1)
      ]),
      w(i.$slots, "end")
    ], 10, Ed));
  }
}), cs = (e) => ["GpMenuItemBtn", "GpMenuItemLink", "GpMenuItemAction"].includes(
  e.component.type.name
), Ad = (e) => cs(e) && e.props != null && e.props.disabled != null && e.props.disabled, an = (e) => e != null && cs(e) && !Ad(e), fs = (e, t, n) => {
  const a = e[t];
  if (t <= 0)
    return an(a) ? t : n;
  const l = e[t - 1];
  return an(l) ? t - 1 : fs(
    e,
    t - 1,
    n
  );
}, hs = (e, t, n) => {
  const a = e[t];
  if (t >= e.length - 1)
    return an(a) ? t : n;
  const l = e[t + 1];
  return an(l) ? t + 1 : hs(
    e,
    t + 1,
    n
  );
}, Fd = (e, t) => {
  const n = O(-1);
  return Rt({
    passive: !0,
    onEventFired(a) {
      a.type === "keydown" && (a.key === "ArrowUp" && (n.value = fs(
        t.menuComponents,
        n.value,
        n.value
      )), a.key === "ArrowDown" && (n.value = hs(
        t.menuComponents,
        n.value,
        n.value
      )));
    }
  }), {
    currentSelectedIndex: n
  };
}, ms = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, l] of t)
    n[a] = l;
  return n;
}, Od = {};
function $d(e, t) {
  return p(), x("li", null, [
    w(e.$slots, "default")
  ]);
}
const Ld = /* @__PURE__ */ ms(Od, [["render", $d]]), Vd = /* @__PURE__ */ E({
  __name: "GpMenuBody",
  props: {
    menuComponents: { default: void 0 },
    bodyClass: { default: void 0 }
  },
  setup(e) {
    const t = e, n = Ie(), a = O(null), { currentSelectedIndex: l } = Fd(a, t);
    return (s, i) => (p(), x("ul", {
      class: I(
        d(n).class || "block list-none rounded bg-gp-midnight-2 px-0 py-2 shadow-xs"
      )
    }, [
      e.menuComponents != null && e.menuComponents.length > 0 ? (p(!0), x(X, { key: 0 }, ce(e.menuComponents, (o, r) => (p(), D(Ld, {
        key: o.itemId
      }, {
        default: T(() => [
          (p(), D($e(o.component), re({ ref_for: !0 }, {
            ...o.props,
            isHighlighted: r === d(l)
          }), null, 16))
        ]),
        _: 2
      }, 1024))), 128)) : $("", !0)
    ], 2));
  }
}), Rd = (e) => {
  const { default: t } = un(), n = e ?? `fallback-${Math.random().toString(36).slice(2, 10)}`, { getDefinitionsRecursive: a } = oa(), l = k(() => t != null ? a(
    t(),
    [],
    [
      "GpMenuItemStatic",
      "GpMenuItemLink",
      "GpMenuItemBtn",
      "GpMenuItemAction",
      "GpMenuItemDivider",
      "GpMenuItemGroupHeader"
    ]
  ) : []);
  return { menuItemDefinitions: k(() => l.value.length > 0 ? l.value.map((i, o) => ({
    itemId: `gp-menu-item-${n}-${o}`,
    component: i,
    props: i.props
  })) : []) };
}, Pd = (e, { onEscape: t = () => {
} }) => {
  Rt({
    passive: !1,
    onEventFired(n) {
      n.key === "Escape" && e.value && (n.preventDefault(), t());
    }
  });
}, Gd = (e, t, n, a = {
  afterOpen: void 0,
  afterClose: void 0,
  menuId: void 0
}) => {
  const l = O(!1), s = async () => {
    l.value = !0, n("update:isOpened", !0), await Ne(), a.afterOpen != null && a.afterOpen();
    const u = t.value;
    if (u.children.length === 0) return;
    const c = u.children[0];
    c != null && c.blur != null && c.blur();
  }, i = () => {
    l.value = !1, n("update:isOpened", !1), a.afterClose != null && a.afterClose();
  }, o = () => {
    l.value ? i() : s();
  };
  H(e, (u) => {
    u ? s() : i();
  });
  const r = a.menuId ?? `gp-menu-${Math.random().toString(36).slice(2, 10)}`;
  return cn(
    t,
    () => {
      l.value && i();
    },
    {
      ignore: [`#${r}`]
    }
  ), {
    internalIsOpened: l,
    toggleMenu: o,
    showMenuBody: s,
    hideMenuBody: i
  };
}, ps = Symbol("GpMenuParentSymbol"), ch = /* @__PURE__ */ E({
  __name: "GpMenu",
  props: {
    isOpened: { type: Boolean, default: !1 },
    disableCloseOnItemClick: { type: Boolean },
    label: { default: void 0 },
    icon: { default: void 0 },
    toggleClass: { default: void 0 },
    flipIndicator: { type: Boolean, default: !1 },
    hideIndicator: { type: Boolean, default: !1 },
    size: { default: "large" },
    btnType: { default: "primary" },
    outline: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    bodyClass: { default: void 0 },
    bodyAutoWidthBreakpoint: { default: void 0 },
    bodyToggleWidth: { type: Boolean, default: !1 },
    bodyMinWidth: { default: "10rem" }
  },
  emits: ["update:isOpened"],
  setup(e, { expose: t, emit: n }) {
    const a = e, l = n;
    Ct({ faChevronUp: lt });
    const s = O(), i = O(), { width: o } = _n(
      s,
      { height: 0, width: 0 },
      { box: "border-box" }
    ), { smaller: r } = fn(), u = O(!1), { alignOverlay: c, overlayStyle: f, middlewareData: m } = ia(
      s,
      i,
      {
        offset: 5
      }
    ), h = k(() => m.value.flip && m.value.flip.overflows != null && m.value.flip.overflows.find(
      (F) => F.placement === "bottom-end"
    ) ? "up" : "down");
    be(() => {
      u.value = a.bodyAutoWidthBreakpoint != null && r(a.bodyAutoWidthBreakpoint).value;
    });
    const { isLarge: g } = Dn(a), v = O(a.isOpened), y = on().replace(/[^a-zA-Z0-9_-]/g, "_").replace(/^_+|_+$/g, "") || "menu", b = `gp-menu-${y}`, { showMenuBody: S, hideMenuBody: B, toggleMenu: M, internalIsOpened: P } = Gd(v, s, l, {
      afterOpen: c,
      menuId: b
    });
    H(
      () => a.isOpened,
      (F) => {
        v.value = F;
      }
    );
    const V = k(() => a.flipIndicator ? P.value ? (
      /* tw */
      "rotate-180"
    ) : (
      /* tw */
      "rotate-0"
    ) : P.value ? (
      /* tw */
      "rotate-0"
    ) : (
      /* tw */
      "rotate-180"
    ));
    H(
      () => a.disabled,
      (F) => {
        F && B();
      }
    );
    const { menuItemDefinitions: C } = Rd(y);
    Pd(P, {
      onEscape: () => {
        B();
      }
    });
    const R = Ie();
    return t({
      toggleMenu: M,
      showMenuBody: S,
      hideMenuBody: B
    }), Xe(ps, {
      onItemSelect: () => {
        a.disableCloseOnItemClick || B();
      }
    }), (F, N) => (p(), x(X, null, [
      L("div", re({
        ref_key: "menuToggle",
        ref: s
      }, d(R), {
        class: d(R).class || "inline-block"
      }), [
        w(F.$slots, "toggle", {
          isOpened: d(P),
          toggle: d(M)
        }, () => [
          A(we, {
            label: e.label,
            icon: e.icon,
            size: e.size,
            "btn-type": e.btnType,
            outline: e.outline,
            disabled: e.disabled,
            "aria-controls": b,
            "aria-haspopup": "true",
            class: I(e.toggleClass),
            onClick: d(M)
          }, {
            end: T(() => [
              e.hideIndicator ? $("", !0) : (p(), D(d(Q), {
                key: 0,
                icon: d(lt),
                class: I(["transition-transform", {
                  "ml-4": d(g),
                  "ml-2": !d(g),
                  [V.value]: !0
                }])
              }, null, 8, ["icon", "class"]))
            ]),
            _: 1
          }, 8, ["label", "icon", "size", "btn-type", "outline", "disabled", "class", "onClick"])
        ])
      ], 16),
      (p(), D(Ze, { to: "body" }, [
        A(da, { direction: h.value }, {
          default: T(() => [
            d(P) ? (p(), D(Vd, {
              key: 0,
              id: b,
              ref_key: "menuBody",
              ref: i,
              role: "menu",
              "aria-expanded": d(P),
              class: I(e.bodyClass),
              "menu-components": d(C),
              style: se({
                ...d(f),
                left: u.value ? "0px" : d(f).left,
                width: u.value || e.bodyToggleWidth ? "100%" : void 0,
                minWidth: "var(--gp-menu-body-min-width)",
                maxWidth: e.bodyToggleWidth && !u.value ? `${d(o)}px` : void 0,
                "--gp-menu-body-min-width": e.bodyMinWidth
              }),
              "data-gp-element": "menu-body"
            }, {
              default: T(({ item: ee, index: _, firstLevelIndex: Z }) => [
                w(F.$slots, "item", {
                  item: ee,
                  index: _,
                  firstLevelIndex: Z
                })
              ]),
              _: 3
            }, 8, ["aria-expanded", "class", "menu-components", "style"])) : $("", !0)
          ]),
          _: 3
        }, 8, ["direction"])
      ]))
    ], 64));
  }
}), Nd = {
  key: 0,
  class: "w-4 text-center"
}, ga = /* @__PURE__ */ E({
  __name: "GpMenuItemContent",
  props: {
    component: {},
    icon: {},
    label: {}
  },
  setup(e) {
    return (t, n) => (p(), D($e(e.component), {
      class: "flex items-center gap-4",
      role: "menuitem"
    }, {
      default: T(() => [
        w(t.$slots, "default", {}, () => [
          e.icon ? (p(), x("span", Nd, [
            A(d(Q), {
              class: "text-gp-rhino",
              icon: e.icon
            }, null, 8, ["icon"])
          ])) : $("", !0),
          ne(" " + G(e.label), 1)
        ])
      ]),
      _: 3
    }));
  }
}), va = () => (
  /* tw */
  "w-full px-4 py-1"
), fh = /* @__PURE__ */ E({
  name: "GpMenuItemStatic",
  inheritAttrs: !1,
  __name: "GpMenuItemStatic",
  props: {
    label: { default: "" },
    icon: { default: null }
  },
  setup(e) {
    const t = Ie(), n = va(), a = k(() => t.class != null ? t.class : n), l = k(() => {
      const { class: s, ...i } = t;
      return i;
    });
    return (s, i) => w(s.$slots, "default", { contentClass: a.value }, () => [
      A(ga, re({
        component: "span",
        label: e.label,
        icon: e.icon,
        class: a.value
      }, l.value), null, 16, ["label", "icon", "class"])
    ]);
  }
}), zd = (e) => {
  const t = (u = !1) => u ? (
    /* tw */
    "pointer-events-none opacity-70"
  ) : (
    /* tw */
    "hover:bg-gp-dark-mouse-light"
  ), n = k(() => t(e.disabled)), a = (u = !1) => u ? (
    /* tw */
    "bg-gp-dark-mouse-light"
  ) : "", l = k(() => a(e.isHighlighted)), s = (u = !1, c = !1) => u ? c ? (
    /* tw */
    "bg-gp-dark-mouse-light"
  ) : (
    /* tw */
    "bg-gp-midnight-1"
  ) : "", i = k(() => s(e.isActive, e.isHighlighted)), o = k(() => e.disabled || e.disableOnActive && e.isActive ? (
    /* tw */
    "pointer-events-none cursor-default"
  ) : (
    /* tw */
    "cursor-pointer"
  ));
  return {
    interactiveClasses: k(() => [
      /* tw */
      "transition-colors text-gp-mouse! outline-hidden",
      n.value,
      l.value,
      i.value,
      o.value
    ].join(" ")),
    getIsActiveClass: s,
    getIsHighlightedClass: a,
    getIsDisabledClass: t
  };
}, gs = () => fe(ps), Yd = ({
  isFocused: e,
  disabled: t,
  disableEnter: n
}) => {
  const a = gs();
  return {
    handleEnterKey: async (s) => {
      !e.value || t.value || n.value || s.type === "keydown" && (s.key.toLowerCase() === "enter" || s.key === " ") && (s.currentTarget.click(), s.preventDefault(), a.onItemSelect(s));
    }
  };
}, Wd = ({
  linkElement: e,
  disabled: t,
  isHighlighted: n
}) => {
  const { focused: a } = fi(e);
  return H(
    () => n.value,
    () => {
      a.value = n.value && !t.value;
    }
  ), H(
    () => t.value,
    () => {
      a.value = n.value && !t.value;
    }
  ), {
    isFocused: a
  };
}, vs = /* @__PURE__ */ E({
  name: "GpMenuItemAction",
  __name: "GpMenuItemAction",
  props: {
    disabled: { type: Boolean, default: !1 },
    isActive: { type: Boolean, default: !1 },
    disableOnActive: { type: Boolean, default: !1 },
    isHighlighted: { type: Boolean, default: !1 },
    disableEnter: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = Ie(), a = va(), { interactiveClasses: l, getIsActiveClass: s } = zd(t), i = k(() => n.class != null && n.class !== "" ? n.class : [a, l.value].join(" ")), o = $t(), r = O(null), { disabled: u, isHighlighted: c, disableEnter: f } = Hn(t), { isFocused: m } = Wd({
      linkElement: r,
      disabled: u,
      isHighlighted: c
    }), { handleEnterKey: h } = Yd({
      isFocused: m,
      disabled: u,
      disableEnter: f
    }), g = (y) => {
      var b;
      return y == null ? null : y.tagName != null && (y.role === "menuitem" || ((b = y.attributes.getNamedItem("role")) == null ? void 0 : b.value) === "menuitem") ? y : g(y.nextElementSibling);
    }, v = () => {
      if (o.subTree.children == null)
        throw new Error("GpMenuItemAction: No children found");
      const y = o.subTree.children[0];
      if (y == null || o.subTree.children.length > 1)
        throw new Error(
          "GpMenuItemAction: Only one child is allowed. Did you forget to wrap your content?"
        );
      const b = g(y.el);
      if (b == null)
        throw new Error(
          'GpMenuItemAction: No menuitem found. Did you forget to add the role="menuitem" attribute?'
        );
      r.value = b, r.value && r.value.addEventListener("keydown", h);
    };
    return xe(() => {
      v();
    }), We(() => {
      r.value && r.value.removeEventListener("keydown", h);
    }), (y, b) => w(y.$slots, "default", {
      contentClass: i.value,
      getActiveClass: d(s),
      isHighlighted: d(c)
    }, () => [
      b[0] || (b[0] = ne(" Component is missing a default slot ", -1))
    ]);
  }
}), hh = /* @__PURE__ */ E({
  name: "GpMenuItemLink",
  inheritAttrs: !1,
  __name: "GpMenuItemLink",
  props: {
    href: { default: void 0 },
    target: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    isActive: { type: Boolean, default: !1 },
    disableOnActive: { type: Boolean, default: !1 },
    isHighlighted: { type: Boolean },
    label: { default: "" },
    icon: { default: void 0 }
  },
  setup(e) {
    const t = Ie(), n = k(() => {
      const { href: a, target: l, class: s, ...i } = t;
      return i;
    });
    return (a, l) => (p(), D(vs, {
      disabled: e.disabled,
      "is-active": e.isActive,
      "is-highlighted": e.isHighlighted
    }, {
      default: T(({ contentClass: s }) => [
        A(ga, re({
          component: "a",
          class: d(t).class != null && d(t).class.length > 0 ? a.$attrs.class : s,
          href: e.href,
          target: e.target,
          icon: e.icon,
          label: e.label,
          "aria-disabled": e.disabled || void 0
        }, n.value, { tabindex: "-1" }), {
          default: T(() => [
            w(a.$slots, "default")
          ]),
          _: 3
        }, 16, ["class", "href", "target", "icon", "label", "aria-disabled"])
      ]),
      _: 3
    }, 8, ["disabled", "is-active", "is-highlighted"]));
  }
}), mh = /* @__PURE__ */ E({
  name: "GpMenuItemBtn",
  inheritAttrs: !1,
  __name: "GpMenuItemBtn",
  props: {
    disabled: { type: Boolean, default: !1 },
    isActive: { type: Boolean, default: !1 },
    isHighlighted: { type: Boolean, default: !1 },
    label: { default: "" },
    icon: { default: null }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = gs(), s = (r) => {
      n.disabled || (l.onItemSelect(r), a("click", r));
    }, i = Ie(), o = k(() => {
      const { class: r, ...u } = i;
      return u;
    });
    return (r, u) => (p(), D(vs, {
      disabled: e.disabled,
      "is-active": e.isActive,
      "is-highlighted": e.isHighlighted
    }, {
      default: T(({ contentClass: c }) => [
        A(ga, re({
          component: "a",
          class: r.$attrs.class != null && r.$attrs.class.length > 0 ? r.$attrs.class : c,
          type: "button",
          icon: e.icon,
          label: e.label,
          "aria-disabled": e.disabled || void 0
        }, o.value, {
          tabindex: "-1",
          onClick: s
        }), {
          default: T(() => [
            w(r.$slots, "default")
          ]),
          _: 3
        }, 16, ["class", "icon", "label", "aria-disabled"])
      ]),
      _: 3
    }, 8, ["disabled", "is-active", "is-highlighted"]));
  }
}), ph = /* @__PURE__ */ E({
  name: "GpMenuItemDivider",
  __name: "GpMenuItemDivider",
  setup(e) {
    const t = Ie();
    return (n, a) => (p(), x("hr", {
      class: I(d(t).class || "my-1 w-full border-gp-rhino")
    }, null, 2));
  }
}), jd = {
  key: 0,
  class: "mr-2 w-4 text-center"
}, gh = /* @__PURE__ */ E({
  name: "GpMenuItemGroupHeader",
  __name: "GpMenuItemGroupHeader",
  props: {
    label: { default: "" },
    icon: { default: null },
    dense: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = Ie(), a = va(), l = k(() => {
      if (n.class != null)
        return n.class;
      const s = [
        a,
        /* tw */
        "font-bold"
      ];
      return t.dense && s.push(
        /* tw */
        "text-xs text-gp-rhino uppercase"
      ), s.join(" ");
    });
    return (s, i) => (p(), x("div", {
      class: I(l.value)
    }, [
      e.icon ? (p(), x("span", jd, [
        A(d(Q), {
          class: "text-gp-rhino",
          icon: e.icon
        }, null, 8, ["icon"])
      ])) : $("", !0),
      ne(" " + G(e.label), 1)
    ], 2));
  }
}), vh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Hd = { class: "relative flex flex-col rounded-t bg-gp-midnight-1" }, Ud = { class: "px-4 pt-8" }, qd = {
  key: 0,
  class: "mx-auto mb-4 flex size-24 items-center justify-center rounded-full bg-gp-midnight-2"
}, Kd = ["src", "alt"], Qd = { class: "mb-4 text-center font-bold" }, Xd = { class: "mb-4 flex-1 px-2 text-center text-gp-rhino" }, Zd = {
  key: 1,
  class: "flex-1 overflow-auto"
}, Jd = { class: "mb-4 flex-1 px-2 text-center text-gp-rhino" }, _d = { class: "rounded-b bg-gp-midnight-2 p-8 py-6 md:p-4" }, ec = { class: "flex w-full flex-wrap justify-center gap-4" }, tc = /* @__PURE__ */ E({
  __name: "GpModalBody",
  props: {
    headerIcon: { default: void 0 },
    headerImage: { default: void 0 },
    headerImageAlt: { default: void 0 },
    headerImageCircle: { type: Boolean, default: !0 },
    headerText: { default: void 0 },
    contentText: { default: void 0 },
    disableContentOverflow: { type: Boolean, default: !1 },
    cancelText: { default: "Cancel" },
    confirmText: { default: "Confirm" },
    showCloseBtn: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    confirmOnEnter: { type: Boolean, default: !0 }
  },
  emits: ["confirm", "cancel", "escape", "close"],
  setup(e, { emit: t }) {
    const n = e, a = t;
    Ct({ faTimes: Je });
    const { escape: l, enter: s } = Rt({
      passive: !1,
      onEventFired: (i) => {
        i.key === "Escape" && i.preventDefault();
      }
    });
    return ka(s, () => {
      n.confirmOnEnter && a("confirm", "enter");
    }), ka(l, () => {
      n.closeOnEscape && a("escape", "escape");
    }), (i, o) => (p(), x("div", Hd, [
      e.showCloseBtn ? (p(), x("button", {
        key: 0,
        class: "absolute right-2 top-2 size-input",
        onClick: o[0] || (o[0] = (r) => a("close", "cancel"))
      }, [
        A(d(Q), {
          icon: ["fas", "fa-times"],
          class: "text-xl text-gp-rhino"
        })
      ])) : $("", !0),
      w(i.$slots, "default", {}, () => [
        w(i.$slots, "header", {}, () => [
          L("div", Ud, [
            e.headerIcon != null ? (p(), x("div", qd, [
              A(d(Q), {
                icon: e.headerIcon,
                class: "text-4xl text-gp-cyan"
              }, null, 8, ["icon"])
            ])) : e.headerImage != null ? (p(), x("img", {
              key: 1,
              class: I(["mx-auto mb-4", {
                "size-24 rounded-full object-cover": e.headerImageCircle,
                "h-24 w-auto rounded": !e.headerImageCircle
              }]),
              src: e.headerImage,
              alt: e.headerImageAlt
            }, null, 10, Kd)) : $("", !0),
            L("p", Qd, G(e.headerText), 1)
          ])
        ]),
        e.disableContentOverflow ? w(i.$slots, "content", { key: 0 }, () => [
          L("p", Xd, G(e.contentText), 1)
        ]) : (p(), x("div", Zd, [
          w(i.$slots, "content", {}, () => [
            L("p", Jd, G(e.contentText), 1)
          ])
        ])),
        L("div", _d, [
          w(i.$slots, "footer", {}, () => [
            L("div", ec, [
              A(d(we), {
                size: "sm",
                "btn-type": "cancel",
                class: "w-full md:w-40",
                onClick: o[1] || (o[1] = (r) => a("cancel", "cancel"))
              }, {
                default: T(() => [
                  ne(G(e.cancelText), 1)
                ]),
                _: 1
              }),
              A(d(we), {
                size: "sm",
                class: "w-full md:w-40",
                onClick: o[2] || (o[2] = (r) => a("confirm", "confirm"))
              }, {
                default: T(() => [
                  ne(G(e.confirmText), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]));
  }
}), yh = /* @__PURE__ */ E({
  inheritAttrs: !1,
  __name: "GpModal",
  props: {
    isOpened: { type: Boolean, default: !1 },
    positioning: { default: "fixed" },
    teleportTarget: { default: "body" },
    headerIcon: { default: void 0 },
    headerImage: { default: void 0 },
    headerImageAlt: { default: void 0 },
    headerImageCircle: { type: Boolean, default: !1 },
    headerText: { default: void 0 },
    modalWrapperClass: { default: void 0 },
    modalWrapperStyle: { type: [Boolean, null, String, Object, Array], default: void 0 },
    modalBodyClass: { default: "max-w-[30rem] w-full" },
    modalBodyStyle: { type: [Boolean, null, String, Object, Array], default: void 0 },
    contentText: { default: void 0 },
    disableContentOverflow: { type: Boolean, default: !1 },
    cancelText: { default: "Cancel" },
    closeOnCancel: { type: Boolean, default: !0 },
    confirmText: { default: "Confirm" },
    showCloseBtn: { type: Boolean, default: !0 },
    backdrop: { type: Boolean, default: !0 },
    backdropBlur: { type: Boolean },
    closeOnBackdrop: { type: Boolean, default: !0 },
    scrollLock: { type: Boolean, default: !0 },
    scrollLockTarget: { default: "body" },
    closeOnEscape: { type: Boolean, default: !0 },
    confirmOnEnter: { type: Boolean, default: !0 }
  },
  emits: ["update:isOpened", "confirm", "cancel", "close"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = O(!1), s = (g) => {
      l.value = !1, a("close", g);
    }, i = (g) => {
      a("cancel", g), n.closeOnCancel && s(g);
    }, o = (g) => {
      n.closeOnEscape && s(g);
    }, r = () => {
      n.closeOnBackdrop && s("backdrop");
    }, u = (g) => {
      !n.confirmOnEnter && g === "enter" || a("confirm", g);
    };
    H(
      () => n.isOpened,
      () => {
        n.isOpened || s("prop");
      }
    ), ds(n);
    const c = k(() => {
      const g = [];
      if (n.disableContentOverflow || g.push("h-full items-center"), n.modalWrapperClass) {
        if (Array.isArray(n.modalWrapperClass))
          return [...g, ...n.modalWrapperClass];
        if (typeof n.modalWrapperClass == "object") {
          const v = Object.keys(n.modalWrapperClass).reduce((y, b) => (n.modalWrapperClass[b] && y.push(b), y), []);
          return [...g, ...v];
        }
      }
      return [...g, n.modalWrapperClass];
    }), f = k(() => n.disableContentOverflow ? n.modalBodyClass : [
      n.modalBodyClass,
      /* tw */
      "max-h-full"
    ]), m = k(() => Object.keys(n).filter(
      (g) => [
        "headerIcon",
        "headerImage",
        "headerImageAlt",
        "headerImageCircle",
        "headerText",
        "contentText",
        "disableContentOverflow",
        "cancelText",
        "confirmText",
        "showCloseBtn"
      ].includes(g)
    ).reduce((g, v) => (g[v] = n[v], g), {})), h = Ie();
    return (g, v) => (p(), D(Ze, {
      to: e.teleportTarget,
      disabled: e.positioning === "static"
    }, [
      A(Ye, {
        appear: "",
        onEnter: v[1] || (v[1] = (y) => l.value = !0)
      }, {
        default: T(() => [
          e.isOpened ? (p(), x("div", {
            key: 0,
            class: I(["fixed top-0 z-20 h-dvh w-screen overflow-auto", d(h).class])
          }, [
            e.backdrop ? (p(), x("div", {
              key: 0,
              class: I(["absolute top-0 size-full bg-gp-midnight-1/70", {
                "backdrop-blur-xs": e.backdropBlur,
                fixed: e.disableContentOverflow,
                absolute: !e.disableContentOverflow
              }]),
              onClick: r
            }, null, 2)) : $("", !0),
            L("div", {
              class: I(["flex w-full justify-center", c.value])
            }, [
              A(ct, {
                "enter-from-class": "-translate-y-8 opacity-0",
                "enter-active-class": "transition-all ease-in-out delay-200",
                "leave-active-class": "transition-all ease-in-out duration-100",
                "leave-to-class": "opacity-0",
                onAfterLeave: v[0] || (v[0] = (y) => a("update:isOpened", !1))
              }, {
                default: T(() => [
                  l.value ? (p(), D(tc, re({ key: 0 }, m.value, {
                    class: f.value,
                    style: e.modalBodyStyle,
                    role: "dialog",
                    "aria-modal": "true",
                    onCancel: i,
                    onClose: s,
                    onConfirm: u,
                    onEscape: o
                  }), {
                    header: T(() => [
                      w(g.$slots, "header")
                    ]),
                    content: T(() => [
                      w(g.$slots, "content")
                    ]),
                    footer: T(() => [
                      w(g.$slots, "footer")
                    ]),
                    default: T(() => [
                      w(g.$slots, "default")
                    ]),
                    _: 3
                  }, 16, ["class", "style"])) : $("", !0)
                ]),
                _: 3
              })
            ], 2)
          ], 2)) : $("", !0)
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"]));
  }
}), ys = /* @__PURE__ */ E({
  __name: "GpBrandImage",
  props: {
    animate: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (p(), x("svg", {
      id: "emxv99o7iw91",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      viewBox: "0 0 189 40",
      "shape-rendering": "geometricPrecision",
      "text-rendering": "geometricPrecision",
      width: "189",
      height: "40",
      class: I(["gp-brand__image", {
        "gp-brand__image--animate": e.animate
      }])
    }, [...n[0] || (n[0] = [
      Ss('<g id="emxv99o7iw92"><polygon id="lightning" points="181,23 181,15 173,15 181,3 181,11 189,11" transform="matrix(1 0 0 1 -2.57589999999999 6)" fill="rgb(73,219,201)" fill-rule="evenodd" stroke="none" stroke-width="1"></polygon><g id="cross-r" transform="translate(147.001381,18.305599) rotate(45)"><polygon id="emxv99o7iw94" points="150.200000,12 155,16.800000 151.800000,20 147,15.200000 142.200000,20 139,16.800000 143.800000,12 139,7.200000 142.200000,4 147,8.800000 151.800000,4 155,7.200000" transform="skewX(-0) skewY(0) scale(1.000004,1.000004) translate(-147,-12)" fill="rgb(251,162,112)" fill-rule="evenodd" stroke="none" stroke-width="1"></polygon></g><g id="circle" transform="translate(114,19.060400) scale(1.170000,1.170000)"><circle id="emxv99o7iw95" r="8" transform="translate(0,0)" fill="rgb(238,62,160)" fill-rule="evenodd" stroke="none" stroke-width="1"></circle></g><polygon id="cross-l" points="88,10 88,14 82,14 82,20 78,20 78,14 72,14 72,10 78,10 78,4 82,4 82,10" transform="matrix(1 0 0 1 0 7)" fill="rgb(246,110,138)" fill-rule="evenodd" stroke="none" stroke-width="1"></polygon><g id="gamepad" transform="translate(45,16.997900)"><path id="emxv99o7iw97" d="M53,8L37,8L37,18L41,18L41,16L49,16L49,18L53,18L53,8ZM55,6L55,8L55,18L55,20L47,20L47,18L43,18L43,20L35,20L35,18L35,8L35,6L37,6L44,6L44,4L44,2L49,2L49,0L51,0L51,2L51,4L46,4L46,6L53,6L55,6ZM47,10L47,12L47,14L51,14L51,12L51,10L47,10ZM39,10L43,10L43,12L43,14L39,14L39,12L39,10Z" transform="translate(-45,-10)" fill="rgb(255,196,96)" fill-rule="evenodd" stroke="none" stroke-width="1"></path></g><g id="mr-maintenance" transform="translate(10.500000,19.500000)"><path id="mr-maintence-inner" d="M15.300000,17.107450C15.300000,17.576650,14.909850,17.957450,14.439800,17.957450C13.970600,17.957450,13.585550,17.576650,13.585550,17.107450C13.585550,16.638250,13.202200,16.257450,12.733000,16.257450C12.262950,16.257450,11.881300,16.809100,11.881300,17.279150C11.881300,17.748350,11.499650,18.300000,11.030450,18.300000L10.180450,18.300000C9.710400,18.300000,9.330450,17.748350,9.330450,17.279150C9.330450,16.809100,8.949650,16.343300,8.480450,16.343300C8.010400,16.343300,7.630450,16.852450,7.630450,17.321650C7.630450,17.790850,7.249650,18.300000,6.780450,18.300000L5.930450,18.300000C5.460400,18.300000,5.080450,17.748350,5.080450,17.279150C5.080450,16.809100,4.699650,16.343300,4.230450,16.343300C3.760400,16.343300,3.380450,16.680750,3.380450,17.149950C3.380450,17.620000,3.009850,17.978700,2.539800,17.978700C2.070600,17.978700,1.700000,17.576650,1.700000,17.107450L1.700000,11.375050C1.700000,7.739600,4.731100,4.700000,8.480450,4.700000C12.229800,4.700000,15.300000,7.739600,15.300000,11.375050L15.300000,17.107450ZM8.480450,3C3.785900,3,0,6.795250,0,11.375050L0,17.957450C0,18.896700,0.741200,20,1.680450,20L2.305200,20C2.781200,20,3.275050,19.676150,3.575100,19.308100C3.729800,19.117700,3.965250,18.911150,4.230450,18.911150C4.494800,18.911150,4.730250,19.161050,4.884950,19.350600C5.185850,19.718650,5.679700,20,6.154850,20L6.577300,20C7.046500,20,7.533550,19.679550,7.833600,19.318300C7.987450,19.133000,8.219500,18.928150,8.480450,18.928150C8.741400,18.928150,8.972600,19.175500,9.127300,19.361650C9.426500,19.722050,9.913550,20,10.382750,20L10.827300,20C11.296500,20,11.783550,19.679550,12.083600,19.318300C12.237450,19.133000,12.469500,18.928150,12.730450,18.928150C12.991400,18.928150,13.222600,19.175500,13.377300,19.361650C13.676500,19.722050,14.163550,20,14.632750,20L15.280450,20C16.218850,20,17,18.896700,17,17.957450L17,11.375050C17,6.795250,13.175000,3,8.480450,3L8.480450,3ZM11.050000,12.066667C10.580800,12.066667,10.200000,11.685017,10.200000,11.216667C10.200000,10.748317,10.580800,10.366667,11.050000,10.366667C11.518350,10.366667,11.900000,10.748317,11.900000,11.216667C11.900000,11.685017,11.518350,12.066667,11.050000,12.066667L11.050000,12.066667ZM11.050000,8.666667C9.641550,8.666667,8.500000,9.808217,8.500000,11.216667C8.500000,12.625117,9.641550,13.766667,11.050000,13.766667C12.458450,13.766667,13.600000,12.625117,13.600000,11.216667C13.600000,9.808217,12.458450,8.666667,11.050000,8.666667L11.050000,8.666667ZM5.950000,12.066667C5.480800,12.066667,5.100000,11.685017,5.100000,11.216667C5.100000,10.748317,5.480800,10.366667,5.950000,10.366667C6.418350,10.366667,6.800000,10.748317,6.800000,11.216667C6.800000,11.685017,6.418350,12.066667,5.950000,12.066667L5.950000,12.066667ZM5.950000,8.666667C4.541550,8.666667,3.400000,9.808217,3.400000,11.216667C3.400000,12.625117,4.541550,13.766667,5.950000,13.766667C7.358450,13.766667,8.500000,12.625117,8.500000,11.216667C8.500000,9.808217,7.358450,8.666667,5.950000,8.666667L5.950000,8.666667Z" transform="translate(-8.500000,-11.500000)" fill="rgb(253,110,190)" stroke="none" stroke-width="1"></path></g></g>', 1)
    ])], 2));
  }
}), nc = { class: "min-w-[200px] max-w-[500px] text-center" }, ac = { class: "mb-0 text-center font-bold uppercase" }, lc = /* @__PURE__ */ E({
  __name: "GpBrandLoading",
  props: {
    animate: { type: Boolean, default: !0 },
    message: { default: "" }
  },
  setup(e) {
    return (t, n) => (p(), x("div", nc, [
      A(ys, {
        animate: e.animate,
        class: "mx-auto mb-2"
      }, null, 8, ["animate"]),
      w(t.$slots, "default", {}, () => [
        L("p", ac, G(e.message), 1)
      ])
    ]));
  }
}), sc = { class: "min-w-[200px] max-w-[500px] text-center" }, ic = { class: "mb-0 text-center font-bold uppercase" }, oc = /* @__PURE__ */ E({
  __name: "GpBrandMessage",
  props: {
    message: { default: "" }
  },
  setup(e) {
    return (t, n) => (p(), x("div", sc, [
      A(ys, { class: "mx-auto mb-2" }),
      w(t.$slots, "default", {}, () => [
        L("p", ic, G(e.message), 1)
      ])
    ]));
  }
}), rc = (e) => {
  const { default: t } = un(), { getDefinitionsRecursive: n } = oa(), a = k(() => t != null ? n(
    t(),
    [],
    "GpTableColumn",
    (s, i) => s.name === "GpTableGenericColumn" && s.field != null ? {
      ...i,
      props: {
        ...i.props,
        field: s.field
      }
    } : null
  ) : []), l = k(() => a.value.length > 0 ? a.value.map((s) => {
    const {
      field: i,
      selection: o,
      label: r,
      alignment: u,
      verticalAlignment: c,
      "vertical-alignment": f,
      columnClass: m,
      "column-class": h,
      columnStyle: g,
      "column-style": v,
      headerClass: y,
      "header-class": b,
      headerStyle: S,
      "header-style": B
    } = s.props;
    return {
      field: i,
      selection: o,
      label: r,
      alignment: u,
      verticalAlignment: c || f,
      bodySlot: s.children != null ? s.children.body : void 0,
      headerSlot: s.children != null ? s.children.header : void 0,
      columnClass: ut(m || h),
      columnStyle: dt(g || v),
      headerClass: ut(y || b),
      headerStyle: dt(S || B)
    };
  }) : e.columns != null ? e.columns : []);
  return {
    slotColumns: a,
    columnDefinitions: l
  };
}, uc = (e, t) => {
  const n = Ae(e, "selectedRows", t), a = (o, r, u) => {
    o && !n.value.some((c) => c.key === r.key) ? n.value = n.value.concat(r) : n.value = n.value.filter(
      (c) => c.key !== r.key
    ), t("rowSelected", { status: o, row: r, rowIndex: u });
  }, l = (o) => n.value.some((r) => r.key === o.key), s = O(!1), i = (o) => {
    s.value = o, s.value ? n.value = e.data.filter(
      // filter out rows that are explicitly set to not be selectable
      (r) => r.selectable !== !1
    ) : n.value = [];
  };
  return H(
    () => e.data,
    () => {
      n.value = [];
    }
  ), H(
    () => e.selectedRows,
    () => {
      s.value = // edge case: if there are no rows selected, but all current rows are not selectable, the value would be come true, which is not correct
      // the length check is here to avoid this
      e.selectedRows.length > 0 && // comparing the length of selectedRows with the length of all rows that are selectable
      e.selectedRows.length === e.data.filter(
        // filter out rows that are explicitly set to not be selectable
        (o) => o.selectable !== !1
      ).length;
    }
  ), {
    handleCheckboxToggle: a,
    isRowSelected: l,
    isAllRowsSelected: s,
    handleAllRowsToggle: i
  };
}, bs = Symbol(
  "GP_TABLE_MOBILE_CONTROL_TARGET"
), Tt = Symbol(
  "GP_TABLE_IS_DESKTOP"
), ya = (e) => {
  const t = fe(Tt), n = k(() => {
    const l = [];
    return l.push(
      /* tw */
      "px-2 py-4 first:pl-4 lg:first:pl-8 last:pr-4 lg:last:pr-8"
    ), e.alignment === "center" ? l.push(
      /* tw */
      "text-center"
    ) : e.alignment === "right" ? l.push(
      /* tw */
      "text-right"
    ) : l.push(
      /* tw */
      "text-left"
    ), e.verticalAlignment === "bottom" ? l.push(
      /* tw */
      "align-bottom"
    ) : e.verticalAlignment === "top" ? l.push(
      /* tw */
      "align-top"
    ) : l.push(
      /* tw */
      "align-middle"
    ), l;
  }), a = k(() => {
    const l = [];
    return t.value || l.push(
      /* tw */
      "flex flex-col gap-1"
    ), l;
  });
  return {
    desktopClass: n,
    mobileClass: a
  };
}, dc = {
  key: 0,
  class: "me-4"
}, cc = { key: 2 }, fc = /* @__PURE__ */ E({
  __name: "GpTableHeaderCell",
  props: {
    field: {},
    columnIndex: {},
    alignment: { default: "left" },
    verticalAlignment: { default: "middle" },
    headerCellClass: { default: () => ({}) },
    headerCellStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    columnLabel: { default: void 0 },
    headerSlotContent: { type: Function, default: null },
    isSelected: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    disableSelect: { type: Boolean, default: !1 }
  },
  emits: ["update:isSelected"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = fe(Tt, O(!1)), s = k(() => n.field !== "checkbox" && n.headerSlotContent == null), { desktopClass: i, mobileClass: o } = ya(n), r = k(() => {
      const f = [];
      return l ? f.push(i.value) : f.push(o.value), s.value && f.push(
        /* tw */
        "font-bold uppercase text-gp-rhino"
      ), n.headerCellClass != null && Object.keys(n.headerCellClass).length > 0 && f.push(
        Object.entries(n.headerCellClass).filter(([m, h]) => h).map(([m]) => m).join(" ")
      ), f;
    }), u = k(() => ({
      field: n.field,
      columnIndex: n.columnIndex
    })), c = (f) => {
      a("update:isSelected", f);
    };
    return (f, m) => (p(), x("th", {
      class: I(r.value),
      style: se(e.headerCellStyle)
    }, [
      e.field === "checkbox" ? (p(), x(X, { key: 0 }, [
        e.selectable ? (p(), D(Qt, {
          key: 0,
          "model-value": e.isSelected,
          "input-id": "gp-table__row-cb-all",
          disabled: e.disableSelect,
          "label-pos": d(l) ? "right" : "left",
          "onUpdate:modelValue": c
        }, {
          label: T(() => [
            d(l) ? $("", !0) : (p(), x("span", dc, G(e.columnLabel), 1))
          ]),
          _: 1
        }, 8, ["model-value", "disabled", "label-pos"])) : $("", !0)
      ], 64)) : e.headerSlotContent != null ? (p(), D($e(e.headerSlotContent), W(re({ key: 1 }, u.value)), null, 16)) : (p(), x("span", cc, G(e.columnLabel), 1))
    ], 6));
  }
}), hc = {
  key: 1,
  class: "-mt- transition-colors hover:cursor-grab hover:text-gp-cyan-light"
}, mc = /* @__PURE__ */ E({
  __name: "GpTableBodyCell",
  props: {
    field: {},
    columnIndex: {},
    rowIndex: {},
    rowIsLast: { type: Boolean, default: !1 },
    rowData: {},
    alignment: { default: "left" },
    verticalAlignment: { default: "middle" },
    bodyCellClass: { default: () => ({}) },
    bodyCellStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    columnLabel: { default: void 0 },
    bodySlotContent: { type: Function, default: null },
    isSelected: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    disableSelect: { type: Boolean, default: !1 }
  },
  emits: ["update:isSelected"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = fe(Tt, O(!1)), { desktopClass: s, mobileClass: i } = ya(n), o = k(() => {
      const c = [];
      return l.value ? c.push(s.value) : c.push(i.value), n.bodyCellClass != null && Object.keys(n.bodyCellClass).length > 0 && c.push(
        Object.entries(n.bodyCellClass).filter(([f, m]) => m).map(([f]) => f).join(" ")
      ), c;
    }), r = k(() => ({
      field: n.field,
      row: n.rowData,
      data: n.rowData[n.field],
      rowIndex: n.rowIndex,
      columnIndex: n.columnIndex
    })), u = (c) => {
      a("update:isSelected", c);
    };
    return (c, f) => (p(), x("td", {
      style: se(e.bodyCellStyle),
      class: I(o.value)
    }, [
      e.field === "checkbox" ? (p(), x(X, { key: 0 }, [
        e.selectable ? (p(), D(Qt, {
          key: 0,
          "model-value": e.isSelected,
          "input-id": `gp-table__row-cb-${e.rowData.key}`,
          disabled: e.disableSelect,
          "onUpdate:modelValue": u
        }, null, 8, ["model-value", "input-id", "disabled"])) : $("", !0)
      ], 64)) : e.field === "reorderHandle" ? (p(), x("div", hc, [
        A(d(Q), { icon: d(il) }, null, 8, ["icon"])
      ])) : (p(), x(X, { key: 2 }, [
        e.bodySlotContent != null ? (p(), D($e(e.bodySlotContent), W(re({ key: 0 }, r.value)), null, 16)) : (p(), x(X, { key: 1 }, [
          ne(G(e.rowData[e.field]), 1)
        ], 64))
      ], 64))
    ], 6));
  }
}), pc = (e) => {
  const t = k(() => ({
    field: e.field,
    columnIndex: e.columnIndex
  })), n = k(() => ({
    field: e.field,
    row: e.rowData,
    data: e.rowData[e.field],
    rowIndex: e.rowIndex,
    columnIndex: e.columnIndex
  }));
  return {
    headSlotProps: t,
    bodySlotProps: n
  };
}, gc = /* @__PURE__ */ E({
  __name: "GpTableMobileCell",
  props: {
    field: {},
    columnIndex: {},
    rowIndex: { default: void 0 },
    rowData: { default: void 0 },
    alignment: { default: "left" },
    verticalAlignment: { default: "middle" },
    headerCellClass: { default: () => ({}) },
    headerCellStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    headerSlotContent: { type: Function, default: null },
    bodyCellClass: { default: () => ({}) },
    bodyCellStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    bodySlotContent: { type: Function, default: null },
    columnLabel: { default: void 0 }
  },
  setup(e) {
    const t = e, { mobileClass: n } = ya(t), { bodySlotProps: a, headSlotProps: l } = pc(t);
    return (s, i) => t.rowData ? (p(), x("td", {
      key: 0,
      class: I(d(n))
    }, [
      e.headerSlotContent != null ? (p(), x("label", {
        key: 0,
        class: I(["block w-full", e.headerCellClass]),
        style: se(e.headerCellStyle)
      }, [
        (p(), D($e(e.headerSlotContent), W(j(d(l))), null, 16))
      ], 6)) : (p(), x("label", {
        key: 1,
        class: I(["block w-full font-bold uppercase text-gp-rhino", e.headerCellClass]),
        style: se(e.headerCellStyle)
      }, G(e.columnLabel), 7)),
      L("div", {
        class: I(e.bodyCellClass),
        style: se(e.bodyCellStyle)
      }, [
        e.bodySlotContent != null ? (p(), D($e(e.bodySlotContent), W(re({ key: 0 }, d(a))), null, 16)) : (p(), x(X, { key: 1 }, [
          ne(G(e.rowData[e.field]), 1)
        ], 64))
      ], 6)
    ], 2)) : $("", !0);
  }
}), vc = /* @__PURE__ */ E({
  __name: "GpTableMobileCheckboxCell",
  props: {
    rowData: { default: void 0 },
    isSelected: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    disableSelect: { type: Boolean, default: !1 },
    bodyCellStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    bodyCellClass: { default: () => ({}) }
  },
  emits: ["update:isSelected"],
  setup(e, { emit: t }) {
    const n = t, a = (s) => {
      n("update:isSelected", s);
    }, l = fe(bs);
    return (s, i) => (p(), x("td", {
      style: se(e.bodyCellStyle),
      class: I(e.bodyCellClass)
    }, [
      d(l) ? (p(), D(Ze, {
        key: 0,
        to: d(l)
      }, [
        e.rowData == null ? (p(), D(d(Qt), {
          key: 0,
          "model-value": e.isSelected,
          "input-id": "gp-table__header-cb-all",
          disabled: e.disableSelect,
          "onUpdate:modelValue": a
        }, null, 8, ["model-value", "disabled"])) : e.selectable ? (p(), D(d(Qt), {
          key: 1,
          "model-value": e.isSelected,
          "input-id": `gp-table__row-cb-${e.rowData.key}`,
          disabled: e.disableSelect,
          "onUpdate:modelValue": a
        }, null, 8, ["model-value", "input-id", "disabled"])) : $("", !0)
      ], 8, ["to"])) : $("", !0)
    ], 6));
  }
}), qa = /* @__PURE__ */ E({
  __name: "GpTableCell",
  props: {
    field: {},
    rowData: { default: void 0 },
    rowIndex: { default: void 0 },
    rowIsLast: { type: Boolean, default: !1 },
    columnLabel: { default: void 0 },
    columnIndex: {},
    alignment: { default: "left" },
    verticalAlignment: { default: "middle" },
    selectable: { type: Boolean, default: !0 },
    disableSelect: { type: Boolean, default: !1 },
    isSelected: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !1 },
    headerCellClass: { default: () => ({}) },
    bodyCellClass: { default: () => ({}) },
    headerCellStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    bodyCellStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    bodySlotContent: { type: Function, default: void 0 },
    headerSlotContent: { type: Function, default: void 0 }
  },
  emits: ["update:isSelected", "reorder"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = z(n, "isSelected"), s = (r) => {
      a("update:isSelected", r);
    }, i = k(() => n.rowData == null && n.rowIndex == null), o = fe(Tt, O(!1));
    return (r, u) => d(o) ? (p(), x(X, { key: 0 }, [
      i.value ? (p(), D(fc, {
        key: 0,
        field: e.field,
        "column-index": e.columnIndex,
        alignment: e.alignment,
        "vertical-alignment": e.verticalAlignment,
        "header-cell-class": e.headerCellClass,
        "header-cell-style": e.headerCellStyle,
        "column-label": e.columnLabel,
        "header-slot-content": e.headerSlotContent,
        selectable: e.selectable,
        "is-selected": l.value,
        "disable-select": e.disableSelect,
        "onUpdate:isSelected": s
      }, null, 8, ["field", "column-index", "alignment", "vertical-alignment", "header-cell-class", "header-cell-style", "column-label", "header-slot-content", "selectable", "is-selected", "disable-select"])) : (p(), D(mc, {
        key: 1,
        field: e.field,
        "column-index": e.columnIndex,
        "row-index": e.rowIndex,
        "row-is-last": e.rowIsLast,
        "row-data": e.rowData,
        alignment: e.alignment,
        "vertical-alignment": e.verticalAlignment,
        "body-cell-class": e.bodyCellClass,
        "body-cell-style": e.bodyCellStyle,
        "column-label": e.columnLabel,
        "body-slot-content": e.bodySlotContent,
        selectable: e.selectable,
        "is-selected": l.value,
        "disable-select": e.disableSelect,
        draggable: e.draggable,
        "onUpdate:isSelected": s
      }, null, 8, ["field", "column-index", "row-index", "row-is-last", "row-data", "alignment", "vertical-alignment", "body-cell-class", "body-cell-style", "column-label", "body-slot-content", "selectable", "is-selected", "disable-select", "draggable"]))
    ], 64)) : e.field === "checkbox" ? (p(), D(vc, {
      key: 1,
      "row-data": e.rowData,
      "is-selected": l.value,
      "disable-select": e.disableSelect,
      selectable: e.selectable,
      "body-cell-class": e.bodyCellClass,
      "body-cell-style": e.bodyCellStyle,
      "onUpdate:isSelected": s
    }, null, 8, ["row-data", "is-selected", "disable-select", "selectable", "body-cell-class", "body-cell-style"])) : (p(), D(gc, {
      key: 2,
      field: e.field,
      "column-index": e.columnIndex,
      "row-index": e.rowIndex,
      "row-data": e.rowData,
      alignment: e.alignment,
      "vertical-alignment": e.verticalAlignment,
      "body-cell-class": e.bodyCellClass,
      "body-cell-style": e.bodyCellStyle,
      "column-label": e.columnLabel,
      "body-slot-content": e.bodySlotContent,
      "header-slot-content": e.headerSlotContent,
      "header-cell-class": e.headerCellClass,
      "header-cell-style": e.headerCellStyle
    }, null, 8, ["field", "column-index", "row-index", "row-data", "alignment", "vertical-alignment", "body-cell-class", "body-cell-style", "column-label", "body-slot-content", "header-slot-content", "header-cell-class", "header-cell-style"]));
  }
}), yc = ["draggable"], Vn = /* @__PURE__ */ E({
  __name: "GpTableRow",
  props: {
    isHeader: { type: Boolean, default: !1 },
    isSelected: { type: Boolean, default: !1 },
    isDropTarget: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !1 },
    float: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = fe(Tt, O(!1)), a = k(() => {
      const r = [];
      return (n.value || t.float) && r.push(
        /* tw */
        "border-b last:border-b-0 border-b-gp-mouse/30"
      ), n.value || (t.float ? (r.push(
        /* tw */
        "border-l-2"
      ), t.isSelected ? r.push(
        /* tw */
        "border-l-gp-cyan"
      ) : r.push(
        /* tw */
        "border-l-transparent"
      )) : (r.push(
        /* tw */
        "rounded shadow-sm border-2"
      ), t.isSelected ? r.push(
        /* tw */
        "border-gp-cyan"
      ) : r.push(
        /* tw */
        "border-transparent"
      ))), r;
    }), l = k(() => t.isDropTarget ? (
      /* tw */
      "bg-gp-midnight-3-a"
    ) : !t.float && (t.isHeader || !n.value) ? (
      /* tw */
      "bg-gp-midnight-2"
    ) : t.isHeader ? (
      /* tw */
      "bg-gp-midnight-3-a"
    ) : ""), s = k(() => n.value ? "" : t.isHeader ? (
      /* tw */
      "min-h-[3.5rem] flex items-stretch justify-end p-4 box-border"
    ) : (
      /* tw */
      "flex transition-all flex-col gap-2 p-4 relative"
    )), i = k(
      () => t.draggable ? "hover:cursor-grab" : ""
    ), o = O();
    return Xe(bs, o), (r, u) => (p(), x("tr", {
      draggable: t.draggable,
      class: I([i.value, s.value, l.value, ...a.value])
    }, [
      d(n) ? $("", !0) : (p(), x("td", {
        key: 0,
        ref_key: "mobileControlTarget",
        ref: o,
        class: "absolute right-4 flex flex-col gap-y-4"
      }, null, 512)),
      w(r.$slots, "default")
    ], 10, yc));
  }
}), Rn = /* @__PURE__ */ E({
  __name: "GpTablePaginationBtn",
  props: {
    isCurrentPage: { type: Boolean, default: !1 },
    label: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, l) => (p(), D(d(we), {
      class: I(["h-input min-w-input rounded-full px-1! text-center", {
        "pointer-events-none": e.isCurrentPage
      }]),
      "btn-type": e.isCurrentPage ? "primary" : "flat",
      label: e.label,
      icon: e.icon,
      disabled: e.disabled,
      size: "sm",
      onClick: l[0] || (l[0] = (s) => n("click"))
    }, {
      default: T(() => [
        w(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "btn-type", "label", "icon", "disabled"]));
  }
}), bc = {
  key: 0,
  class: "flex items-center justify-center gap-4 py-4 sm:gap-2"
}, kc = { key: 0 }, wc = { class: "items-middle hidden gap-2 sm:flex" }, xc = {
  key: 0,
  class: "hidden sm:block"
}, Cc = { class: "items-middle block gap-2 sm:hidden" }, vt = 2, Tc = /* @__PURE__ */ E({
  __name: "GpTablePagination",
  props: {
    modelValue: {},
    maxPages: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, l = Ae(n, "modelValue", t), s = (f) => l.value + 1 === f, i = k(() => l.value === 0), o = k(
      () => n.maxPages !== 1 / 0 && l.value === n.maxPages - 1
    ), r = k(() => {
      const f = l.value + 1, m = [1];
      if (n.maxPages > 5) {
        const h = f - vt, g = h < vt;
        let v = vt;
        g || (v = h), v > vt && m.push("dots");
        const y = f + vt, b = y > n.maxPages - 1;
        let S = n.maxPages - 1;
        b || (S = y);
        for (let B = v; B <= S; B += 1)
          m.push(B);
        return S <= n.maxPages - vt && m.push("dots"), m.push(n.maxPages), m;
      }
      for (let h = 1; h < n.maxPages; h += 1)
        m.push(h + 1);
      return m;
    }), u = k(() => ({
      currentPage: l.value,
      maxPages: n.maxPages,
      isAtFirst: i.value,
      isAtLast: o.value
    })), c = (f) => ({
      ...u.value,
      pageIndex: f - 1,
      isActive: s(f)
    });
    return (f, m) => e.maxPages > 1 ? (p(), x("ul", bc, [
      w(f.$slots, "default", W(j(u.value)), () => [
        L("li", null, [
          w(f.$slots, "back-item", W(j(u.value)), () => [
            A(Rn, {
              icon: d(Ns),
              disabled: i.value,
              onClick: m[0] || (m[0] = (h) => l.value = d(l) - 1)
            }, {
              default: T(() => [
                w(f.$slots, "back-item-content", W(j(u.value)))
              ]),
              _: 3
            }, 8, ["icon", "disabled"])
          ])
        ]),
        e.maxPages !== 1 / 0 ? (p(), x("li", kc, [
          L("ul", wc, [
            (p(!0), x(X, null, ce(r.value, (h, g) => (p(), x("li", {
              key: h === "dots" ? `dots_${g}` : `page_${h}`
            }, [
              h === "dots" ? (p(), x("span", xc, " ... ")) : w(f.$slots, "item", re({
                key: 1,
                ref_for: !0
              }, c(h)), () => [
                (p(), D(Rn, {
                  key: `page_${h}`,
                  label: `${h}`,
                  "is-current-page": s(h),
                  onClick: (v) => l.value = h - 1
                }, {
                  default: T(() => [
                    w(f.$slots, "item-content", re({ ref_for: !0 }, c(h)))
                  ]),
                  _: 2
                }, 1032, ["label", "is-current-page", "onClick"]))
              ])
            ]))), 128))
          ]),
          L("p", Cc, G(d(l) + 1) + " / " + G(e.maxPages), 1)
        ])) : $("", !0),
        L("li", null, [
          w(f.$slots, "next-item", W(j(u.value)), () => [
            A(Rn, {
              icon: d(Gs),
              disabled: o.value,
              onClick: m[1] || (m[1] = (h) => l.value = d(l) + 1)
            }, {
              default: T(() => [
                w(f.$slots, "next-item-content", W(j(u.value)))
              ]),
              _: 3
            }, 8, ["icon", "disabled"])
          ])
        ])
      ])
    ])) : $("", !0);
  }
}), Sc = { key: 0 }, Bc = ["colspan"], bh = /* @__PURE__ */ E({
  __name: "GpTable",
  props: {
    data: {},
    columns: { default: void 0 },
    selectedRows: { default: () => [] },
    caption: { default: void 0 },
    isLoading: { type: Boolean, default: !1 },
    loadingMessage: { default: "Loading data..." },
    emptyMessage: { default: "No data provided" },
    float: { type: Boolean, default: !1 },
    forceMobileView: { type: Boolean, default: !1 },
    forceDesktopView: { type: Boolean, default: !1 },
    desktopBreakpoint: { default: "md" },
    reorder: { type: Boolean, default: !1 },
    reorderOn: { default: "all" },
    pagination: { type: Boolean, default: !1 },
    rowsPerPage: { default: 1 / 0 },
    page: { default: 0 },
    maxPages: { default: 0 }
  },
  emits: ["update:selectedRows", "rowSelected", "rowReordered", "update:page"],
  setup(e, { emit: t }) {
    const n = e, a = t, { greaterOrEqual: l } = fn(), s = l(n.desktopBreakpoint), i = k(
      () => n.forceDesktopView || !n.forceMobileView && s.value
    );
    Xe(Tt, i);
    const { columnDefinitions: o } = rc(n), {
      handleCheckboxToggle: r,
      isRowSelected: u,
      isAllRowsSelected: c,
      handleAllRowsToggle: f
    } = uc(n, a), m = (C, R, F) => {
      r(C, R, F);
    }, h = k(() => n.maxPages < 1 ? Math.ceil(n.data.length / n.rowsPerPage) : n.maxPages), g = k(() => n.pagination && n.rowsPerPage > 0 && n.rowsPerPage !== 1 / 0 && Math.ceil(n.data.length / n.rowsPerPage) > 1 ? (n.page + 1) * n.rowsPerPage > n.data.length ? n.data.slice(
      n.page * n.rowsPerPage,
      n.data.length
    ) : n.data.slice(
      n.page * n.rowsPerPage,
      (n.page + 1) * n.rowsPerPage
    ) : n.data), v = Ae(n, "page", a), {
      liveOrderedData: y,
      rowIsDropTarget: b,
      handleDragStart: S,
      handleDragEnd: B,
      handleDragOver: M,
      handleDrop: P
    } = os(
      g,
      (C, R) => {
        a("rowReordered", {
          fromIndex: C,
          toIndex: R
        });
      },
      {
        reorderDisabled: !n.reorder
      }
    ), V = k(
      () => o.value.some((C) => C.field === "checkbox") && n.data.some((C) => C.selectable !== !1)
    );
    return (C, R) => (p(), x("div", {
      class: I(["relative min-h-28", {
        "bg-linear-to-r from-gp-midnight-gradient-a to-gp-midnight-gradient-b shadow-xl": n.float
      }])
    }, [
      C.$slots.header != null ? (p(), x("div", {
        key: 0,
        class: I(["rounded-t px-4 py-2", {
          "mb-4": !i.value && !n.float,
          "bg-gp-midnight-2": !n.float,
          "bg-gp-midnight-3-a": n.float
        }])
      }, [
        w(C.$slots, "header")
      ], 2)) : $("", !0),
      L("table", {
        class: I(["w-full", i.value ? "table table-auto" : "block"])
      }, [
        e.caption ? (p(), x("caption", Sc, G(e.caption), 1)) : $("", !0),
        ft(L("thead", {
          class: I({
            block: !i.value
          })
        }, [
          A(Vn, {
            class: "transition-colors",
            "is-desktop": i.value,
            "is-header": "",
            float: n.float
          }, {
            default: T(() => [
              (p(!0), x(X, null, ce(d(o), (F, N) => (p(), x(X, {
                key: `gp-table_c_${F.field}`
              }, [
                i.value || F.field === "checkbox" ? (p(), D(qa, {
                  key: 0,
                  "header-cell-class": F.headerClass,
                  field: F.field,
                  "column-index": N,
                  "is-selected": d(c),
                  "header-slot-content": F.headerSlot,
                  "column-label": F.label,
                  alignment: F.alignment,
                  "header-cell-style": F.headerStyle,
                  "onUpdate:isSelected": d(f)
                }, null, 8, ["header-cell-class", "field", "column-index", "is-selected", "header-slot-content", "column-label", "alignment", "header-cell-style", "onUpdate:isSelected"])) : $("", !0)
              ], 64))), 128))
            ]),
            _: 1
          }, 8, ["is-desktop", "float"])
        ], 2), [
          [Lt, i.value || V.value]
        ]),
        L("tbody", {
          class: I({
            "flex flex-col": !i.value,
            "mt-4 gap-4": !i.value && !n.float
          })
        }, [
          (g.value == null || g.value.length === 0) && !e.isLoading ? (p(), D(Vn, {
            key: 0,
            "is-desktop": i.value,
            float: n.float
          }, {
            default: T(() => [
              L("td", {
                class: "w-full border-0",
                colspan: d(o).length
              }, [
                w(C.$slots, "empty", {}, () => [
                  A(oc, {
                    message: e.emptyMessage,
                    class: I(["mx-auto", n.float ? "py-4" : "pt-2"])
                  }, null, 8, ["message", "class"])
                ])
              ], 8, Bc)
            ]),
            _: 3
          }, 8, ["is-desktop", "float"])) : (p(!0), x(X, { key: 1 }, ce(d(y), ({ index: F, row: N }, ee) => (p(), D(Vn, {
            key: N.key,
            "is-selected": d(u)(N),
            "is-drop-target": d(b)(ee),
            float: n.float,
            draggable: n.reorder && i.value && n.reorderOn === "all",
            onDragstart: (_) => d(S)(_, ee),
            onDragend: d(B),
            onDragover: (_) => d(M)(_, ee),
            onDrop: (_) => d(P)(_, ee)
          }, {
            default: T(() => [
              (p(!0), x(X, null, ce(d(o), (_, Z) => (p(), D(qa, {
                key: `gp-table_r_${N.key}_${_.field}`,
                selectable: N.selectable,
                "is-selected": d(u)(N),
                "body-slot-content": _.bodySlot,
                "header-slot-content": _.headerSlot,
                field: _.field,
                draggable: _.field === "reorderHandle" && n.reorder && i.value && n.reorderOn === "handle",
                "row-data": N,
                "row-index": F,
                "row-is-last": F === d(y).length - 1,
                "column-label": _.label,
                "column-index": Z,
                alignment: _.alignment,
                "vertical-alignment": _.verticalAlignment,
                "header-cell-class": _.headerClass,
                "body-cell-class": _.columnClass,
                "header-cell-style": _.headerStyle,
                "body-cell-style": _.columnStyle,
                "onUpdate:isSelected": (U) => m(U, N, F)
              }, null, 8, ["selectable", "is-selected", "body-slot-content", "header-slot-content", "field", "draggable", "row-data", "row-index", "row-is-last", "column-label", "column-index", "alignment", "vertical-alignment", "header-cell-class", "body-cell-class", "header-cell-style", "body-cell-style", "onUpdate:isSelected"]))), 128))
            ]),
            _: 2
          }, 1032, ["is-selected", "is-drop-target", "float", "draggable", "onDragstart", "onDragend", "onDragover", "onDrop"]))), 128))
        ], 2)
      ], 2),
      A(Ye, null, {
        default: T(() => [
          e.isLoading ? (p(), x("div", {
            key: 0,
            class: I(["absolute top-0 flex size-full items-center justify-center rounded py-4", { "bg-gp-midnight-2/70": i.value }])
          }, [
            w(C.$slots, "loading", {}, () => [
              A(lc, {
                message: e.loadingMessage,
                "is-loading": "",
                class: "mx-auto"
              }, null, 8, ["message"])
            ])
          ], 2)) : $("", !0)
        ]),
        _: 3
      }),
      e.pagination && e.data.length > 0 ? w(C.$slots, "pagination", {
        key: 1,
        maxPages: h.value,
        isAtFirst: d(v) === 0,
        isAtLast: d(v) === h.value - 1
      }, () => [
        A(Tc, {
          modelValue: d(v),
          "onUpdate:modelValue": R[0] || (R[0] = (F) => ln(v) ? v.value = F : null),
          class: I({
            "border-t border-t-gp-mouse/30": e.float && !i.value
          }),
          "max-pages": h.value
        }, {
          default: T((F) => [
            w(C.$slots, "pagination-inner", W(j(F)))
          ]),
          "back-item": T((F) => [
            w(C.$slots, "pagination-back-item", W(j(F)))
          ]),
          "back-item-content": T((F) => [
            w(C.$slots, "pagination-back-item-content", W(j(F)))
          ]),
          "next-item": T((F) => [
            w(C.$slots, "pagination-next-item", W(j(F)))
          ]),
          "next-item-content": T((F) => [
            w(C.$slots, "pagination-next-item-content", W(j(F)))
          ]),
          item: T((F) => [
            w(C.$slots, "pagination-item", W(j(F)))
          ]),
          "item-content": T((F) => [
            w(C.$slots, "pagination-item-content", W(j(F)))
          ]),
          _: 3
        }, 8, ["modelValue", "class", "max-pages"])
      ]) : $("", !0),
      w(C.$slots, "default")
    ], 2));
  }
}), ks = /* @__PURE__ */ E({
  name: "GpTableColumn",
  inheritAttrs: !1,
  customOptions: {},
  __name: "GpTableColumn",
  props: {
    field: {},
    label: { default: "Column" },
    selection: { default: void 0 },
    alignment: { default: "left" },
    verticalAlignment: { default: void 0 },
    columnClass: { default: void 0 },
    columnStyle: { type: [Boolean, null, String, Object, Array], default: void 0 },
    headerClass: { default: void 0 },
    headerStyle: { type: [Boolean, null, String, Object, Array], default: void 0 }
  },
  setup(e) {
    return k(() => ({})), k(
      () => ({})
    ), (t, n) => $("", !0);
  }
}), kh = (e, t) => E({
  name: "GpTableGenericColumn",
  setup: (a, { slots: l }) => () => jn(ks, { ...a, field: t }, l),
  field: t
}), wh = (e) => E({
  name: "GpTableColumn",
  setup: (n, { slots: a }) => () => jn(ks, n, a)
}), Dc = ["alt"], xh = /* @__PURE__ */ E({
  __name: "GpBrandImageStatic",
  props: {
    alt: {}
  },
  setup(e) {
    return (t, n) => (p(), x("img", {
      src: Ds,
      alt: e.alt
    }, null, 8, Dc));
  }
}), Ic = { class: "relative flex h-full flex-col justify-between" }, Mc = {
  key: 0,
  class: "px-4 py-2"
}, Ec = { class: "px-4 py-2" }, Ac = { class: "mb-2 text-2xl font-bold" }, Fc = {
  key: 0,
  class: "px-4 py-2"
}, Ka = /* @__PURE__ */ E({
  __name: "GpCardBody",
  props: {
    headerText: {},
    contentTitle: {},
    contentText: {},
    footerText: {}
  },
  setup(e) {
    return (t, n) => (p(), x("div", Ic, [
      w(t.$slots, "header", {}, () => [
        e.headerText ? (p(), x("p", Mc, G(e.headerText), 1)) : $("", !0)
      ]),
      w(t.$slots, "content", {}, () => [
        L("div", Ec, [
          L("p", Ac, G(e.contentTitle), 1),
          L("p", null, G(e.contentText), 1)
        ])
      ]),
      w(t.$slots, "footer", {}, () => [
        e.footerText ? (p(), x("p", Fc, G(e.footerText), 1)) : $("", !0)
      ])
    ]));
  }
}), Oc = ["src", "alt"], $c = /* @__PURE__ */ E({
  __name: "GpCardFancy",
  props: {
    active: { type: Boolean, default: !1 },
    shadow: { type: Boolean },
    borderOnHover: { type: Boolean, default: !1 },
    backgroundImage: { default: "" },
    backgroundImageAlt: { default: "" },
    backgroundImageTransparent: { type: Boolean, default: !1 },
    hasBackgroundSlot: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = k(() => {
      const s = ["gp-card-fancy-border"];
      return t.borderOnHover && (s.push(
        /* tw */
        "group p-[2px] before:absolute before:-inset-0 before:-z-[2] before:block before:h-full before:w-full before:rounded before:transition-opacity"
      ), s.push(
        /* tw */
        "before:opacity-0 hover:before:opacity-100"
      )), s;
    }), a = k(() => {
      const s = [];
      return t.backgroundImage != null && s.push(
        /* tw */
        "inset-0 overflow-hidden"
      ), (t.active || t.borderOnHover) && s.push(
        /* tw */
        "inset-0"
      ), (t.backgroundImage == null || t.backgroundImage.length === 0 || t.backgroundImageTransparent) && !t.hasBackgroundSlot && s.push("bg-gp-midnight-1"), s;
    }), l = k(() => t.shadow ? "shadow-sm" : "");
    return (s, i) => (p(), x("div", {
      class: I(n.value)
    }, [
      L("div", {
        class: I(["relative h-full rounded", l.value])
      }, [
        w(s.$slots, "default", {}, () => [
          L("div", {
            class: I(["absolute rounded", a.value])
          }, [
            w(s.$slots, "background", {}, () => [
              t.backgroundImage && t.backgroundImage.length > 0 ? (p(), x("img", {
                key: 0,
                src: e.backgroundImage,
                alt: e.backgroundImageAlt,
                class: "h-auto w-full"
              }, null, 8, Oc)) : $("", !0)
            ], !0)
          ], 2),
          w(s.$slots, "body", {}, void 0, !0)
        ], !0)
      ], 2)
    ], 2));
  }
}), Lc = /* @__PURE__ */ ms($c, [["__scopeId", "data-v-6adf62d9"]]), Vc = ["src", "alt"], Rc = /* @__PURE__ */ E({
  __name: "GpCardDefault",
  props: {
    active: { type: Boolean, default: !1 },
    shadow: { type: Boolean },
    borderOnHover: { type: Boolean, default: !1 },
    backgroundImage: { default: "" },
    backgroundImageAlt: { default: "" },
    backgroundImageTransparent: { type: Boolean, default: !1 },
    hasBackgroundSlot: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = k(() => {
      const s = [];
      return t.borderOnHover && (s.push(
        /* tw */
        "border-2"
      ), t.active ? s.push(
        /* tw */
        "border-gp-cyan"
      ) : s.push(
        /* tw */
        "border-transparent hover:border-gp-cyan"
      )), s;
    }), a = k(() => t.shadow ? "shadow-sm" : ""), l = k(() => (t.backgroundImage == null || t.backgroundImage.length === 0 || t.backgroundImageTransparent) && !t.hasBackgroundSlot ? "bg-gp-midnight-1" : "");
    return (s, i) => (p(), x("div", {
      class: I(n.value)
    }, [
      L("div", {
        class: I(["relative h-full rounded", [a.value, l.value]])
      }, [
        w(s.$slots, "default", {}, () => [
          w(s.$slots, "background", {}, () => [
            e.backgroundImage != null ? (p(), x("img", {
              key: 0,
              src: e.backgroundImage,
              alt: e.backgroundImageAlt,
              class: "absolute h-auto w-full max-w-full rounded"
            }, null, 8, Vc)) : $("", !0)
          ]),
          w(s.$slots, "body")
        ])
      ], 2)
    ], 2));
  }
}), Qa = "relative overflow-hidden rounded transition-all", Ch = /* @__PURE__ */ E({
  __name: "GpCard",
  props: {
    bodyClass: { default: null },
    body: { default: null },
    headerText: { default: "" },
    contentTitle: { default: "" },
    contentText: { default: "" },
    footerText: { default: "" },
    enlargeOnHover: { type: Boolean, default: !0 },
    borderOnHover: { type: Boolean, default: !0 },
    fancyBorder: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    shadow: { type: Boolean, default: !0 },
    backgroundImage: { default: null },
    backgroundImageAlt: { default: null },
    backgroundImageTransparent: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = k(
      () => t.enlargeOnHover ? "hover:scale-105" : ""
    ), a = k(() => t.body == null || t.body.class == null ? t.bodyClass : t.body.class), l = un(), s = k(() => l.background != null);
    return (i, o) => e.fancyBorder ? (p(), D(Lc, {
      key: 0,
      active: e.active,
      "border-on-hover": e.borderOnHover,
      shadow: e.shadow,
      "background-image": e.backgroundImage,
      "background-image-alt": e.backgroundImageAlt,
      "background-image-transparent": "",
      "has-background-slot": s.value,
      class: I([Qa, n.value])
    }, {
      default: T(() => [
        w(i.$slots, "default")
      ]),
      background: T(() => [
        w(i.$slots, "background")
      ]),
      body: T(() => [
        A(Ka, {
          "header-text": e.headerText,
          "content-title": e.contentTitle,
          "content-text": e.contentText,
          "footer-text": e.footerText,
          class: I(a.value),
          style: se(e.body == null || e.body.style == null ? "" : e.body.style)
        }, {
          header: T(() => [
            w(i.$slots, "header")
          ]),
          content: T(() => [
            w(i.$slots, "content")
          ]),
          footer: T(() => [
            w(i.$slots, "footer")
          ]),
          _: 3
        }, 8, ["header-text", "content-title", "content-text", "footer-text", "class", "style"])
      ]),
      _: 3
    }, 8, ["active", "border-on-hover", "shadow", "background-image", "background-image-alt", "has-background-slot", "class"])) : (p(), D(Rc, {
      key: 1,
      active: e.active,
      "border-on-hover": e.borderOnHover,
      shadow: e.shadow,
      "background-image": e.backgroundImage,
      "background-image-alt": e.backgroundImageAlt,
      "background-image-transparent": e.backgroundImageTransparent,
      "has-background-slot": s.value,
      class: I([Qa, n.value])
    }, {
      default: T(() => [
        w(i.$slots, "default")
      ]),
      background: T(() => [
        w(i.$slots, "background")
      ]),
      body: T(() => [
        A(Ka, {
          "header-text": e.headerText,
          "content-title": e.contentTitle,
          "content-text": e.contentText,
          "footer-text": e.footerText,
          class: I(a.value),
          style: se(e.body == null || e.body.style == null ? "" : e.body.style)
        }, {
          header: T(() => [
            w(i.$slots, "header")
          ]),
          content: T(() => [
            w(i.$slots, "content")
          ]),
          footer: T(() => [
            w(i.$slots, "footer")
          ]),
          _: 3
        }, 8, ["header-text", "content-title", "content-text", "footer-text", "class", "style"])
      ]),
      _: 3
    }, 8, ["active", "border-on-hover", "shadow", "background-image", "background-image-alt", "background-image-transparent", "has-background-slot", "class"]));
  }
}), Pc = (e, t, n) => {
  const a = O(!1), l = k(
    () => d(n) == null ? null : d(n).$el
  ), { smaller: s } = fn(), i = O(!1), { overlayStyle: o } = ia(t, l, {
    fullWidth: !0,
    offset: 10
  });
  return be(() => {
    i.value = e.overlayBreakpoint != null && s(e.overlayBreakpoint).value, i.value || (a.value = !1);
  }), cn(
    l,
    () => {
      i.value && (a.value = !1);
    },
    {
      ignore: ['[data-gp-element="gp-tab-bar-toggle"]']
    }
  ), {
    isBelowBreakpoint: i,
    isOpened: a,
    toggle: () => {
      a.value = !a.value;
    },
    overlayStyle: o
  };
}, Gc = (e, t) => {
  const n = O(0), { width: a } = _n(t), l = k(
    () => d(t) == null ? null : d(t).$el
  ), { x: s, arrivedState: i } = vl(l, { behavior: "smooth" }), o = k(() => n.value > Math.round(a.value));
  Jn(t, () => {
    e.overflow && (n.value = l.value.scrollWidth, n.value === a.value && (s.value = 0, i.right = !1));
  });
  const r = () => {
    if (!i.right) {
      const c = Array.from(
        l.value.querySelectorAll('[data-gp-element="gp-tab-entry"]')
      ).find((f) => f.offsetLeft > s.value);
      if (c == null) return;
      s.value = c.offsetLeft;
    }
  }, u = () => {
    if (!i.left) {
      const c = Array.from(
        l.value.querySelectorAll('[data-gp-element="gp-tab-entry"]')
      ).reverse().find((f) => f.offsetLeft + f.getBoundingClientRect().width <= s.value || f.offsetLeft < s.value && f.offsetLeft + f.getBoundingClientRect().width > s.value);
      if (c == null) return;
      s.value = c.offsetLeft;
    }
  };
  return xe(() => {
    d(t) != null && (n.value = l.value.scrollWidth);
  }), {
    arrivedState: i,
    isOverflowing: o,
    scrollToNextTab: r,
    scrollToPreviousTab: u
  };
}, Nc = /* @__PURE__ */ E({
  __name: "GpTabBtn",
  props: {
    isActive: { type: Boolean },
    label: {},
    icon: { default: null },
    activeType: { default: "primary" },
    inactiveType: { default: "flat" },
    disabled: { type: Boolean }
  },
  emits: ["tabSelected"],
  setup(e, { emit: t }) {
    const n = t, a = () => {
      n("tabSelected");
    };
    return (l, s) => (p(), D(we, {
      size: "sm",
      class: I({ "cursor-default!": e.isActive }),
      "btn-type": e.isActive ? e.activeType : e.inactiveType,
      label: e.label,
      icon: e.icon,
      disabled: e.disabled,
      onClick: a
    }, {
      default: T(() => [
        w(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "btn-type", "label", "icon", "disabled"]));
  }
}), zc = /* @__PURE__ */ E({
  __name: "GpTabItem",
  props: {
    isActive: { type: Boolean },
    label: {},
    icon: { default: null },
    disabled: { type: Boolean }
  },
  emits: ["tabSelected"],
  setup(e, { emit: t }) {
    const n = t, a = (l) => {
      l.preventDefault(), n("tabSelected");
    };
    return (l, s) => (p(), x("a", {
      class: I(["block whitespace-nowrap text-center font-bold transition-colors hover:text-gp-cyan", {
        "text-gp-cyan": e.isActive,
        "cursor-pointer": !e.isActive && !e.disabled,
        "pointer-events-none cursor-default": e.isActive || e.disabled,
        "opacity-70": e.disabled
      }]),
      onClick: a
    }, [
      w(l.$slots, "default", {}, () => [
        e.icon != null ? (p(), D(d(Q), {
          key: 0,
          icon: e.icon,
          class: "mr-2"
        }, null, 8, ["icon"])) : $("", !0),
        ne(" " + G(e.label), 1)
      ])
    ], 2));
  }
}), Xa = /* @__PURE__ */ E({
  __name: "GpTabsList",
  props: {
    modelValue: { default: 0 },
    tabsModel: { default: () => [] },
    tabsType: { default: "default" },
    isOverlaying: { type: Boolean },
    isGrowMode: { type: Boolean, default: !1 },
    isGridMode: { type: Boolean, default: !1 },
    activeType: { default: "primary" },
    inactiveType: { default: "flat" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const l = Ae(e, "modelValue", t), s = (i) => {
      l.value = i;
    };
    return (i, o) => (p(), x("ul", {
      class: I({ "py-2": e.isOverlaying })
    }, [
      w(i.$slots, "default", {}, () => [
        (p(!0), x(X, null, ce(e.tabsModel, (r, u) => (p(), x("li", {
          key: r.id || r.label.replaceAll(/\s/g, "_") + "__" + u,
          "data-gp-element": "gp-tab-entry",
          class: I({
            "flex-1": e.isGrowMode,
            "px-4": e.isOverlaying && e.tabsType === "btn"
          })
        }, [
          w(i.$slots, "item", {
            item: r,
            index: u,
            isActive: u === d(l) || r.id === d(l)
          }, () => [
            e.tabsType === "default" ? (p(), D(zc, {
              key: 0,
              label: r.label,
              "is-active": u === d(l) || r.id === d(l),
              class: I({
                "py-1 text-center hover:bg-gp-dark-mouse-light": e.isOverlaying
              }),
              icon: r.icon,
              disabled: r.disabled,
              onTabSelected: (c) => s(r.id || u)
            }, {
              default: T(() => [
                w(i.$slots, "item-content", {
                  item: r,
                  index: u,
                  isActive: u === d(l) || r.id === d(l)
                })
              ]),
              _: 2
            }, 1032, ["label", "is-active", "class", "icon", "disabled", "onTabSelected"])) : $("", !0),
            e.tabsType === "btn" ? (p(), D(Nc, {
              key: 1,
              class: "block w-full",
              "is-active": u === d(l) || r.id === d(l),
              label: r.label,
              "active-type": e.activeType,
              "inactive-type": e.inactiveType,
              icon: r.icon,
              disabled: r.disabled,
              onTabSelected: (c) => s(r.id || u)
            }, {
              default: T(() => [
                w(i.$slots, "item-content", {
                  item: r,
                  index: u,
                  isActive: u === d(l) || r.id === d(l)
                })
              ]),
              _: 2
            }, 1032, ["is-active", "label", "active-type", "inactive-type", "icon", "disabled", "onTabSelected"])) : $("", !0)
          ])
        ], 2))), 128))
      ])
    ], 2));
  }
}), Yc = ["disabled"], Wc = ["disabled"], Th = /* @__PURE__ */ E({
  __name: "GpTabBar",
  props: {
    modelValue: { default: 0 },
    tabsModel: { default: () => [] },
    tabsType: { default: "default" },
    overlayBreakpoint: { default: "md" },
    persistOverlay: { type: Boolean, default: !1 },
    showLabelInOverlayToggle: { type: Boolean },
    overflow: { type: Boolean },
    grid: { type: Boolean, default: !1 },
    grow: { type: Boolean, default: !1 },
    activeType: { default: "primary" },
    inactiveType: { default: "flat" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, l = Ae(n, "modelValue", t), s = O(), i = O(), { isOpened: o, toggle: r, isBelowBreakpoint: u, overlayStyle: c } = Pc(
      n,
      s,
      i
    ), { isOverflowing: f, arrivedState: m, scrollToNextTab: h, scrollToPreviousTab: g } = Gc(n, i), v = (b) => {
      l.value = b, n.persistOverlay || (o.value = !1);
    }, y = k(() => n.tabsModel.find(
      (b, S) => S === l.value || b.id === l.value
    ));
    return (b, S) => (p(), x("div", {
      ref_key: "root",
      ref: s,
      class: I({ "flex gap-2": e.overflow })
    }, [
      !e.grid && !e.overflow && d(u) ? w(b.$slots, "overlay-toggle", {
        key: 0,
        toggle: d(r),
        isOpen: d(o)
      }, () => [
        A(we, {
          icon: e.showLabelInOverlayToggle ? null : d(zs),
          size: "sm",
          "btn-type": "transparent",
          "data-gp-element": "gp-tab-bar-toggle",
          onClick: d(r)
        }, {
          default: T(() => [
            e.showLabelInOverlayToggle && y.value != null ? (p(), x(X, { key: 0 }, [
              ne(G(y.value.label) + " ", 1),
              A(d(Q), {
                icon: d(lt),
                class: I(["ml-2 rotate-180 transition-transform", { "rotate-0!": d(o) }])
              }, null, 8, ["icon", "class"])
            ], 64)) : $("", !0)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]) : $("", !0),
      e.overflow && d(f) ? (p(), x("button", {
        key: 1,
        class: I(["my-1 size-input rounded-full bg-gp-midnight-2", { "opacity-70": d(m).left }]),
        disabled: d(m).left,
        onClick: S[0] || (S[0] = //@ts-ignore
        (...B) => d(g) && d(g)(...B))
      }, [
        A(d(Q), { icon: d(ul) }, null, 8, ["icon"])
      ], 10, Yc)) : $("", !0),
      (p(), D(Ze, {
        to: "body",
        disabled: e.overflow || e.grid || !d(u)
      }, [
        !e.overflow && !e.grid && d(u) ? (p(), D(da, { key: 0 }, {
          default: T(() => [
            d(o) ? (p(), D(Xa, {
              key: 0,
              ref_key: "tabs",
              ref: i,
              "model-value": d(l),
              class: I({
                "gap-4": e.tabsType === "default",
                "gap-2": e.tabsType === "btn",
                "origin-top rounded bg-gp-midnight-2 ": d(u),
                "w-full": d(o)
              }),
              style: se(
                d(o) && d(u) ? { ...d(c), width: "100%" } : void 0
              ),
              "tabs-model": e.tabsModel,
              "tabs-type": e.tabsType,
              "active-type": e.activeType,
              "is-grid-mode": e.grid,
              "is-grow-mode": e.grow,
              "is-overlaying": !0,
              "inactive-type": e.inactiveType,
              "onUpdate:modelValue": v
            }, {
              item: T(({ index: B, isActive: M, item: P }) => [
                w(b.$slots, "item", {
                  item: P,
                  index: B,
                  isActive: M
                })
              ]),
              "item-content": T(({ index: B, isActive: M, item: P }) => [
                w(b.$slots, "item-content", {
                  item: P,
                  index: B,
                  isActive: M
                })
              ]),
              default: T(() => [
                w(b.$slots, "default")
              ]),
              _: 3
            }, 8, ["model-value", "class", "style", "tabs-model", "tabs-type", "active-type", "is-grid-mode", "is-grow-mode", "inactive-type"])) : $("", !0)
          ]),
          _: 3
        })) : (p(), D(Xa, {
          key: 1,
          ref_key: "tabs",
          ref: i,
          modelValue: d(l),
          "onUpdate:modelValue": [
            S[1] || (S[1] = (B) => ln(l) ? l.value = B : null),
            v
          ],
          class: I(["relative flex-1 py-1", {
            "gap-4": e.tabsType === "default",
            "gap-2": e.tabsType === "btn",
            "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4": e.grid,
            flex: !e.grid,
            "overflow-x-hidden": e.overflow
          }]),
          "tabs-model": e.tabsModel,
          "tabs-type": e.tabsType,
          "active-type": e.activeType,
          "is-grid-mode": e.grid,
          "is-grow-mode": e.grow,
          "inactive-type": e.inactiveType
        }, {
          item: T(({ index: B, isActive: M, item: P }) => [
            w(b.$slots, "item", {
              item: P,
              index: B,
              isActive: M
            })
          ]),
          "item-content": T(({ index: B, isActive: M, item: P }) => [
            w(b.$slots, "item-content", {
              item: P,
              index: B,
              isActive: M
            })
          ]),
          default: T(() => [
            w(b.$slots, "default")
          ]),
          _: 3
        }, 8, ["modelValue", "class", "tabs-model", "tabs-type", "active-type", "is-grid-mode", "is-grow-mode", "inactive-type"]))
      ], 8, ["disabled"])),
      e.overflow && d(f) ? (p(), x("button", {
        key: 2,
        class: I(["my-1 size-input rounded-full bg-gp-midnight-2", { "opacity-70": d(m).right }]),
        disabled: d(m).right,
        onClick: S[2] || (S[2] = //@ts-ignore
        (...B) => d(h) && d(h)(...B))
      }, [
        A(d(Q), { icon: d(dl) }, null, 8, ["icon"])
      ], 10, Wc)) : $("", !0)
    ], 2));
  }
});
/*!
 * Font Awesome Pro 6.7.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const jc = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, Hc = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, Uc = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, qc = /* @__PURE__ */ E({
  __name: "GpIconFancy",
  props: {
    icon: {},
    title: { default: void 0 }
  },
  setup(e) {
    const t = Ie(), a = `gp-icon-fancy-gradient-${on().replace(/[^a-zA-Z0-9_-]/g, "_").replace(/^_+|_+$/g, "") || "icon"}`;
    return (l, s) => (p(), x(X, null, [
      A(d(Q), re({ icon: e.icon }, d(t), {
        class: "[&>path]:fill-(--gp-icon-fancy-gradient)",
        style: `--gp-icon-fancy-gradient: url(#${a})`,
        title: e.title
      }), null, 16, ["icon", "style", "title"]),
      L("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "absolute size-px overflow-hidden [clip:rect(1px_1px_1px_1px)]"
      }, [
        L("defs", null, [
          L("linearGradient", { id: a }, [...s[0] || (s[0] = [
            L("stop", {
              class: "[stop-color:var(--color-gp-mr-maintenance-a)]",
              offset: "0%"
            }, null, -1),
            L("stop", {
              class: "[stop-color:var(--color-gp-mr-maintenance-b)]",
              offset: "100%"
            }, null, -1)
          ])])
        ])
      ])
    ], 64));
  }
}), Kc = {
  key: 0,
  class: "basis-1/1 flex items-center gap-4 px-4 py-2 md:basis-1/2"
}, Qc = { class: "break-words text-base font-bold text-black" }, Xc = { class: "flex w-full flex-nowrap items-center gap-4 rounded-t-3xl bg-gp-cyan px-4 py-2 pr-16" }, Zc = { class: "break-words text-base font-bold text-black" }, Jc = { class: "shadow-3xl flex flex-col gap-8 rounded-3xl bg-gp-midnight-3-a" }, _c = { class: "flex items-center gap-4" }, ef = { class: "flex flex-col gap-x-4 gap-y-2 md:flex-row" }, tf = { class: "break-words text-2xl font-bold" }, nf = {
  key: 0,
  class: "mt-2.5 w-full pl-0 md:pl-12"
}, af = {
  key: 0,
  class: "px-4 py-2 text-right text-sm text-gp-rhino"
}, lf = { class: "flex items-center justify-end" }, sf = { key: 0 }, of = { key: 1 }, Sh = /* @__PURE__ */ E({
  __name: "GpPanel",
  props: {
    title: { default: "" },
    icon: {},
    subText: { default: "" },
    showHelp: { type: Boolean },
    showImportant: { type: Boolean },
    showToggle: { type: Boolean },
    showMore: { default: "Show more" },
    showLess: { default: "Show less" }
  },
  setup(e) {
    const t = O(!0);
    return (n, a) => (p(), x("div", {
      class: I({ "rounded-3xl bg-gp-cyan": e.showImportant })
    }, [
      L("div", {
        class: I(["flex flex-col flex-wrap md:flex-row md:flex-nowrap", { "justify-end": !e.showImportant }])
      }, [
        e.showImportant ? (p(), x("div", Kc, [
          A(d(Q), {
            icon: d(Uc),
            class: "text-2xl text-gp-midnight-2"
          }, null, 8, ["icon"]),
          L("span", Qc, [
            w(n.$slots, "importantText", {}, () => [
              a[1] || (a[1] = ne("Missing important text", -1))
            ])
          ])
        ])) : $("", !0),
        e.showHelp ? (p(), x("div", {
          key: 1,
          class: I(["basis-1/1 relative flex md:basis-1/2 md:flex-nowrap", e.showImportant ? "flex-wrap justify-between pr-5" : "px-4"])
        }, [
          L("div", Xc, [
            A(d(Q), {
              icon: d(Hc),
              class: "text-2xl text-gp-black"
            }, null, 8, ["icon"]),
            L("span", Zc, [
              w(n.$slots, "helpText", {}, () => [
                a[2] || (a[2] = ne("Missing help text", -1))
              ])
            ])
          ]),
          L("div", {
            class: "absolute -bottom-3 right-3 z-0 hidden size-16 bg-[image:var(--gp-panel-ghost)] bg-cover bg-no-repeat sm:block",
            style: se({ "--gp-panel-ghost": `url('${d(Ms)}')` })
          }, null, 4)
        ], 2)) : $("", !0)
      ], 2),
      L("div", {
        class: I(["relative", { "px-0.5 pb-0.5": e.showImportant }])
      }, [
        L("div", Jc, [
          w(n.$slots, "customHeader", {}, () => [
            L("div", {
              class: "mb-0 rounded-3xl bg-[image:var(--gp-panel-pattern)] bg-right bg-no-repeat px-8 py-6 shadow-lg md:pr-12",
              style: se({
                "--gp-panel-pattern": `url('${d(Is)}'), linear-gradient(to right, #364757 3%, #3b3b51 63%, #40304b 93%)`
              })
            }, [
              L("div", _c, [
                A(qc, {
                  icon: e.icon,
                  class: "size-8"
                }, null, 8, ["icon"]),
                L("div", ef, [
                  L("h2", tf, [
                    w(n.$slots, "title", {}, () => [
                      ne(G(e.title), 1)
                    ])
                  ]),
                  w(n.$slots, "title-row-content")
                ])
              ]),
              e.subText ? (p(), x("div", nf, [
                w(n.$slots, "subText", {}, () => [
                  ne(G(e.subText), 1)
                ])
              ])) : $("", !0)
            ], 4)
          ]),
          A(Wn, null, {
            default: T(() => [
              ft(L("div", {
                class: I(["flex max-h-max flex-col gap-6 rounded-b-3xl px-8 md:pl-20 md:pr-12", e.showToggle ? "" : "mb-6"])
              }, [
                w(n.$slots, "body-content", {}, () => [
                  a[3] || (a[3] = ne("Missing Body Content", -1))
                ])
              ], 2), [
                [Lt, !e.showToggle || t.value]
              ])
            ]),
            _: 3
          }),
          e.showToggle ? (p(), x("div", af, [
            L("span", {
              class: "cursor-pointer duration-500 hover:text-white",
              onClick: a[0] || (a[0] = (l) => t.value = !t.value)
            }, [
              L("span", lf, [
                A(d(Q), {
                  icon: d(jc),
                  class: I(["mr-4 block text-gp-rhino transition-transform", { "rotate-180": !t.value }])
                }, null, 8, ["icon", "class"]),
                t.value ? (p(), x("span", of, G(e.showLess), 1)) : (p(), x("span", sf, G(e.showMore), 1))
              ])
            ])
          ])) : $("", !0)
        ])
      ], 2)
    ], 2));
  }
}), rf = (e, t, n, a) => {
  const l = (u, c) => {
    let f = [];
    n.value != null && (f = [...n.value]);
    const m = f.findIndex(
      (h) => h === c || h === u[t]
    );
    m === -1 ? u[t] != null ? n.value = [
      ...f,
      u[t]
    ] : n.value = [...f, c] : (!a.forceOpen || a.forceOpen && f.length > 1) && (f.splice(m, 1), n.value = [...f]);
  }, s = (u, c) => {
    e.value[0][t] != null ? u[t] !== n.value ? n.value = u[t] : a.forceOpen || (n.value = null) : c !== n.value ? n.value = c : a.forceOpen || (n.value = null);
  }, i = (u, c) => {
    a.multiple ? l(u, c) : s(u, c);
  }, o = (u, c) => a.multiple ? n.value == null || !Array.isArray(n.value) ? !1 : [...n.value].some(
    (m) => m === c || m === u[t]
  ) : e.value[0][t] != null ? u[t] === n.value : c === n.value;
  H(
    () => n.value,
    (u) => {
      if (u == null && e.value.length > 0 && a.forceOpen) {
        i(e.value[0], 0);
        return;
      }
      if (a.multiple && u != null && !Array.isArray(u)) {
        if (typeof u == "string" && e.value.some((c) => c[t] != null)) {
          n.value = [u];
          return;
        }
        if (typeof u == "number" && e.value[u] != null && e.value[u][t] != null) {
          n.value = [e.value[u][t]];
          return;
        }
        n.value = [u];
        return;
      }
      if (a.multiple && u != null && Array.isArray(u) && u.length > 0) {
        const c = typeof u[0];
        if (!u.some(
          (m) => typeof m !== c
        )) return;
        if (e.value[0][t] == null) {
          n.value = u.map((m) => typeof m == "number" ? m : e.value.findIndex((h) => h[t] === m)).filter((m) => m !== -1 && e.value[m] != null);
          return;
        }
        n.value = u.map((m) => typeof m == "string" ? m : e.value[m][t]).filter(
          (m) => m != null && e.value.some((h) => h[t] === m)
        );
      }
      if (!a.multiple && u != null && Array.isArray(u)) {
        n.value = u[0];
        return;
      }
      if (typeof u == "number" && e.value.length > 0 && e.value[u][t] != null) {
        n.value = e.value[u][t];
        return;
      }
      typeof u == "string" && e.value.length > 0 && e.value[0][t] == null && (n.value = null);
    }
  ), H(
    () => a.multiple,
    () => {
      n.value = a.multiple ? [] : null;
    }
  );
  const r = () => {
    a.forceOpen && e.value.length > 0 && (n.value == null || n.value.length === 0) && i(e.value[0], 0);
  };
  return H(
    () => a.forceOpen,
    () => {
      r();
    }
  ), xe(() => {
    r();
  }), {
    toggle: i,
    isOpened: o
  };
}, uf = {
  key: 0,
  class: "h-full"
}, Za = /* @__PURE__ */ E({
  __name: "GpCollapsePanelContent",
  props: {
    isOpened: { type: Boolean, default: !1 },
    content: { type: [String, Function], default: "" },
    toggleFn: {}
  },
  setup(e) {
    return (t, n) => typeof e.content == "string" ? (p(), x("p", uf, G(e.content), 1)) : (p(), D($e(e.content), {
      key: 1,
      toggle: e.toggleFn,
      "is-opened": e.isOpened
    }, null, 8, ["toggle", "is-opened"]));
  }
}), df = { key: 0 }, cf = {
  key: 0,
  class: "w-full text-end"
}, ff = ["aria-labelledby"], hf = /* @__PURE__ */ E({
  __name: "GpCollapsePanelBody",
  props: {
    isOpened: { type: Boolean, default: !1 },
    content: { type: [String, Function], default: "" },
    outline: { type: Boolean, default: !1 },
    size: { default: "large" },
    expandToggle: { type: Boolean, default: !1 },
    expandToggleLabel: { default: "Show more" },
    collapseToggleLabel: { default: "Show less" },
    expandToggleSlot: { type: Function, default: void 0 },
    contentClass: { default: () => [] },
    contentStyle: { type: [Boolean, null, String, Object, Array], default: () => ({}) },
    collapseId: {}
  },
  emits: ["toggle", "expanded", "collapsed"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = () => a("toggle"), s = k(() => n.outline ? (
      /* tw */
      "border-l border-r border-b border-gp-rhino rounded-b"
    ) : (
      /* tw */
      "bg-gp-midnight-1 rounded-b"
    )), i = k(() => n.expandToggle ? (
      /* tw */
      "relative"
    ) : ""), o = k(() => !n.isOpened && n.expandToggle ? (
      /* tw */
      "h-full"
    ) : ""), r = k(() => n.size === "large" || n.size === "lg" ? (
      /* tw */
      "p-4"
    ) : (
      /* tw */
      "py-2 px-3"
    )), u = k(() => {
      const h = ["w-full"];
      return h.push(r.value), h.push(s.value), h.push(i.value), h.push(o.value), h;
    }), c = k(() => n.contentClass != null && (n.contentClass.length > 0 || Object.keys(n.contentClass).length > 0) ? n.contentClass : u.value), f = O(!1), m = () => {
      n.expandToggle && (f.value = !0), a("expanded");
    };
    return H(
      () => n.isOpened,
      () => {
        n.expandToggle ? n.isOpened || (f.value = !1) : f.value = n.isOpened;
      }
    ), (h, g) => e.expandToggle ? (p(), x("div", {
      key: 0,
      class: I(c.value),
      style: se(e.contentStyle),
      role: "region"
    }, [
      A(Wn, {
        mode: "out-in",
        onExpanded: m,
        onCollapsed: g[0] || (g[0] = (v) => a("collapsed"))
      }, {
        default: T(() => [
          e.isOpened ? (p(), x("div", df, [
            A(Za, {
              content: e.content,
              "toggle-fn": l,
              "is-opened": e.isOpened
            }, null, 8, ["content", "is-opened"])
          ])) : $("", !0)
        ]),
        _: 1
      }),
      e.expandToggle ? (p(), x(X, { key: 0 }, [
        e.expandToggleSlot == null ? (p(), x("div", cf, [
          L("a", {
            role: "button",
            tabindex: "0",
            onClick: ke(l, ["prevent"])
          }, G(e.isOpened ? e.collapseToggleLabel : e.expandToggleLabel), 1)
        ])) : $("", !0),
        (p(), D($e(e.expandToggleSlot), {
          toggle: l,
          "is-opened": e.isOpened
        }, null, 8, ["is-opened"]))
      ], 64)) : $("", !0)
    ], 6)) : (p(), D(Wn, {
      key: 1,
      mode: "out-in",
      onExpanded: m,
      onCollapsed: g[1] || (g[1] = (v) => a("collapsed"))
    }, {
      default: T(() => [
        ft(L("div", {
          role: "region",
          "aria-labelledby": e.collapseId
        }, [
          L("div", {
            class: I(c.value),
            style: se(e.contentStyle)
          }, [
            A(Za, {
              content: e.content,
              "toggle-fn": l,
              "is-opened": e.isOpened
            }, null, 8, ["content", "is-opened"])
          ], 6)
        ], 8, ff), [
          [Lt, e.isOpened]
        ])
      ]),
      _: 1
    }));
  }
}), mf = ["id", "aria-expanded"], pf = { class: "flex-1" }, gf = /* @__PURE__ */ E({
  __name: "GpCollapsePanelHeader",
  props: {
    isOpened: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    label: { default: "" },
    outline: { type: Boolean, default: !1 },
    size: { default: "large" },
    expandToggle: { type: Boolean, default: !1 },
    slotContent: { type: Function, default: void 0 },
    disabled: { type: Boolean, default: !1 },
    collapseId: {}
  },
  emits: ["toggle"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = Ie(), s = k(() => n.size === "large" || n.size === "lg" ? (
      /* tw */
      "p-4"
    ) : (
      /* tw */
      "py-2 px-3"
    )), i = k(() => n.isOpened || n.expandToggle ? (
      /* tw */
      "rounded-t"
    ) : (
      /* tw */
      "rounded"
    )), o = k(() => n.outline ? (
      /* tw */
      "border border-gp-rhino"
    ) : (
      /* tw */
      "bg-gp-charcoal-grey hover:bg-gp-charcoal-grey-light transition-colors"
    )), r = k(() => n.disabled ? (
      /* tw */
      "pointer-events-none opacity-70"
    ) : ""), u = k(() => {
      const m = [
        /* tw */
        "flex items-center"
      ];
      return m.push(s.value), m.push(i.value), m.push(o.value), m.push(r.value), m;
    }), c = k(() => l.class != null && l.class.length > 0 ? l.class : u.value), f = (m) => {
      m.preventDefault(), !n.disabled && a("toggle");
    };
    return (m, h) => e.slotContent == null ? (p(), x("a", {
      key: 0,
      id: e.collapseId,
      class: I(c.value),
      role: "button",
      tabindex: "0",
      "aria-expanded": e.isOpened ? "true" : "false",
      onClick: f
    }, [
      L("div", pf, [
        e.icon ? (p(), D(d(Q), {
          key: 0,
          icon: e.icon,
          class: "me-2"
        }, null, 8, ["icon"])) : $("", !0),
        ne(" " + G(e.label), 1)
      ]),
      A(d(Q), {
        icon: d(lt),
        class: I(["block text-gp-rhino transition-transform", { "rotate-180": !e.isOpened }])
      }, null, 8, ["icon", "class"])
    ], 10, mf)) : (p(), D($e(e.slotContent), W(re({ key: 1 }, { toggle: f, isOpened: e.isOpened, collapseId: e.collapseId })), null, 16));
  }
}), Bh = /* @__PURE__ */ E({
  __name: "GpCollapsePanel",
  props: {
    panelKey: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    headerLabel: { default: "" },
    headerIcon: { default: void 0 },
    headerClass: { default: void 0 },
    headerStyle: { type: [Boolean, null, String, Object, Array], default: void 0 },
    bodyContent: { default: "" },
    bodyClass: { default: void 0 },
    bodyStyle: { type: [Boolean, null, String, Object, Array], default: void 0 },
    expandToggle: { type: Boolean, default: !1 },
    expandToggleLabel: { default: "Show more" },
    collapseToggleLabel: { default: "Show less" }
  },
  setup(e) {
    return E({
      name: "GpCollapsePanel",
      inheritAttrs: !1,
      customOptions: {}
    }), (t, n) => $("", !0);
  }
}), vf = (e) => {
  const { default: t } = un(), { getDefinitionsRecursive: n } = oa(), a = k(() => t != null ? n(t(), [], "GpCollapsePanel") : []);
  return {
    panelDefinitions: k(() => a.value.length > 0 ? a.value.map((s) => {
      const { disabled: i } = s.props;
      return {
        key: s.props["panel-key"] || s.props.panelKey,
        disabled: i,
        label: s.props["header-label"] || s.props.headerLabel,
        icon: s.props["header-icon"] || s.props.headerIcon,
        headerSlot: s.children != null ? s.children.header : void 0,
        headerClass: ut(
          s.props["header-class"] || s.props.headerClass
        ),
        headerStyle: dt(
          s.props["header-style"] || s.props.headerStyle
        ),
        content: s.props["body-content"] || s.props.bodyContent,
        bodySlot: s.children != null ? s.children.body : void 0,
        bodyClass: ut(
          s.props["body-class"] || s.props.bodyClass
        ),
        bodyStyle: dt(
          s.props["body-style"] || s.props.bodyStyle
        ),
        expandToggle: s.props["expand-toggle"] || s.props.expandToggle,
        expandToggleLabel: s.props["expand-toggle-label"] || s.props.expandToggleLabel,
        collapseToggleLabel: s.props["collapse-toggle-label"] || s.props.collapseToggleLabel,
        expandToggleSlot: s.children != null ? s.children.expandToggle : void 0
      };
    }) : e.value)
  };
}, yf = /* @__PURE__ */ E({
  __name: "GpCollapsePanelWrapper",
  props: {
    isOpened: { type: Boolean }
  },
  setup(e) {
    return (t, n) => w(t.$slots, "default", { isOpened: e.isOpened });
  }
}), Dh = /* @__PURE__ */ E({
  __name: "GpCollapse",
  props: {
    modelValue: { default: null },
    multiple: { type: Boolean, default: !1 },
    forceOpen: { type: Boolean },
    collapseModel: { default: () => [] },
    outline: { type: Boolean, default: !1 },
    size: { default: "large" }
  },
  emits: ["update:modelValue", "expanded", "collapsed"],
  setup(e, { emit: t }) {
    const n = e, a = t, { panelDefinitions: l } = vf(z(n, "collapseModel")), s = Ae(n, "modelValue", a), { isOpened: i, toggle: o } = rf(
      l,
      "key",
      s,
      n
    ), u = on().replace(/[^a-zA-Z0-9_-]/g, "_").replace(/^_+|_+$/g, "") || "clps";
    return (c, f) => (p(), x("ul", null, [
      (p(!0), x(X, null, ce(d(l), (m, h) => (p(), x("li", {
        key: `gp-clps-${d(u)}-${m.key ?? h}`,
        class: "mt-4 first:mt-0"
      }, [
        A(yf, {
          "is-opened": d(i)(m, h)
        }, {
          default: T(({ isOpened: g }) => [
            A(gf, {
              "collapse-id": `gp-clps-${d(u)}-${m.key ?? h}`,
              "is-opened": g,
              label: m.label,
              icon: m.icon,
              "slot-content": m.headerSlot,
              outline: e.outline,
              size: e.size,
              class: I(m.headerClass),
              "expand-toggle": m.expandToggle,
              style: se(m.headerStyle),
              disabled: m.disabled,
              onToggle: (v) => d(o)(m, h)
            }, null, 8, ["collapse-id", "is-opened", "label", "icon", "slot-content", "outline", "size", "class", "expand-toggle", "style", "disabled", "onToggle"]),
            A(hf, {
              "collapse-id": `gp-clps-${d(u)}-${m.key ?? h}`,
              "is-opened": g,
              content: m.bodySlot || m.content,
              outline: e.outline,
              size: e.size,
              "expand-toggle": m.expandToggle,
              "expand-toggle-label": m.expandToggleLabel,
              "collapse-toggle-label": m.collapseToggleLabel,
              "content-class": m.bodyClass,
              "content-style": m.bodyStyle,
              onToggle: (v) => d(o)(m, h),
              onExpanded: (v) => a("expanded", m.key || h),
              onCollapsed: (v) => a("collapsed", m.key || h)
            }, null, 8, ["collapse-id", "is-opened", "content", "outline", "size", "expand-toggle", "expand-toggle-label", "collapse-toggle-label", "content-class", "content-style", "onToggle", "onExpanded", "onCollapsed"])
          ]),
          _: 2
        }, 1032, ["is-opened"])
      ]))), 128)),
      w(c.$slots, "default")
    ]));
  }
}), bf = { class: "flex-1" }, kf = { class: "mb-0" }, Ih = /* @__PURE__ */ E({
  __name: "GpAlert",
  props: {
    alertType: { default: "neutral" },
    outline: { type: Boolean, default: !1 },
    size: { default: "lg" },
    shadow: { type: Boolean, default: !1 },
    title: { default: "" },
    message: { default: "" },
    icon: { default: null }
  },
  setup(e) {
    const t = {
      primary: (
        /* tw */
        "bg-gp-cyan/10"
      ),
      danger: (
        /* tw */
        "bg-gp-crab/10"
      ),
      success: (
        /* tw */
        "bg-gp-green/10"
      ),
      warning: (
        /* tw */
        "bg-gp-orange/10"
      ),
      info: (
        /* tw */
        "bg-gp-ocean/10"
      )
    }, n = e, a = z(n, "alertType"), l = Pt(a), s = El(a), i = k(() => {
      const o = [];
      return ["lg", "large"].includes(n.size) ? o.push(
        /* tw */
        "px-8 py-4"
      ) : ["sm", "small"].includes(n.size) && o.push(
        /* tw */
        "px-4 py-2"
      ), n.alertType === "neutral" ? (o.push(
        /* tw */
        "bg-linear-to-r from-gp-midnight-3-a to-gp-midnight-3-b text-gp-mouse"
      ), n.shadow && o.push(
        /* tw */
        "shadow-xl"
      )) : n.outline ? (o.push(
        /* tw */
        "border border-solid"
      ), n.alertType === "danger" ? o.push(
        /* tw */
        "border-gp-crab text-gp-crab"
      ) : o.push(s.value), o.push(t[n.alertType])) : (o.push(l.value), n.shadow && o.push(
        /* tw */
        "shadow-xl"
      )), n.icon != null && o.push(
        /* tw */
        "flex items-center"
      ), o;
    });
    return (o, r) => (p(), x("div", {
      class: I(["rounded", i.value])
    }, [
      w(o.$slots, "default", {}, () => [
        e.icon != null ? (p(), D(d(Q), {
          key: 0,
          class: I(["mr-4", {
            "mr-4 text-2xl": ["lg", "large"].includes(e.size)
          }]),
          icon: e.icon
        }, null, 8, ["class", "icon"])) : $("", !0),
        L("div", bf, [
          L("h6", {
            class: I(["mb-0 font-bold", {
              "text-xl": ["lg", "large"].includes(e.size)
            }])
          }, G(e.title), 3),
          L("p", kf, G(e.message), 1)
        ])
      ])
    ], 2));
  }
}), wf = ["aria-valuenow", "aria-valuemin", "aria-valuemax"], xf = { key: 0 }, Cf = /* @__PURE__ */ E({
  __name: "GpProgress",
  props: {
    progressType: { default: "neutral" },
    size: { default: "md" },
    outline: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    striped: { type: Boolean, default: !1 },
    animateProgress: { type: Boolean, default: !1 },
    label: { default: void 0 },
    absolute: { type: Boolean },
    hideLabel: { type: Boolean, default: !1 },
    value: {},
    valueMin: { default: 0 },
    valueMax: { default: 100 }
  },
  setup(e) {
    const t = e, n = z(t, "progressType"), a = Pt(
      n
    ), l = El(
      n
    ), s = k(() => t.valueMin === void 0 || t.valueMax === void 0 || t.valueMax <= 0 || t.valueMin >= t.valueMax || t.value < 0 || t.value < t.valueMin ? 0 : Math.round(
      (t.value - t.valueMin) / (t.valueMax - t.valueMin) * 100
    )), i = k(() => {
      if (t.absolute && t.value != null && t.valueMax)
        return `${t.value} / ${t.valueMax}`;
    }), o = k(() => s.value > 100 ? 100 : s.value), r = k(() => {
      const m = [];
      return o.value > 0 && (n.value === "fancy" ? (m.push(
        /* tw */
        "bg-linear-to-r from-gp-mr-maintenance-a to-gp-mr-maintenance-b text-black"
      ), t.loading && m.push(
        /* tw */
        "animate-rainbow bg-size-[200%_200%]"
      )) : (m.push(a.value), t.striped && (m.push(
        /* tw */
        "bg-progress-img-striped bg-progress-bg-striped"
      ), t.loading && m.push(
        /* tw */
        "animate-progress-bar"
      )))), m.push(
        /* tw */
        "h-full"
      ), ["small", "sm"].includes(t.size) ? m.push(
        /* tw */
        "px-1 text-xs"
      ) : ["large", "lg"].includes(t.size) ? m.push(
        /* tw */
        "px-4 py-3"
      ) : m.push(
        /* tw */
        "px-2 py-1 leading-tight"
      ), m;
    }), u = k(() => {
      const m = [];
      return ["small", "sm"].includes(t.size) ? m.push(
        /* tw */
        "h-4"
      ) : ["large", "lg"].includes(t.size) ? m.push(
        /* tw */
        "h-component-lg"
      ) : m.push(
        /* tw */
        "h-component-base"
      ), m.join(" ");
    }), c = O(!1), f = O(!1);
    return xe(() => {
      t.animateProgress ? c.value = !0 : f.value = !0;
    }), (m, h) => (p(), x("div", {
      class: I(["flex items-center overflow-hidden rounded bg-gp-midnight-1", {
        [`border ${d(l)}`]: e.progressType === "fancy" ? !1 : e.outline,
        "text-center": o.value === 0,
        [u.value]: !0,
        "[--gp-progress-min-width:13%] sm:[--gp-progress-min-width:10%]": !e.hideLabel
      }]),
      style: se({
        "--gp-progress-stripe-width": e.striped ? "2rem" : void 0,
        "--gp-progress-width": o.value > 0 ? `${o.value}%` : "100%"
      })
    }, [
      A(ct, {
        "enter-from-class": "scale-x-0",
        "enter-active-class": "transition duration-500 ease-out-in origin-left",
        "enter-to-class": "scale-x-100",
        onAfterEnter: h[0] || (h[0] = (g) => f.value = !0)
      }, {
        default: T(() => [
          !e.animateProgress || e.animateProgress && c.value ? (p(), x("div", {
            key: 0,
            class: I(["flex-nowrap overflow-hidden rounded text-center font-bold", r.value]),
            role: "progressbar",
            "aria-valuenow": e.value,
            "aria-valuemin": e.valueMin,
            "aria-valuemax": e.valueMax,
            style: { width: "var(--gp-progress-width)", "min-width": "var(--gp-progress-min-width)" }
          }, [
            w(m.$slots, "default", {}, () => [
              A(Ye, {
                disabled: !e.animateProgress
              }, {
                default: T(() => [
                  !e.hideLabel && f.value ? (p(), x("span", xf, [
                    e.label != null ? (p(), x(X, { key: 0 }, [
                      ne(G(e.label), 1)
                    ], 64)) : i.value != null ? (p(), x(X, { key: 1 }, [
                      ne(G(i.value), 1)
                    ], 64)) : (p(), x(X, { key: 2 }, [
                      ne(G(o.value) + "% ", 1)
                    ], 64))
                  ])) : $("", !0)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ], 10, wf)) : $("", !0)
        ]),
        _: 3
      })
    ], 6));
  }
}), Mh = /* @__PURE__ */ E({
  __name: "GpProgressFancy",
  props: {
    size: { default: "md" },
    loading: { type: Boolean, default: !1 },
    animateProgress: { type: Boolean, default: !1 },
    label: { default: void 0 },
    hideLabel: { type: Boolean, default: !1 },
    value: {},
    valueMin: { default: 0 },
    valueMax: { default: 100 }
  },
  setup(e) {
    return (t, n) => (p(), D(Cf, {
      value: e.value,
      "value-min": e.valueMin,
      "value-max": e.valueMax,
      "progress-type": "fancy",
      outline: !1,
      size: e.size,
      striped: !1,
      loading: e.loading,
      "animate-progress": e.animateProgress,
      "hide-label": e.hideLabel,
      label: e.label
    }, {
      default: T(() => [
        w(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["value", "value-min", "value-max", "size", "loading", "animate-progress", "hide-label", "label"]));
  }
}), ws = (e, t) => ({ sizeClass: k(() => {
  if (e.value)
    return (
      /* tw */
      "w-(--gp-avatar-size) h-(--gp-avatar-size)"
    );
  switch (t.value) {
    case "sm":
    case "small":
      return (
        /* tw */
        "w-4 h-4"
      );
    case "lg":
    case "large":
      return (
        /* tw */
        "w-component-lg h-component-lg"
      );
    case "md":
    case "medium":
      return (
        /* tw */
        "w-component-base h-component-base"
      );
    default:
      return (
        /* tw */
        "w-component-base h-component-base"
      );
  }
}) }), Tf = ["src", "alt"], Eh = /* @__PURE__ */ E({
  __name: "GpAvatar",
  props: {
    src: {},
    alt: {},
    rounded: { type: Boolean, default: !1 },
    size: { default: "md" },
    customSize: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = z(t, "customSize"), a = z(t, "size"), { sizeClass: l } = ws(n, a);
    return (s, i) => (p(), x("img", {
      src: e.src,
      alt: e.alt,
      class: I({
        "rounded-full": e.rounded,
        rounded: !e.rounded,
        [d(l)]: !0
      })
    }, null, 10, Tf));
  }
}), Ah = /* @__PURE__ */ E({
  __name: "GpAvatarInitials",
  props: {
    firstName: {},
    lastName: { default: void 0 },
    rounded: { type: Boolean, default: !1 },
    size: { default: "md" },
    customSize: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = z(t, "customSize"), a = z(t, "size"), { sizeClass: l } = ws(n, a), s = k(() => {
      if (n.value)
        return (
          /* tw */
          "text-(length:--gp-avatar-initials-size)"
        );
      switch (a.value) {
        case "sm":
        case "small":
          return (
            /* tw */
            "text-xs"
          );
        case "lg":
        case "large":
          return (
            /* tw */
            "text-2xl py-2"
          );
        default:
          return (
            /* tw */
            "text-base py-1 leading-5"
          );
      }
    });
    return (i, o) => (p(), x("div", {
      class: I(["relative bg-gp-cyan text-center font-bold text-black", {
        "rounded-full": e.rounded,
        rounded: !e.rounded,
        [d(l)]: !0,
        [s.value]: !0
      }])
    }, [
      ne(G(e.firstName[0]), 1),
      e.lastName != null ? (p(), x(X, { key: 0 }, [
        ne(G(e.lastName[0]), 1)
      ], 64)) : $("", !0)
    ], 2));
  }
}), Sf = /* @__PURE__ */ E({
  __name: "GpToastProgress",
  props: {
    timeout: {},
    isPausing: { type: Boolean, default: !1 }
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const n = t, a = () => {
      e.timeout !== 0 && n("dismiss");
    };
    return (l, s) => (p(), x("div", {
      ref: "progress",
      role: "progressbar",
      class: I(["h-1 w-full origin-left animate-toast-progress bg-black/40 [animation-duration:var(--gp-toast-progress-duration)] [animation-fill-mode:forwards]", {
        "[animation-play-state:paused]": e.isPausing
      }]),
      style: se({
        "--gp-toast-progress-duration": `${e.timeout}ms`
      }),
      onAnimationend: a
    }, null, 38));
  }
}), Bf = {
  key: 1,
  class: "flex justify-between gap-2 px-6 py-4"
}, Df = { class: "flex-1" }, If = {
  key: 0,
  class: "text-xl font-bold"
}, Mf = { key: 1 }, Ef = /* @__PURE__ */ E({
  __name: "GpToastBody",
  props: {
    toastType: { default: "primary" },
    icon: { default: () => {
    } },
    title: { default: () => {
    } },
    text: { default: () => {
    } },
    timeout: { default: 5e3 },
    dismissible: { type: Boolean, default: !0 },
    dismissOnBody: { type: Boolean, default: !0 },
    bodyComponent: { default: () => {
    } },
    bodyComponentProps: { default: () => {
    } },
    toastStyle: { default: () => {
    } },
    position: {},
    onBeforeDismiss: { type: Function, default: void 0 },
    onAfterDismiss: { type: Function, default: void 0 }
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const n = t, a = () => {
      e.dismissOnBody && l();
    };
    async function l() {
      e.onBeforeDismiss && await e.onBeforeDismiss(), n("dismiss"), e.onAfterDismiss && await e.onAfterDismiss();
    }
    const s = O(!1), i = () => {
      s.value = !0;
    }, o = () => {
      s.value = !1;
    }, r = z(() => e.toastType), u = Pt(r);
    return be(() => {
      e.timeout === 0 && e.dismissible === !1 && e.dismissOnBody === !1 && console.warn(
        "Toast is not dismissible and has no timeout. It will be shown forever. Please make sure to dismiss it programmatically with 'dismissToast'."
      );
    }), (c, f) => (p(), x("div", {
      class: I(["overflow-hidden rounded", [
        e.toastStyle != null ? e.toastStyle : d(u),
        e.dismissOnBody && !e.toastStyle ? [
          d(it)[e.toastType],
          "transition-colors",
          "cursor-pointer"
        ] : void 0
      ]]),
      onClick: a,
      onMouseover: i,
      onMouseout: o,
      role: "alert"
    }, [
      e.bodyComponent != null ? (p(), D($e(e.bodyComponent), re({ key: 0 }, e.bodyComponentProps, { onDismiss: l }), null, 16)) : (p(), x("div", Bf, [
        w(c.$slots, "default", {}, () => [
          e.icon != null ? (p(), D(d(Q), {
            key: 0,
            icon: e.icon,
            class: "mt-1 text-lg"
          }, null, 8, ["icon"])) : $("", !0),
          L("div", Df, [
            e.title ? (p(), x("div", If, G(e.title), 1)) : $("", !0),
            e.text ? (p(), x("p", Mf, G(e.text), 1)) : $("", !0)
          ])
        ]),
        e.dismissible && !e.dismissOnBody ? (p(), x("div", {
          key: 0,
          onClick: ke(l, ["stop"]),
          class: "cursor-pointer p-1"
        }, [
          A(d(Q), { icon: d(rl) }, null, 8, ["icon"])
        ])) : $("", !0)
      ])),
      A(Sf, {
        ref: "progress",
        timeout: e.timeout,
        "is-pausing": s.value,
        onDismiss: l
      }, null, 8, ["timeout", "is-pausing"])
    ], 34));
  }
}), Af = /* @__PURE__ */ E({
  __name: "GpToastsList",
  props: {
    stack: { default: () => [] },
    position: { default: "top-right" }
  },
  emits: ["dismissed"],
  setup(e, { emit: t }) {
    const n = {
      enterActiveClass: "transition-transform ease duration-500",
      moveClass: "transition-[transform,opacity] ease duration-500",
      leaveActiveClass: "transition-[opacity,transform] ease duration-500"
    }, a = t, s = fe(qn).defaultTimeout, i = (u) => {
      a("dismissed", u);
    }, o = k(() => e.position.startsWith("top") ? e.stack : e.stack.slice().reverse()), r = k(() => {
      switch (e.position) {
        case "top-right":
          return {
            baseClass: "top-0 right-0",
            transitionClasses: {
              ...n,
              enterFromClass: "translate-x-[150%]",
              enterToClass: "translate-x-0",
              leaveFromClass: "translate-x-0 opacity-100",
              leaveToClass: "translate-x-[150%] opacity-50"
            }
          };
        case "top-center":
          return {
            baseClass: "top-0 left-1/2 transform -translate-x-1/2",
            transitionClasses: {
              ...n,
              enterFromClass: "-translate-y-[150%]",
              enterToClass: "translate-y-0",
              leaveFromClass: "translate-y-0 opacity-100",
              leaveToClass: "-translate-y-[20%] opacity-0"
            }
          };
        case "top-left":
          return {
            baseClass: "top-0 left-0",
            transitionClasses: {
              ...n,
              enterFromClass: "-translate-x-[150%]",
              enterToClass: "translate-x-0",
              leaveFromClass: "translate-x-0 opacity-100",
              leaveToClass: "-translate-x-[150%] opacity-50"
            }
          };
        case "bottom-left":
          return {
            baseClass: "bottom-0 left-0",
            transitionClasses: {
              ...n,
              enterFromClass: "-translate-x-[150%]",
              enterToClass: "translate-x-0",
              leaveFromClass: "translate-x-0 opacity-100",
              leaveToClass: "opacity-50 -translate-x-[150%]"
            }
          };
        case "bottom-center":
          return {
            baseClass: "bottom-0 left-1/2 transform -translate-x-1/2",
            transitionClasses: {
              ...n,
              enterFromClass: "translate-y-[150%]",
              enterToClass: "translate-y-0",
              leaveFromClass: "translate-y-0 opacity-100",
              leaveToClass: "translate-y-[20%] opacity-0"
            }
          };
        case "bottom-right":
          return {
            baseClass: "bottom-0 right-0",
            transitionClasses: {
              ...n,
              enterFromClass: "translate-x-[150%]",
              enterToClass: "translate-x-0",
              leaveFromClass: "translate-x-0 opacity-100",
              leaveToClass: "translate-x-[150%] opacity-50"
            }
          };
        default:
          return null;
      }
    });
    return (u, c) => (p(), x("div", {
      class: I(["fixed z-30 w-full max-w-full px-4 pt-4 md:w-96", r.value.baseClass])
    }, [
      A(rn, {
        tag: "ul",
        class: "relative",
        "enter-from-class": r.value.transitionClasses.enterFromClass,
        "enter-active-class": r.value.transitionClasses.enterActiveClass,
        "enter-to-class": r.value.transitionClasses.enterToClass,
        "move-class": r.value.transitionClasses.moveClass,
        "leave-from-class": r.value.transitionClasses.leaveFromClass,
        "leave-active-class": r.value.transitionClasses.leaveActiveClass,
        "leave-to-class": r.value.transitionClasses.leaveToClass
      }, {
        default: T(() => [
          (p(!0), x(X, null, ce(o.value, (f) => (p(), x("li", {
            key: f.utid,
            class: "min-w-full"
          }, [
            A(Ef, {
              class: "mb-4",
              "toast-type": f.toastType,
              icon: f.icon,
              title: f.title,
              text: f.text,
              dismissible: f.dismissible,
              "dismiss-on-body": f.dismissOnBody,
              timeout: f.timeout == null ? d(s) : f.timeout,
              "toast-style": f.toastStyle,
              "body-component": f.bodyComponent,
              "body-component-props": f.bodyComponentProps,
              "on-before-dismiss": f.onBeforeDismiss,
              "on-after-dismiss": f.onAfterDismiss,
              onDismiss: (m) => i(f.utid)
            }, null, 8, ["toast-type", "icon", "title", "text", "dismissible", "dismiss-on-body", "timeout", "toast-style", "body-component", "body-component-props", "on-before-dismiss", "on-after-dismiss", "onDismiss"])
          ]))), 128))
        ]),
        _: 1
      }, 8, ["enter-from-class", "enter-active-class", "enter-to-class", "move-class", "leave-from-class", "leave-active-class", "leave-to-class"])
    ], 2));
  }
}), Fh = /* @__PURE__ */ E({
  __name: "GpToastsWrapper",
  setup(e) {
    const t = fe(Un, al), n = fe(qn, Rs);
    function a(s) {
      t.value = t.value.filter(
        (i) => i.utid !== s
      );
    }
    const l = k(() => {
      const s = n.positions.reduce(
        (i, o) => (i[o] = [], i),
        {}
      );
      return t.value.forEach((i) => {
        if (s[i.position] === void 0) {
          console.warn(
            `The toast position "${i.position}" is unknown. Either register the position in "toastOptions.positions" in the plugin settings or use the default.`
          );
          return;
        }
        s[i.position].push(i);
      }), s;
    });
    return (s, i) => (p(), D(Ze, { to: "body" }, [
      (p(!0), x(X, null, ce(l.value, (o, r) => (p(), D(Af, {
        key: r,
        stack: o,
        position: r,
        onDismissed: a
      }, null, 8, ["stack", "position"]))), 128))
    ]));
  }
});
function Oh() {
  const e = fe(Un, al);
  function t(u) {
    const c = u;
    return c.utid = (/* @__PURE__ */ new Date()).getTime().toString(), u.position == null && (c.position = dn.TOP_RIGHT), e.value.unshift(c), c.utid;
  }
  return {
    createToast: t,
    createPrimary: (u) => t({
      ...u,
      toastType: "primary"
    }),
    createFlat: (u) => t({
      ...u,
      toastType: "flat"
    }),
    createWarning: (u) => t({
      ...u,
      toastType: "warning"
    }),
    createDanger: (u) => t({
      ...u,
      toastType: "danger"
    }),
    createSuccess: (u) => t({
      ...u,
      toastType: "success"
    }),
    createInfo: (u) => t({
      ...u,
      toastType: "info"
    }),
    dismissToast: (u) => {
      e.value = e.value.filter(
        (c) => c.utid !== u
      );
    }
  };
}
function Ff(e) {
  return new Promise((t) => {
    const n = document.createElement("textarea");
    n.value = e.trim(), n.setAttribute("readonly", ""), document.body.appendChild(n), n.select(), document.execCommand("copy"), document.body.removeChild(n), t();
  });
}
const Of = { class: "flex items-center gap-2" }, $f = { key: 0 }, Lf = { key: 1 }, $h = /* @__PURE__ */ E({
  name: "GpText",
  __name: "GpText",
  props: {
    text: { default: void 0 },
    isPassword: { type: Boolean, default: !1 },
    allowCopy: { type: Boolean, default: !1 },
    copyValue: { default: void 0 }
  },
  emits: ["copy"],
  setup(e, { emit: t }) {
    const n = e, a = t, l = O(n.isPassword), s = O(!1), i = O(void 0), o = O(void 0), r = k(() => n.copyValue !== void 0 ? String(n.copyValue) : n.text !== void 0 ? String(n.text) : "");
    function u() {
      l.value = !1, n.allowCopy && clearTimeout(o.value), o.value = window.setTimeout(() => {
        n.isPassword && !s.value && (l.value = !0);
      }, 1e4);
    }
    function c() {
      const m = r.value;
      if (!m) {
        console.warn(
          "GpText: No value to copy. Provide text or copyValue prop when using slots."
        );
        return;
      }
      Ff(m), a("copy", m), s.value = !0, i.value && clearTimeout(i.value), i.value = window.setTimeout(() => {
        s.value = !1, n.isPassword && n.allowCopy && (l.value = !0);
      }, 2e3);
    }
    function f() {
      l.value = !l.value;
    }
    return We(() => {
      i.value && clearTimeout(i.value), o.value && clearTimeout(o.value);
    }), (m, h) => (p(), x("div", Of, [
      e.isPassword && l.value ? (p(), x("span", $f, " •••••••• ")) : (p(), x("span", Lf, [
        w(m.$slots, "default", {}, () => [
          ne(G(e.text), 1)
        ])
      ])),
      w(m.$slots, "icons", {
        onCopy: c,
        onTogglePassword: f,
        onShowPassword: u,
        isHidden: l.value,
        showCheck: s.value
      }, () => [
        e.isPassword && !e.allowCopy ? (p(), D(d(Q), {
          key: 0,
          icon: l.value ? d(Pn) : d(sl),
          class: "cursor-pointer text-gp-rhino",
          onClick: f
        }, null, 8, ["icon"])) : e.isPassword && e.allowCopy ? (p(), x(X, { key: 1 }, [
          l.value ? (p(), D(d(Q), {
            key: 0,
            icon: d(Pn),
            class: "cursor-pointer text-gp-rhino",
            onClick: u
          }, null, 8, ["icon"])) : s.value ? (p(), D(d(Q), {
            key: 1,
            icon: d(Gn),
            class: "text-gp-green"
          }, null, 8, ["icon"])) : (p(), D(d(Q), {
            key: 2,
            icon: d(ba),
            class: "cursor-pointer text-gp-rhino",
            onClick: c
          }, null, 8, ["icon"]))
        ], 64)) : e.allowCopy ? (p(), x(X, { key: 2 }, [
          s.value ? (p(), D(d(Q), {
            key: 0,
            icon: d(Gn),
            class: "text-gp-green"
          }, null, 8, ["icon"])) : (p(), D(d(Q), {
            key: 1,
            icon: d(ba),
            class: "cursor-pointer text-gp-rhino",
            onClick: c
          }, null, 8, ["icon"]))
        ], 64)) : $("", !0)
      ])
    ]));
  }
}), Lh = (e) => e, It = {
  useTheming: !1,
  useToasts: !1,
  toastOptions: {
    defaultTimeout: 5e3,
    positions: ["top-right"]
  }
}, Vh = {
  install(e, t) {
    const {
      useTheming: n = It.useTheming,
      useToasts: a = It.useToasts,
      toastOptions: l = It.toastOptions
    } = t || It;
    n && Vs(e), a && Ps(e, l, It.toastOptions);
  }
};
export {
  Fs as GP_THEME,
  As as GP_THEME_DEFAULT,
  Ih as GpAlert,
  Eh as GpAvatar,
  Ah as GpAvatarInitials,
  ys as GpBrandImage,
  xh as GpBrandImageImageStatic,
  lc as GpBrandLoading,
  oc as GpBrandMessage,
  we as GpBtn,
  dh as GpBtnLink,
  Ch as GpCard,
  Qt as GpCheckbox,
  Dh as GpCollapse,
  Bh as GpCollapsePanel,
  _f as GpDatePicker,
  eh as GpDragAndDropList,
  Xf as GpDropdown,
  no as GpDropdownItem,
  Wn as GpExpandTransition,
  th as GpExpandTransitionGroup,
  da as GpFadeSlideTransition,
  nh as GpFadeSlideTransitionGroup,
  Ye as GpFadeTransition,
  ah as GpFadeTransitionGroup,
  qc as GpIconFancy,
  st as GpInputBtn,
  pe as GpInputHint,
  ht as GpInputlabel,
  Kf as GpMaskInput,
  ch as GpMenu,
  vs as GpMenuItemAction,
  mh as GpMenuItemBtn,
  ga as GpMenuItemContent,
  ph as GpMenuItemDivider,
  gh as GpMenuItemGroupHeader,
  hh as GpMenuItemLink,
  fh as GpMenuItemStatic,
  vh as GpMenuTypes,
  yh as GpModal,
  tc as GpModalBody,
  lh as GpNavigation,
  sh as GpNavigationGroup,
  ih as GpNavigationItem,
  rh as GpNavigationItemBtn,
  oh as GpNavigationItemLink,
  uh as GpNavigationTypes,
  qf as GpNumberInput,
  Sh as GpPanel,
  jf as GpPasswordInput,
  Cf as GpProgress,
  Mh as GpProgressFancy,
  Jf as GpRadio,
  kr as GpRadioInput,
  xt as GpSlideTransition,
  Zf as GpSlider,
  Qf as GpSwitch,
  Th as GpTabBar,
  Nc as GpTabBtn,
  zc as GpTabItem,
  bh as GpTable,
  ks as GpTableColumn,
  En as GpTag,
  $h as GpText,
  Wf as GpTextArea,
  Kn as GpTextInput,
  Es as GpThemeDefault,
  Ef as GpToastBody,
  dn as GpToastPosition,
  Fh as GpToastsWrapper,
  or as GpTooltip,
  gi as PasswordStrength,
  Os as convertHexToRGBA,
  Vh as default,
  md as reorderArray,
  Lh as tw,
  fn as useBreakpoints,
  Ct as useFaIcons,
  kh as useGenericFieldColumn,
  wh as useGenericRowColumn,
  Oh as useGpToasts,
  Hf as usePasswordValidation,
  Uf as useScrollToTop
};
